export default {
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-النفل"}': {
    path: "/الرياض/شمال-الرياض/حي-النفل",
    __typename: "DistrictType",
    district_id: 610,
    name: "حي النفل",
    uri: "حي-النفل",
  },
  'DirectionType:{"uri":"شمال-الرياض"}': {
    uri: "شمال-الرياض",
    __typename: "DirectionType",
    direction_id: 4,
    name: "شمال الرياض",
    path: "/الرياض/شمال-الرياض",
  },
  'CityType:{"uri":"الرياض"}': {
    uri: "الرياض",
    __typename: "CityType",
    city_id: 21,
    name: "الرياض",
    path: "/الرياض",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-الهدا"}': {
    path: "/الرياض/غرب-الرياض/حي-الهدا",
    __typename: "DistrictType",
    district_id: 618,
    name: "حي الهدا",
    uri: "حي-الهدا",
  },
  'DirectionType:{"uri":"غرب-الرياض"}': {
    uri: "غرب-الرياض",
    __typename: "DirectionType",
    direction_id: 6,
    name: "غرب الرياض",
    path: "/الرياض/غرب-الرياض",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-الوشام"}': {
    path: "/الرياض/وسط-الرياض/حي-الوشام",
    __typename: "DistrictType",
    district_id: 630,
    name: "حي الوشام",
    uri: "حي-الوشام",
  },
  'DirectionType:{"uri":"وسط-الرياض"}': {
    uri: "وسط-الرياض",
    __typename: "DirectionType",
    direction_id: 7,
    name: "وسط الرياض",
    path: "/الرياض/وسط-الرياض",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-ام-سليم"}': {
    path: "/الرياض/وسط-الرياض/حي-ام-سليم",
    __typename: "DistrictType",
    district_id: 644,
    name: "حي ام سليم",
    uri: "حي-ام-سليم",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-أحد"}': {
    path: "/الرياض/جنوب-الرياض/حي-أحد",
    __typename: "DistrictType",
    district_id: 646,
    name: "حي أحد",
    uri: "حي-أحد",
  },
  'DirectionType:{"uri":"جنوب-الرياض"}': {
    uri: "جنوب-الرياض",
    __typename: "DirectionType",
    direction_id: 1,
    name: "جنوب الرياض",
    path: "/الرياض/جنوب-الرياض",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-جامعة-الأميرة-نورة"}': {
    path: "/الرياض/شمال-الرياض/حي-جامعة-الأميرة-نورة",
    __typename: "DistrictType",
    district_id: 656,
    name: "حي جامعة الأميرة نورة",
    uri: "حي-جامعة-الأميرة-نورة",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-خشم-العان"}': {
    path: "/الرياض/جنوب-الرياض/حي-خشم-العان",
    __typename: "DistrictType",
    district_id: 666,
    name: "حي خشم العان",
    uri: "حي-خشم-العان",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-سلطانة"}': {
    path: "/الرياض/غرب-الرياض/حي-سلطانة",
    __typename: "DistrictType",
    district_id: 672,
    name: "حي سلطانة",
    uri: "حي-سلطانة",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-طيبة"}': {
    path: "/الرياض/جنوب-الرياض/حي-طيبة",
    __typename: "DistrictType",
    district_id: 684,
    name: "حي طيبة",
    uri: "حي-طيبة",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-ظهرة-لبن"}': {
    path: "/الرياض/غرب-الرياض/حي-ظهرة-لبن",
    __typename: "DistrictType",
    district_id: 688,
    name: "حي ظهرة لبن",
    uri: "حي-ظهرة-لبن",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-عريض"}': {
    path: "/الرياض/جنوب-الرياض/حي-عريض",
    __typename: "DistrictType",
    district_id: 696,
    name: "حي عريض",
    uri: "حي-عريض",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-عكاظ"}': {
    path: "/الرياض/جنوب-الرياض/حي-عكاظ",
    __typename: "DistrictType",
    district_id: 698,
    name: "حي عكاظ",
    uri: "حي-عكاظ",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-لبن"}': {
    path: "/الرياض/غرب-الرياض/حي-لبن",
    __typename: "DistrictType",
    district_id: 708,
    name: "حي لبن",
    uri: "حي-لبن",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-مطار-الملك-خالد-الدولي"}': {
    path: "/الرياض/شمال-الرياض/حي-مطار-الملك-خالد-الدولي",
    __typename: "DistrictType",
    district_id: 712,
    name: "حي مطار الملك خالد الدولي",
    uri: "حي-مطار-الملك-خالد-الدولي",
  },
  'DistrictType:{"path":"/الزلفي/حي-الدرعية"}': {
    path: "/الزلفي/حي-الدرعية",
    __typename: "DistrictType",
    district_id: 728,
    name: "حي الدرعية",
    uri: "حي-الدرعية",
  },
  'CityType:{"uri":"الزلفي"}': {
    uri: "الزلفي",
    __typename: "CityType",
    city_id: 22,
    name: "الزلفي",
    path: "/الزلفي",
  },
  'DistrictType:{"path":"/الزلفي/حي-الريان"}': {
    path: "/الزلفي/حي-الريان",
    __typename: "DistrictType",
    district_id: 734,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'DistrictType:{"path":"/الزلفي/حي-الصناعية"}': {
    path: "/الزلفي/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 742,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/الزلفي/حي-القدس"}': {
    path: "/الزلفي/حي-القدس",
    __typename: "DistrictType",
    district_id: 752,
    name: "حي القدس",
    uri: "حي-القدس",
  },
  'DistrictType:{"path":"/الزلفي/حي-المنتزة"}': {
    path: "/الزلفي/حي-المنتزة",
    __typename: "DistrictType",
    district_id: 754,
    name: "حي المنتزة",
    uri: "حي-المنتزة",
  },
  'DistrictType:{"path":"/السليل/حي-الديرة"}': {
    path: "/السليل/حي-الديرة",
    __typename: "DistrictType",
    district_id: 778,
    name: "حي الديرة",
    uri: "حي-الديرة",
  },
  'CityType:{"uri":"السليل"}': {
    uri: "السليل",
    __typename: "CityType",
    city_id: 23,
    name: "السليل",
    path: "/السليل",
  },
  'DistrictType:{"path":"/السليل/حي-الزهرة"}': {
    path: "/السليل/حي-الزهرة",
    __typename: "DistrictType",
    district_id: 782,
    name: "حي الزهرة",
    uri: "حي-الزهرة",
  },
  'DistrictType:{"path":"/السليل/حي-الشفاء"}': {
    path: "/السليل/حي-الشفاء",
    __typename: "DistrictType",
    district_id: 784,
    name: "حي الشفاء",
    uri: "حي-الشفاء",
  },
  'DistrictType:{"path":"/السليل/حي-الملك-عبدالعزيز"}': {
    path: "/السليل/حي-الملك-عبدالعزيز",
    __typename: "DistrictType",
    district_id: 786,
    name: "حي الملك عبدالعزيز",
    uri: "حي-الملك-عبدالعزيز",
  },
  'DistrictType:{"path":"/الغاط/حي-البستان"}': {
    path: "/الغاط/حي-البستان",
    __typename: "DistrictType",
    district_id: 792,
    name: "حي البستان",
    uri: "حي-البستان",
  },
  'CityType:{"uri":"الغاط"}': {
    uri: "الغاط",
    __typename: "CityType",
    city_id: 30,
    name: "الغاط",
    path: "/الغاط",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الورود"}': {
    path: "/حفر-الباطن/حي-الورود",
    __typename: "DistrictType",
    district_id: 1802,
    name: "حي الورود",
    uri: "حي-الورود",
  },
  'CityType:{"uri":"حفر-الباطن"}': {
    uri: "حفر-الباطن",
    __typename: "CityType",
    city_id: 68,
    name: "حفر الباطن",
    path: "/حفر-الباطن",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-قرطبة"}': {
    path: "/حفر-الباطن/حي-قرطبة",
    __typename: "DistrictType",
    district_id: 1810,
    name: "حي قرطبة",
    uri: "حي-قرطبة",
  },
  'DistrictType:{"path":"/راس-تنورة/حي-الدانة"}': {
    path: "/راس-تنورة/حي-الدانة",
    __typename: "DistrictType",
    district_id: 1814,
    name: "حي الدانة",
    uri: "حي-الدانة",
  },
  'CityType:{"uri":"راس-تنورة"}': {
    uri: "راس-تنورة",
    __typename: "CityType",
    city_id: 74,
    name: "راس تنورة",
    path: "/راس-تنورة",
  },
  'DistrictType:{"path":"/سيهات/حي-السلام"}': {
    path: "/سيهات/حي-السلام",
    __typename: "DistrictType",
    district_id: 1838,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'CityType:{"uri":"سيهات"}': {
    uri: "سيهات",
    __typename: "CityType",
    city_id: 80,
    name: "سيهات",
    path: "/سيهات",
  },
  'DistrictType:{"path":"/سيهات/حي-الصناعية"}': {
    path: "/سيهات/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 1840,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/سيهات/حي-الغدير"}': {
    path: "/سيهات/حي-الغدير",
    __typename: "DistrictType",
    district_id: 1844,
    name: "حي الغدير",
    uri: "حي-الغدير",
  },
  'DistrictType:{"path":"/سيهات/حي-المنتزه"}': {
    path: "/سيهات/حي-المنتزه",
    __typename: "DistrictType",
    district_id: 1850,
    name: "حي المنتزه",
    uri: "حي-المنتزه",
  },
  'DistrictType:{"path":"/سيهات/حي-النابية"}': {
    path: "/سيهات/حي-النابية",
    __typename: "DistrictType",
    district_id: 1852,
    name: "حي النابية",
    uri: "حي-النابية",
  },
  'DistrictType:{"path":"/صفوى/حي-ابو-معن"}': {
    path: "/صفوى/حي-ابو-معن",
    __typename: "DistrictType",
    district_id: 1866,
    name: "حي ابو معن",
    uri: "حي-ابو-معن",
  },
  'CityType:{"uri":"صفوى"}': {
    uri: "صفوى",
    __typename: "CityType",
    city_id: 85,
    name: "صفوى",
    path: "/صفوى",
  },
  'DistrictType:{"path":"/صفوى/حي-الاوجام"}': {
    path: "/صفوى/حي-الاوجام",
    __typename: "DistrictType",
    district_id: 1868,
    name: "حي الاوجام",
    uri: "حي-الاوجام",
  },
  'DistrictType:{"path":"/صفوى/حي-الخترشية"}': {
    path: "/صفوى/حي-الخترشية",
    __typename: "DistrictType",
    district_id: 1874,
    name: "حي الخترشية",
    uri: "حي-الخترشية",
  },
  'DistrictType:{"path":"/صفوى/حي-الدريدي"}': {
    path: "/صفوى/حي-الدريدي",
    __typename: "DistrictType",
    district_id: 1876,
    name: "حي الدريدي",
    uri: "حي-الدريدي",
  },
  'DistrictType:{"path":"/صفوى/حي-الربوة"}': {
    path: "/صفوى/حي-الربوة",
    __typename: "DistrictType",
    district_id: 1878,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/صفوى/حي-العمل"}': {
    path: "/صفوى/حي-العمل",
    __typename: "DistrictType",
    district_id: 1890,
    name: "حي العمل",
    uri: "حي-العمل",
  },
  'DistrictType:{"path":"/صفوى/حي-ام-الساهك"}': {
    path: "/صفوى/حي-ام-الساهك",
    __typename: "DistrictType",
    district_id: 1898,
    name: "حي ام الساهك",
    uri: "حي-ام-الساهك",
  },
  'DistrictType:{"path":"/صفوى/حي-حزم"}': {
    path: "/صفوى/حي-حزم",
    __typename: "DistrictType",
    district_id: 1900,
    name: "حي حزم",
    uri: "حي-حزم",
  },
  'DistrictType:{"path":"/عنك/حي-العقيق"}': {
    path: "/عنك/حي-العقيق",
    __typename: "DistrictType",
    district_id: 1908,
    name: "حي العقيق",
    uri: "حي-العقيق",
  },
  'CityType:{"uri":"عنك"}': {
    uri: "عنك",
    __typename: "CityType",
    city_id: 90,
    name: "عنك",
    path: "/عنك",
  },
  'DistrictType:{"path":"/رفحاء/حي-العمال"}': {
    path: "/رفحاء/حي-العمال",
    __typename: "DistrictType",
    district_id: 1926,
    name: "حي العمال",
    uri: "حي-العمال",
  },
  'CityType:{"uri":"رفحاء"}': {
    uri: "رفحاء",
    __typename: "CityType",
    city_id: 75,
    name: "رفحاء",
    path: "/رفحاء",
  },
  'DistrictType:{"path":"/رفحاء/حي-القادسية"}': {
    path: "/رفحاء/حي-القادسية",
    __typename: "DistrictType",
    district_id: 1930,
    name: "حي القادسية",
    uri: "حي-القادسية",
  },
  'DistrictType:{"path":"/رفحاء/حي-المحمدية"}': {
    path: "/رفحاء/حي-المحمدية",
    __typename: "DistrictType",
    district_id: 1932,
    name: "حي المحمدية",
    uri: "حي-المحمدية",
  },
  'DistrictType:{"path":"/رفحاء/حي-المدينة"}': {
    path: "/رفحاء/حي-المدينة",
    __typename: "DistrictType",
    district_id: 1934,
    name: "حي المدينة",
    uri: "حي-المدينة",
  },
  'DistrictType:{"path":"/طريف/حي-الخليج"}': {
    path: "/طريف/حي-الخليج",
    __typename: "DistrictType",
    district_id: 1950,
    name: "حي الخليج",
    uri: "حي-الخليج",
  },
  'CityType:{"uri":"طريف"}': {
    uri: "طريف",
    __typename: "CityType",
    city_id: 87,
    name: "طريف",
    path: "/طريف",
  },
  'DistrictType:{"path":"/عرعر/حي-الروضة"}': {
    path: "/عرعر/حي-الروضة",
    __typename: "DistrictType",
    district_id: 1972,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'CityType:{"uri":"عرعر"}': {
    uri: "عرعر",
    __typename: "CityType",
    city_id: 88,
    name: "عرعر",
    path: "/عرعر",
  },
  'DistrictType:{"path":"/عرعر/حي-الناصرية"}': {
    path: "/عرعر/حي-الناصرية",
    __typename: "DistrictType",
    district_id: 1990,
    name: "حي الناصرية",
    uri: "حي-الناصرية",
  },
  'DistrictType:{"path":"/الشنان/حي-الصالحية"}': {
    path: "/الشنان/حي-الصالحية",
    __typename: "DistrictType",
    district_id: 2000,
    name: "حي الصالحية",
    uri: "حي-الصالحية",
  },
  'CityType:{"uri":"الشنان"}': {
    uri: "الشنان",
    __typename: "CityType",
    city_id: 25,
    name: "الشنان",
    path: "/الشنان",
  },
  'DistrictType:{"path":"/القطيف/حي-الدويج"}': {
    path: "/القطيف/حي-الدويج",
    __typename: "DistrictType",
    district_id: 1414,
    name: "حي الدويج",
    uri: "حي-الدويج",
  },
  'CityType:{"uri":"القطيف"}': {
    uri: "القطيف",
    __typename: "CityType",
    city_id: 33,
    name: "القطيف",
    path: "/القطيف",
  },
  'DistrictType:{"path":"/القطيف/حي-الروضة"}': {
    path: "/القطيف/حي-الروضة",
    __typename: "DistrictType",
    district_id: 1422,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/القطيف/حي-الزهراء"}': {
    path: "/القطيف/حي-الزهراء",
    __typename: "DistrictType",
    district_id: 1430,
    name: "حي الزهراء",
    uri: "حي-الزهراء",
  },
  'DistrictType:{"path":"/القطيف/حي-الشاطئ"}': {
    path: "/القطيف/حي-الشاطئ",
    __typename: "DistrictType",
    district_id: 1432,
    name: "حي الشاطئ",
    uri: "حي-الشاطئ",
  },
  'DistrictType:{"path":"/القطيف/حي-العليوات"}': {
    path: "/القطيف/حي-العليوات",
    __typename: "DistrictType",
    district_id: 1444,
    name: "حي العليوات",
    uri: "حي-العليوات",
  },
  'DistrictType:{"path":"/القطيف/حي-الفتح"}': {
    path: "/القطيف/حي-الفتح",
    __typename: "DistrictType",
    district_id: 1448,
    name: "حي الفتح",
    uri: "حي-الفتح",
  },
  'DistrictType:{"path":"/القطيف/حي-القديح"}': {
    path: "/القطيف/حي-القديح",
    __typename: "DistrictType",
    district_id: 1450,
    name: "حي القديح",
    uri: "حي-القديح",
  },
  'DistrictType:{"path":"/القطيف/حي-المروج"}': {
    path: "/القطيف/حي-المروج",
    __typename: "DistrictType",
    district_id: 1462,
    name: "حي المروج",
    uri: "حي-المروج",
  },
  'DistrictType:{"path":"/القطيف/حي-الوديعة"}': {
    path: "/القطيف/حي-الوديعة",
    __typename: "DistrictType",
    district_id: 1478,
    name: "حي الوديعة",
    uri: "حي-الوديعة",
  },
  'DistrictType:{"path":"/القطيف/حي-الورود"}': {
    path: "/القطيف/حي-الورود",
    __typename: "DistrictType",
    district_id: 1480,
    name: "حي الورود",
    uri: "حي-الورود",
  },
  'DistrictType:{"path":"/القطيف/حي-الياقوت"}': {
    path: "/القطيف/حي-الياقوت",
    __typename: "DistrictType",
    district_id: 1484,
    name: "حي الياقوت",
    uri: "حي-الياقوت",
  },
  'DistrictType:{"path":"/القطيف/حي-حلة-محيش"}': {
    path: "/القطيف/حي-حلة-محيش",
    __typename: "DistrictType",
    district_id: 1494,
    name: "حي حلة محيش",
    uri: "حي-حلة-محيش",
  },
  'DistrictType:{"path":"/المبرز/حي-المبرز"}': {
    path: "/المبرز/حي-المبرز",
    __typename: "DistrictType",
    district_id: 1498,
    name: "حي المبرز",
    uri: "حي-المبرز",
  },
  'CityType:{"uri":"المبرز"}': {
    uri: "المبرز",
    __typename: "CityType",
    city_id: 38,
    name: "المبرز",
    path: "/المبرز",
  },
  'DistrictType:{"path":"/النعيرية/حي-الخليج"}': {
    path: "/النعيرية/حي-الخليج",
    __typename: "DistrictType",
    district_id: 1502,
    name: "حي الخليج",
    uri: "حي-الخليج",
  },
  'CityType:{"uri":"النعيرية"}': {
    uri: "النعيرية",
    __typename: "CityType",
    city_id: 45,
    name: "النعيرية",
    path: "/النعيرية",
  },
  'DistrictType:{"path":"/الهفوف/حي-اسكان-الحرس-الوطني"}': {
    path: "/الهفوف/حي-اسكان-الحرس-الوطني",
    __typename: "DistrictType",
    district_id: 1514,
    name: "حي اسكان الحرس الوطني",
    uri: "حي-اسكان-الحرس-الوطني",
  },
  'CityType:{"uri":"الهفوف"}': {
    uri: "الهفوف",
    __typename: "CityType",
    city_id: 46,
    name: "الهفوف",
    path: "/الهفوف",
  },
  'DistrictType:{"path":"/الهفوف/حي-التهيمية"}': {
    path: "/الهفوف/حي-التهيمية",
    __typename: "DistrictType",
    district_id: 1526,
    name: "حي التهيمية",
    uri: "حي-التهيمية",
  },
  'DistrictType:{"path":"/الهفوف/حي-الجشة"}': {
    path: "/الهفوف/حي-الجشة",
    __typename: "DistrictType",
    district_id: 1536,
    name: "حي الجشة",
    uri: "حي-الجشة",
  },
  'DistrictType:{"path":"/الهفوف/حي-الخرس"}': {
    path: "/الهفوف/حي-الخرس",
    __typename: "DistrictType",
    district_id: 1542,
    name: "حي الخرس",
    uri: "حي-الخرس",
  },
  'DistrictType:{"path":"/الهفوف/حي-الدالوة"}': {
    path: "/الهفوف/حي-الدالوة",
    __typename: "DistrictType",
    district_id: 1544,
    name: "حي الدالوة",
    uri: "حي-الدالوة",
  },
  'DistrictType:{"path":"/الهفوف/حي-الرفعة-الشمالية"}': {
    path: "/الهفوف/حي-الرفعة-الشمالية",
    __typename: "DistrictType",
    district_id: 1550,
    name: "حي الرفعة الشمالية",
    uri: "حي-الرفعة-الشمالية",
  },
  'DistrictType:{"path":"/الهفوف/حي-السلمانية-الشمالية"}': {
    path: "/الهفوف/حي-السلمانية-الشمالية",
    __typename: "DistrictType",
    district_id: 1564,
    name: "حي السلمانية الشمالية",
    uri: "حي-السلمانية-الشمالية",
  },
  'DistrictType:{"path":"/الهفوف/حي-السياسب"}': {
    path: "/الهفوف/حي-السياسب",
    __typename: "DistrictType",
    district_id: 1566,
    name: "حي السياسب",
    uri: "حي-السياسب",
  },
  'DistrictType:{"path":"/الهفوف/حي-الشروق"}': {
    path: "/الهفوف/حي-الشروق",
    __typename: "DistrictType",
    district_id: 1570,
    name: "حي الشروق",
    uri: "حي-الشروق",
  },
  'DistrictType:{"path":"/الهفوف/حي-العتبان"}': {
    path: "/الهفوف/حي-العتبان",
    __typename: "DistrictType",
    district_id: 1588,
    name: "حي العتبان",
    uri: "حي-العتبان",
  },
  'DistrictType:{"path":"/الهفوف/حي-العزيزية"}': {
    path: "/الهفوف/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 1590,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/الهفوف/حي-العقار"}': {
    path: "/الهفوف/حي-العقار",
    __typename: "DistrictType",
    district_id: 1592,
    name: "حي العقار",
    uri: "حي-العقار",
  },
  'DistrictType:{"path":"/الهفوف/حي-العويمرية"}': {
    path: "/الهفوف/حي-العويمرية",
    __typename: "DistrictType",
    district_id: 1594,
    name: "حي العويمرية",
    uri: "حي-العويمرية",
  },
  'DistrictType:{"path":"/الغاط/حي-المصيف"}': {
    path: "/الغاط/حي-المصيف",
    __typename: "DistrictType",
    district_id: 806,
    name: "حي المصيف",
    uri: "حي-المصيف",
  },
  'DistrictType:{"path":"/الغاط/حي-النخيل"}': {
    path: "/الغاط/حي-النخيل",
    __typename: "DistrictType",
    district_id: 808,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/القويعية/حي-الخليج"}': {
    path: "/القويعية/حي-الخليج",
    __typename: "DistrictType",
    district_id: 828,
    name: "حي الخليج",
    uri: "حي-الخليج",
  },
  'CityType:{"uri":"القويعية"}': {
    uri: "القويعية",
    __typename: "CityType",
    city_id: 35,
    name: "القويعية",
    path: "/القويعية",
  },
  'DistrictType:{"path":"/القويعية/حي-الديرة"}': {
    path: "/القويعية/حي-الديرة",
    __typename: "DistrictType",
    district_id: 830,
    name: "حي الديرة",
    uri: "حي-الديرة",
  },
  'DistrictType:{"path":"/القويعية/حي-السلام"}': {
    path: "/القويعية/حي-السلام",
    __typename: "DistrictType",
    district_id: 836,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/القويعية/حي-الضريب"}': {
    path: "/القويعية/حي-الضريب",
    __typename: "DistrictType",
    district_id: 840,
    name: "حي الضريب",
    uri: "حي-الضريب",
  },
  'DistrictType:{"path":"/القويعية/حي-الواحة"}': {
    path: "/القويعية/حي-الواحة",
    __typename: "DistrictType",
    district_id: 844,
    name: "حي الواحة",
    uri: "حي-الواحة",
  },
  'DistrictType:{"path":"/المجمعة/حي-البصرة"}': {
    path: "/المجمعة/حي-البصرة",
    __typename: "DistrictType",
    district_id: 852,
    name: "حي البصرة",
    uri: "حي-البصرة",
  },
  'CityType:{"uri":"المجمعة"}': {
    uri: "المجمعة",
    __typename: "CityType",
    city_id: 40,
    name: "المجمعة",
    path: "/المجمعة",
  },
  'DistrictType:{"path":"/المجمعة/حي-الفحياء"}': {
    path: "/المجمعة/حي-الفحياء",
    __typename: "DistrictType",
    district_id: 860,
    name: "حي الفحياء",
    uri: "حي-الفحياء",
  },
  'DistrictType:{"path":"/المزاحمية/حي-الصقورية"}': {
    path: "/المزاحمية/حي-الصقورية",
    __typename: "DistrictType",
    district_id: 880,
    name: "حي الصقورية",
    uri: "حي-الصقورية",
  },
  'CityType:{"uri":"المزاحمية"}': {
    uri: "المزاحمية",
    __typename: "CityType",
    city_id: 43,
    name: "المزاحمية",
    path: "/المزاحمية",
  },
  'DistrictType:{"path":"/المزاحمية/حي-الغطغط"}': {
    path: "/المزاحمية/حي-الغطغط",
    __typename: "DistrictType",
    district_id: 886,
    name: "حي الغطغط",
    uri: "حي-الغطغط",
  },
  'DistrictType:{"path":"/المزاحمية/حي-هذلولة"}': {
    path: "/المزاحمية/حي-هذلولة",
    __typename: "DistrictType",
    district_id: 898,
    name: "حي هذلولة",
    uri: "حي-هذلولة",
  },
  'DistrictType:{"path":"/الهياثم/حي-الهياثم"}': {
    path: "/الهياثم/حي-الهياثم",
    __typename: "DistrictType",
    district_id: 900,
    name: "حي الهياثم",
    uri: "حي-الهياثم",
  },
  'CityType:{"uri":"الهياثم"}': {
    uri: "الهياثم",
    __typename: "CityType",
    city_id: 47,
    name: "الهياثم",
    path: "/الهياثم",
  },
  'DistrictType:{"path":"/حوطة-بني-تميم/حي-الصدر"}': {
    path: "/حوطة-بني-تميم/حي-الصدر",
    __typename: "DistrictType",
    district_id: 922,
    name: "حي الصدر",
    uri: "حي-الصدر",
  },
  'CityType:{"uri":"حوطة-بني-تميم"}': {
    uri: "حوطة-بني-تميم",
    __typename: "CityType",
    city_id: 69,
    name: "حوطة بني تميم",
    path: "/حوطة-بني-تميم",
  },
  'DistrictType:{"path":"/حوطة-بني-تميم/حي-المصيف"}': {
    path: "/حوطة-بني-تميم/حي-المصيف",
    __typename: "DistrictType",
    district_id: 930,
    name: "حي المصيف",
    uri: "حي-المصيف",
  },
  'DistrictType:{"path":"/رماح/حي-رماح"}': {
    path: "/رماح/حي-رماح",
    __typename: "DistrictType",
    district_id: 942,
    name: "حي رماح",
    uri: "حي-رماح",
  },
  'CityType:{"uri":"رماح"}': {
    uri: "رماح",
    __typename: "CityType",
    city_id: 76,
    name: "رماح",
    path: "/رماح",
  },
  'DistrictType:{"path":"/شقراء/حي-الرحبة"}': {
    path: "/شقراء/حي-الرحبة",
    __typename: "DistrictType",
    district_id: 944,
    name: "حي الرحبة",
    uri: "حي-الرحبة",
  },
  'CityType:{"uri":"شقراء"}': {
    uri: "شقراء",
    __typename: "CityType",
    city_id: 82,
    name: "شقراء",
    path: "/شقراء",
  },
  'DistrictType:{"path":"/شقراء/حي-الشفاء"}': {
    path: "/شقراء/حي-الشفاء",
    __typename: "DistrictType",
    district_id: 948,
    name: "حي الشفاء",
    uri: "حي-الشفاء",
  },
  'DistrictType:{"path":"/عفيف/حي-الملز"}': {
    path: "/عفيف/حي-الملز",
    __typename: "DistrictType",
    district_id: 980,
    name: "حي الملز",
    uri: "حي-الملز",
  },
  'CityType:{"uri":"عفيف"}': {
    uri: "عفيف",
    __typename: "CityType",
    city_id: 89,
    name: "عفيف",
    path: "/عفيف",
  },
  'DistrictType:{"path":"/عفيف/حي-الملك-خالد"}': {
    path: "/عفيف/حي-الملك-خالد",
    __typename: "DistrictType",
    district_id: 982,
    name: "حي الملك خالد",
    uri: "حي-الملك-خالد",
  },
  'DistrictType:{"path":"/الجبيل/حي-الاحساء"}': {
    path: "/الجبيل/حي-الاحساء",
    __typename: "DistrictType",
    district_id: 984,
    name: "حي الاحساء",
    uri: "حي-الاحساء",
  },
  'CityType:{"uri":"الجبيل"}': {
    uri: "الجبيل",
    __typename: "CityType",
    city_id: 8,
    name: "الجبيل",
    path: "/الجبيل",
  },
  'DistrictType:{"path":"/الجبيل/حي-الخليج"}': {
    path: "/الجبيل/حي-الخليج",
    __typename: "DistrictType",
    district_id: 994,
    name: "حي الخليج",
    uri: "حي-الخليج",
  },
  'DistrictType:{"path":"/صبيا/حي-السعادة"}': {
    path: "/صبيا/حي-السعادة",
    __typename: "DistrictType",
    district_id: 204,
    name: "حي السعادة",
    uri: "حي-السعادة",
  },
  'CityType:{"uri":"صبيا"}': {
    uri: "صبيا",
    __typename: "CityType",
    city_id: 84,
    name: "صبيا",
    path: "/صبيا",
  },
  'DistrictType:{"path":"/صبيا/حي-الصفاء"}': {
    path: "/صبيا/حي-الصفاء",
    __typename: "DistrictType",
    district_id: 206,
    name: "حي الصفاء",
    uri: "حي-الصفاء",
  },
  'DistrictType:{"path":"/صبيا/حي-الظبيه"}': {
    path: "/صبيا/حي-الظبيه",
    __typename: "DistrictType",
    district_id: 208,
    name: "حي الظبيه",
    uri: "حي-الظبيه",
  },
  'DistrictType:{"path":"/صبيا/حي-المجد"}': {
    path: "/صبيا/حي-المجد",
    __typename: "DistrictType",
    district_id: 222,
    name: "حي المجد",
    uri: "حي-المجد",
  },
  'DistrictType:{"path":"/الحريق/حي-العثمانية"}': {
    path: "/الحريق/حي-العثمانية",
    __typename: "DistrictType",
    district_id: 240,
    name: "حي العثمانية",
    uri: "حي-العثمانية",
  },
  'CityType:{"uri":"الحريق"}': {
    uri: "الحريق",
    __typename: "CityType",
    city_id: 10,
    name: "الحريق",
    path: "/الحريق",
  },
  'DistrictType:{"path":"/الخرج/حي-البركة"}': {
    path: "/الخرج/حي-البركة",
    __typename: "DistrictType",
    district_id: 254,
    name: "حي البركة",
    uri: "حي-البركة",
  },
  'CityType:{"uri":"الخرج"}': {
    uri: "الخرج",
    __typename: "CityType",
    city_id: 13,
    name: "الخرج",
    path: "/الخرج",
  },
  'DistrictType:{"path":"/الخرج/حي-الخالدية"}': {
    path: "/الخرج/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 256,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/الخرج/حي-الراشدية"}': {
    path: "/الخرج/حي-الراشدية",
    __typename: "DistrictType",
    district_id: 260,
    name: "حي الراشدية",
    uri: "حي-الراشدية",
  },
  'DistrictType:{"path":"/الخرج/حي-الريان"}': {
    path: "/الخرج/حي-الريان",
    __typename: "DistrictType",
    district_id: 264,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'DistrictType:{"path":"/الخرج/حي-السليمانية"}': {
    path: "/الخرج/حي-السليمانية",
    __typename: "DistrictType",
    district_id: 270,
    name: "حي السليمانية",
    uri: "حي-السليمانية",
  },
  'DistrictType:{"path":"/الدرعية/حي-البجيري"}': {
    path: "/الدرعية/حي-البجيري",
    __typename: "DistrictType",
    district_id: 300,
    name: "حي البجيري",
    uri: "حي-البجيري",
  },
  'CityType:{"uri":"الدرعية"}': {
    uri: "الدرعية",
    __typename: "CityType",
    city_id: 16,
    name: "الدرعية",
    path: "/الدرعية",
  },
  'DistrictType:{"path":"/الدرعية/حي-الخالدية"}': {
    path: "/الدرعية/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 302,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/الدرعية/حي-المريح"}': {
    path: "/الدرعية/حي-المريح",
    __typename: "DistrictType",
    district_id: 314,
    name: "حي المريح",
    uri: "حي-المريح",
  },
  'DistrictType:{"path":"/الدلم/حي-الخالدية"}': {
    path: "/الدلم/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 322,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'CityType:{"uri":"الدلم"}': {
    uri: "الدلم",
    __typename: "CityType",
    city_id: 17,
    name: "الدلم",
    path: "/الدلم",
  },
  'DistrictType:{"path":"/الدلم/حي-الشفاء"}': {
    path: "/الدلم/حي-الشفاء",
    __typename: "DistrictType",
    district_id: 332,
    name: "حي الشفاء",
    uri: "حي-الشفاء",
  },
  'DistrictType:{"path":"/الدلم/حي-العويمرية"}': {
    path: "/الدلم/حي-العويمرية",
    __typename: "DistrictType",
    district_id: 338,
    name: "حي العويمرية",
    uri: "حي-العويمرية",
  },
  'DistrictType:{"path":"/الدلم/حي-الناصرية"}': {
    path: "/الدلم/حي-الناصرية",
    __typename: "DistrictType",
    district_id: 340,
    name: "حي الناصرية",
    uri: "حي-الناصرية",
  },
  'DistrictType:{"path":"/الدوادمي/حي-الروضة"}': {
    path: "/الدوادمي/حي-الروضة",
    __typename: "DistrictType",
    district_id: 356,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'CityType:{"uri":"الدوادمي"}': {
    uri: "الدوادمي",
    __typename: "CityType",
    city_id: 19,
    name: "الدوادمي",
    path: "/الدوادمي",
  },
  'DistrictType:{"path":"/الدوادمي/حي-العزيزية"}': {
    path: "/الدوادمي/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 366,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/الدوادمي/حي-القدس"}': {
    path: "/الدوادمي/حي-القدس",
    __typename: "DistrictType",
    district_id: 372,
    name: "حي القدس",
    uri: "حي-القدس",
  },
  'DistrictType:{"path":"/الدوادمي/حي-الملك-فهد"}': {
    path: "/الدوادمي/حي-الملك-فهد",
    __typename: "DistrictType",
    district_id: 374,
    name: "حي الملك فهد",
    uri: "حي-الملك-فهد",
  },
  'DistrictType:{"path":"/الدوادمي/حي-مصده"}': {
    path: "/الدوادمي/حي-مصده",
    __typename: "DistrictType",
    district_id: 386,
    name: "حي مصده",
    uri: "حي-مصده",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-البرية"}': {
    path: "/الرياض/جنوب-الرياض/حي-البرية",
    __typename: "DistrictType",
    district_id: 400,
    name: "حي البرية",
    uri: "حي-البرية",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-الخشابية"}': {
    path: "/ابو-عريش/حي-الخشابية",
    __typename: "DistrictType",
    district_id: 14,
    name: "حي الخشابية",
    uri: "حي-الخشابية",
  },
  'CityType:{"uri":"ابو-عريش"}': {
    uri: "ابو-عريش",
    __typename: "CityType",
    city_id: 2,
    name: "ابو عريش",
    path: "/ابو-عريش",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-السادلية"}': {
    path: "/ابو-عريش/حي-السادلية",
    __typename: "DistrictType",
    district_id: 22,
    name: "حي السادلية",
    uri: "حي-السادلية",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-السر"}': {
    path: "/ابو-عريش/حي-السر",
    __typename: "DistrictType",
    district_id: 24,
    name: "حي السر",
    uri: "حي-السر",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-السلام"}': {
    path: "/ابو-عريش/حي-السلام",
    __typename: "DistrictType",
    district_id: 26,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-القدس"}': {
    path: "/ابو-عريش/حي-القدس",
    __typename: "DistrictType",
    district_id: 40,
    name: "حي القدس",
    uri: "حي-القدس",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-المريخية"}': {
    path: "/ابو-عريش/حي-المريخية",
    __typename: "DistrictType",
    district_id: 44,
    name: "حي المريخية",
    uri: "حي-المريخية",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-المشايخ-الجنوبية"}': {
    path: "/ابو-عريش/حي-المشايخ-الجنوبية",
    __typename: "DistrictType",
    district_id: 48,
    name: "حي المشايخ الجنوبية",
    uri: "حي-المشايخ-الجنوبية",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-المضايا"}': {
    path: "/ابو-عريش/حي-المضايا",
    __typename: "DistrictType",
    district_id: 52,
    name: "حي المضايا",
    uri: "حي-المضايا",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-النسيم"}': {
    path: "/ابو-عريش/حي-النسيم",
    __typename: "DistrictType",
    district_id: 60,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-ضمد"}': {
    path: "/ابو-عريش/حي-ضمد",
    __typename: "DistrictType",
    district_id: 84,
    name: "حي ضمد",
    uri: "حي-ضمد",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-مزهرة"}': {
    path: "/ابو-عريش/حي-مزهرة",
    __typename: "DistrictType",
    district_id: 92,
    name: "حي مزهرة",
    uri: "حي-مزهرة",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-البياطرية"}': {
    path: "/احد-المسارحة/حي-البياطرية",
    __typename: "DistrictType",
    district_id: 98,
    name: "حي البياطرية",
    uri: "حي-البياطرية",
  },
  'CityType:{"uri":"احد-المسارحة"}': {
    uri: "احد-المسارحة",
    __typename: "CityType",
    city_id: 3,
    name: "احد المسارحة",
    path: "/احد-المسارحة",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-العز"}': {
    path: "/احد-المسارحة/حي-العز",
    __typename: "DistrictType",
    district_id: 108,
    name: "حي العز",
    uri: "حي-العز",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-العمارية"}': {
    path: "/احد-المسارحة/حي-العمارية",
    __typename: "DistrictType",
    district_id: 110,
    name: "حي العمارية",
    uri: "حي-العمارية",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-المطلع"}': {
    path: "/احد-المسارحة/حي-المطلع",
    __typename: "DistrictType",
    district_id: 116,
    name: "حي المطلع",
    uri: "حي-المطلع",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-المنطقة-الصناعية"}': {
    path: "/احد-المسارحة/حي-المنطقة-الصناعية",
    __typename: "DistrictType",
    district_id: 120,
    name: "حي المنطقة الصناعية",
    uri: "حي-المنطقة-الصناعية",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-حاكمية-الدغادير"}': {
    path: "/احد-المسارحة/حي-حاكمية-الدغادير",
    __typename: "DistrictType",
    district_id: 126,
    name: "حي حاكمية الدغادير",
    uri: "حي-حاكمية-الدغادير",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-خلب"}': {
    path: "/احد-المسارحة/حي-خلب",
    __typename: "DistrictType",
    district_id: 130,
    name: "حي خلب",
    uri: "حي-خلب",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-رمادة"}': {
    path: "/احد-المسارحة/حي-رمادة",
    __typename: "DistrictType",
    district_id: 132,
    name: "حي رمادة",
    uri: "حي-رمادة",
  },
  'DistrictType:{"path":"/جازان/حي-الجبل"}': {
    path: "/جازان/حي-الجبل",
    __typename: "DistrictType",
    district_id: 144,
    name: "حي الجبل",
    uri: "حي-الجبل",
  },
  'CityType:{"uri":"جازان"}': {
    uri: "جازان",
    __typename: "CityType",
    city_id: 65,
    name: "جازان",
    path: "/جازان",
  },
  'DistrictType:{"path":"/جازان/حي-النسيم"}': {
    path: "/جازان/حي-النسيم",
    __typename: "DistrictType",
    district_id: 166,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/صامطة/حي-الجرادية"}': {
    path: "/صامطة/حي-الجرادية",
    __typename: "DistrictType",
    district_id: 172,
    name: "حي الجرادية",
    uri: "حي-الجرادية",
  },
  'CityType:{"uri":"صامطة"}': {
    uri: "صامطة",
    __typename: "CityType",
    city_id: 83,
    name: "صامطة",
    path: "/صامطة",
  },
  'DistrictType:{"path":"/صبيا/حي-الحشيبرية"}': {
    path: "/صبيا/حي-الحشيبرية",
    __typename: "DistrictType",
    district_id: 190,
    name: "حي الحشيبرية",
    uri: "حي-الحشيبرية",
  },
  'DistrictType:{"path":"/الدمام/حي-الحمراء"}': {
    path: "/الدمام/حي-الحمراء",
    __typename: "DistrictType",
    district_id: 1210,
    name: "حي الحمراء",
    uri: "حي-الحمراء",
  },
  'CityType:{"uri":"الدمام"}': {
    uri: "الدمام",
    __typename: "CityType",
    city_id: 18,
    name: "الدمام",
    path: "/الدمام",
  },
  'DistrictType:{"path":"/الدمام/حي-الخالدية-الشمالية"}': {
    path: "/الدمام/حي-الخالدية-الشمالية",
    __typename: "DistrictType",
    district_id: 1212,
    name: "حي الخالدية الشمالية",
    uri: "حي-الخالدية-الشمالية",
  },
  'DistrictType:{"path":"/الدمام/حي-الزهور"}': {
    path: "/الدمام/حي-الزهور",
    __typename: "DistrictType",
    district_id: 1230,
    name: "حي الزهور",
    uri: "حي-الزهور",
  },
  'DistrictType:{"path":"/الدمام/حي-الصدفة"}': {
    path: "/الدمام/حي-الصدفة",
    __typename: "DistrictType",
    district_id: 1246,
    name: "حي الصدفة",
    uri: "حي-الصدفة",
  },
  'DistrictType:{"path":"/الدمام/حي-الطبيشي"}': {
    path: "/الدمام/حي-الطبيشي",
    __typename: "DistrictType",
    district_id: 1254,
    name: "حي الطبيشي",
    uri: "حي-الطبيشي",
  },
  'DistrictType:{"path":"/الدمام/حي-العنود"}': {
    path: "/الدمام/حي-العنود",
    __typename: "DistrictType",
    district_id: 1262,
    name: "حي العنود",
    uri: "حي-العنود",
  },
  'DistrictType:{"path":"/الدمام/حي-القادسية"}': {
    path: "/الدمام/حي-القادسية",
    __typename: "DistrictType",
    district_id: 1274,
    name: "حي القادسية",
    uri: "حي-القادسية",
  },
  'DistrictType:{"path":"/الدمام/حي-جامعة-الدمام"}': {
    path: "/الدمام/حي-جامعة-الدمام",
    __typename: "DistrictType",
    district_id: 1314,
    name: "حي جامعة الدمام",
    uri: "حي-جامعة-الدمام",
  },
  'DistrictType:{"path":"/الدمام/حي-ضاحية-الملك-فهد"}': {
    path: "/الدمام/حي-ضاحية-الملك-فهد",
    __typename: "DistrictType",
    district_id: 1316,
    name: "حي ضاحية الملك فهد",
    uri: "حي-ضاحية-الملك-فهد",
  },
  'DistrictType:{"path":"/الدمام/حي-عبدالله-فؤاد"}': {
    path: "/الدمام/حي-عبدالله-فؤاد",
    __typename: "DistrictType",
    district_id: 1320,
    name: "حي عبدالله فؤاد",
    uri: "حي-عبدالله-فؤاد",
  },
  'DistrictType:{"path":"/الدمام/حي-مدينة-العمال"}': {
    path: "/الدمام/حي-مدينة-العمال",
    __typename: "DistrictType",
    district_id: 1326,
    name: "حي مدينة العمال",
    uri: "حي-مدينة-العمال",
  },
  'DistrictType:{"path":"/الدمام/حي-ميناء-الملك-عبدالعزيز"}': {
    path: "/الدمام/حي-ميناء-الملك-عبدالعزيز",
    __typename: "DistrictType",
    district_id: 1330,
    name: "حي ميناء الملك عبدالعزيز",
    uri: "حي-ميناء-الملك-عبدالعزيز",
  },
  'DistrictType:{"path":"/الظهران/حي-تهامة"}': {
    path: "/الظهران/حي-تهامة",
    __typename: "DistrictType",
    district_id: 1350,
    name: "حي تهامة",
    uri: "حي-تهامة",
  },
  'CityType:{"uri":"الظهران"}': {
    uri: "الظهران",
    __typename: "CityType",
    city_id: 27,
    name: "الظهران",
    path: "/الظهران",
  },
  'DistrictType:{"path":"/العيون/حي-العوضية"}': {
    path: "/العيون/حي-العوضية",
    __typename: "DistrictType",
    district_id: 1364,
    name: "حي العوضية",
    uri: "حي-العوضية",
  },
  'CityType:{"uri":"العيون"}': {
    uri: "العيون",
    __typename: "CityType",
    city_id: 29,
    name: "العيون",
    path: "/العيون",
  },
  'DistrictType:{"path":"/القطيف/حي-التوبي"}': {
    path: "/القطيف/حي-التوبي",
    __typename: "DistrictType",
    district_id: 1388,
    name: "حي التوبي",
    uri: "حي-التوبي",
  },
  'DistrictType:{"path":"/القطيف/حي-الجارودية"}': {
    path: "/القطيف/حي-الجارودية",
    __typename: "DistrictType",
    district_id: 1392,
    name: "حي الجارودية",
    uri: "حي-الجارودية",
  },
  'DistrictType:{"path":"/القطيف/حي-الجميمة"}': {
    path: "/القطيف/حي-الجميمة",
    __typename: "DistrictType",
    district_id: 1400,
    name: "حي الجميمة",
    uri: "حي-الجميمة",
  },
  'DistrictType:{"path":"/الجبيل/حي-القدس"}': {
    path: "/الجبيل/حي-القدس",
    __typename: "DistrictType",
    district_id: 1004,
    name: "حي القدس",
    uri: "حي-القدس",
  },
  'DistrictType:{"path":"/الجبيل/حي-اللؤلؤ"}': {
    path: "/الجبيل/حي-اللؤلؤ",
    __typename: "DistrictType",
    district_id: 1006,
    name: "حي اللؤلؤ",
    uri: "حي-اللؤلؤ",
  },
  'DistrictType:{"path":"/الجبيل/حي-منطقة-العريفي"}': {
    path: "/الجبيل/حي-منطقة-العريفي",
    __typename: "DistrictType",
    district_id: 1032,
    name: "حي منطقة العريفي",
    uri: "حي-منطقة-العريفي",
  },
  'DistrictType:{"path":"/الجبيل/حي-ينبع"}': {
    path: "/الجبيل/حي-ينبع",
    __typename: "DistrictType",
    district_id: 1036,
    name: "حي ينبع",
    uri: "حي-ينبع",
  },
  'DistrictType:{"path":"/الخبر/حي-الامواج"}': {
    path: "/الخبر/حي-الامواج",
    __typename: "DistrictType",
    district_id: 1044,
    name: "حي الامواج",
    uri: "حي-الامواج",
  },
  'CityType:{"uri":"الخبر"}': {
    uri: "الخبر",
    __typename: "CityType",
    city_id: 12,
    name: "الخبر",
    path: "/الخبر",
  },
  'DistrictType:{"path":"/الخبر/حي-البستان"}': {
    path: "/الخبر/حي-البستان",
    __typename: "DistrictType",
    district_id: 1052,
    name: "حي البستان",
    uri: "حي-البستان",
  },
  'DistrictType:{"path":"/الخبر/حي-البندرية"}': {
    path: "/الخبر/حي-البندرية",
    __typename: "DistrictType",
    district_id: 1054,
    name: "حي البندرية",
    uri: "حي-البندرية",
  },
  'DistrictType:{"path":"/الخبر/حي-الجوهرة"}': {
    path: "/الخبر/حي-الجوهرة",
    __typename: "DistrictType",
    district_id: 1064,
    name: "حي الجوهرة",
    uri: "حي-الجوهرة",
  },
  'DistrictType:{"path":"/الخبر/حي-الرجاء"}': {
    path: "/الخبر/حي-الرجاء",
    __typename: "DistrictType",
    district_id: 1082,
    name: "حي الرجاء",
    uri: "حي-الرجاء",
  },
  'DistrictType:{"path":"/الخبر/حي-الروابي"}': {
    path: "/الخبر/حي-الروابي",
    __typename: "DistrictType",
    district_id: 1084,
    name: "حي الروابي",
    uri: "حي-الروابي",
  },
  'DistrictType:{"path":"/الخبر/حي-الكورنيش"}': {
    path: "/الخبر/حي-الكورنيش",
    __typename: "DistrictType",
    district_id: 1102,
    name: "حي الكورنيش",
    uri: "حي-الكورنيش",
  },
  'DistrictType:{"path":"/الخبر/حي-المها"}': {
    path: "/الخبر/حي-المها",
    __typename: "DistrictType",
    district_id: 1110,
    name: "حي المها",
    uri: "حي-المها",
  },
  'DistrictType:{"path":"/الخفجي/حي-الامل"}': {
    path: "/الخفجي/حي-الامل",
    __typename: "DistrictType",
    district_id: 1124,
    name: "حي الامل",
    uri: "حي-الامل",
  },
  'CityType:{"uri":"الخفجي"}': {
    uri: "الخفجي",
    __typename: "CityType",
    city_id: 15,
    name: "الخفجي",
    path: "/الخفجي",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الجزيرة"}': {
    path: "/الرياض/شرق-الرياض/حي-الجزيرة",
    __typename: "DistrictType",
    district_id: 408,
    name: "حي الجزيرة",
    uri: "حي-الجزيرة",
  },
  'DirectionType:{"uri":"شرق-الرياض"}': {
    uri: "شرق-الرياض",
    __typename: "DirectionType",
    direction_id: 3,
    name: "شرق الرياض",
    path: "/الرياض/شرق-الرياض",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الروابي"}': {
    path: "/الرياض/شرق-الرياض/حي-الروابي",
    __typename: "DistrictType",
    district_id: 450,
    name: "حي الروابي",
    uri: "حي-الروابي",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الروضة"}': {
    path: "/الرياض/شرق-الرياض/حي-الروضة",
    __typename: "DistrictType",
    district_id: 452,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-الزهرة"}': {
    path: "/الرياض/غرب-الرياض/حي-الزهرة",
    __typename: "DistrictType",
    district_id: 458,
    name: "حي الزهرة",
    uri: "حي-الزهرة",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-السعادة"}': {
    path: "/الرياض/شرق-الرياض/حي-السعادة",
    __typename: "DistrictType",
    district_id: 460,
    name: "حي السعادة",
    uri: "حي-السعادة",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-السليمانية"}': {
    path: "/الرياض/شمال-الرياض/حي-السليمانية",
    __typename: "DistrictType",
    district_id: 468,
    name: "حي السليمانية",
    uri: "حي-السليمانية",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-السويدي"}': {
    path: "/الرياض/غرب-الرياض/حي-السويدي",
    __typename: "DistrictType",
    district_id: 470,
    name: "حي السويدي",
    uri: "حي-السويدي",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-الشفا"}': {
    path: "/الرياض/جنوب-الرياض/حي-الشفا",
    __typename: "DistrictType",
    district_id: 478,
    name: "حي الشفا",
    uri: "حي-الشفا",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-الصحافة"}': {
    path: "/الرياض/شمال-الرياض/حي-الصحافة",
    __typename: "DistrictType",
    district_id: 486,
    name: "حي الصحافة",
    uri: "حي-الصحافة",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-العود"}': {
    path: "/الرياض/وسط-الرياض/حي-العود",
    __typename: "DistrictType",
    district_id: 512,
    name: "حي العود",
    uri: "حي-العود",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-الفاروق"}': {
    path: "/الرياض/وسط-الرياض/حي-الفاروق",
    __typename: "DistrictType",
    district_id: 520,
    name: "حي الفاروق",
    uri: "حي-الفاروق",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الفيحاء"}': {
    path: "/الرياض/شرق-الرياض/حي-الفيحاء",
    __typename: "DistrictType",
    district_id: 526,
    name: "حي الفيحاء",
    uri: "حي-الفيحاء",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الملك-عبدالعزيز"}': {
    path: "/الرياض/شرق-الرياض/حي-الملك-عبدالعزيز",
    __typename: "DistrictType",
    district_id: 572,
    name: "حي الملك عبدالعزيز",
    uri: "حي-الملك-عبدالعزيز",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-المنار"}': {
    path: "/الرياض/شرق-الرياض/حي-المنار",
    __typename: "DistrictType",
    district_id: 582,
    name: "حي المنار",
    uri: "حي-المنار",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-المهدية"}': {
    path: "/الرياض/غرب-الرياض/حي-المهدية",
    __typename: "DistrictType",
    district_id: 588,
    name: "حي المهدية",
    uri: "حي-المهدية",
  },
  'DistrictType:{"path":"/الخفجي/حي-الامير-نايف"}': {
    path: "/الخفجي/حي-الامير-نايف",
    __typename: "DistrictType",
    district_id: 1128,
    name: "حي الامير نايف",
    uri: "حي-الامير-نايف",
  },
  'DistrictType:{"path":"/الخفجي/حي-الخالدية"}': {
    path: "/الخفجي/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 1136,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/الخفجي/حي-الزهور"}': {
    path: "/الخفجي/حي-الزهور",
    __typename: "DistrictType",
    district_id: 1146,
    name: "حي الزهور",
    uri: "حي-الزهور",
  },
  'DistrictType:{"path":"/الخفجي/حي-الفيصلية"}': {
    path: "/الخفجي/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 1156,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/الخفجي/حي-المحمدية"}': {
    path: "/الخفجي/حي-المحمدية",
    __typename: "DistrictType",
    district_id: 1160,
    name: "حي المحمدية",
    uri: "حي-المحمدية",
  },
  'DistrictType:{"path":"/الخفجي/حي-الملك-فهد"}': {
    path: "/الخفجي/حي-الملك-فهد",
    __typename: "DistrictType",
    district_id: 1164,
    name: "حي الملك فهد",
    uri: "حي-الملك-فهد",
  },
  'DistrictType:{"path":"/الخفجي/حي-النهضة"}': {
    path: "/الخفجي/حي-النهضة",
    __typename: "DistrictType",
    district_id: 1172,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/الخفجي/حي-الياسمين"}': {
    path: "/الخفجي/حي-الياسمين",
    __typename: "DistrictType",
    district_id: 1174,
    name: "حي الياسمين",
    uri: "حي-الياسمين",
  },
  'DistrictType:{"path":"/عنيزة/حي-الوهلان"}': {
    path: "/عنيزة/حي-الوهلان",
    __typename: "DistrictType",
    district_id: 2614,
    name: "حي الوهلان",
    uri: "حي-الوهلان",
  },
  'CityType:{"uri":"عنيزة"}': {
    uri: "عنيزة",
    __typename: "CityType",
    city_id: 91,
    name: "عنيزة",
    path: "/عنيزة",
  },
  'DistrictType:{"path":"/عنيزة/حي-بدر"}': {
    path: "/عنيزة/حي-بدر",
    __typename: "DistrictType",
    district_id: 2620,
    name: "حي بدر",
    uri: "حي-بدر",
  },
  'DistrictType:{"path":"/عنيزة/حي-مليحة"}': {
    path: "/عنيزة/حي-مليحة",
    __typename: "DistrictType",
    district_id: 2640,
    name: "حي مليحة",
    uri: "حي-مليحة",
  },
  'DistrictType:{"path":"/القريات/حي-الفيصلية"}': {
    path: "/القريات/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 2644,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'CityType:{"uri":"القريات"}': {
    uri: "القريات",
    __typename: "CityType",
    city_id: 32,
    name: "القريات",
    path: "/القريات",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الحصيباء"}': {
    path: "/دومة-الجندل/حي-الحصيباء",
    __typename: "DistrictType",
    district_id: 2656,
    name: "حي الحصيباء",
    uri: "حي-الحصيباء",
  },
  'CityType:{"uri":"دومة-الجندل"}': {
    uri: "دومة-الجندل",
    __typename: "CityType",
    city_id: 72,
    name: "دومة الجندل",
    path: "/دومة-الجندل",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الحميدية"}': {
    path: "/دومة-الجندل/حي-الحميدية",
    __typename: "DistrictType",
    district_id: 2658,
    name: "حي الحميدية",
    uri: "حي-الحميدية",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الرفاع"}': {
    path: "/دومة-الجندل/حي-الرفاع",
    __typename: "DistrictType",
    district_id: 2664,
    name: "حي الرفاع",
    uri: "حي-الرفاع",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الصفاه-الجنوبي"}': {
    path: "/دومة-الجندل/حي-الصفاه-الجنوبي",
    __typename: "DistrictType",
    district_id: 2674,
    name: "حي الصفاه الجنوبي",
    uri: "حي-الصفاه-الجنوبي",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الصناعية"}': {
    path: "/دومة-الجندل/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 2678,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-العزيزية"}': {
    path: "/دومة-الجندل/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 2680,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-العليا"}': {
    path: "/دومة-الجندل/حي-العليا",
    __typename: "DistrictType",
    district_id: 2682,
    name: "حي العليا",
    uri: "حي-العليا",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الفاروق"}': {
    path: "/دومة-الجندل/حي-الفاروق",
    __typename: "DistrictType",
    district_id: 2688,
    name: "حي الفاروق",
    uri: "حي-الفاروق",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-المروج"}': {
    path: "/دومة-الجندل/حي-المروج",
    __typename: "DistrictType",
    district_id: 2692,
    name: "حي المروج",
    uri: "حي-المروج",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الملك-فهد-الشمالي"}': {
    path: "/دومة-الجندل/حي-الملك-فهد-الشمالي",
    __typename: "DistrictType",
    district_id: 2700,
    name: "حي الملك فهد الشمالي",
    uri: "حي-الملك-فهد-الشمالي",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الوادي"}': {
    path: "/دومة-الجندل/حي-الوادي",
    __typename: "DistrictType",
    district_id: 2704,
    name: "حي الوادي",
    uri: "حي-الوادي",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-خذماء"}': {
    path: "/دومة-الجندل/حي-خذماء",
    __typename: "DistrictType",
    district_id: 2708,
    name: "حي خذماء",
    uri: "حي-خذماء",
  },
  'DistrictType:{"path":"/سكاكا/حي-الروابي"}': {
    path: "/سكاكا/حي-الروابي",
    __typename: "DistrictType",
    district_id: 2714,
    name: "حي الروابي",
    uri: "حي-الروابي",
  },
  'CityType:{"uri":"سكاكا"}': {
    uri: "سكاكا",
    __typename: "CityType",
    city_id: 79,
    name: "سكاكا",
    path: "/سكاكا",
  },
  'DistrictType:{"path":"/سكاكا/حي-السوق"}': {
    path: "/سكاكا/حي-السوق",
    __typename: "DistrictType",
    district_id: 2722,
    name: "حي السوق",
    uri: "حي-السوق",
  },
  'DistrictType:{"path":"/سكاكا/حي-الشعيب"}': {
    path: "/سكاكا/حي-الشعيب",
    __typename: "DistrictType",
    district_id: 2724,
    name: "حي الشعيب",
    uri: "حي-الشعيب",
  },
  'DistrictType:{"path":"/سكاكا/حي-العفاش"}': {
    path: "/سكاكا/حي-العفاش",
    __typename: "DistrictType",
    district_id: 2734,
    name: "حي العفاش",
    uri: "حي-العفاش",
  },
  'DistrictType:{"path":"/سكاكا/حي-المحمدية-ن"}': {
    path: "/سكاكا/حي-المحمدية-ن",
    __typename: "DistrictType",
    district_id: 2750,
    name: "حي المحمدية ن",
    uri: "حي-المحمدية-ن",
  },
  'DistrictType:{"path":"/سكاكا/حي-المطر"}': {
    path: "/سكاكا/حي-المطر",
    __typename: "DistrictType",
    district_id: 2758,
    name: "حي المطر",
    uri: "حي-المطر",
  },
  'DistrictType:{"path":"/بريدة/حي-وهطان"}': {
    path: "/بريدة/حي-وهطان",
    __typename: "DistrictType",
    district_id: 2414,
    name: "حي وهطان",
    uri: "حي-وهطان",
  },
  'CityType:{"uri":"بريدة"}': {
    uri: "بريدة",
    __typename: "CityType",
    city_id: 52,
    name: "بريدة",
    path: "/بريدة",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-الاندلس"}': {
    path: "/رياض-الخبراء/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 2418,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'CityType:{"uri":"رياض-الخبراء"}': {
    uri: "رياض-الخبراء",
    __typename: "CityType",
    city_id: 78,
    name: "رياض الخبراء",
    path: "/رياض-الخبراء",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-الحزم"}': {
    path: "/رياض-الخبراء/حي-الحزم",
    __typename: "DistrictType",
    district_id: 2422,
    name: "حي الحزم",
    uri: "حي-الحزم",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-الروضة"}': {
    path: "/رياض-الخبراء/حي-الروضة",
    __typename: "DistrictType",
    district_id: 2434,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-القدس"}': {
    path: "/رياض-الخبراء/حي-القدس",
    __typename: "DistrictType",
    district_id: 2448,
    name: "حي القدس",
    uri: "حي-القدس",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-النهضة"}': {
    path: "/رياض-الخبراء/حي-النهضة",
    __typename: "DistrictType",
    district_id: 2454,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-الياسمين"}': {
    path: "/رياض-الخبراء/حي-الياسمين",
    __typename: "DistrictType",
    district_id: 2456,
    name: "حي الياسمين",
    uri: "حي-الياسمين",
  },
  'DistrictType:{"path":"/عنيزة/حي-اشبيلية"}': {
    path: "/عنيزة/حي-اشبيلية",
    __typename: "DistrictType",
    district_id: 2460,
    name: "حي اشبيلية",
    uri: "حي-اشبيلية",
  },
  'DistrictType:{"path":"/عنيزة/حي-البستان"}': {
    path: "/عنيزة/حي-البستان",
    __typename: "DistrictType",
    district_id: 2468,
    name: "حي البستان",
    uri: "حي-البستان",
  },
  'DistrictType:{"path":"/عنيزة/حي-التحلية"}': {
    path: "/عنيزة/حي-التحلية",
    __typename: "DistrictType",
    district_id: 2472,
    name: "حي التحلية",
    uri: "حي-التحلية",
  },
  'DistrictType:{"path":"/عنيزة/حي-الجامعي"}': {
    path: "/عنيزة/حي-الجامعي",
    __typename: "DistrictType",
    district_id: 2476,
    name: "حي الجامعي",
    uri: "حي-الجامعي",
  },
  'DistrictType:{"path":"/عنيزة/حي-الجوهرة"}': {
    path: "/عنيزة/حي-الجوهرة",
    __typename: "DistrictType",
    district_id: 2482,
    name: "حي الجوهرة",
    uri: "حي-الجوهرة",
  },
  'DistrictType:{"path":"/عنيزة/حي-الحفيرة"}': {
    path: "/عنيزة/حي-الحفيرة",
    __typename: "DistrictType",
    district_id: 2490,
    name: "حي الحفيرة",
    uri: "حي-الحفيرة",
  },
  'DistrictType:{"path":"/عنيزة/حي-الخزامى"}': {
    path: "/عنيزة/حي-الخزامى",
    __typename: "DistrictType",
    district_id: 2496,
    name: "حي الخزامى",
    uri: "حي-الخزامى",
  },
  'DistrictType:{"path":"/عنيزة/حي-الروابي"}': {
    path: "/عنيزة/حي-الروابي",
    __typename: "DistrictType",
    district_id: 2508,
    name: "حي الروابي",
    uri: "حي-الروابي",
  },
  'DistrictType:{"path":"/عنيزة/حي-الريان"}': {
    path: "/عنيزة/حي-الريان",
    __typename: "DistrictType",
    district_id: 2516,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'DistrictType:{"path":"/عنيزة/حي-الزهراء"}': {
    path: "/عنيزة/حي-الزهراء",
    __typename: "DistrictType",
    district_id: 2522,
    name: "حي الزهراء",
    uri: "حي-الزهراء",
  },
  'DistrictType:{"path":"/عنيزة/حي-العقيق"}': {
    path: "/عنيزة/حي-العقيق",
    __typename: "DistrictType",
    district_id: 2542,
    name: "حي العقيق",
    uri: "حي-العقيق",
  },
  'DistrictType:{"path":"/عنيزة/حي-العليا"}': {
    path: "/عنيزة/حي-العليا",
    __typename: "DistrictType",
    district_id: 2544,
    name: "حي العليا",
    uri: "حي-العليا",
  },
  'DistrictType:{"path":"/عنيزة/حي-الفيحاء"}': {
    path: "/عنيزة/حي-الفيحاء",
    __typename: "DistrictType",
    district_id: 2554,
    name: "حي الفيحاء",
    uri: "حي-الفيحاء",
  },
  'DistrictType:{"path":"/عنيزة/حي-المطار"}': {
    path: "/عنيزة/حي-المطار",
    __typename: "DistrictType",
    district_id: 2578,
    name: "حي المطار",
    uri: "حي-المطار",
  },
  'DistrictType:{"path":"/عنيزة/حي-المنطقة-الصناعية-الاولى"}': {
    path: "/عنيزة/حي-المنطقة-الصناعية-الاولى",
    __typename: "DistrictType",
    district_id: 2588,
    name: "حي المنطقة الصناعية الاولى",
    uri: "حي-المنطقة-الصناعية-الاولى",
  },
  'DistrictType:{"path":"/العلا/حي-الصخيرات"}': {
    path: "/العلا/حي-الصخيرات",
    __typename: "DistrictType",
    district_id: 2210,
    name: "حي الصخيرات",
    uri: "حي-الصخيرات",
  },
  'CityType:{"uri":"العلا"}': {
    uri: "العلا",
    __typename: "CityType",
    city_id: 28,
    name: "العلا",
    path: "/العلا",
  },
  'DistrictType:{"path":"/العلا/حي-صدر-الغربية"}': {
    path: "/العلا/حي-صدر-الغربية",
    __typename: "DistrictType",
    district_id: 2218,
    name: "حي صدر الغربية",
    uri: "حي-صدر-الغربية",
  },
  'DistrictType:{"path":"/المذنب/حي-الصفراء"}': {
    path: "/المذنب/حي-الصفراء",
    __typename: "DistrictType",
    district_id: 2236,
    name: "حي الصفراء",
    uri: "حي-الصفراء",
  },
  'CityType:{"uri":"المذنب"}': {
    uri: "المذنب",
    __typename: "CityType",
    city_id: 42,
    name: "المذنب",
    path: "/المذنب",
  },
  'DistrictType:{"path":"/المذنب/حي-النخيل"}': {
    path: "/المذنب/حي-النخيل",
    __typename: "DistrictType",
    district_id: 2246,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/المذنب/حي-ام-عشيرة"}': {
    path: "/المذنب/حي-ام-عشيرة",
    __typename: "DistrictType",
    district_id: 2250,
    name: "حي ام عشيرة",
    uri: "حي-ام-عشيرة",
  },
  'DistrictType:{"path":"/المذنب/حي-نبعه"}': {
    path: "/المذنب/حي-نبعه",
    __typename: "DistrictType",
    district_id: 2254,
    name: "حي نبعه",
    uri: "حي-نبعه",
  },
  'DistrictType:{"path":"/بريدة/حي-الامن"}': {
    path: "/بريدة/حي-الامن",
    __typename: "DistrictType",
    district_id: 2264,
    name: "حي الامن",
    uri: "حي-الامن",
  },
  'DistrictType:{"path":"/بريدة/حي-البصر"}': {
    path: "/بريدة/حي-البصر",
    __typename: "DistrictType",
    district_id: 2270,
    name: "حي البصر",
    uri: "حي-البصر",
  },
  'DistrictType:{"path":"/بريدة/حي-التوفيق"}': {
    path: "/بريدة/حي-التوفيق",
    __typename: "DistrictType",
    district_id: 2276,
    name: "حي التوفيق",
    uri: "حي-التوفيق",
  },
  'DistrictType:{"path":"/بريدة/حي-الجامعيين"}': {
    path: "/بريدة/حي-الجامعيين",
    __typename: "DistrictType",
    district_id: 2278,
    name: "حي الجامعيين",
    uri: "حي-الجامعيين",
  },
  'DistrictType:{"path":"/بريدة/حي-الحمر"}': {
    path: "/بريدة/حي-الحمر",
    __typename: "DistrictType",
    district_id: 2286,
    name: "حي الحمر",
    uri: "حي-الحمر",
  },
  'DistrictType:{"path":"/بريدة/حي-الخالدية"}': {
    path: "/بريدة/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 2290,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/بريدة/حي-الخبيبية"}': {
    path: "/بريدة/حي-الخبيبية",
    __typename: "DistrictType",
    district_id: 2292,
    name: "حي الخبيبية",
    uri: "حي-الخبيبية",
  },
  'DistrictType:{"path":"/بريدة/حي-السادة"}': {
    path: "/بريدة/حي-السادة",
    __typename: "DistrictType",
    district_id: 2308,
    name: "حي السادة",
    uri: "حي-السادة",
  },
  'DistrictType:{"path":"/الهفوف/حي-الكوت-النعاثل"}': {
    path: "/الهفوف/حي-الكوت-النعاثل",
    __typename: "DistrictType",
    district_id: 1606,
    name: "حي الكوت النعاثل",
    uri: "حي-الكوت-النعاثل",
  },
  'DistrictType:{"path":"/الهفوف/حي-المركز"}': {
    path: "/الهفوف/حي-المركز",
    __typename: "DistrictType",
    district_id: 1612,
    name: "حي المركز",
    uri: "حي-المركز",
  },
  'DistrictType:{"path":"/الهفوف/حي-المزاوي"}': {
    path: "/الهفوف/حي-المزاوي",
    __typename: "DistrictType",
    district_id: 1614,
    name: "حي المزاوي",
    uri: "حي-المزاوي",
  },
  'DistrictType:{"path":"/الهفوف/حي-المطيرفي"}': {
    path: "/الهفوف/حي-المطيرفي",
    __typename: "DistrictType",
    district_id: 1620,
    name: "حي المطيرفي",
    uri: "حي-المطيرفي",
  },
  'DistrictType:{"path":"/الهفوف/حي-بو-سحبل"}': {
    path: "/الهفوف/حي-بو-سحبل",
    __typename: "DistrictType",
    district_id: 1648,
    name: "حي بو سحبل",
    uri: "حي-بو-سحبل",
  },
  'DistrictType:{"path":"/الهفوف/حي-محاسن-البلدية"}': {
    path: "/الهفوف/حي-محاسن-البلدية",
    __typename: "DistrictType",
    district_id: 1664,
    name: "حي محاسن البلدية",
    uri: "حي-محاسن-البلدية",
  },
  'DistrictType:{"path":"/بقيق/حي-ارامكو"}': {
    path: "/بقيق/حي-ارامكو",
    __typename: "DistrictType",
    district_id: 1678,
    name: "حي ارامكو",
    uri: "حي-ارامكو",
  },
  'CityType:{"uri":"بقيق"}': {
    uri: "بقيق",
    __typename: "CityType",
    city_id: 54,
    name: "بقيق",
    path: "/بقيق",
  },
  'DistrictType:{"path":"/بقيق/حي-الفردوس"}': {
    path: "/بقيق/حي-الفردوس",
    __typename: "DistrictType",
    district_id: 1692,
    name: "حي الفردوس",
    uri: "حي-الفردوس",
  },
  'DistrictType:{"path":"/بقيق/حي-المطار"}': {
    path: "/بقيق/حي-المطار",
    __typename: "DistrictType",
    district_id: 1696,
    name: "حي المطار",
    uri: "حي-المطار",
  },
  'DistrictType:{"path":"/تاروت/حي-الصواري"}': {
    path: "/تاروت/حي-الصواري",
    __typename: "DistrictType",
    district_id: 1724,
    name: "حي الصواري",
    uri: "حي-الصواري",
  },
  'CityType:{"uri":"تاروت"}': {
    uri: "تاروت",
    __typename: "CityType",
    city_id: 58,
    name: "تاروت",
    path: "/تاروت",
  },
  'DistrictType:{"path":"/تاروت/حي-المناخ"}': {
    path: "/تاروت/حي-المناخ",
    __typename: "DistrictType",
    district_id: 1728,
    name: "حي المناخ",
    uri: "حي-المناخ",
  },
  'DistrictType:{"path":"/تاروت/حي-اليمامة"}': {
    path: "/تاروت/حي-اليمامة",
    __typename: "DistrictType",
    district_id: 1734,
    name: "حي اليمامة",
    uri: "حي-اليمامة",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-ابو-موسى-الاشعري"}': {
    path: "/حفر-الباطن/حي-ابو-موسى-الاشعري",
    __typename: "DistrictType",
    district_id: 1740,
    name: "حي ابو موسى الاشعري",
    uri: "حي-ابو-موسى-الاشعري",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الخليج"}': {
    path: "/حفر-الباطن/حي-الخليج",
    __typename: "DistrictType",
    district_id: 1754,
    name: "حي الخليج",
    uri: "حي-الخليج",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الرابية"}': {
    path: "/حفر-الباطن/حي-الرابية",
    __typename: "DistrictType",
    district_id: 1756,
    name: "حي الرابية",
    uri: "حي-الرابية",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الربوة"}': {
    path: "/حفر-الباطن/حي-الربوة",
    __typename: "DistrictType",
    district_id: 1760,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الربيع"}': {
    path: "/حفر-الباطن/حي-الربيع",
    __typename: "DistrictType",
    district_id: 1762,
    name: "حي الربيع",
    uri: "حي-الربيع",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-المروج"}': {
    path: "/حفر-الباطن/حي-المروج",
    __typename: "DistrictType",
    district_id: 1784,
    name: "حي المروج",
    uri: "حي-المروج",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-النهضة"}': {
    path: "/حفر-الباطن/حي-النهضة",
    __typename: "DistrictType",
    district_id: 1796,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-المبعوث"}': {
    path: "/المدينة-المنورة/حي-المبعوث",
    __typename: "DistrictType",
    district_id: 3014,
    name: "حي المبعوث",
    uri: "حي-المبعوث",
  },
  'CityType:{"uri":"المدينة-المنورة"}': {
    uri: "المدينة-المنورة",
    __typename: "CityType",
    city_id: 41,
    name: "المدينة المنورة",
    path: "/المدينة-المنورة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الهدراء"}': {
    path: "/المدينة-المنورة/حي-الهدراء",
    __typename: "DistrictType",
    district_id: 3030,
    name: "حي الهدراء",
    uri: "حي-الهدراء",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-بني-حارثة"}': {
    path: "/المدينة-المنورة/حي-بني-حارثة",
    __typename: "DistrictType",
    district_id: 3038,
    name: "حي بني حارثة",
    uri: "حي-بني-حارثة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-بني-معاوية"}': {
    path: "/المدينة-المنورة/حي-بني-معاوية",
    __typename: "DistrictType",
    district_id: 3044,
    name: "حي بني معاوية",
    uri: "حي-بني-معاوية",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-جبل-جمة-وغرابة"}': {
    path: "/المدينة-المنورة/حي-جبل-جمة-وغرابة",
    __typename: "DistrictType",
    district_id: 3050,
    name: "حي جبل جمة وغرابة",
    uri: "حي-جبل-جمة-وغرابة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-ذو-الحليفة"}': {
    path: "/المدينة-المنورة/حي-ذو-الحليفة",
    __typename: "DistrictType",
    district_id: 3058,
    name: "حي ذو الحليفة",
    uri: "حي-ذو-الحليفة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-سيد-الشهداء"}': {
    path: "/المدينة-المنورة/حي-سيد-الشهداء",
    __typename: "DistrictType",
    district_id: 3062,
    name: "حي سيد الشهداء",
    uri: "حي-سيد-الشهداء",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-شظاة"}': {
    path: "/المدينة-المنورة/حي-شظاة",
    __typename: "DistrictType",
    district_id: 3064,
    name: "حي شظاة",
    uri: "حي-شظاة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-كتانة"}': {
    path: "/المدينة-المنورة/حي-كتانة",
    __typename: "DistrictType",
    district_id: 3078,
    name: "حي كتانة",
    uri: "حي-كتانة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-نبلاء"}': {
    path: "/المدينة-المنورة/حي-نبلاء",
    __typename: "DistrictType",
    district_id: 3086,
    name: "حي نبلاء",
    uri: "حي-نبلاء",
  },
  'DistrictType:{"path":"/ينبع/حي-الجابرية-2"}': {
    path: "/ينبع/حي-الجابرية-2",
    __typename: "DistrictType",
    district_id: 3140,
    name: "حي الجابرية 2",
    uri: "حي-الجابرية-2",
  },
  'CityType:{"uri":"ينبع"}': {
    uri: "ينبع",
    __typename: "CityType",
    city_id: 97,
    name: "ينبع",
    path: "/ينبع",
  },
  'DistrictType:{"path":"/ينبع/حي-الحوراء"}': {
    path: "/ينبع/حي-الحوراء",
    __typename: "DistrictType",
    district_id: 3152,
    name: "حي الحوراء",
    uri: "حي-الحوراء",
  },
  'DistrictType:{"path":"/ينبع/حي-الخريق"}': {
    path: "/ينبع/حي-الخريق",
    __typename: "DistrictType",
    district_id: 3156,
    name: "حي الخريق",
    uri: "حي-الخريق",
  },
  'DistrictType:{"path":"/ينبع/حي-الزهور"}': {
    path: "/ينبع/حي-الزهور",
    __typename: "DistrictType",
    district_id: 3168,
    name: "حي الزهور",
    uri: "حي-الزهور",
  },
  'DistrictType:{"path":"/ينبع/حي-السلام"}': {
    path: "/ينبع/حي-السلام",
    __typename: "DistrictType",
    district_id: 3170,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/ينبع/حي-السميري"}': {
    path: "/ينبع/حي-السميري",
    __typename: "DistrictType",
    district_id: 3172,
    name: "حي السميري",
    uri: "حي-السميري",
  },
  'DistrictType:{"path":"/ينبع/حي-السميري-2"}': {
    path: "/ينبع/حي-السميري-2",
    __typename: "DistrictType",
    district_id: 3174,
    name: "حي السميري 2",
    uri: "حي-السميري-2",
  },
  'DistrictType:{"path":"/الشنان/حي-العليا"}': {
    path: "/الشنان/حي-العليا",
    __typename: "DistrictType",
    district_id: 2006,
    name: "حي العليا",
    uri: "حي-العليا",
  },
  'DistrictType:{"path":"/حائل/حي-البدنة"}': {
    path: "/حائل/حي-البدنة",
    __typename: "DistrictType",
    district_id: 2022,
    name: "حي البدنة",
    uri: "حي-البدنة",
  },
  'CityType:{"uri":"حائل"}': {
    uri: "حائل",
    __typename: "CityType",
    city_id: 67,
    name: "حائل",
    path: "/حائل",
  },
  'DistrictType:{"path":"/حائل/حي-الخريمي"}': {
    path: "/حائل/حي-الخريمي",
    __typename: "DistrictType",
    district_id: 2024,
    name: "حي الخريمي",
    uri: "حي-الخريمي",
  },
  'DistrictType:{"path":"/حائل/حي-الخماشية"}': {
    path: "/حائل/حي-الخماشية",
    __typename: "DistrictType",
    district_id: 2028,
    name: "حي الخماشية",
    uri: "حي-الخماشية",
  },
  'DistrictType:{"path":"/حائل/حي-المنتزه-الغربي"}': {
    path: "/حائل/حي-المنتزه-الغربي",
    __typename: "DistrictType",
    district_id: 2050,
    name: "حي المنتزه الغربي",
    uri: "حي-المنتزه-الغربي",
  },
  'DistrictType:{"path":"/البدائع/حي-العزيزية"}': {
    path: "/البدائع/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 2088,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'CityType:{"uri":"البدائع"}': {
    uri: "البدائع",
    __typename: "CityType",
    city_id: 6,
    name: "البدائع",
    path: "/البدائع",
  },
  'DistrictType:{"path":"/البدائع/حي-قرطبة"}': {
    path: "/البدائع/حي-قرطبة",
    __typename: "DistrictType",
    district_id: 2102,
    name: "حي قرطبة",
    uri: "حي-قرطبة",
  },
  'DistrictType:{"path":"/البكيرية/حي-العزيزية"}': {
    path: "/البكيرية/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 2116,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'CityType:{"uri":"البكيرية"}': {
    uri: "البكيرية",
    __typename: "CityType",
    city_id: 7,
    name: "البكيرية",
    path: "/البكيرية",
  },
  'DistrictType:{"path":"/الرس/حي-الجندل"}': {
    path: "/الرس/حي-الجندل",
    __typename: "DistrictType",
    district_id: 2134,
    name: "حي الجندل",
    uri: "حي-الجندل",
  },
  'CityType:{"uri":"الرس"}': {
    uri: "الرس",
    __typename: "CityType",
    city_id: 20,
    name: "الرس",
    path: "/الرس",
  },
  'DistrictType:{"path":"/الرس/حي-الحزم"}': {
    path: "/الرس/حي-الحزم",
    __typename: "DistrictType",
    district_id: 2136,
    name: "حي الحزم",
    uri: "حي-الحزم",
  },
  'DistrictType:{"path":"/الرس/حي-قصر-بن-عقيل"}': {
    path: "/الرس/حي-قصر-بن-عقيل",
    __typename: "DistrictType",
    district_id: 2168,
    name: "حي قصر بن عقيل",
    uri: "حي-قصر-بن-عقيل",
  },
  'DistrictType:{"path":"/الشماسية/حي-الشفاء"}': {
    path: "/الشماسية/حي-الشفاء",
    __typename: "DistrictType",
    district_id: 2180,
    name: "حي الشفاء",
    uri: "حي-الشفاء",
  },
  'CityType:{"uri":"الشماسية"}': {
    uri: "الشماسية",
    __typename: "CityType",
    city_id: 24,
    name: "الشماسية",
    path: "/الشماسية",
  },
  'DistrictType:{"path":"/الشماسية/حي-الواسط"}': {
    path: "/الشماسية/حي-الواسط",
    __typename: "DistrictType",
    district_id: 2200,
    name: "حي الواسط",
    uri: "حي-الواسط",
  },
  'DistrictType:{"path":"/املج/حي-الصيادية"}': {
    path: "/املج/حي-الصيادية",
    __typename: "DistrictType",
    district_id: 2828,
    name: "حي الصيادية",
    uri: "حي-الصيادية",
  },
  'CityType:{"uri":"املج"}': {
    uri: "املج",
    __typename: "CityType",
    city_id: 50,
    name: "املج",
    path: "/املج",
  },
  'DistrictType:{"path":"/املج/حي-الضويحي"}': {
    path: "/املج/حي-الضويحي",
    __typename: "DistrictType",
    district_id: 2830,
    name: "حي الضويحي",
    uri: "حي-الضويحي",
  },
  'DistrictType:{"path":"/تبوك/حي-ابو-سبعة"}': {
    path: "/تبوك/حي-ابو-سبعة",
    __typename: "DistrictType",
    district_id: 2838,
    name: "حي ابو سبعة",
    uri: "حي-ابو-سبعة",
  },
  'CityType:{"uri":"تبوك"}': {
    uri: "تبوك",
    __typename: "CityType",
    city_id: 59,
    name: "تبوك",
    path: "/تبوك",
  },
  'DistrictType:{"path":"/تبوك/حي-الروضة"}': {
    path: "/تبوك/حي-الروضة",
    __typename: "DistrictType",
    district_id: 2844,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/تبوك/حي-السلمان"}': {
    path: "/تبوك/حي-السلمان",
    __typename: "DistrictType",
    district_id: 2850,
    name: "حي السلمان",
    uri: "حي-السلمان",
  },
  'DistrictType:{"path":"/تبوك/حي-العزيزية-الجديدة"}': {
    path: "/تبوك/حي-العزيزية-الجديدة",
    __typename: "DistrictType",
    district_id: 2860,
    name: "حي العزيزية الجديدة",
    uri: "حي-العزيزية-الجديدة",
  },
  'DistrictType:{"path":"/تبوك/حي-المروج"}': {
    path: "/تبوك/حي-المروج",
    __typename: "DistrictType",
    district_id: 2872,
    name: "حي المروج",
    uri: "حي-المروج",
  },
  'DistrictType:{"path":"/تبوك/حي-المنشية-القديمة"}': {
    path: "/تبوك/حي-المنشية-القديمة",
    __typename: "DistrictType",
    district_id: 2882,
    name: "حي المنشية القديمة",
    uri: "حي-المنشية-القديمة",
  },
  'DistrictType:{"path":"/تبوك/حي-الورود"}': {
    path: "/تبوك/حي-الورود",
    __typename: "DistrictType",
    district_id: 2890,
    name: "حي الورود",
    uri: "حي-الورود",
  },
  'DistrictType:{"path":"/تيماء/حي-الروضة"}': {
    path: "/تيماء/حي-الروضة",
    __typename: "DistrictType",
    district_id: 2908,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'CityType:{"uri":"تيماء"}': {
    uri: "تيماء",
    __typename: "CityType",
    city_id: 62,
    name: "تيماء",
    path: "/تيماء",
  },
  'DistrictType:{"path":"/تيماء/حي-المنتزه"}': {
    path: "/تيماء/حي-المنتزه",
    __typename: "DistrictType",
    district_id: 2914,
    name: "حي المنتزه",
    uri: "حي-المنتزه",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الخالدية"}': {
    path: "/المدينة-المنورة/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 2950,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الرمانة"}': {
    path: "/المدينة-المنورة/حي-الرمانة",
    __typename: "DistrictType",
    district_id: 2964,
    name: "حي الرمانة",
    uri: "حي-الرمانة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-العريض"}': {
    path: "/المدينة-المنورة/حي-العريض",
    __typename: "DistrictType",
    district_id: 2992,
    name: "حي العريض",
    uri: "حي-العريض",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الغراء"}': {
    path: "/المدينة-المنورة/حي-الغراء",
    __typename: "DistrictType",
    district_id: 3004,
    name: "حي الغراء",
    uri: "حي-الغراء",
  },
  'DistrictType:{"path":"/بريدة/حي-الصبيحية"}': {
    path: "/بريدة/حي-الصبيحية",
    __typename: "DistrictType",
    district_id: 2320,
    name: "حي الصبيحية",
    uri: "حي-الصبيحية",
  },
  'DistrictType:{"path":"/بريدة/حي-الصقرات"}': {
    path: "/بريدة/حي-الصقرات",
    __typename: "DistrictType",
    district_id: 2324,
    name: "حي الصقرات",
    uri: "حي-الصقرات",
  },
  'DistrictType:{"path":"/بريدة/حي-الضاحي"}': {
    path: "/بريدة/حي-الضاحي",
    __typename: "DistrictType",
    district_id: 2326,
    name: "حي الضاحي",
    uri: "حي-الضاحي",
  },
  'DistrictType:{"path":"/بريدة/حي-العجيبة"}': {
    path: "/بريدة/حي-العجيبة",
    __typename: "DistrictType",
    district_id: 2328,
    name: "حي العجيبة",
    uri: "حي-العجيبة",
  },
  'DistrictType:{"path":"/بريدة/حي-الفايزية"}': {
    path: "/بريدة/حي-الفايزية",
    __typename: "DistrictType",
    district_id: 2338,
    name: "حي الفايزية",
    uri: "حي-الفايزية",
  },
  'DistrictType:{"path":"/بريدة/حي-القاع-البارد"}': {
    path: "/بريدة/حي-القاع-البارد",
    __typename: "DistrictType",
    district_id: 2340,
    name: "حي القاع البارد",
    uri: "حي-القاع-البارد",
  },
  'DistrictType:{"path":"/بريدة/حي-المريديسية"}': {
    path: "/بريدة/حي-المريديسية",
    __typename: "DistrictType",
    district_id: 2348,
    name: "حي المريديسية",
    uri: "حي-المريديسية",
  },
  'DistrictType:{"path":"/بريدة/حي-النسيم"}': {
    path: "/بريدة/حي-النسيم",
    __typename: "DistrictType",
    district_id: 2366,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/بريدة/حي-النقع-الغربية"}': {
    path: "/بريدة/حي-النقع-الغربية",
    __typename: "DistrictType",
    district_id: 2372,
    name: "حي النقع الغربية",
    uri: "حي-النقع-الغربية",
  },
  'DistrictType:{"path":"/بريدة/حي-جرية-العمران-وخب-الثنيان"}': {
    path: "/بريدة/حي-جرية-العمران-وخب-الثنيان",
    __typename: "DistrictType",
    district_id: 2380,
    name: "حي جرية العمران وخب الثنيان",
    uri: "حي-جرية-العمران-وخب-الثنيان",
  },
  'DistrictType:{"path":"/بريدة/حي-خب-روضان"}': {
    path: "/بريدة/حي-خب-روضان",
    __typename: "DistrictType",
    district_id: 2396,
    name: "حي خب روضان",
    uri: "حي-خب-روضان",
  },
  'DistrictType:{"path":"/الوجه/حي-النهضة"}': {
    path: "/الوجه/حي-النهضة",
    __typename: "DistrictType",
    district_id: 2812,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'CityType:{"uri":"الوجه"}': {
    uri: "الوجه",
    __typename: "CityType",
    city_id: 48,
    name: "الوجه",
    path: "/الوجه",
  },
  'DistrictType:{"path":"/املج/حي-التحلية"}': {
    path: "/املج/حي-التحلية",
    __typename: "DistrictType",
    district_id: 2820,
    name: "حي التحلية",
    uri: "حي-التحلية",
  },
  'DistrictType:{"path":"/ينبع/حي-السناف"}': {
    path: "/ينبع/حي-السناف",
    __typename: "DistrictType",
    district_id: 3176,
    name: "حي السناف",
    uri: "حي-السناف",
  },
  'DistrictType:{"path":"/ينبع/حي-السور"}': {
    path: "/ينبع/حي-السور",
    __typename: "DistrictType",
    district_id: 3178,
    name: "حي السور",
    uri: "حي-السور",
  },
  'DistrictType:{"path":"/ينبع/حي-الصواري-2"}': {
    path: "/ينبع/حي-الصواري-2",
    __typename: "DistrictType",
    district_id: 3200,
    name: "حي الصواري 2",
    uri: "حي-الصواري-2",
  },
  'DistrictType:{"path":"/ينبع/حي-العصبلي"}': {
    path: "/ينبع/حي-العصبلي",
    __typename: "DistrictType",
    district_id: 3204,
    name: "حي العصبلي",
    uri: "حي-العصبلي",
  },
  'DistrictType:{"path":"/ينبع/حي-الفلاح"}': {
    path: "/ينبع/حي-الفلاح",
    __typename: "DistrictType",
    district_id: 3208,
    name: "حي الفلاح",
    uri: "حي-الفلاح",
  },
  'DistrictType:{"path":"/ينبع/حي-المنتزه"}': {
    path: "/ينبع/حي-المنتزه",
    __typename: "DistrictType",
    district_id: 3232,
    name: "حي المنتزه",
    uri: "حي-المنتزه",
  },
  'DistrictType:{"path":"/ينبع/حي-النهضة-2"}': {
    path: "/ينبع/حي-النهضة-2",
    __typename: "DistrictType",
    district_id: 3248,
    name: "حي النهضة 2",
    uri: "حي-النهضة-2",
  },
  'DistrictType:{"path":"/ينبع/حي-رضوى"}': {
    path: "/ينبع/حي-رضوى",
    __typename: "DistrictType",
    district_id: 3256,
    name: "حي رضوى",
    uri: "حي-رضوى",
  },
  'DistrictType:{"path":"/ينبع/حي-شجوى"}': {
    path: "/ينبع/حي-شجوى",
    __typename: "DistrictType",
    district_id: 3260,
    name: "حي شجوى",
    uri: "حي-شجوى",
  },
  'DistrictType:{"path":"/الجموم/حي-الخيف"}': {
    path: "/الجموم/حي-الخيف",
    __typename: "DistrictType",
    district_id: 3270,
    name: "حي الخيف",
    uri: "حي-الخيف",
  },
  'CityType:{"uri":"الجموم"}': {
    uri: "الجموم",
    __typename: "CityType",
    city_id: 9,
    name: "الجموم",
    path: "/الجموم",
  },
  'DistrictType:{"path":"/الجموم/حي-السلامة"}': {
    path: "/الجموم/حي-السلامة",
    __typename: "DistrictType",
    district_id: 3274,
    name: "حي السلامة",
    uri: "حي-السلامة",
  },
  'DistrictType:{"path":"/الجموم/حي-الصفاء"}': {
    path: "/الجموم/حي-الصفاء",
    __typename: "DistrictType",
    district_id: 3278,
    name: "حي الصفاء",
    uri: "حي-الصفاء",
  },
  'DistrictType:{"path":"/الجموم/حي-سدر"}': {
    path: "/الجموم/حي-سدر",
    __typename: "DistrictType",
    district_id: 3292,
    name: "حي سدر",
    uri: "حي-سدر",
  },
  'DistrictType:{"path":"/الخرمة/حي-الحارثية"}': {
    path: "/الخرمة/حي-الحارثية",
    __typename: "DistrictType",
    district_id: 3294,
    name: "حي الحارثية",
    uri: "حي-الحارثية",
  },
  'CityType:{"uri":"الخرمة"}': {
    uri: "الخرمة",
    __typename: "CityType",
    city_id: 14,
    name: "الخرمة",
    path: "/الخرمة",
  },
  'DistrictType:{"path":"/الخرمة/حي-الدغمية"}': {
    path: "/الخرمة/حي-الدغمية",
    __typename: "DistrictType",
    district_id: 3302,
    name: "حي الدغمية",
    uri: "حي-الدغمية",
  },
  'DistrictType:{"path":"/الخرمة/حي-الروضة"}': {
    path: "/الخرمة/حي-الروضة",
    __typename: "DistrictType",
    district_id: 3304,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/الخرمة/حي-المحمدية"}': {
    path: "/الخرمة/حي-المحمدية",
    __typename: "DistrictType",
    district_id: 3310,
    name: "حي المحمدية",
    uri: "حي-المحمدية",
  },
  'DistrictType:{"path":"/الطائف/حي-الريان"}': {
    path: "/الطائف/حي-الريان",
    __typename: "DistrictType",
    district_id: 3322,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'CityType:{"uri":"الطائف"}': {
    uri: "الطائف",
    __typename: "CityType",
    city_id: 26,
    name: "الطائف",
    path: "/الطائف",
  },
  'DistrictType:{"path":"/الطائف/حي-القطبية"}': {
    path: "/الطائف/حي-القطبية",
    __typename: "DistrictType",
    district_id: 3340,
    name: "حي القطبية",
    uri: "حي-القطبية",
  },
  'DistrictType:{"path":"/الطائف/حي-الوسام"}': {
    path: "/الطائف/حي-الوسام",
    __typename: "DistrictType",
    district_id: 3350,
    name: "حي الوسام",
    uri: "حي-الوسام",
  },
  'DistrictType:{"path":"/الطائف/حي-ام-العراد"}': {
    path: "/الطائف/حي-ام-العراد",
    __typename: "DistrictType",
    district_id: 3360,
    name: "حي ام العراد",
    uri: "حي-ام-العراد",
  },
  'DistrictType:{"path":"/الطائف/حي-قروى"}': {
    path: "/الطائف/حي-قروى",
    __typename: "DistrictType",
    district_id: 3372,
    name: "حي قروى",
    uri: "حي-قروى",
  },
  'DistrictType:{"path":"/القنفذة/حي-الرتبة"}': {
    path: "/القنفذة/حي-الرتبة",
    __typename: "DistrictType",
    district_id: 3384,
    name: "حي الرتبة",
    uri: "حي-الرتبة",
  },
  'CityType:{"uri":"القنفذة"}': {
    uri: "القنفذة",
    __typename: "CityType",
    city_id: 34,
    name: "القنفذة",
    path: "/القنفذة",
  },
  'DistrictType:{"path":"/القنفذة/حي-الناعمية"}': {
    path: "/القنفذة/حي-الناعمية",
    __typename: "DistrictType",
    district_id: 3392,
    name: "حي الناعمية",
    uri: "حي-الناعمية",
  },
  'DistrictType:{"path":"/تربه/حي-الخالدية"}': {
    path: "/تربه/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 3402,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'CityType:{"uri":"تربه"}': {
    uri: "تربه",
    __typename: "CityType",
    city_id: 61,
    name: "تربه",
    path: "/تربه",
  },
  'DistrictType:{"path":"/تربه/حي-السوق"}': {
    path: "/تربه/حي-السوق",
    __typename: "DistrictType",
    district_id: 3406,
    name: "حي السوق",
    uri: "حي-السوق",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الامير-فواز-الجنوبي"}': {
    path: "/جدة/جنوب-جدة/حي-الامير-فواز-الجنوبي",
    __typename: "DistrictType",
    district_id: 3434,
    name: "حي الامير فواز الجنوبي",
    uri: "حي-الامير-فواز-الجنوبي",
  },
  'DirectionType:{"uri":"جنوب-جدة"}': {
    uri: "جنوب-جدة",
    __typename: "DirectionType",
    direction_id: 2,
    name: "جنوب جدة",
    path: "/جدة/جنوب-جدة",
  },
  'CityType:{"uri":"جدة"}': {
    uri: "جدة",
    __typename: "CityType",
    city_id: 66,
    name: "جدة",
    path: "/جدة",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الامير-فواز-الشمالي"}': {
    path: "/جدة/جنوب-جدة/حي-الامير-فواز-الشمالي",
    __typename: "DistrictType",
    district_id: 3436,
    name: "حي الامير فواز الشمالي",
    uri: "حي-الامير-فواز-الشمالي",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الاميرعبدالمجيد"}': {
    path: "/جدة/جنوب-جدة/حي-الاميرعبدالمجيد",
    __typename: "DistrictType",
    district_id: 3438,
    name: "حي الاميرعبدالمجيد",
    uri: "حي-الاميرعبدالمجيد",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الجوهرة"}': {
    path: "/جدة/جنوب-جدة/حي-الجوهرة",
    __typename: "DistrictType",
    district_id: 3466,
    name: "حي الجوهرة",
    uri: "حي-الجوهرة",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الروابي"}': {
    path: "/جدة/جنوب-جدة/حي-الروابي",
    __typename: "DistrictType",
    district_id: 3484,
    name: "حي الروابي",
    uri: "حي-الروابي",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الزهراء"}': {
    path: "/جدة/شمال-جدة/حي-الزهراء",
    __typename: "DistrictType",
    district_id: 3496,
    name: "حي الزهراء",
    uri: "حي-الزهراء",
  },
  'DirectionType:{"uri":"شمال-جدة"}': {
    uri: "شمال-جدة",
    __typename: "DirectionType",
    direction_id: 5,
    name: "شمال جدة",
    path: "/جدة/شمال-جدة",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-السرورية"}': {
    path: "/جدة/جنوب-جدة/حي-السرورية",
    __typename: "DistrictType",
    district_id: 3506,
    name: "حي السرورية",
    uri: "حي-السرورية",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الشروق"}': {
    path: "/جدة/شمال-جدة/حي-الشروق",
    __typename: "DistrictType",
    district_id: 3520,
    name: "حي الشروق",
    uri: "حي-الشروق",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الصحيفة"}': {
    path: "/جدة/شمال-جدة/حي-الصحيفة",
    __typename: "DistrictType",
    district_id: 3526,
    name: "حي الصحيفة",
    uri: "حي-الصحيفة",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-العدل"}': {
    path: "/جدة/جنوب-جدة/حي-العدل",
    __typename: "DistrictType",
    district_id: 3536,
    name: "حي العدل",
    uri: "حي-العدل",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الفاروق"}': {
    path: "/جدة/جنوب-جدة/حي-الفاروق",
    __typename: "DistrictType",
    district_id: 3544,
    name: "حي الفاروق",
    uri: "حي-الفاروق",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الفروسية"}': {
    path: "/جدة/شمال-جدة/حي-الفروسية",
    __typename: "DistrictType",
    district_id: 3548,
    name: "حي الفروسية",
    uri: "حي-الفروسية",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-القرينة"}': {
    path: "/جدة/جنوب-جدة/حي-القرينة",
    __typename: "DistrictType",
    district_id: 3562,
    name: "حي القرينة",
    uri: "حي-القرينة",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الكندرة"}': {
    path: "/جدة/شمال-جدة/حي-الكندرة",
    __typename: "DistrictType",
    district_id: 3568,
    name: "حي الكندرة",
    uri: "حي-الكندرة",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الكوثر"}': {
    path: "/جدة/شمال-جدة/حي-الكوثر",
    __typename: "DistrictType",
    district_id: 3570,
    name: "حي الكوثر",
    uri: "حي-الكوثر",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-اللؤلؤ"}': {
    path: "/جدة/شمال-جدة/حي-اللؤلؤ",
    __typename: "DistrictType",
    district_id: 3572,
    name: "حي اللؤلؤ",
    uri: "حي-اللؤلؤ",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-المروة"}': {
    path: "/جدة/شمال-جدة/حي-المروة",
    __typename: "DistrictType",
    district_id: 3586,
    name: "حي المروة",
    uri: "حي-المروة",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-المنتزه"}': {
    path: "/جدة/شمال-جدة/حي-المنتزه",
    __typename: "DistrictType",
    district_id: 3594,
    name: "حي المنتزه",
    uri: "حي-المنتزه",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الهدى"}': {
    path: "/جدة/جنوب-جدة/حي-الهدى",
    __typename: "DistrictType",
    district_id: 3610,
    name: "حي الهدى",
    uri: "حي-الهدى",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الواحة"}': {
    path: "/جدة/شمال-جدة/حي-الواحة",
    __typename: "DistrictType",
    district_id: 3614,
    name: "حي الواحة",
    uri: "حي-الواحة",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-ام-حبلين"}': {
    path: "/جدة/شمال-جدة/حي-ام-حبلين",
    __typename: "DistrictType",
    district_id: 3626,
    name: "حي ام حبلين",
    uri: "حي-ام-حبلين",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-جامعة-الملك-عبدالعزيز"}': {
    path: "/جدة/شمال-جدة/حي-جامعة-الملك-عبدالعزيز",
    __typename: "DistrictType",
    district_id: 3636,
    name: "حي جامعة الملك عبدالعزيز",
    uri: "حي-جامعة-الملك-عبدالعزيز",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-قاعدة-الملك-فيصل-البحرية"}': {
    path: "/جدة/جنوب-جدة/حي-قاعدة-الملك-فيصل-البحرية",
    __typename: "DistrictType",
    district_id: 3640,
    name: "حي قاعدة الملك فيصل البحرية",
    uri: "حي-قاعدة-الملك-فيصل-البحرية",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-مدينة-الملك-عبدالعزيز-الطبية"}': {
    path: "/جدة/جنوب-جدة/حي-مدينة-الملك-عبدالعزيز-الطبية",
    __typename: "DistrictType",
    district_id: 3644,
    name: "حي مدينة الملك عبدالعزيز الطبية",
    uri: "حي-مدينة-الملك-عبدالعزيز-الطبية",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-ميناء-جدة-الاسلامي"}': {
    path: "/جدة/شمال-جدة/حي-ميناء-جدة-الاسلامي",
    __typename: "DistrictType",
    district_id: 3652,
    name: "حي ميناء جدة الاسلامي",
    uri: "حي-ميناء-جدة-الاسلامي",
  },
  'DistrictType:{"path":"/مدينة-الملك-عبدالله-الاقتصادية/حي-البيلسان"}': {
    path: "/مدينة-الملك-عبدالله-الاقتصادية/حي-البيلسان",
    __typename: "DistrictType",
    district_id: 3670,
    name: "حي البيلسان",
    uri: "حي-البيلسان",
  },
  'CityType:{"uri":"مدينة-الملك-عبدالله-الاقتصادية"}': {
    uri: "مدينة-الملك-عبدالله-الاقتصادية",
    __typename: "CityType",
    city_id: 93,
    name: "مدينة الملك عبدالله الاقتصادية",
    path: "/مدينة-الملك-عبدالله-الاقتصادية",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الاندلس"}': {
    path: "/مكة-المكرمة/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 3684,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'CityType:{"uri":"مكة-المكرمة"}': {
    uri: "مكة-المكرمة",
    __typename: "CityType",
    city_id: 94,
    name: "مكة المكرمة",
    path: "/مكة-المكرمة",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-البحيرات"}': {
    path: "/مكة-المكرمة/حي-البحيرات",
    __typename: "DistrictType",
    district_id: 3686,
    name: "حي البحيرات",
    uri: "حي-البحيرات",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-التنعيم"}': {
    path: "/مكة-المكرمة/حي-التنعيم",
    __typename: "DistrictType",
    district_id: 3692,
    name: "حي التنعيم",
    uri: "حي-التنعيم",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الحرم"}': {
    path: "/مكة-المكرمة/حي-الحرم",
    __typename: "DistrictType",
    district_id: 3702,
    name: "حي الحرم",
    uri: "حي-الحرم",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الضيافة"}': {
    path: "/مكة-المكرمة/حي-الضيافة",
    __typename: "DistrictType",
    district_id: 3736,
    name: "حي الضيافة",
    uri: "حي-الضيافة",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-العتيبية"}': {
    path: "/مكة-المكرمة/حي-العتيبية",
    __typename: "DistrictType",
    district_id: 3740,
    name: "حي العتيبية",
    uri: "حي-العتيبية",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-النوارية"}': {
    path: "/مكة-المكرمة/حي-النوارية",
    __typename: "DistrictType",
    district_id: 3774,
    name: "حي النوارية",
    uri: "حي-النوارية",
  },
  'DistrictType:{"path":"/ابها/حي-الخالدية"}': {
    path: "/ابها/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 3788,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'CityType:{"uri":"ابها"}': {
    uri: "ابها",
    __typename: "CityType",
    city_id: 1,
    name: "ابها",
    path: "/ابها",
  },
  'DistrictType:{"path":"/ابها/حي-الربوة"}': {
    path: "/ابها/حي-الربوة",
    __typename: "DistrictType",
    district_id: 3792,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/ابها/حي-الوصايف"}': {
    path: "/ابها/حي-الوصايف",
    __typename: "DistrictType",
    district_id: 3830,
    name: "حي الوصايف",
    uri: "حي-الوصايف",
  },
  'DistrictType:{"path":"/احد-رفيده/حي-الصالحية"}': {
    path: "/احد-رفيده/حي-الصالحية",
    __typename: "DistrictType",
    district_id: 3852,
    name: "حي الصالحية",
    uri: "حي-الصالحية",
  },
  'CityType:{"uri":"احد-رفيده"}': {
    uri: "احد-رفيده",
    __typename: "CityType",
    city_id: 4,
    name: "احد رفيده",
    path: "/احد-رفيده",
  },
  'DistrictType:{"path":"/احد-رفيده/حي-المصيف"}': {
    path: "/احد-رفيده/حي-المصيف",
    __typename: "DistrictType",
    district_id: 3858,
    name: "حي المصيف",
    uri: "حي-المصيف",
  },
  'DistrictType:{"path":"/المجاردة/حي-الاندلس"}': {
    path: "/المجاردة/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 3868,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'CityType:{"uri":"المجاردة"}': {
    uri: "المجاردة",
    __typename: "CityType",
    city_id: 39,
    name: "المجاردة",
    path: "/المجاردة",
  },
  'DistrictType:{"path":"/المجاردة/حي-التقدم"}': {
    path: "/المجاردة/حي-التقدم",
    __typename: "DistrictType",
    district_id: 3870,
    name: "حي التقدم",
    uri: "حي-التقدم",
  },
  'DistrictType:{"path":"/المجاردة/حي-النسيم"}': {
    path: "/المجاردة/حي-النسيم",
    __typename: "DistrictType",
    district_id: 3888,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/بللسمر/حي-الخالدية"}': {
    path: "/بللسمر/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 3894,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'CityType:{"uri":"بللسمر"}': {
    uri: "بللسمر",
    __typename: "CityType",
    city_id: 55,
    name: "بللسمر",
    path: "/بللسمر",
  },
  'DistrictType:{"path":"/بللسمر/حي-السلام"}': {
    path: "/بللسمر/حي-السلام",
    __typename: "DistrictType",
    district_id: 3910,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/بيشة/حي-التضامن"}': {
    path: "/بيشة/حي-التضامن",
    __typename: "DistrictType",
    district_id: 3930,
    name: "حي التضامن",
    uri: "حي-التضامن",
  },
  'CityType:{"uri":"بيشة"}': {
    uri: "بيشة",
    __typename: "CityType",
    city_id: 57,
    name: "بيشة",
    path: "/بيشة",
  },
  'DistrictType:{"path":"/بيشة/حي-الزهور"}': {
    path: "/بيشة/حي-الزهور",
    __typename: "DistrictType",
    district_id: 3946,
    name: "حي الزهور",
    uri: "حي-الزهور",
  },
  'DistrictType:{"path":"/بيشة/حي-الصناعية"}': {
    path: "/بيشة/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 3952,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/بيشة/حي-الملك-عبدالله"}': {
    path: "/بيشة/حي-الملك-عبدالله",
    __typename: "DistrictType",
    district_id: 3966,
    name: "حي الملك عبدالله",
    uri: "حي-الملك-عبدالله",
  },
  'DistrictType:{"path":"/بيشة/حي-الورود"}': {
    path: "/بيشة/حي-الورود",
    __typename: "DistrictType",
    district_id: 3978,
    name: "حي الورود",
    uri: "حي-الورود",
  },
  'DistrictType:{"path":"/تثليث/حي-الخالدية"}': {
    path: "/تثليث/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 3984,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'CityType:{"uri":"تثليث"}': {
    uri: "تثليث",
    __typename: "CityType",
    city_id: 60,
    name: "تثليث",
    path: "/تثليث",
  },
  'DistrictType:{"path":"/تثليث/حي-الخزان"}': {
    path: "/تثليث/حي-الخزان",
    __typename: "DistrictType",
    district_id: 3986,
    name: "حي الخزان",
    uri: "حي-الخزان",
  },
  'DistrictType:{"path":"/تثليث/حي-الزهور"}': {
    path: "/تثليث/حي-الزهور",
    __typename: "DistrictType",
    district_id: 3988,
    name: "حي الزهور",
    uri: "حي-الزهور",
  },
  'DistrictType:{"path":"/تثليث/حي-العزيزية"}': {
    path: "/تثليث/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 3990,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/تثليث/حي-الغزالة"}': {
    path: "/تثليث/حي-الغزالة",
    __typename: "DistrictType",
    district_id: 3992,
    name: "حي الغزالة",
    uri: "حي-الغزالة",
  },
  'DistrictType:{"path":"/تثليث/حي-تثليث"}': {
    path: "/تثليث/حي-تثليث",
    __typename: "DistrictType",
    district_id: 4002,
    name: "حي تثليث",
    uri: "حي-تثليث",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-العزيزية"}': {
    path: "/خميس-مشيط/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 4036,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'CityType:{"uri":"خميس-مشيط"}': {
    uri: "خميس-مشيط",
    __typename: "CityType",
    city_id: 70,
    name: "خميس مشيط",
    path: "/خميس-مشيط",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-المنتزه"}': {
    path: "/خميس-مشيط/حي-المنتزه",
    __typename: "DistrictType",
    district_id: 4050,
    name: "حي المنتزه",
    uri: "حي-المنتزه",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-النزهة"}': {
    path: "/خميس-مشيط/حي-النزهة",
    __typename: "DistrictType",
    district_id: 4054,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/محايل/حي-الضرس"}': {
    path: "/محايل/حي-الضرس",
    __typename: "DistrictType",
    district_id: 4108,
    name: "حي الضرس",
    uri: "حي-الضرس",
  },
  'CityType:{"uri":"محايل"}': {
    uri: "محايل",
    __typename: "CityType",
    city_id: 92,
    name: "محايل",
    path: "/محايل",
  },
  'DistrictType:{"path":"/شرورة/حي-الروضة-الشمالية"}': {
    path: "/شرورة/حي-الروضة-الشمالية",
    __typename: "DistrictType",
    district_id: 4346,
    name: "حي الروضة الشمالية",
    uri: "حي-الروضة-الشمالية",
  },
  'CityType:{"uri":"شرورة"}': {
    uri: "شرورة",
    __typename: "CityType",
    city_id: 81,
    name: "شرورة",
    path: "/شرورة",
  },
  'DistrictType:{"path":"/شرورة/حي-سلطانة"}': {
    path: "/شرورة/حي-سلطانة",
    __typename: "DistrictType",
    district_id: 4360,
    name: "حي سلطانة",
    uri: "حي-سلطانة",
  },
  'DistrictType:{"path":"/نجران/حي-الخالدية"}': {
    path: "/نجران/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 4374,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'CityType:{"uri":"نجران"}': {
    uri: "نجران",
    __typename: "CityType",
    city_id: 96,
    name: "نجران",
    path: "/نجران",
  },
  'DistrictType:{"path":"/نجران/حي-دحضة"}': {
    path: "/نجران/حي-دحضة",
    __typename: "DistrictType",
    district_id: 4390,
    name: "حي دحضة",
    uri: "حي-دحضة",
  },
  'DistrictType:{"path":"/نجران/حي-مخطط-ابن-جارالله-السكني"}': {
    path: "/نجران/حي-مخطط-ابن-جارالله-السكني",
    __typename: "DistrictType",
    district_id: 4398,
    name: "حي مخطط ابن جارالله السكني",
    uri: "حي-مخطط-ابن-جارالله-السكني",
  },
  'DistrictType:{"path":"/نجران/حي-مخطط-الاثايبة-الشمالية-الزراعي"}': {
    path: "/نجران/حي-مخطط-الاثايبة-الشمالية-الزراعي",
    __typename: "DistrictType",
    district_id: 4400,
    name: "حي مخطط الاثايبة الشمالية الزراعي",
    uri: "حي-مخطط-الاثايبة-الشمالية-الزراعي",
  },
  'DistrictType:{"path":"/الباحة/حي-شهبة"}': {
    path: "/الباحة/حي-شهبة",
    __typename: "DistrictType",
    district_id: 4434,
    name: "حي شهبة",
    uri: "حي-شهبة",
  },
  'CityType:{"uri":"الباحة"}': {
    uri: "الباحة",
    __typename: "CityType",
    city_id: 5,
    name: "الباحة",
    path: "/الباحة",
  },
  'DistrictType:{"path":"/شرورة/حي-السوق"}': {
    path: "/شرورة/حي-السوق",
    __typename: "DistrictType",
    district_id: 4348,
    name: "حي السوق",
    uri: "حي-السوق",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-البطيحا"}': {
    path: "/الرياض/وسط-الرياض/حي-البطيحا",
    __typename: "DistrictType",
    district_id: 402,
    name: "حي البطيحا",
    uri: "حي-البطيحا",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-الجرادية"}': {
    path: "/الرياض/غرب-الرياض/حي-الجرادية",
    __typename: "DistrictType",
    district_id: 406,
    name: "حي الجرادية",
    uri: "حي-الجرادية",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-الدوبية"}': {
    path: "/الرياض/وسط-الرياض/حي-الدوبية",
    __typename: "DistrictType",
    district_id: 432,
    name: "حي الدوبية",
    uri: "حي-الدوبية",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-الربوة"}': {
    path: "/الرياض/وسط-الرياض/حي-الربوة",
    __typename: "DistrictType",
    district_id: 438,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-الشميسي"}': {
    path: "/الرياض/وسط-الرياض/حي-الشميسي",
    __typename: "DistrictType",
    district_id: 480,
    name: "حي الشميسي",
    uri: "حي-الشميسي",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الشهداء"}': {
    path: "/الرياض/شرق-الرياض/حي-الشهداء",
    __typename: "DistrictType",
    district_id: 482,
    name: "حي الشهداء",
    uri: "حي-الشهداء",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-الصناعية"}': {
    path: "/الرياض/وسط-الرياض/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 490,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-العارض"}': {
    path: "/الرياض/شمال-الرياض/حي-العارض",
    __typename: "DistrictType",
    district_id: 494,
    name: "حي العارض",
    uri: "حي-العارض",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-العماجية"}': {
    path: "/الرياض/جنوب-الرياض/حي-العماجية",
    __typename: "DistrictType",
    district_id: 508,
    name: "حي العماجية",
    uri: "حي-العماجية",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-الغدير"}': {
    path: "/الرياض/شمال-الرياض/حي-الغدير",
    __typename: "DistrictType",
    district_id: 514,
    name: "حي الغدير",
    uri: "حي-الغدير",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-الفلاح"}': {
    path: "/الرياض/شمال-الرياض/حي-الفلاح",
    __typename: "DistrictType",
    district_id: 522,
    name: "حي الفلاح",
    uri: "حي-الفلاح",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-الفوطة"}': {
    path: "/الرياض/وسط-الرياض/حي-الفوطة",
    __typename: "DistrictType",
    district_id: 524,
    name: "حي الفوطة",
    uri: "حي-الفوطة",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-الفيصلية"}': {
    path: "/الرياض/وسط-الرياض/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 528,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-القري"}': {
    path: "/الرياض/وسط-الرياض/حي-القري",
    __typename: "DistrictType",
    district_id: 534,
    name: "حي القري",
    uri: "حي-القري",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-المصانع"}': {
    path: "/الرياض/جنوب-الرياض/حي-المصانع",
    __typename: "DistrictType",
    district_id: 552,
    name: "حي المصانع",
    uri: "حي-المصانع",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-المصفاة"}': {
    path: "/الرياض/جنوب-الرياض/حي-المصفاة",
    __typename: "DistrictType",
    district_id: 554,
    name: "حي المصفاة",
    uri: "حي-المصفاة",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-المعذر"}': {
    path: "/الرياض/غرب-الرياض/حي-المعذر",
    __typename: "DistrictType",
    district_id: 558,
    name: "حي المعذر",
    uri: "حي-المعذر",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-المغرزات"}': {
    path: "/الرياض/شمال-الرياض/حي-المغرزات",
    __typename: "DistrictType",
    district_id: 566,
    name: "حي المغرزات",
    uri: "حي-المغرزات",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الملز"}': {
    path: "/الرياض/شرق-الرياض/حي-الملز",
    __typename: "DistrictType",
    district_id: 568,
    name: "حي الملز",
    uri: "حي-الملز",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-الملك-عبدالله"}': {
    path: "/الرياض/شمال-الرياض/حي-الملك-عبدالله",
    __typename: "DistrictType",
    district_id: 574,
    name: "حي الملك عبدالله",
    uri: "حي-الملك-عبدالله",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-الملك-فهد"}': {
    path: "/الرياض/شمال-الرياض/حي-الملك-فهد",
    __typename: "DistrictType",
    district_id: 576,
    name: "حي الملك فهد",
    uri: "حي-الملك-فهد",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-المناخ"}': {
    path: "/الرياض/جنوب-الرياض/حي-المناخ",
    __typename: "DistrictType",
    district_id: 580,
    name: "حي المناخ",
    uri: "حي-المناخ",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-النخيل"}': {
    path: "/الرياض/شمال-الرياض/حي-النخيل",
    __typename: "DistrictType",
    district_id: 596,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-النرجس"}': {
    path: "/الرياض/شمال-الرياض/حي-النرجس",
    __typename: "DistrictType",
    district_id: 600,
    name: "حي النرجس",
    uri: "حي-النرجس",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-الورود"}': {
    path: "/الرياض/شمال-الرياض/حي-الورود",
    __typename: "DistrictType",
    district_id: 624,
    name: "حي الورود",
    uri: "حي-الورود",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-ام-الحمام-الغربي"}': {
    path: "/الرياض/غرب-الرياض/حي-ام-الحمام-الغربي",
    __typename: "DistrictType",
    district_id: 640,
    name: "حي ام الحمام الغربي",
    uri: "حي-ام-الحمام-الغربي",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-عرقة"}': {
    path: "/الرياض/غرب-الرياض/حي-عرقة",
    __typename: "DistrictType",
    district_id: 694,
    name: "حي عرقة",
    uri: "حي-عرقة",
  },
  'DistrictType:{"path":"/القطيف/حي-الشويكة"}': {
    path: "/القطيف/حي-الشويكة",
    __typename: "DistrictType",
    district_id: 1440,
    name: "حي الشويكة",
    uri: "حي-الشويكة",
  },
  'DistrictType:{"path":"/القطيف/حي-العوامية"}': {
    path: "/القطيف/حي-العوامية",
    __typename: "DistrictType",
    district_id: 1446,
    name: "حي العوامية",
    uri: "حي-العوامية",
  },
  'DistrictType:{"path":"/القطيف/حي-المجيدية"}': {
    path: "/القطيف/حي-المجيدية",
    __typename: "DistrictType",
    district_id: 1456,
    name: "حي المجيدية",
    uri: "حي-المجيدية",
  },
  'DistrictType:{"path":"/القطيف/حي-المدارس"}': {
    path: "/القطيف/حي-المدارس",
    __typename: "DistrictType",
    district_id: 1458,
    name: "حي المدارس",
    uri: "حي-المدارس",
  },
  'DistrictType:{"path":"/القطيف/حي-المشتل"}': {
    path: "/القطيف/حي-المشتل",
    __typename: "DistrictType",
    district_id: 1468,
    name: "حي المشتل",
    uri: "حي-المشتل",
  },
  'DistrictType:{"path":"/القطيف/حي-الوسادة"}': {
    path: "/القطيف/حي-الوسادة",
    __typename: "DistrictType",
    district_id: 1482,
    name: "حي الوسادة",
    uri: "حي-الوسادة",
  },
  'DistrictType:{"path":"/القطيف/حي-ام-الحمام"}': {
    path: "/القطيف/حي-ام-الحمام",
    __typename: "DistrictType",
    district_id: 1488,
    name: "حي ام الحمام",
    uri: "حي-ام-الحمام",
  },
  'DistrictType:{"path":"/النعيرية/حي-العزيزية"}': {
    path: "/النعيرية/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 1508,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/الهفوف/حي-الامراء"}': {
    path: "/الهفوف/حي-الامراء",
    __typename: "DistrictType",
    district_id: 1518,
    name: "حي الامراء",
    uri: "حي-الامراء",
  },
  'DistrictType:{"path":"/الهفوف/حي-الاندلس"}': {
    path: "/الهفوف/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 1520,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/الهفوف/حي-البندرية"}': {
    path: "/الهفوف/حي-البندرية",
    __typename: "DistrictType",
    district_id: 1524,
    name: "حي البندرية",
    uri: "حي-البندرية",
  },
  'DistrictType:{"path":"/الهفوف/حي-الحزم"}': {
    path: "/الهفوف/حي-الحزم",
    __typename: "DistrictType",
    district_id: 1538,
    name: "حي الحزم",
    uri: "حي-الحزم",
  },
  'DistrictType:{"path":"/الهفوف/حي-الرفعةالجنوبية"}': {
    path: "/الهفوف/حي-الرفعةالجنوبية",
    __typename: "DistrictType",
    district_id: 1552,
    name: "حي الرفعةالجنوبية",
    uri: "حي-الرفعةالجنوبية",
  },
  'DistrictType:{"path":"/الهفوف/حي-الرقيقة"}': {
    path: "/الهفوف/حي-الرقيقة",
    __typename: "DistrictType",
    district_id: 1554,
    name: "حي الرقيقة",
    uri: "حي-الرقيقة",
  },
  'DistrictType:{"path":"/الهفوف/حي-الزهرة"}': {
    path: "/الهفوف/حي-الزهرة",
    __typename: "DistrictType",
    district_id: 1560,
    name: "حي الزهرة",
    uri: "حي-الزهرة",
  },
  'DistrictType:{"path":"/الهفوف/حي-الشهارين"}': {
    path: "/الهفوف/حي-الشهارين",
    __typename: "DistrictType",
    district_id: 1578,
    name: "حي الشهارين",
    uri: "حي-الشهارين",
  },
  'DistrictType:{"path":"/الهفوف/حي-الصالحية"}': {
    path: "/الهفوف/حي-الصالحية",
    __typename: "DistrictType",
    district_id: 1580,
    name: "حي الصالحية",
    uri: "حي-الصالحية",
  },
  'DistrictType:{"path":"/صبيا/حي-الغراء"}': {
    path: "/صبيا/حي-الغراء",
    __typename: "DistrictType",
    district_id: 214,
    name: "حي الغراء",
    uri: "حي-الغراء",
  },
  'DistrictType:{"path":"/صبيا/حي-الفيصلية"}': {
    path: "/صبيا/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 220,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/صبيا/حي-المروج"}': {
    path: "/صبيا/حي-المروج",
    __typename: "DistrictType",
    district_id: 224,
    name: "حي المروج",
    uri: "حي-المروج",
  },
  'DistrictType:{"path":"/صبيا/حي-المعترض"}': {
    path: "/صبيا/حي-المعترض",
    __typename: "DistrictType",
    district_id: 226,
    name: "حي المعترض",
    uri: "حي-المعترض",
  },
  'DistrictType:{"path":"/الحريق/حي-الركبة"}': {
    path: "/الحريق/حي-الركبة",
    __typename: "DistrictType",
    district_id: 236,
    name: "حي الركبة",
    uri: "حي-الركبة",
  },
  'DistrictType:{"path":"/الحريق/حي-الصناعية"}': {
    path: "/الحريق/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 238,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/الحريق/حي-المفيجر"}': {
    path: "/الحريق/حي-المفيجر",
    __typename: "DistrictType",
    district_id: 244,
    name: "حي المفيجر",
    uri: "حي-المفيجر",
  },
  'DistrictType:{"path":"/الخرج/حي-الاندلس"}': {
    path: "/الخرج/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 248,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/الخرج/حي-الرفيعة"}': {
    path: "/الخرج/حي-الرفيعة",
    __typename: "DistrictType",
    district_id: 262,
    name: "حي الرفيعة",
    uri: "حي-الرفيعة",
  },
  'DistrictType:{"path":"/الخرج/حي-الصناعية-الجديدة"}': {
    path: "/الخرج/حي-الصناعية-الجديدة",
    __typename: "DistrictType",
    district_id: 274,
    name: "حي الصناعية الجديدة",
    uri: "حي-الصناعية-الجديدة",
  },
  'DistrictType:{"path":"/الخرج/حي-العالية"}': {
    path: "/الخرج/حي-العالية",
    __typename: "DistrictType",
    district_id: 276,
    name: "حي العالية",
    uri: "حي-العالية",
  },
  'DistrictType:{"path":"/الخرج/حي-العزيزية"}': {
    path: "/الخرج/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 278,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/الخرج/حي-المنتزة"}': {
    path: "/الخرج/حي-المنتزة",
    __typename: "DistrictType",
    district_id: 282,
    name: "حي المنتزة",
    uri: "حي-المنتزة",
  },
  'DistrictType:{"path":"/الدلم/حي-الديرة"}': {
    path: "/الدلم/حي-الديرة",
    __typename: "DistrictType",
    district_id: 324,
    name: "حي الديرة",
    uri: "حي-الديرة",
  },
  'DistrictType:{"path":"/الدوادمي/حي-الحرمين"}': {
    path: "/الدوادمي/حي-الحرمين",
    __typename: "DistrictType",
    district_id: 344,
    name: "حي الحرمين",
    uri: "حي-الحرمين",
  },
  'DistrictType:{"path":"/الدوادمي/حي-الدرع"}': {
    path: "/الدوادمي/حي-الدرع",
    __typename: "DistrictType",
    district_id: 350,
    name: "حي الدرع",
    uri: "حي-الدرع",
  },
  'DistrictType:{"path":"/الدوادمي/حي-السنبلة"}': {
    path: "/الدوادمي/حي-السنبلة",
    __typename: "DistrictType",
    district_id: 362,
    name: "حي السنبلة",
    uri: "حي-السنبلة",
  },
  'DistrictType:{"path":"/الدوادمي/حي-العلوة"}': {
    path: "/الدوادمي/حي-العلوة",
    __typename: "DistrictType",
    district_id: 368,
    name: "حي العلوة",
    uri: "حي-العلوة",
  },
  'DistrictType:{"path":"/الدوادمي/حي-النهضة"}': {
    path: "/الدوادمي/حي-النهضة",
    __typename: "DistrictType",
    district_id: 378,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الاندلس"}': {
    path: "/الرياض/شرق-الرياض/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 396,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/الغاط/حي-النفل"}': {
    path: "/الغاط/حي-النفل",
    __typename: "DistrictType",
    district_id: 810,
    name: "حي النفل",
    uri: "حي-النفل",
  },
  'DistrictType:{"path":"/القويعية/حي-ابو-سليم"}': {
    path: "/القويعية/حي-ابو-سليم",
    __typename: "DistrictType",
    district_id: 818,
    name: "حي ابو سليم",
    uri: "حي-ابو-سليم",
  },
  'DistrictType:{"path":"/القويعية/حي-البستان"}': {
    path: "/القويعية/حي-البستان",
    __typename: "DistrictType",
    district_id: 820,
    name: "حي البستان",
    uri: "حي-البستان",
  },
  'DistrictType:{"path":"/القويعية/حي-الجزيرة"}': {
    path: "/القويعية/حي-الجزيرة",
    __typename: "DistrictType",
    district_id: 822,
    name: "حي الجزيرة",
    uri: "حي-الجزيرة",
  },
  'DistrictType:{"path":"/القويعية/حي-الحزم"}': {
    path: "/القويعية/حي-الحزم",
    __typename: "DistrictType",
    district_id: 826,
    name: "حي الحزم",
    uri: "حي-الحزم",
  },
  'DistrictType:{"path":"/القويعية/حي-الربوة"}': {
    path: "/القويعية/حي-الربوة",
    __typename: "DistrictType",
    district_id: 832,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/القويعية/حي-الورود"}': {
    path: "/القويعية/حي-الورود",
    __typename: "DistrictType",
    district_id: 846,
    name: "حي الورود",
    uri: "حي-الورود",
  },
  'DistrictType:{"path":"/المجمعة/حي-الامير-سلمان"}': {
    path: "/المجمعة/حي-الامير-سلمان",
    __typename: "DistrictType",
    district_id: 848,
    name: "حي الامير سلمان",
    uri: "حي-الامير-سلمان",
  },
  'DistrictType:{"path":"/المجمعة/حي-المروج"}': {
    path: "/المجمعة/حي-المروج",
    __typename: "DistrictType",
    district_id: 864,
    name: "حي المروج",
    uri: "حي-المروج",
  },
  'DistrictType:{"path":"/المزاحمية/حي-العليا"}': {
    path: "/المزاحمية/حي-العليا",
    __typename: "DistrictType",
    district_id: 884,
    name: "حي العليا",
    uri: "حي-العليا",
  },
  'DistrictType:{"path":"/المزاحمية/حي-الهدا"}': {
    path: "/المزاحمية/حي-الهدا",
    __typename: "DistrictType",
    district_id: 890,
    name: "حي الهدا",
    uri: "حي-الهدا",
  },
  'DistrictType:{"path":"/المزاحمية/حي-شخيب"}': {
    path: "/المزاحمية/حي-شخيب",
    __typename: "DistrictType",
    district_id: 892,
    name: "حي شخيب",
    uri: "حي-شخيب",
  },
  'DistrictType:{"path":"/شقراء/حي-المنطقة-الصناعية"}': {
    path: "/شقراء/حي-المنطقة-الصناعية",
    __typename: "DistrictType",
    district_id: 952,
    name: "حي المنطقة الصناعية",
    uri: "حي-المنطقة-الصناعية",
  },
  'DistrictType:{"path":"/شقراء/حي-الوقف"}': {
    path: "/شقراء/حي-الوقف",
    __typename: "DistrictType",
    district_id: 958,
    name: "حي الوقف",
    uri: "حي-الوقف",
  },
  'DistrictType:{"path":"/عفيف/حي-الصالحية"}': {
    path: "/عفيف/حي-الصالحية",
    __typename: "DistrictType",
    district_id: 972,
    name: "حي الصالحية",
    uri: "حي-الصالحية",
  },
  'DistrictType:{"path":"/عفيف/حي-الصناعية"}': {
    path: "/عفيف/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 974,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/الجبيل/حي-الشاطئ"}': {
    path: "/الجبيل/حي-الشاطئ",
    __typename: "DistrictType",
    district_id: 996,
    name: "حي الشاطئ",
    uri: "حي-الشاطئ",
  },
  'DistrictType:{"path":"/الجبيل/حي-الفاروق"}': {
    path: "/الجبيل/حي-الفاروق",
    __typename: "DistrictType",
    district_id: 998,
    name: "حي الفاروق",
    uri: "حي-الفاروق",
  },
  'DistrictType:{"path":"/الدمام/حي-الجلوية"}': {
    path: "/الدمام/حي-الجلوية",
    __typename: "DistrictType",
    district_id: 1206,
    name: "حي الجلوية",
    uri: "حي-الجلوية",
  },
  'DistrictType:{"path":"/الدمام/حي-الخضرية"}': {
    path: "/الدمام/حي-الخضرية",
    __typename: "DistrictType",
    district_id: 1214,
    name: "حي الخضرية",
    uri: "حي-الخضرية",
  },
  'DistrictType:{"path":"/الدمام/حي-الخليج"}': {
    path: "/الدمام/حي-الخليج",
    __typename: "DistrictType",
    district_id: 1216,
    name: "حي الخليج",
    uri: "حي-الخليج",
  },
  'DistrictType:{"path":"/الدمام/حي-الدواسر"}': {
    path: "/الدمام/حي-الدواسر",
    __typename: "DistrictType",
    district_id: 1220,
    name: "حي الدواسر",
    uri: "حي-الدواسر",
  },
  'DistrictType:{"path":"/الدمام/حي-الشاطئ-الشرقي"}': {
    path: "/الدمام/حي-الشاطئ-الشرقي",
    __typename: "DistrictType",
    district_id: 1238,
    name: "حي الشاطئ الشرقي",
    uri: "حي-الشاطئ-الشرقي",
  },
  'DistrictType:{"path":"/الدمام/حي-العدامة"}': {
    path: "/الدمام/حي-العدامة",
    __typename: "DistrictType",
    district_id: 1256,
    name: "حي العدامة",
    uri: "حي-العدامة",
  },
  'DistrictType:{"path":"/الدمام/حي-العزيزية"}': {
    path: "/الدمام/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 1258,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/الدمام/حي-الفردوس"}': {
    path: "/الدمام/حي-الفردوس",
    __typename: "DistrictType",
    district_id: 1264,
    name: "حي الفردوس",
    uri: "حي-الفردوس",
  },
  'DistrictType:{"path":"/الدمام/حي-الفنار"}': {
    path: "/الدمام/حي-الفنار",
    __typename: "DistrictType",
    district_id: 1268,
    name: "حي الفنار",
    uri: "حي-الفنار",
  },
  'DistrictType:{"path":"/الدمام/حي-المنتزه"}': {
    path: "/الدمام/حي-المنتزه",
    __typename: "DistrictType",
    district_id: 1290,
    name: "حي المنتزه",
    uri: "حي-المنتزه",
  },
  'DistrictType:{"path":"/الدمام/حي-النورس"}': {
    path: "/الدمام/حي-النورس",
    __typename: "DistrictType",
    district_id: 1308,
    name: "حي النورس",
    uri: "حي-النورس",
  },
  'DistrictType:{"path":"/الدمام/حي-بدر"}': {
    path: "/الدمام/حي-بدر",
    __typename: "DistrictType",
    district_id: 1312,
    name: "حي بدر",
    uri: "حي-بدر",
  },
  'DistrictType:{"path":"/الدمام/حي-غرناطة"}': {
    path: "/الدمام/حي-غرناطة",
    __typename: "DistrictType",
    district_id: 1322,
    name: "حي غرناطة",
    uri: "حي-غرناطة",
  },
  'DistrictType:{"path":"/الظهران/حي-الحرس-الوطني"}': {
    path: "/الظهران/حي-الحرس-الوطني",
    __typename: "DistrictType",
    district_id: 1336,
    name: "حي الحرس الوطني",
    uri: "حي-الحرس-الوطني",
  },
  'DistrictType:{"path":"/الظهران/حي-الدوحة-الجنوبية"}': {
    path: "/الظهران/حي-الدوحة-الجنوبية",
    __typename: "DistrictType",
    district_id: 1342,
    name: "حي الدوحة الجنوبية",
    uri: "حي-الدوحة-الجنوبية",
  },
  'DistrictType:{"path":"/القطيف/حي-الثريا"}': {
    path: "/القطيف/حي-الثريا",
    __typename: "DistrictType",
    district_id: 1390,
    name: "حي الثريا",
    uri: "حي-الثريا",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-البرصة"}': {
    path: "/ابو-عريش/حي-البرصة",
    __typename: "DistrictType",
    district_id: 8,
    name: "حي البرصة",
    uri: "حي-البرصة",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-الجغادمة"}': {
    path: "/ابو-عريش/حي-الجغادمة",
    __typename: "DistrictType",
    district_id: 10,
    name: "حي الجغادمة",
    uri: "حي-الجغادمة",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-الخالدية"}': {
    path: "/ابو-عريش/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 12,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-الشعوب"}': {
    path: "/ابو-عريش/حي-الشعوب",
    __typename: "DistrictType",
    district_id: 30,
    name: "حي الشعوب",
    uri: "حي-الشعوب",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-الصفا"}': {
    path: "/ابو-عريش/حي-الصفا",
    __typename: "DistrictType",
    district_id: 32,
    name: "حي الصفا",
    uri: "حي-الصفا",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-العروس"}': {
    path: "/ابو-عريش/حي-العروس",
    __typename: "DistrictType",
    district_id: 34,
    name: "حي العروس",
    uri: "حي-العروس",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-القويعية"}': {
    path: "/ابو-عريش/حي-القويعية",
    __typename: "DistrictType",
    district_id: 42,
    name: "حي القويعية",
    uri: "حي-القويعية",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-النهضة"}': {
    path: "/ابو-عريش/حي-النهضة",
    __typename: "DistrictType",
    district_id: 62,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-بديع-الخرم"}': {
    path: "/ابو-عريش/حي-بديع-الخرم",
    __typename: "DistrictType",
    district_id: 70,
    name: "حي بديع الخرم",
    uri: "حي-بديع-الخرم",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-سلامة-الدراج"}': {
    path: "/ابو-عريش/حي-سلامة-الدراج",
    __typename: "DistrictType",
    district_id: 78,
    name: "حي سلامة الدراج",
    uri: "حي-سلامة-الدراج",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-صديقة"}': {
    path: "/ابو-عريش/حي-صديقة",
    __typename: "DistrictType",
    district_id: 82,
    name: "حي صديقة",
    uri: "حي-صديقة",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-قنبورة"}': {
    path: "/ابو-عريش/حي-قنبورة",
    __typename: "DistrictType",
    district_id: 88,
    name: "حي قنبورة",
    uri: "حي-قنبورة",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-ابو-حجر"}': {
    path: "/احد-المسارحة/حي-ابو-حجر",
    __typename: "DistrictType",
    district_id: 94,
    name: "حي ابو حجر",
    uri: "حي-ابو-حجر",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-البلدية"}': {
    path: "/احد-المسارحة/حي-البلدية",
    __typename: "DistrictType",
    district_id: 96,
    name: "حي البلدية",
    uri: "حي-البلدية",
  },
  'DistrictType:{"path":"/الجبيل/حي-المنطقة-الصناعية"}': {
    path: "/الجبيل/حي-المنطقة-الصناعية",
    __typename: "DistrictType",
    district_id: 1008,
    name: "حي المنطقة الصناعية",
    uri: "حي-المنطقة-الصناعية",
  },
  'DistrictType:{"path":"/الجبيل/حي-المنطقة-الصناعية-الاولى"}': {
    path: "/الجبيل/حي-المنطقة-الصناعية-الاولى",
    __typename: "DistrictType",
    district_id: 1010,
    name: "حي المنطقة الصناعية الاولى",
    uri: "حي-المنطقة-الصناعية-الاولى",
  },
  'DistrictType:{"path":"/الخبر/حي-الاسكان"}': {
    path: "/الخبر/حي-الاسكان",
    __typename: "DistrictType",
    district_id: 1042,
    name: "حي الاسكان",
    uri: "حي-الاسكان",
  },
  'DistrictType:{"path":"/الخبر/حي-البحيرة"}': {
    path: "/الخبر/حي-البحيرة",
    __typename: "DistrictType",
    district_id: 1050,
    name: "حي البحيرة",
    uri: "حي-البحيرة",
  },
  'DistrictType:{"path":"/الخبر/حي-الثقبة"}': {
    path: "/الخبر/حي-الثقبة",
    __typename: "DistrictType",
    district_id: 1060,
    name: "حي الثقبة",
    uri: "حي-الثقبة",
  },
  'DistrictType:{"path":"/الخبر/حي-الحمرا"}': {
    path: "/الخبر/حي-الحمرا",
    __typename: "DistrictType",
    district_id: 1070,
    name: "حي الحمرا",
    uri: "حي-الحمرا",
  },
  'DistrictType:{"path":"/الخبر/حي-الخزامى"}': {
    path: "/الخبر/حي-الخزامى",
    __typename: "DistrictType",
    district_id: 1076,
    name: "حي الخزامى",
    uri: "حي-الخزامى",
  },
  'DistrictType:{"path":"/الخبر/حي-السفن"}': {
    path: "/الخبر/حي-السفن",
    __typename: "DistrictType",
    district_id: 1088,
    name: "حي السفن",
    uri: "حي-السفن",
  },
  'DistrictType:{"path":"/الخبر/حي-الشراع"}': {
    path: "/الخبر/حي-الشراع",
    __typename: "DistrictType",
    district_id: 1090,
    name: "حي الشراع",
    uri: "حي-الشراع",
  },
  'DistrictType:{"path":"/الخبر/حي-الكوثر"}': {
    path: "/الخبر/حي-الكوثر",
    __typename: "DistrictType",
    district_id: 1100,
    name: "حي الكوثر",
    uri: "حي-الكوثر",
  },
  'DistrictType:{"path":"/الخبر/حي-اللؤلؤ"}': {
    path: "/الخبر/حي-اللؤلؤ",
    __typename: "DistrictType",
    district_id: 1104,
    name: "حي اللؤلؤ",
    uri: "حي-اللؤلؤ",
  },
  'DistrictType:{"path":"/الخبر/حي-الهدا"}': {
    path: "/الخبر/حي-الهدا",
    __typename: "DistrictType",
    district_id: 1112,
    name: "حي الهدا",
    uri: "حي-الهدا",
  },
  'DistrictType:{"path":"/الخفجي/حي-اللؤلؤة"}': {
    path: "/الخفجي/حي-اللؤلؤة",
    __typename: "DistrictType",
    district_id: 1158,
    name: "حي اللؤلؤة",
    uri: "حي-اللؤلؤة",
  },
  'DistrictType:{"path":"/الدمام/حي-الاثير"}': {
    path: "/الدمام/حي-الاثير",
    __typename: "DistrictType",
    district_id: 1186,
    name: "حي الاثير",
    uri: "حي-الاثير",
  },
  'DistrictType:{"path":"/الدمام/حي-البديع"}': {
    path: "/الدمام/حي-البديع",
    __typename: "DistrictType",
    district_id: 1200,
    name: "حي البديع",
    uri: "حي-البديع",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-الحصامة"}': {
    path: "/احد-المسارحة/حي-الحصامة",
    __typename: "DistrictType",
    district_id: 100,
    name: "حي الحصامة",
    uri: "حي-الحصامة",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-الروضة"}': {
    path: "/احد-المسارحة/حي-الروضة",
    __typename: "DistrictType",
    district_id: 104,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-مختارة"}': {
    path: "/احد-المسارحة/حي-مختارة",
    __typename: "DistrictType",
    district_id: 136,
    name: "حي مختارة",
    uri: "حي-مختارة",
  },
  'DistrictType:{"path":"/جازان/حي-البشائر"}': {
    path: "/جازان/حي-البشائر",
    __typename: "DistrictType",
    district_id: 142,
    name: "حي البشائر",
    uri: "حي-البشائر",
  },
  'DistrictType:{"path":"/جازان/حي-الروابي"}': {
    path: "/جازان/حي-الروابي",
    __typename: "DistrictType",
    district_id: 146,
    name: "حي الروابي",
    uri: "حي-الروابي",
  },
  'DistrictType:{"path":"/جازان/حي-القلعة"}': {
    path: "/جازان/حي-القلعة",
    __typename: "DistrictType",
    district_id: 160,
    name: "حي القلعة",
    uri: "حي-القلعة",
  },
  'DistrictType:{"path":"/جازان/حي-المنطقة-الصناعية"}': {
    path: "/جازان/حي-المنطقة-الصناعية",
    __typename: "DistrictType",
    district_id: 164,
    name: "حي المنطقة الصناعية",
    uri: "حي-المنطقة-الصناعية",
  },
  'DistrictType:{"path":"/جازان/حي-النور"}': {
    path: "/جازان/حي-النور",
    __typename: "DistrictType",
    district_id: 168,
    name: "حي النور",
    uri: "حي-النور",
  },
  'DistrictType:{"path":"/صبيا/حي-الرونة"}': {
    path: "/صبيا/حي-الرونة",
    __typename: "DistrictType",
    district_id: 200,
    name: "حي الرونة",
    uri: "حي-الرونة",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-غبيرة"}': {
    path: "/الرياض/وسط-الرياض/حي-غبيرة",
    __typename: "DistrictType",
    district_id: 702,
    name: "حي غبيرة",
    uri: "حي-غبيرة",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-غرناطة"}': {
    path: "/الرياض/شرق-الرياض/حي-غرناطة",
    __typename: "DistrictType",
    district_id: 704,
    name: "حي غرناطة",
    uri: "حي-غرناطة",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-مركز-الملك-عبدالله-للدراسات-والبحوث"}':
    {
      path: "/الرياض/شمال-الرياض/حي-مركز-الملك-عبدالله-للدراسات-والبحوث",
      __typename: "DistrictType",
      district_id: 710,
      name: "حي مركز الملك عبدالله للدراسات والبحوث",
      uri: "حي-مركز-الملك-عبدالله-للدراسات-والبحوث",
    },
  'DistrictType:{"path":"/الزلفي/حي-احد"}': {
    path: "/الزلفي/حي-احد",
    __typename: "DistrictType",
    district_id: 722,
    name: "حي احد",
    uri: "حي-احد",
  },
  'DistrictType:{"path":"/الزلفي/حي-الربوة"}': {
    path: "/الزلفي/حي-الربوة",
    __typename: "DistrictType",
    district_id: 730,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/الزلفي/حي-السيح"}': {
    path: "/الزلفي/حي-السيح",
    __typename: "DistrictType",
    district_id: 738,
    name: "حي السيح",
    uri: "حي-السيح",
  },
  'DistrictType:{"path":"/الزلفي/حي-حطين"}': {
    path: "/الزلفي/حي-حطين",
    __typename: "DistrictType",
    district_id: 764,
    name: "حي حطين",
    uri: "حي-حطين",
  },
  'DistrictType:{"path":"/الزلفي/حي-مرخ"}': {
    path: "/الزلفي/حي-مرخ",
    __typename: "DistrictType",
    district_id: 776,
    name: "حي مرخ",
    uri: "حي-مرخ",
  },
  'DistrictType:{"path":"/الغاط/حي-الصناعية"}': {
    path: "/الغاط/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 800,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/القطيف/حي-الجواهر"}': {
    path: "/القطيف/حي-الجواهر",
    __typename: "DistrictType",
    district_id: 1402,
    name: "حي الجواهر",
    uri: "حي-الجواهر",
  },
  'DistrictType:{"path":"/القطيف/حي-الخزامى"}': {
    path: "/القطيف/حي-الخزامى",
    __typename: "DistrictType",
    district_id: 1408,
    name: "حي الخزامى",
    uri: "حي-الخزامى",
  },
  'DistrictType:{"path":"/القطيف/حي-الخويلدية"}': {
    path: "/القطيف/حي-الخويلدية",
    __typename: "DistrictType",
    district_id: 1410,
    name: "حي الخويلدية",
    uri: "حي-الخويلدية",
  },
  'DistrictType:{"path":"/القطيف/حي-الدبابية"}': {
    path: "/القطيف/حي-الدبابية",
    __typename: "DistrictType",
    district_id: 1412,
    name: "حي الدبابية",
    uri: "حي-الدبابية",
  },
  'DistrictType:{"path":"/الشنان/حي-الصناعية"}': {
    path: "/الشنان/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 2002,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/تربه/حي-تربه"}': {
    path: "/تربه/حي-تربه",
    __typename: "DistrictType",
    district_id: 2016,
    name: "حي تربه",
    uri: "حي-تربه",
  },
  'DistrictType:{"path":"/حائل/حي-السويفلة"}': {
    path: "/حائل/حي-السويفلة",
    __typename: "DistrictType",
    district_id: 2036,
    name: "حي السويفلة",
    uri: "حي-السويفلة",
  },
  'DistrictType:{"path":"/البدائع/حي-البساتين"}': {
    path: "/البدائع/حي-البساتين",
    __typename: "DistrictType",
    district_id: 2070,
    name: "حي البساتين",
    uri: "حي-البساتين",
  },
  'DistrictType:{"path":"/البدائع/حي-ام-تلعة"}': {
    path: "/البدائع/حي-ام-تلعة",
    __typename: "DistrictType",
    district_id: 2098,
    name: "حي ام تلعة",
    uri: "حي-ام-تلعة",
  },
  'DistrictType:{"path":"/البدائع/حي-رامات"}': {
    path: "/البدائع/حي-رامات",
    __typename: "DistrictType",
    district_id: 2100,
    name: "حي رامات",
    uri: "حي-رامات",
  },
  'DistrictType:{"path":"/البكيرية/حي-البيضاء"}': {
    path: "/البكيرية/حي-البيضاء",
    __typename: "DistrictType",
    district_id: 2108,
    name: "حي البيضاء",
    uri: "حي-البيضاء",
  },
  'DistrictType:{"path":"/البكيرية/حي-النهضة"}': {
    path: "/البكيرية/حي-النهضة",
    __typename: "DistrictType",
    district_id: 2122,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/الرس/حي-الربوة"}': {
    path: "/الرس/حي-الربوة",
    __typename: "DistrictType",
    district_id: 2140,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/الرس/حي-الزهرة"}': {
    path: "/الرس/حي-الزهرة",
    __typename: "DistrictType",
    district_id: 2146,
    name: "حي الزهرة",
    uri: "حي-الزهرة",
  },
  'DistrictType:{"path":"/الرس/حي-الشفاء"}': {
    path: "/الرس/حي-الشفاء",
    __typename: "DistrictType",
    district_id: 2150,
    name: "حي الشفاء",
    uri: "حي-الشفاء",
  },
  'DistrictType:{"path":"/الرس/حي-الملك-فيصل"}': {
    path: "/الرس/حي-الملك-فيصل",
    __typename: "DistrictType",
    district_id: 2164,
    name: "حي الملك فيصل",
    uri: "حي-الملك-فيصل",
  },
  'DistrictType:{"path":"/الشماسية/حي-البدع"}': {
    path: "/الشماسية/حي-البدع",
    __typename: "DistrictType",
    district_id: 2174,
    name: "حي البدع",
    uri: "حي-البدع",
  },
  'DistrictType:{"path":"/الشماسية/حي-المتحف"}': {
    path: "/الشماسية/حي-المتحف",
    __typename: "DistrictType",
    district_id: 2192,
    name: "حي المتحف",
    uri: "حي-المتحف",
  },
  'DistrictType:{"path":"/الشماسية/حي-الميدان"}': {
    path: "/الشماسية/حي-الميدان",
    __typename: "DistrictType",
    district_id: 2196,
    name: "حي الميدان",
    uri: "حي-الميدان",
  },
  'DistrictType:{"path":"/الشماسية/حي-النخيل"}': {
    path: "/الشماسية/حي-النخيل",
    __typename: "DistrictType",
    district_id: 2198,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الفيصلية"}': {
    path: "/دومة-الجندل/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 2690,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-المطار"}': {
    path: "/دومة-الجندل/حي-المطار",
    __typename: "DistrictType",
    district_id: 2694,
    name: "حي المطار",
    uri: "حي-المطار",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-حصيدة"}': {
    path: "/دومة-الجندل/حي-حصيدة",
    __typename: "DistrictType",
    district_id: 2706,
    name: "حي حصيدة",
    uri: "حي-حصيدة",
  },
  'DistrictType:{"path":"/سكاكا/حي-الروابي-2"}': {
    path: "/سكاكا/حي-الروابي-2",
    __typename: "DistrictType",
    district_id: 2716,
    name: "حي الروابي 2",
    uri: "حي-الروابي-2",
  },
  'DistrictType:{"path":"/سكاكا/حي-الريان"}': {
    path: "/سكاكا/حي-الريان",
    __typename: "DistrictType",
    district_id: 2720,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'DistrictType:{"path":"/سكاكا/حي-الشلهوب"}': {
    path: "/سكاكا/حي-الشلهوب",
    __typename: "DistrictType",
    district_id: 2726,
    name: "حي الشلهوب",
    uri: "حي-الشلهوب",
  },
  'DistrictType:{"path":"/سكاكا/حي-العزيزية"}': {
    path: "/سكاكا/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 2732,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/سكاكا/حي-الفاروق"}': {
    path: "/سكاكا/حي-الفاروق",
    __typename: "DistrictType",
    district_id: 2736,
    name: "حي الفاروق",
    uri: "حي-الفاروق",
  },
  'DistrictType:{"path":"/سكاكا/حي-المحمدية-م"}': {
    path: "/سكاكا/حي-المحمدية-م",
    __typename: "DistrictType",
    district_id: 2748,
    name: "حي المحمدية م",
    uri: "حي-المحمدية-م",
  },
  'DistrictType:{"path":"/سكاكا/حي-المعاقلة"}': {
    path: "/سكاكا/حي-المعاقلة",
    __typename: "DistrictType",
    district_id: 2760,
    name: "حي المعاقلة",
    uri: "حي-المعاقلة",
  },
  'DistrictType:{"path":"/سكاكا/حي-النفل"}': {
    path: "/سكاكا/حي-النفل",
    __typename: "DistrictType",
    district_id: 2764,
    name: "حي النفل",
    uri: "حي-النفل",
  },
  'DistrictType:{"path":"/سكاكا/حي-الهدا"}': {
    path: "/سكاكا/حي-الهدا",
    __typename: "DistrictType",
    district_id: 2766,
    name: "حي الهدا",
    uri: "حي-الهدا",
  },
  'DistrictType:{"path":"/سكاكا/حي-شمال-النفل"}': {
    path: "/سكاكا/حي-شمال-النفل",
    __typename: "DistrictType",
    district_id: 2774,
    name: "حي شمال النفل",
    uri: "حي-شمال-النفل",
  },
  'DistrictType:{"path":"/سكاكا/حي-مخطط-الفياض"}': {
    path: "/سكاكا/حي-مخطط-الفياض",
    __typename: "DistrictType",
    district_id: 2790,
    name: "حي مخطط الفياض",
    uri: "حي-مخطط-الفياض",
  },
  'DistrictType:{"path":"/سكاكا/حي-مخطط-الفيصلي"}': {
    path: "/سكاكا/حي-مخطط-الفيصلي",
    __typename: "DistrictType",
    district_id: 2792,
    name: "حي مخطط الفيصلي",
    uri: "حي-مخطط-الفيصلي",
  },
  'DistrictType:{"path":"/سكاكا/حي-مخطط-المنح-الخاصة"}': {
    path: "/سكاكا/حي-مخطط-المنح-الخاصة",
    __typename: "DistrictType",
    district_id: 2796,
    name: "حي مخطط المنح الخاصة",
    uri: "حي-مخطط-المنح-الخاصة",
  },
  'DistrictType:{"path":"/سكاكا/حي-مخطط-غرب-الاقليمي"}': {
    path: "/سكاكا/حي-مخطط-غرب-الاقليمي",
    __typename: "DistrictType",
    district_id: 2800,
    name: "حي مخطط غرب الاقليمي",
    uri: "حي-مخطط-غرب-الاقليمي",
  },
  'DistrictType:{"path":"/سكاكا/حي-مخطط-كريم-الدرزي"}': {
    path: "/سكاكا/حي-مخطط-كريم-الدرزي",
    __typename: "DistrictType",
    district_id: 2802,
    name: "حي مخطط كريم الدرزي",
    uri: "حي-مخطط-كريم-الدرزي",
  },
  'DistrictType:{"path":"/عنيزة/حي-الروضة"}': {
    path: "/عنيزة/حي-الروضة",
    __typename: "DistrictType",
    district_id: 2510,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/عنيزة/حي-الزاهر"}': {
    path: "/عنيزة/حي-الزاهر",
    __typename: "DistrictType",
    district_id: 2518,
    name: "حي الزاهر",
    uri: "حي-الزاهر",
  },
  'DistrictType:{"path":"/عنيزة/حي-السلام"}': {
    path: "/عنيزة/حي-السلام",
    __typename: "DistrictType",
    district_id: 2526,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/عنيزة/حي-السليمانية"}': {
    path: "/عنيزة/حي-السليمانية",
    __typename: "DistrictType",
    district_id: 2528,
    name: "حي السليمانية",
    uri: "حي-السليمانية",
  },
  'DistrictType:{"path":"/عنيزة/حي-الشعيب"}': {
    path: "/عنيزة/حي-الشعيب",
    __typename: "DistrictType",
    district_id: 2530,
    name: "حي الشعيب",
    uri: "حي-الشعيب",
  },
  'DistrictType:{"path":"/عنيزة/حي-الصفا"}': {
    path: "/عنيزة/حي-الصفا",
    __typename: "DistrictType",
    district_id: 2536,
    name: "حي الصفا",
    uri: "حي-الصفا",
  },
  'DistrictType:{"path":"/عنيزة/حي-الصفراء"}': {
    path: "/عنيزة/حي-الصفراء",
    __typename: "DistrictType",
    district_id: 2538,
    name: "حي الصفراء",
    uri: "حي-الصفراء",
  },
  'DistrictType:{"path":"/عنيزة/حي-الفيصلية"}': {
    path: "/عنيزة/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 2556,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/عنيزة/حي-المحمدية"}': {
    path: "/عنيزة/حي-المحمدية",
    __typename: "DistrictType",
    district_id: 2566,
    name: "حي المحمدية",
    uri: "حي-المحمدية",
  },
  'DistrictType:{"path":"/عنيزة/حي-المدوية"}': {
    path: "/عنيزة/حي-المدوية",
    __typename: "DistrictType",
    district_id: 2568,
    name: "حي المدوية",
    uri: "حي-المدوية",
  },
  'DistrictType:{"path":"/عنيزة/حي-المروج"}': {
    path: "/عنيزة/حي-المروج",
    __typename: "DistrictType",
    district_id: 2572,
    name: "حي المروج",
    uri: "حي-المروج",
  },
  'DistrictType:{"path":"/عنيزة/حي-المستودعات"}': {
    path: "/عنيزة/حي-المستودعات",
    __typename: "DistrictType",
    district_id: 2574,
    name: "حي المستودعات",
    uri: "حي-المستودعات",
  },
  'DistrictType:{"path":"/عنيزة/حي-الملك-خالد"}': {
    path: "/عنيزة/حي-الملك-خالد",
    __typename: "DistrictType",
    district_id: 2580,
    name: "حي الملك خالد",
    uri: "حي-الملك-خالد",
  },
  'DistrictType:{"path":"/عنيزة/حي-المنار"}': {
    path: "/عنيزة/حي-المنار",
    __typename: "DistrictType",
    district_id: 2584,
    name: "حي المنار",
    uri: "حي-المنار",
  },
  'DistrictType:{"path":"/عنيزة/حي-المنطقة-الصناعية-الثانية"}': {
    path: "/عنيزة/حي-المنطقة-الصناعية-الثانية",
    __typename: "DistrictType",
    district_id: 2590,
    name: "حي المنطقة الصناعية الثانية",
    uri: "حي-المنطقة-الصناعية-الثانية",
  },
  'DistrictType:{"path":"/عنيزة/حي-الواحة"}': {
    path: "/عنيزة/حي-الواحة",
    __typename: "DistrictType",
    district_id: 2606,
    name: "حي الواحة",
    uri: "حي-الواحة",
  },
  'DistrictType:{"path":"/الهفوف/حي-النزهة"}': {
    path: "/الهفوف/حي-النزهة",
    __typename: "DistrictType",
    district_id: 1634,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/الهفوف/حي-الهدى"}': {
    path: "/الهفوف/حي-الهدى",
    __typename: "DistrictType",
    district_id: 1638,
    name: "حي الهدى",
    uri: "حي-الهدى",
  },
  'DistrictType:{"path":"/الهفوف/حي-اليحيى"}': {
    path: "/الهفوف/حي-اليحيى",
    __typename: "DistrictType",
    district_id: 1644,
    name: "حي اليحيى",
    uri: "حي-اليحيى",
  },
  'DistrictType:{"path":"/الهفوف/حي-جامعة-الملك-فيصل"}': {
    path: "/الهفوف/حي-جامعة-الملك-فيصل",
    __typename: "DistrictType",
    district_id: 1650,
    name: "حي جامعة الملك فيصل",
    uri: "حي-جامعة-الملك-فيصل",
  },
  'DistrictType:{"path":"/الهفوف/حي-جنوب-الهفوف"}': {
    path: "/الهفوف/حي-جنوب-الهفوف",
    __typename: "DistrictType",
    district_id: 1652,
    name: "حي جنوب الهفوف",
    uri: "حي-جنوب-الهفوف",
  },
  'DistrictType:{"path":"/الهفوف/حي-حي-الزهراء"}': {
    path: "/الهفوف/حي-حي-الزهراء",
    __typename: "DistrictType",
    district_id: 1658,
    name: "حي حي الزهراء",
    uri: "حي-حي-الزهراء",
  },
  'DistrictType:{"path":"/الهفوف/حي-عبداللطيف-العيسى"}': {
    path: "/الهفوف/حي-عبداللطيف-العيسى",
    __typename: "DistrictType",
    district_id: 1660,
    name: "حي عبداللطيف العيسى",
    uri: "حي-عبداللطيف-العيسى",
  },
  'DistrictType:{"path":"/بقيق/حي-اشبيلية"}': {
    path: "/بقيق/حي-اشبيلية",
    __typename: "DistrictType",
    district_id: 1680,
    name: "حي اشبيلية",
    uri: "حي-اشبيلية",
  },
  'DistrictType:{"path":"/بقيق/حي-الاندلس"}': {
    path: "/بقيق/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 1682,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/بقيق/حي-الربوة"}': {
    path: "/بقيق/حي-الربوة",
    __typename: "DistrictType",
    district_id: 1686,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/بقيق/حي-الروضة"}': {
    path: "/بقيق/حي-الروضة",
    __typename: "DistrictType",
    district_id: 1688,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/تاروت/حي-الجامعيين"}': {
    path: "/تاروت/حي-الجامعيين",
    __typename: "DistrictType",
    district_id: 1708,
    name: "حي الجامعيين",
    uri: "حي-الجامعيين",
  },
  'DistrictType:{"path":"/بريدة/حي-مشعل"}': {
    path: "/بريدة/حي-مشعل",
    __typename: "DistrictType",
    district_id: 2410,
    name: "حي مشعل",
    uri: "حي-مشعل",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-الريان"}': {
    path: "/رياض-الخبراء/حي-الريان",
    __typename: "DistrictType",
    district_id: 2436,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-السحابين-الجنوبي"}': {
    path: "/رياض-الخبراء/حي-السحابين-الجنوبي",
    __typename: "DistrictType",
    district_id: 2438,
    name: "حي السحابين الجنوبي",
    uri: "حي-السحابين-الجنوبي",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-القادسية"}': {
    path: "/رياض-الخبراء/حي-القادسية",
    __typename: "DistrictType",
    district_id: 2446,
    name: "حي القادسية",
    uri: "حي-القادسية",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-النزهة"}': {
    path: "/رياض-الخبراء/حي-النزهة",
    __typename: "DistrictType",
    district_id: 2452,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/عنيزة/حي-الاشرفية"}': {
    path: "/عنيزة/حي-الاشرفية",
    __typename: "DistrictType",
    district_id: 2464,
    name: "حي الاشرفية",
    uri: "حي-الاشرفية",
  },
  'DistrictType:{"path":"/عنيزة/حي-الثقافة"}': {
    path: "/عنيزة/حي-الثقافة",
    __typename: "DistrictType",
    district_id: 2474,
    name: "حي الثقافة",
    uri: "حي-الثقافة",
  },
  'DistrictType:{"path":"/عنيزة/حي-الحاجب"}': {
    path: "/عنيزة/حي-الحاجب",
    __typename: "DistrictType",
    district_id: 2484,
    name: "حي الحاجب",
    uri: "حي-الحاجب",
  },
  'DistrictType:{"path":"/عنيزة/حي-الحمراء"}': {
    path: "/عنيزة/حي-الحمراء",
    __typename: "DistrictType",
    district_id: 2492,
    name: "حي الحمراء",
    uri: "حي-الحمراء",
  },
  'DistrictType:{"path":"/عنيزة/حي-الذهبي"}': {
    path: "/عنيزة/حي-الذهبي",
    __typename: "DistrictType",
    district_id: 2502,
    name: "حي الذهبي",
    uri: "حي-الذهبي",
  },
  'DistrictType:{"path":"/عنيزة/حي-الرمال"}': {
    path: "/عنيزة/حي-الرمال",
    __typename: "DistrictType",
    district_id: 2506,
    name: "حي الرمال",
    uri: "حي-الرمال",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-غرناطة"}': {
    path: "/حفر-الباطن/حي-غرناطة",
    __typename: "DistrictType",
    district_id: 1806,
    name: "حي غرناطة",
    uri: "حي-غرناطة",
  },
  'DistrictType:{"path":"/راس-تنورة/حي-المنتزة"}': {
    path: "/راس-تنورة/حي-المنتزة",
    __typename: "DistrictType",
    district_id: 1824,
    name: "حي المنتزة",
    uri: "حي-المنتزة",
  },
  'DistrictType:{"path":"/سيهات/حي-الديرة"}': {
    path: "/سيهات/حي-الديرة",
    __typename: "DistrictType",
    district_id: 1834,
    name: "حي الديرة",
    uri: "حي-الديرة",
  },
  'DistrictType:{"path":"/سيهات/حي-قرطبة"}': {
    path: "/سيهات/حي-قرطبة",
    __typename: "DistrictType",
    district_id: 1864,
    name: "حي قرطبة",
    uri: "حي-قرطبة",
  },
  'DistrictType:{"path":"/صفوى/حي-الصفاء"}': {
    path: "/صفوى/حي-الصفاء",
    __typename: "DistrictType",
    district_id: 1886,
    name: "حي الصفاء",
    uri: "حي-الصفاء",
  },
  'DistrictType:{"path":"/صفوى/حي-المروة"}': {
    path: "/صفوى/حي-المروة",
    __typename: "DistrictType",
    district_id: 1892,
    name: "حي المروة",
    uri: "حي-المروة",
  },
  'DistrictType:{"path":"/صفوى/حي-المصيف"}': {
    path: "/صفوى/حي-المصيف",
    __typename: "DistrictType",
    district_id: 1894,
    name: "حي المصيف",
    uri: "حي-المصيف",
  },
  'DistrictType:{"path":"/عنك/حي-المحار"}': {
    path: "/عنك/حي-المحار",
    __typename: "DistrictType",
    district_id: 1910,
    name: "حي المحار",
    uri: "حي-المحار",
  },
  'DistrictType:{"path":"/رفحاء/حي-الاسكان-التنموي"}': {
    path: "/رفحاء/حي-الاسكان-التنموي",
    __typename: "DistrictType",
    district_id: 1914,
    name: "حي الاسكان التنموي",
    uri: "حي-الاسكان-التنموي",
  },
  'DistrictType:{"path":"/رفحاء/حي-الصناعية"}': {
    path: "/رفحاء/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 1922,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/عرعر/حي-الصالحية"}': {
    path: "/عرعر/حي-الصالحية",
    __typename: "DistrictType",
    district_id: 1976,
    name: "حي الصالحية",
    uri: "حي-الصالحية",
  },
  'DistrictType:{"path":"/عرعر/حي-المحمدية"}': {
    path: "/عرعر/حي-المحمدية",
    __typename: "DistrictType",
    district_id: 1982,
    name: "حي المحمدية",
    uri: "حي-المحمدية",
  },
  'DistrictType:{"path":"/الشنان/حي-الازدهار"}': {
    path: "/الشنان/حي-الازدهار",
    __typename: "DistrictType",
    district_id: 1992,
    name: "حي الازدهار",
    uri: "حي-الازدهار",
  },
  'DistrictType:{"path":"/المذنب/حي-البستان"}': {
    path: "/المذنب/حي-البستان",
    __typename: "DistrictType",
    district_id: 2220,
    name: "حي البستان",
    uri: "حي-البستان",
  },
  'DistrictType:{"path":"/المذنب/حي-القادسية"}': {
    path: "/المذنب/حي-القادسية",
    __typename: "DistrictType",
    district_id: 2240,
    name: "حي القادسية",
    uri: "حي-القادسية",
  },
  'DistrictType:{"path":"/المذنب/حي-الورود"}': {
    path: "/المذنب/حي-الورود",
    __typename: "DistrictType",
    district_id: 2248,
    name: "حي الورود",
    uri: "حي-الورود",
  },
  'DistrictType:{"path":"/بريدة/حي-الريان"}': {
    path: "/بريدة/حي-الريان",
    __typename: "DistrictType",
    district_id: 2304,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'DistrictType:{"path":"/بريدة/حي-الزرقاء"}': {
    path: "/بريدة/حي-الزرقاء",
    __typename: "DistrictType",
    district_id: 2306,
    name: "حي الزرقاء",
    uri: "حي-الزرقاء",
  },
  'DistrictType:{"path":"/بريدة/حي-السالمية"}': {
    path: "/بريدة/حي-السالمية",
    __typename: "DistrictType",
    district_id: 2310,
    name: "حي السالمية",
    uri: "حي-السالمية",
  },
  'DistrictType:{"path":"/بريدة/حي-الشقة"}': {
    path: "/بريدة/حي-الشقة",
    __typename: "DistrictType",
    district_id: 2314,
    name: "حي الشقة",
    uri: "حي-الشقة",
  },
  'DistrictType:{"path":"/بريدة/حي-الصفراء"}': {
    path: "/بريدة/حي-الصفراء",
    __typename: "DistrictType",
    district_id: 2322,
    name: "حي الصفراء",
    uri: "حي-الصفراء",
  },
  'DistrictType:{"path":"/بريدة/حي-المنتزه"}': {
    path: "/بريدة/حي-المنتزه",
    __typename: "DistrictType",
    district_id: 2356,
    name: "حي المنتزه",
    uri: "حي-المنتزه",
  },
  'DistrictType:{"path":"/بريدة/حي-الناصرية"}': {
    path: "/بريدة/حي-الناصرية",
    __typename: "DistrictType",
    district_id: 2364,
    name: "حي الناصرية",
    uri: "حي-الناصرية",
  },
  'DistrictType:{"path":"/بريدة/حي-النصار"}': {
    path: "/بريدة/حي-النصار",
    __typename: "DistrictType",
    district_id: 2368,
    name: "حي النصار",
    uri: "حي-النصار",
  },
  'DistrictType:{"path":"/بريدة/حي-الورش-الجنوبية"}': {
    path: "/بريدة/حي-الورش-الجنوبية",
    __typename: "DistrictType",
    district_id: 2376,
    name: "حي الورش الجنوبية",
    uri: "حي-الورش-الجنوبية",
  },
  'DistrictType:{"path":"/بريدة/حي-الوسيطى"}': {
    path: "/بريدة/حي-الوسيطى",
    __typename: "DistrictType",
    district_id: 2378,
    name: "حي الوسيطى",
    uri: "حي-الوسيطى",
  },
  'DistrictType:{"path":"/بريدة/حي-خب-الكيفة"}': {
    path: "/بريدة/حي-خب-الكيفة",
    __typename: "DistrictType",
    district_id: 2394,
    name: "حي خب الكيفة",
    uri: "حي-خب-الكيفة",
  },
  'DistrictType:{"path":"/بريدة/حي-سلطانة"}': {
    path: "/بريدة/حي-سلطانة",
    __typename: "DistrictType",
    district_id: 2402,
    name: "حي سلطانة",
    uri: "حي-سلطانة",
  },
  'DistrictType:{"path":"/تاروت/حي-الجبل"}': {
    path: "/تاروت/حي-الجبل",
    __typename: "DistrictType",
    district_id: 1710,
    name: "حي الجبل",
    uri: "حي-الجبل",
  },
  'DistrictType:{"path":"/تاروت/حي-الديرة"}': {
    path: "/تاروت/حي-الديرة",
    __typename: "DistrictType",
    district_id: 1714,
    name: "حي الديرة",
    uri: "حي-الديرة",
  },
  'DistrictType:{"path":"/تاروت/حي-الربيعية"}': {
    path: "/تاروت/حي-الربيعية",
    __typename: "DistrictType",
    district_id: 1716,
    name: "حي الربيعية",
    uri: "حي-الربيعية",
  },
  'DistrictType:{"path":"/تاروت/حي-الزور"}': {
    path: "/تاروت/حي-الزور",
    __typename: "DistrictType",
    district_id: 1720,
    name: "حي الزور",
    uri: "حي-الزور",
  },
  'DistrictType:{"path":"/تاروت/حي-الصدفة"}': {
    path: "/تاروت/حي-الصدفة",
    __typename: "DistrictType",
    district_id: 1722,
    name: "حي الصدفة",
    uri: "حي-الصدفة",
  },
  'DistrictType:{"path":"/تاروت/حي-سنابس"}': {
    path: "/تاروت/حي-سنابس",
    __typename: "DistrictType",
    district_id: 1738,
    name: "حي سنابس",
    uri: "حي-سنابس",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-البلدية"}': {
    path: "/حفر-الباطن/حي-البلدية",
    __typename: "DistrictType",
    district_id: 1746,
    name: "حي البلدية",
    uri: "حي-البلدية",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الخالدية"}': {
    path: "/حفر-الباطن/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 1752,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الصناعية"}': {
    path: "/حفر-الباطن/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 1774,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-العزيزية"}': {
    path: "/حفر-الباطن/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 1776,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الفيحاء"}': {
    path: "/حفر-الباطن/حي-الفيحاء",
    __typename: "DistrictType",
    district_id: 1778,
    name: "حي الفيحاء",
    uri: "حي-الفيحاء",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-المحمدية"}': {
    path: "/حفر-الباطن/حي-المحمدية",
    __typename: "DistrictType",
    district_id: 1782,
    name: "حي المحمدية",
    uri: "حي-المحمدية",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-المصيف"}': {
    path: "/حفر-الباطن/حي-المصيف",
    __typename: "DistrictType",
    district_id: 1786,
    name: "حي المصيف",
    uri: "حي-المصيف",
  },
  'DistrictType:{"path":"/عنيزة/حي-الوفاء"}': {
    path: "/عنيزة/حي-الوفاء",
    __typename: "DistrictType",
    district_id: 2612,
    name: "حي الوفاء",
    uri: "حي-الوفاء",
  },
  'DistrictType:{"path":"/عنيزة/حي-اليمامة"}': {
    path: "/عنيزة/حي-اليمامة",
    __typename: "DistrictType",
    district_id: 2618,
    name: "حي اليمامة",
    uri: "حي-اليمامة",
  },
  'DistrictType:{"path":"/عنيزة/حي-حطين"}': {
    path: "/عنيزة/حي-حطين",
    __typename: "DistrictType",
    district_id: 2622,
    name: "حي حطين",
    uri: "حي-حطين",
  },
  'DistrictType:{"path":"/عنيزة/حي-سوق-المواشي"}': {
    path: "/عنيزة/حي-سوق-المواشي",
    __typename: "DistrictType",
    district_id: 2630,
    name: "حي سوق المواشي",
    uri: "حي-سوق-المواشي",
  },
  'DistrictType:{"path":"/عنيزة/حي-مريبدة"}': {
    path: "/عنيزة/حي-مريبدة",
    __typename: "DistrictType",
    district_id: 2638,
    name: "حي مريبدة",
    uri: "حي-مريبدة",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الخالدية"}': {
    path: "/دومة-الجندل/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 2660,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الزراعي"}': {
    path: "/دومة-الجندل/حي-الزراعي",
    __typename: "DistrictType",
    district_id: 2666,
    name: "حي الزراعي",
    uri: "حي-الزراعي",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الصفاه-الشمالي"}': {
    path: "/دومة-الجندل/حي-الصفاه-الشمالي",
    __typename: "DistrictType",
    district_id: 2676,
    name: "حي الصفاه الشمالي",
    uri: "حي-الصفاه-الشمالي",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الهندواية"}': {
    path: "/جدة/جنوب-جدة/حي-الهندواية",
    __typename: "DistrictType",
    district_id: 3612,
    name: "حي الهندواية",
    uri: "حي-الهندواية",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الوزيرية"}': {
    path: "/جدة/جنوب-جدة/حي-الوزيرية",
    __typename: "DistrictType",
    district_id: 3620,
    name: "حي الوزيرية",
    uri: "حي-الوزيرية",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الياقوت"}': {
    path: "/جدة/شمال-جدة/حي-الياقوت",
    __typename: "DistrictType",
    district_id: 3622,
    name: "حي الياقوت",
    uri: "حي-الياقوت",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-بترومين"}': {
    path: "/جدة/جنوب-جدة/حي-بترومين",
    __typename: "DistrictType",
    district_id: 3628,
    name: "حي بترومين",
    uri: "حي-بترومين",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-بريمان"}': {
    path: "/جدة/شمال-جدة/حي-بريمان",
    __typename: "DistrictType",
    district_id: 3632,
    name: "حي بريمان",
    uri: "حي-بريمان",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-مدائن-الفهد"}': {
    path: "/جدة/جنوب-جدة/حي-مدائن-الفهد",
    __typename: "DistrictType",
    district_id: 3642,
    name: "حي مدائن الفهد",
    uri: "حي-مدائن-الفهد",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-مطار-الملك-عبدالعزيز-الدولي"}': {
    path: "/جدة/شمال-جدة/حي-مطار-الملك-عبدالعزيز-الدولي",
    __typename: "DistrictType",
    district_id: 3650,
    name: "حي مطار الملك عبدالعزيز الدولي",
    uri: "حي-مطار-الملك-عبدالعزيز-الدولي",
  },
  'DistrictType:{"path":"/رابغ/حي-الصليب-الغربي"}': {
    path: "/رابغ/حي-الصليب-الغربي",
    __typename: "DistrictType",
    district_id: 3654,
    name: "حي الصليب الغربي",
    uri: "حي-الصليب-الغربي",
  },
  'CityType:{"uri":"رابغ"}': {
    uri: "رابغ",
    __typename: "CityType",
    city_id: 73,
    name: "رابغ",
    path: "/رابغ",
  },
  'DistrictType:{"path":"/رابغ/حي-الفرنيسية-الشرقية"}': {
    path: "/رابغ/حي-الفرنيسية-الشرقية",
    __typename: "DistrictType",
    district_id: 3664,
    name: "حي الفرنيسية الشرقية",
    uri: "حي-الفرنيسية-الشرقية",
  },
  'DistrictType:{"path":"/رنية/حي-رنية"}': {
    path: "/رنية/حي-رنية",
    __typename: "DistrictType",
    district_id: 3666,
    name: "حي رنية",
    uri: "حي-رنية",
  },
  'CityType:{"uri":"رنية"}': {
    uri: "رنية",
    __typename: "CityType",
    city_id: 77,
    name: "رنية",
    path: "/رنية",
  },
  'DistrictType:{"path":"/مدينة-الملك-عبدالله-الاقتصادية/حي-منطقة-محطة-القطار"}':
    {
      path: "/مدينة-الملك-عبدالله-الاقتصادية/حي-منطقة-محطة-القطار",
      __typename: "DistrictType",
      district_id: 3680,
      name: "حي منطقة محطة القطار",
      uri: "حي-منطقة-محطة-القطار",
    },

  'DistrictType:{"path":"/مكة-المكرمة/حي-التيسير"}': {
    path: "/مكة-المكرمة/حي-التيسير",
    __typename: "DistrictType",
    district_id: 3694,
    name: "حي التيسير",
    uri: "حي-التيسير",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الخنساء"}': {
    path: "/مكة-المكرمة/حي-الخنساء",
    __typename: "DistrictType",
    district_id: 3710,
    name: "حي الخنساء",
    uri: "حي-الخنساء",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الرصيفة"}': {
    path: "/مكة-المكرمة/حي-الرصيفة",
    __typename: "DistrictType",
    district_id: 3714,
    name: "حي الرصيفة",
    uri: "حي-الرصيفة",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الزاهر"}': {
    path: "/مكة-المكرمة/حي-الزاهر",
    __typename: "DistrictType",
    district_id: 3720,
    name: "حي الزاهر",
    uri: "حي-الزاهر",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الزهراء"}': {
    path: "/مكة-المكرمة/حي-الزهراء",
    __typename: "DistrictType",
    district_id: 3722,
    name: "حي الزهراء",
    uri: "حي-الزهراء",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-السليمانية"}': {
    path: "/مكة-المكرمة/حي-السليمانية",
    __typename: "DistrictType",
    district_id: 3726,
    name: "حي السليمانية",
    uri: "حي-السليمانية",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الشبيكة"}': {
    path: "/مكة-المكرمة/حي-الشبيكة",
    __typename: "DistrictType",
    district_id: 3728,
    name: "حي الشبيكة",
    uri: "حي-الشبيكة",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الشوقية"}': {
    path: "/مكة-المكرمة/حي-الشوقية",
    __typename: "DistrictType",
    district_id: 3734,
    name: "حي الشوقية",
    uri: "حي-الشوقية",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-العزيزية"}': {
    path: "/مكة-المكرمة/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 3744,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-العسيلة"}': {
    path: "/مكة-المكرمة/حي-العسيلة",
    __typename: "DistrictType",
    district_id: 3746,
    name: "حي العسيلة",
    uri: "حي-العسيلة",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-العمرة-الجديدة"}': {
    path: "/مكة-المكرمة/حي-العمرة-الجديدة",
    __typename: "DistrictType",
    district_id: 3750,
    name: "حي العمرة الجديدة",
    uri: "حي-العمرة-الجديدة",
  },
  'DistrictType:{"path":"/ابها/حي-ابها-الجديدة"}': {
    path: "/ابها/حي-ابها-الجديدة",
    __typename: "DistrictType",
    district_id: 3784,
    name: "حي ابها الجديدة",
    uri: "حي-ابها-الجديدة",
  },
  'DistrictType:{"path":"/ابها/حي-السد"}': {
    path: "/ابها/حي-السد",
    __typename: "DistrictType",
    district_id: 3794,
    name: "حي السد",
    uri: "حي-السد",
  },
  'DistrictType:{"path":"/ابها/حي-الشرفية"}': {
    path: "/ابها/حي-الشرفية",
    __typename: "DistrictType",
    district_id: 3798,
    name: "حي الشرفية",
    uri: "حي-الشرفية",
  },
  'DistrictType:{"path":"/ابها/حي-العزيزية"}': {
    path: "/ابها/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 3806,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/ابها/حي-الفيصلي"}': {
    path: "/ابها/حي-الفيصلي",
    __typename: "DistrictType",
    district_id: 3808,
    name: "حي الفيصلي",
    uri: "حي-الفيصلي",
  },
  'DistrictType:{"path":"/تربه/حي-كرا-السردي"}': {
    path: "/تربه/حي-كرا-السردي",
    __typename: "DistrictType",
    district_id: 3410,
    name: "حي كرا السردي",
    uri: "حي-كرا-السردي",
  },
  'DistrictType:{"path":"/تربه/حي-منيف"}': {
    path: "/تربه/حي-منيف",
    __typename: "DistrictType",
    district_id: 3412,
    name: "حي منيف",
    uri: "حي-منيف",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-ابحر-الشمالية"}': {
    path: "/جدة/شمال-جدة/حي-ابحر-الشمالية",
    __typename: "DistrictType",
    district_id: 3424,
    name: "حي ابحر الشمالية",
    uri: "حي-ابحر-الشمالية",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الاجاويد"}': {
    path: "/جدة/جنوب-جدة/حي-الاجاويد",
    __typename: "DistrictType",
    district_id: 3428,
    name: "حي الاجاويد",
    uri: "حي-الاجاويد",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الامواج"}': {
    path: "/جدة/شمال-جدة/حي-الامواج",
    __typename: "DistrictType",
    district_id: 3432,
    name: "حي الامواج",
    uri: "حي-الامواج",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الاندلس"}': {
    path: "/جدة/شمال-جدة/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 3440,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-التعاون"}': {
    path: "/جدة/جنوب-جدة/حي-التعاون",
    __typename: "DistrictType",
    district_id: 3458,
    name: "حي التعاون",
    uri: "حي-التعاون",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الثغر"}': {
    path: "/جدة/جنوب-جدة/حي-الثغر",
    __typename: "DistrictType",
    district_id: 3462,
    name: "حي الثغر",
    uri: "حي-الثغر",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الجامعة"}': {
    path: "/جدة/جنوب-جدة/حي-الجامعة",
    __typename: "DistrictType",
    district_id: 3464,
    name: "حي الجامعة",
    uri: "حي-الجامعة",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الخمرة"}': {
    path: "/جدة/جنوب-جدة/حي-الخمرة",
    __typename: "DistrictType",
    district_id: 3474,
    name: "حي الخمرة",
    uri: "حي-الخمرة",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الربوة"}': {
    path: "/جدة/شمال-جدة/حي-الربوة",
    __typename: "DistrictType",
    district_id: 3476,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-السروات"}': {
    path: "/جدة/جنوب-جدة/حي-السروات",
    __typename: "DistrictType",
    district_id: 3504,
    name: "حي السروات",
    uri: "حي-السروات",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الصناعية"}': {
    path: "/جدة/جنوب-جدة/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 3530,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الصوارى"}': {
    path: "/جدة/شمال-جدة/حي-الصوارى",
    __typename: "DistrictType",
    district_id: 3532,
    name: "حي الصوارى",
    uri: "حي-الصوارى",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الضاحية"}': {
    path: "/جدة/جنوب-جدة/حي-الضاحية",
    __typename: "DistrictType",
    district_id: 3534,
    name: "حي الضاحية",
    uri: "حي-الضاحية",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-المحجر"}': {
    path: "/جدة/جنوب-جدة/حي-المحجر",
    __typename: "DistrictType",
    district_id: 3576,
    name: "حي المحجر",
    uri: "حي-المحجر",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-المدينة-الصناعية-الثانية"}': {
    path: "/جدة/جنوب-جدة/حي-المدينة-الصناعية-الثانية",
    __typename: "DistrictType",
    district_id: 3582,
    name: "حي المدينة الصناعية الثانية",
    uri: "حي-المدينة-الصناعية-الثانية",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-المرجان"}': {
    path: "/جدة/شمال-جدة/حي-المرجان",
    __typename: "DistrictType",
    district_id: 3584,
    name: "حي المرجان",
    uri: "حي-المرجان",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-المسرة"}': {
    path: "/جدة/جنوب-جدة/حي-المسرة",
    __typename: "DistrictType",
    district_id: 3588,
    name: "حي المسرة",
    uri: "حي-المسرة",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-النخيل"}': {
    path: "/جدة/شمال-جدة/حي-النخيل",
    __typename: "DistrictType",
    district_id: 3596,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-النسيم"}': {
    path: "/جدة/شمال-جدة/حي-النسيم",
    __typename: "DistrictType",
    district_id: 3604,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-الصقور"}': {
    path: "/خميس-مشيط/حي-الصقور",
    __typename: "DistrictType",
    district_id: 4030,
    name: "حي الصقور",
    uri: "حي-الصقور",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-المعزاب"}': {
    path: "/خميس-مشيط/حي-المعزاب",
    __typename: "DistrictType",
    district_id: 4046,
    name: "حي المعزاب",
    uri: "حي-المعزاب",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-المعمورة"}': {
    path: "/خميس-مشيط/حي-المعمورة",
    __typename: "DistrictType",
    district_id: 4048,
    name: "حي المعمورة",
    uri: "حي-المعمورة",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-الهرير"}': {
    path: "/خميس-مشيط/حي-الهرير",
    __typename: "DistrictType",
    district_id: 4060,
    name: "حي الهرير",
    uri: "حي-الهرير",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-شكر"}': {
    path: "/خميس-مشيط/حي-شكر",
    __typename: "DistrictType",
    district_id: 4076,
    name: "حي شكر",
    uri: "حي-شكر",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-ضمك"}': {
    path: "/خميس-مشيط/حي-ضمك",
    __typename: "DistrictType",
    district_id: 4078,
    name: "حي ضمك",
    uri: "حي-ضمك",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-قمبر"}': {
    path: "/خميس-مشيط/حي-قمبر",
    __typename: "DistrictType",
    district_id: 4084,
    name: "حي قمبر",
    uri: "حي-قمبر",
  },
  'DistrictType:{"path":"/محايل/حي-البصرة"}': {
    path: "/محايل/حي-البصرة",
    __typename: "DistrictType",
    district_id: 4088,
    name: "حي البصرة",
    uri: "حي-البصرة",
  },
  'DistrictType:{"path":"/محايل/حي-الحيلة-الشرقي"}': {
    path: "/محايل/حي-الحيلة-الشرقي",
    __typename: "DistrictType",
    district_id: 4094,
    name: "حي الحيلة الشرقي",
    uri: "حي-الحيلة-الشرقي",
  },
  'DistrictType:{"path":"/شرورة/حي-المستشفى-العسكري"}': {
    path: "/شرورة/حي-المستشفى-العسكري",
    __typename: "DistrictType",
    district_id: 4356,
    name: "حي المستشفى العسكري",
    uri: "حي-المستشفى-العسكري",
  },
  'DistrictType:{"path":"/نجران/حي-ابا-لسعود"}': {
    path: "/نجران/حي-ابا-لسعود",
    __typename: "DistrictType",
    district_id: 4366,
    name: "حي ابا لسعود",
    uri: "حي-ابا-لسعود",
  },
  'DistrictType:{"path":"/نجران/حي-الضباط"}': {
    path: "/نجران/حي-الضباط",
    __typename: "DistrictType",
    district_id: 4376,
    name: "حي الضباط",
    uri: "حي-الضباط",
  },
  'DistrictType:{"path":"/نجران/حي-القابل"}': {
    path: "/نجران/حي-القابل",
    __typename: "DistrictType",
    district_id: 4382,
    name: "حي القابل",
    uri: "حي-القابل",
  },
  'DistrictType:{"path":"/نجران/حي-حي-الشرفة"}': {
    path: "/نجران/حي-حي-الشرفة",
    __typename: "DistrictType",
    district_id: 4388,
    name: "حي حي الشرفة",
    uri: "حي-حي-الشرفة",
  },
  'DistrictType:{"path":"/نجران/حي-شمال-الضباط"}': {
    path: "/نجران/حي-شمال-الضباط",
    __typename: "DistrictType",
    district_id: 4394,
    name: "حي شمال الضباط",
    uri: "حي-شمال-الضباط",
  },
  'DistrictType:{"path":"/نجران/حي-مخطط-العريسة-الشمالي"}': {
    path: "/نجران/حي-مخطط-العريسة-الشمالي",
    __typename: "DistrictType",
    district_id: 4408,
    name: "حي مخطط العريسة الشمالي",
    uri: "حي-مخطط-العريسة-الشمالي",
  },
  'DistrictType:{"path":"/نجران/حي-مخطط-رجلا-الجنوبية-الزراعي"}': {
    path: "/نجران/حي-مخطط-رجلا-الجنوبية-الزراعي",
    __typename: "DistrictType",
    district_id: 4410,
    name: "حي مخطط رجلا الجنوبية الزراعي",
    uri: "حي-مخطط-رجلا-الجنوبية-الزراعي",
  },
  'DistrictType:{"path":"/نجران/حي-مخطط-شعب-رير-السكني"}': {
    path: "/نجران/حي-مخطط-شعب-رير-السكني",
    __typename: "DistrictType",
    district_id: 4414,
    name: "حي مخطط شعب رير السكني",
    uri: "حي-مخطط-شعب-رير-السكني",
  },
  'DistrictType:{"path":"/نجران/حي-مخطط-نهوفة-السكني"}': {
    path: "/نجران/حي-مخطط-نهوفة-السكني",
    __typename: "DistrictType",
    district_id: 4418,
    name: "حي مخطط نهوفة السكني",
    uri: "حي-مخطط-نهوفة-السكني",
  },
  'DistrictType:{"path":"/الباحة/حي-الزرقاء"}': {
    path: "/الباحة/حي-الزرقاء",
    __typename: "DistrictType",
    district_id: 4428,
    name: "حي الزرقاء",
    uri: "حي-الزرقاء",
  },
  'DistrictType:{"path":"/ينبع/حي-الفيصل"}': {
    path: "/ينبع/حي-الفيصل",
    __typename: "DistrictType",
    district_id: 3212,
    name: "حي الفيصل",
    uri: "حي-الفيصل",
  },
  'DistrictType:{"path":"/ينبع/حي-النبراس"}': {
    path: "/ينبع/حي-النبراس",
    __typename: "DistrictType",
    district_id: 3238,
    name: "حي النبراس",
    uri: "حي-النبراس",
  },
  'DistrictType:{"path":"/ينبع/حي-النواة"}': {
    path: "/ينبع/حي-النواة",
    __typename: "DistrictType",
    district_id: 3250,
    name: "حي النواة",
    uri: "حي-النواة",
  },
  'DistrictType:{"path":"/الجموم/حي-ابو-عروة"}': {
    path: "/الجموم/حي-ابو-عروة",
    __typename: "DistrictType",
    district_id: 3266,
    name: "حي ابو عروة",
    uri: "حي-ابو-عروة",
  },
  'DistrictType:{"path":"/الجموم/حي-الشهداء"}': {
    path: "/الجموم/حي-الشهداء",
    __typename: "DistrictType",
    district_id: 3276,
    name: "حي الشهداء",
    uri: "حي-الشهداء",
  },
  'DistrictType:{"path":"/الجموم/حي-العزيزية"}': {
    path: "/الجموم/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 3280,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/الخرمة/حي-الفيصلية"}': {
    path: "/الخرمة/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 3308,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/الخرمة/حي-الناصرية"}': {
    path: "/الخرمة/حي-الناصرية",
    __typename: "DistrictType",
    district_id: 3312,
    name: "حي الناصرية",
    uri: "حي-الناصرية",
  },
  'DistrictType:{"path":"/الطائف/حي-القمرية"}': {
    path: "/الطائف/حي-القمرية",
    __typename: "DistrictType",
    district_id: 3342,
    name: "حي القمرية",
    uri: "حي-القمرية",
  },
  'DistrictType:{"path":"/الطائف/حي-الوشحاء"}': {
    path: "/الطائف/حي-الوشحاء",
    __typename: "DistrictType",
    district_id: 3352,
    name: "حي الوشحاء",
    uri: "حي-الوشحاء",
  },
  'DistrictType:{"path":"/الطائف/حي-شبرا"}': {
    path: "/الطائف/حي-شبرا",
    __typename: "DistrictType",
    district_id: 3366,
    name: "حي شبرا",
    uri: "حي-شبرا",
  },
  'DistrictType:{"path":"/القنفذة/حي-الازهار"}': {
    path: "/القنفذة/حي-الازهار",
    __typename: "DistrictType",
    district_id: 3380,
    name: "حي الازهار",
    uri: "حي-الازهار",
  },
  'DistrictType:{"path":"/القنفذة/حي-الشرقية"}': {
    path: "/القنفذة/حي-الشرقية",
    __typename: "DistrictType",
    district_id: 3388,
    name: "حي الشرقية",
    uri: "حي-الشرقية",
  },
  'DistrictType:{"path":"/الليث/حي-الكليبية"}': {
    path: "/الليث/حي-الكليبية",
    __typename: "DistrictType",
    district_id: 3396,
    name: "حي الكليبية",
    uri: "حي-الكليبية",
  },
  'CityType:{"uri":"الليث"}': {
    uri: "الليث",
    __typename: "CityType",
    city_id: 37,
    name: "الليث",
    path: "/الليث",
  },
  'DistrictType:{"path":"/تربه/حي-السلام"}': {
    path: "/تربه/حي-السلام",
    __typename: "DistrictType",
    district_id: 3404,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/ابها/حي-القابل"}': {
    path: "/ابها/حي-القابل",
    __typename: "DistrictType",
    district_id: 3810,
    name: "حي القابل",
    uri: "حي-القابل",
  },
  'DistrictType:{"path":"/احد-رفيده/حي-الخليج"}': {
    path: "/احد-رفيده/حي-الخليج",
    __typename: "DistrictType",
    district_id: 3842,
    name: "حي الخليج",
    uri: "حي-الخليج",
  },
  'DistrictType:{"path":"/احد-رفيده/حي-العزيزية"}': {
    path: "/احد-رفيده/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 3854,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/احد-رفيده/حي-صفوان"}': {
    path: "/احد-رفيده/حي-صفوان",
    __typename: "DistrictType",
    district_id: 3864,
    name: "حي صفوان",
    uri: "حي-صفوان",
  },
  'DistrictType:{"path":"/بللسمر/حي-البساتين"}': {
    path: "/بللسمر/حي-البساتين",
    __typename: "DistrictType",
    district_id: 3892,
    name: "حي البساتين",
    uri: "حي-البساتين",
  },
  'DistrictType:{"path":"/بللسمر/حي-الربوة"}': {
    path: "/بللسمر/حي-الربوة",
    __typename: "DistrictType",
    district_id: 3896,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/بللسمر/حي-السروات"}': {
    path: "/بللسمر/حي-السروات",
    __typename: "DistrictType",
    district_id: 3908,
    name: "حي السروات",
    uri: "حي-السروات",
  },
  'DistrictType:{"path":"/بللسمر/حي-السلامة"}': {
    path: "/بللسمر/حي-السلامة",
    __typename: "DistrictType",
    district_id: 3912,
    name: "حي السلامة",
    uri: "حي-السلامة",
  },
  'DistrictType:{"path":"/بيشة/حي-الاندلس"}': {
    path: "/بيشة/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 3926,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/بيشة/حي-البوادي"}': {
    path: "/بيشة/حي-البوادي",
    __typename: "DistrictType",
    district_id: 3928,
    name: "حي البوادي",
    uri: "حي-البوادي",
  },
  'DistrictType:{"path":"/بيشة/حي-الخزامى"}': {
    path: "/بيشة/حي-الخزامى",
    __typename: "DistrictType",
    district_id: 3932,
    name: "حي الخزامى",
    uri: "حي-الخزامى",
  },
  'DistrictType:{"path":"/بيشة/حي-الربوة"}': {
    path: "/بيشة/حي-الربوة",
    __typename: "DistrictType",
    district_id: 3936,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/بيشة/حي-الريان"}': {
    path: "/بيشة/حي-الريان",
    __typename: "DistrictType",
    district_id: 3944,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'DistrictType:{"path":"/بيشة/حي-الفهد"}': {
    path: "/بيشة/حي-الفهد",
    __typename: "DistrictType",
    district_id: 3956,
    name: "حي الفهد",
    uri: "حي-الفهد",
  },
  'DistrictType:{"path":"/بيشة/حي-النسيم"}': {
    path: "/بيشة/حي-النسيم",
    __typename: "DistrictType",
    district_id: 3972,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-الخالدية"}': {
    path: "/خميس-مشيط/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 4008,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-الربيع"}': {
    path: "/خميس-مشيط/حي-الربيع",
    __typename: "DistrictType",
    district_id: 4014,
    name: "حي الربيع",
    uri: "حي-الربيع",
  },
  'DistrictType:{"path":"/املج/حي-البلد"}': {
    path: "/املج/حي-البلد",
    __typename: "DistrictType",
    district_id: 2818,
    name: "حي البلد",
    uri: "حي-البلد",
  },
  'DistrictType:{"path":"/املج/حي-العليا"}': {
    path: "/املج/حي-العليا",
    __typename: "DistrictType",
    district_id: 2832,
    name: "حي العليا",
    uri: "حي-العليا",
  },
  'DistrictType:{"path":"/املج/حي-المرجان"}': {
    path: "/املج/حي-المرجان",
    __typename: "DistrictType",
    district_id: 2834,
    name: "حي المرجان",
    uri: "حي-المرجان",
  },
  'DistrictType:{"path":"/تبوك/حي-البساتين"}': {
    path: "/تبوك/حي-البساتين",
    __typename: "DistrictType",
    district_id: 2842,
    name: "حي البساتين",
    uri: "حي-البساتين",
  },
  'DistrictType:{"path":"/تبوك/حي-الصناعية"}': {
    path: "/تبوك/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 2858,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/تبوك/حي-المصيف"}': {
    path: "/تبوك/حي-المصيف",
    __typename: "DistrictType",
    district_id: 2876,
    name: "حي المصيف",
    uri: "حي-المصيف",
  },
  'DistrictType:{"path":"/تبوك/حي-النهضة"}': {
    path: "/تبوك/حي-النهضة",
    __typename: "DistrictType",
    district_id: 2886,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/تبوك/حي-رحيل"}': {
    path: "/تبوك/حي-رحيل",
    __typename: "DistrictType",
    district_id: 2894,
    name: "حي رحيل",
    uri: "حي-رحيل",
  },
  'DistrictType:{"path":"/تبوك/حي-منطقة-الزراعية"}': {
    path: "/تبوك/حي-منطقة-الزراعية",
    __typename: "DistrictType",
    district_id: 2902,
    name: "حي منطقة الزراعية",
    uri: "حي-منطقة-الزراعية",
  },
  'DistrictType:{"path":"/تيماء/حي-الربوة"}': {
    path: "/تيماء/حي-الربوة",
    __typename: "DistrictType",
    district_id: 2906,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الجامعة"}': {
    path: "/المدينة-المنورة/حي-الجامعة",
    __typename: "DistrictType",
    district_id: 2936,
    name: "حي الجامعة",
    uri: "حي-الجامعة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الخاتم"}': {
    path: "/المدينة-المنورة/حي-الخاتم",
    __typename: "DistrictType",
    district_id: 2948,
    name: "حي الخاتم",
    uri: "حي-الخاتم",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الصادقية"}': {
    path: "/المدينة-المنورة/حي-الصادقية",
    __typename: "DistrictType",
    district_id: 2986,
    name: "حي الصادقية",
    uri: "حي-الصادقية",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-القبلتين"}': {
    path: "/المدينة-المنورة/حي-القبلتين",
    __typename: "DistrictType",
    district_id: 3008,
    name: "حي القبلتين",
    uri: "حي-القبلتين",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-القصواء"}': {
    path: "/المدينة-المنورة/حي-القصواء",
    __typename: "DistrictType",
    district_id: 3010,
    name: "حي القصواء",
    uri: "حي-القصواء",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الوبرة"}': {
    path: "/المدينة-المنورة/حي-الوبرة",
    __typename: "DistrictType",
    district_id: 3032,
    name: "حي الوبرة",
    uri: "حي-الوبرة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-بني-بياضة"}': {
    path: "/المدينة-المنورة/حي-بني-بياضة",
    __typename: "DistrictType",
    district_id: 3036,
    name: "حي بني بياضة",
    uri: "حي-بني-بياضة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-بني-ظفر"}': {
    path: "/المدينة-المنورة/حي-بني-ظفر",
    __typename: "DistrictType",
    district_id: 3040,
    name: "حي بني ظفر",
    uri: "حي-بني-ظفر",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-جبل-احد"}': {
    path: "/المدينة-المنورة/حي-جبل-احد",
    __typename: "DistrictType",
    district_id: 3048,
    name: "حي جبل احد",
    uri: "حي-جبل-احد",
  },
  'DistrictType:{"path":"/بدر/حي-الروضة"}': {
    path: "/بدر/حي-الروضة",
    __typename: "DistrictType",
    district_id: 3096,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'CityType:{"uri":"بدر"}': {
    uri: "بدر",
    __typename: "CityType",
    city_id: 51,
    name: "بدر",
    path: "/بدر",
  },
  'DistrictType:{"path":"/بدر/حي-الشهداء"}': {
    path: "/بدر/حي-الشهداء",
    __typename: "DistrictType",
    district_id: 3098,
    name: "حي الشهداء",
    uri: "حي-الشهداء",
  },
  'DistrictType:{"path":"/خيبر/حي-الخالدية"}': {
    path: "/خيبر/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 3108,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'CityType:{"uri":"خيبر"}': {
    uri: "خيبر",
    __typename: "CityType",
    city_id: 71,
    name: "خيبر",
    path: "/خيبر",
  },
  'DistrictType:{"path":"/مهد-الذهب/حي-مهد-الذهب"}': {
    path: "/مهد-الذهب/حي-مهد-الذهب",
    __typename: "DistrictType",
    district_id: 3118,
    name: "حي مهد الذهب",
    uri: "حي-مهد-الذهب",
  },
  'CityType:{"uri":"مهد-الذهب"}': {
    uri: "مهد-الذهب",
    __typename: "CityType",
    city_id: 95,
    name: "مهد الذهب",
    path: "/مهد-الذهب",
  },
  'DistrictType:{"path":"/ينبع/حي-الامارة"}': {
    path: "/ينبع/حي-الامارة",
    __typename: "DistrictType",
    district_id: 3124,
    name: "حي الامارة",
    uri: "حي-الامارة",
  },
  'DistrictType:{"path":"/ينبع/حي-البثنة"}': {
    path: "/ينبع/حي-البثنة",
    __typename: "DistrictType",
    district_id: 3126,
    name: "حي البثنة",
    uri: "حي-البثنة",
  },
  'DistrictType:{"path":"/ينبع/حي-البحيرة"}': {
    path: "/ينبع/حي-البحيرة",
    __typename: "DistrictType",
    district_id: 3128,
    name: "حي البحيرة",
    uri: "حي-البحيرة",
  },
  'DistrictType:{"path":"/ينبع/حي-الجامعة"}': {
    path: "/ينبع/حي-الجامعة",
    __typename: "DistrictType",
    district_id: 3144,
    name: "حي الجامعة",
    uri: "حي-الجامعة",
  },
  'DistrictType:{"path":"/ينبع/حي-الحرس-الوطني"}': {
    path: "/ينبع/حي-الحرس-الوطني",
    __typename: "DistrictType",
    district_id: 3150,
    name: "حي الحرس الوطني",
    uri: "حي-الحرس-الوطني",
  },
  'DistrictType:{"path":"/ينبع/حي-الديار"}': {
    path: "/ينبع/حي-الديار",
    __typename: "DistrictType",
    district_id: 3160,
    name: "حي الديار",
    uri: "حي-الديار",
  },
  'DistrictType:{"path":"/ينبع/حي-الربوة"}': {
    path: "/ينبع/حي-الربوة",
    __typename: "DistrictType",
    district_id: 3162,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/ينبع/حي-الصبح"}': {
    path: "/ينبع/حي-الصبح",
    __typename: "DistrictType",
    district_id: 3190,
    name: "حي الصبح",
    uri: "حي-الصبح",
  },
  'DistrictType:{"path":"/ينبع/حي-الصريف"}': {
    path: "/ينبع/حي-الصريف",
    __typename: "DistrictType",
    district_id: 3192,
    name: "حي الصريف",
    uri: "حي-الصريف",
  },
  'DistrictType:{"path":"/الظهران/حي-ارامكو-السعودية"}': {
    path: "/الظهران/حي-ارامكو-السعودية",
    __typename: "DistrictType",
    district_id: 1332,
    name: "حي ارامكو السعودية",
    uri: "حي-ارامكو-السعودية",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-النزهة"}': {
    path: "/الرياض/شمال-الرياض/حي-النزهة",
    __typename: "DistrictType",
    district_id: 602,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-النور"}': {
    path: "/الرياض/جنوب-الرياض/حي-النور",
    __typename: "DistrictType",
    district_id: 616,
    name: "حي النور",
    uri: "حي-النور",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-الواحة"}': {
    path: "/الرياض/شمال-الرياض/حي-الواحة",
    __typename: "DistrictType",
    district_id: 620,
    name: "حي الواحة",
    uri: "حي-الواحة",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-ام-الحمام-الشرقي"}': {
    path: "/الرياض/غرب-الرياض/حي-ام-الحمام-الشرقي",
    __typename: "DistrictType",
    district_id: 638,
    name: "حي ام الحمام الشرقي",
    uri: "حي-ام-الحمام-الشرقي",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-بدر"}': {
    path: "/الرياض/جنوب-الرياض/حي-بدر",
    __typename: "DistrictType",
    district_id: 648,
    name: "حي بدر",
    uri: "حي-بدر",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-جامعة-الامام-محمد-بن-سعود-الاسلامية"}':
    {
      path: "/الرياض/شمال-الرياض/حي-جامعة-الامام-محمد-بن-سعود-الاسلامية",
      __typename: "DistrictType",
      district_id: 654,
      name: "حي جامعة الامام محمد بن سعود الاسلامية",
      uri: "حي-جامعة-الامام-محمد-بن-سعود-الاسلامية",
    },

  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-جرير"}': {
    path: "/الرياض/وسط-الرياض/حي-جرير",
    __typename: "DistrictType",
    district_id: 662,
    name: "حي جرير",
    uri: "حي-جرير",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-ديراب"}': {
    path: "/الرياض/غرب-الرياض/حي-ديراب",
    __typename: "DistrictType",
    district_id: 668,
    name: "حي ديراب",
    uri: "حي-ديراب",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-شبرا"}': {
    path: "/الرياض/غرب-الرياض/حي-شبرا",
    __typename: "DistrictType",
    district_id: 674,
    name: "حي شبرا",
    uri: "حي-شبرا",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-صياح"}': {
    path: "/الرياض/غرب-الرياض/حي-صياح",
    __typename: "DistrictType",
    district_id: 678,
    name: "حي صياح",
    uri: "حي-صياح",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-طويق"}': {
    path: "/الرياض/غرب-الرياض/حي-طويق",
    __typename: "DistrictType",
    district_id: 682,
    name: "حي طويق",
    uri: "حي-طويق",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-ظهرة-نمار"}': {
    path: "/الرياض/غرب-الرياض/حي-ظهرة-نمار",
    __typename: "DistrictType",
    district_id: 690,
    name: "حي ظهرة نمار",
    uri: "حي-ظهرة-نمار",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-منفوحة"}': {
    path: "/الرياض/وسط-الرياض/حي-منفوحة",
    __typename: "DistrictType",
    district_id: 714,
    name: "حي منفوحة",
    uri: "حي-منفوحة",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-نمار"}': {
    path: "/الرياض/غرب-الرياض/حي-نمار",
    __typename: "DistrictType",
    district_id: 718,
    name: "حي نمار",
    uri: "حي-نمار",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-هيت"}': {
    path: "/الرياض/جنوب-الرياض/حي-هيت",
    __typename: "DistrictType",
    district_id: 720,
    name: "حي هيت",
    uri: "حي-هيت",
  },
  'DistrictType:{"path":"/الزلفي/حي-الاندلس"}': {
    path: "/الزلفي/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 724,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/الزلفي/حي-الصديق"}': {
    path: "/الزلفي/حي-الصديق",
    __typename: "DistrictType",
    district_id: 740,
    name: "حي الصديق",
    uri: "حي-الصديق",
  },
  'DistrictType:{"path":"/الزلفي/حي-العزيزية"}': {
    path: "/الزلفي/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 744,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/الزلفي/حي-الفالح"}': {
    path: "/الزلفي/حي-الفالح",
    __typename: "DistrictType",
    district_id: 748,
    name: "حي الفالح",
    uri: "حي-الفالح",
  },
  'DistrictType:{"path":"/الزلفي/حي-الفيصلية"}': {
    path: "/الزلفي/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 750,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/الزلفي/حي-النهضة"}': {
    path: "/الزلفي/حي-النهضة",
    __typename: "DistrictType",
    district_id: 756,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/الزلفي/حي-بدر"}': {
    path: "/الزلفي/حي-بدر",
    __typename: "DistrictType",
    district_id: 762,
    name: "حي بدر",
    uri: "حي-بدر",
  },
  'DistrictType:{"path":"/الزلفي/حي-طويق"}': {
    path: "/الزلفي/حي-طويق",
    __typename: "DistrictType",
    district_id: 768,
    name: "حي طويق",
    uri: "حي-طويق",
  },
  'DistrictType:{"path":"/السليل/حي-النخيل"}': {
    path: "/السليل/حي-النخيل",
    __typename: "DistrictType",
    district_id: 788,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-الاساملة"}': {
    path: "/ابو-عريش/حي-الاساملة",
    __typename: "DistrictType",
    district_id: 2,
    name: "حي الاساملة",
    uri: "حي-الاساملة",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-الاندلس"}': {
    path: "/ابو-عريش/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 4,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-البديع-والقرفي"}': {
    path: "/ابو-عريش/حي-البديع-والقرفي",
    __typename: "DistrictType",
    district_id: 6,
    name: "حي البديع والقرفي",
    uri: "حي-البديع-والقرفي",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-الزهور"}': {
    path: "/ابو-عريش/حي-الزهور",
    __typename: "DistrictType",
    district_id: 20,
    name: "حي الزهور",
    uri: "حي-الزهور",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-العسيلة"}': {
    path: "/ابو-عريش/حي-العسيلة",
    __typename: "DistrictType",
    district_id: 36,
    name: "حي العسيلة",
    uri: "حي-العسيلة",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-العقدة"}': {
    path: "/ابو-عريش/حي-العقدة",
    __typename: "DistrictType",
    district_id: 38,
    name: "حي العقدة",
    uri: "حي-العقدة",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-الملك-فهد"}': {
    path: "/ابو-عريش/حي-الملك-فهد",
    __typename: "DistrictType",
    district_id: 54,
    name: "حي الملك فهد",
    uri: "حي-الملك-فهد",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-شويهة"}': {
    path: "/ابو-عريش/حي-شويهة",
    __typename: "DistrictType",
    district_id: 80,
    name: "حي شويهة",
    uri: "حي-شويهة",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-الصفا"}': {
    path: "/احد-المسارحة/حي-الصفا",
    __typename: "DistrictType",
    district_id: 106,
    name: "حي الصفا",
    uri: "حي-الصفا",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-القسوم"}': {
    path: "/احد-المسارحة/حي-القسوم",
    __typename: "DistrictType",
    district_id: 114,
    name: "حي القسوم",
    uri: "حي-القسوم",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-المنزم"}': {
    path: "/احد-المسارحة/حي-المنزم",
    __typename: "DistrictType",
    district_id: 118,
    name: "حي المنزم",
    uri: "حي-المنزم",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-سوق-الليل"}': {
    path: "/احد-المسارحة/حي-سوق-الليل",
    __typename: "DistrictType",
    district_id: 134,
    name: "حي سوق الليل",
    uri: "حي-سوق-الليل",
  },
  'DistrictType:{"path":"/جازان/حي-الزهور"}': {
    path: "/جازان/حي-الزهور",
    __typename: "DistrictType",
    district_id: 150,
    name: "حي الزهور",
    uri: "حي-الزهور",
  },
  'DistrictType:{"path":"/جازان/حي-المطار"}': {
    path: "/جازان/حي-المطار",
    __typename: "DistrictType",
    district_id: 162,
    name: "حي المطار",
    uri: "حي-المطار",
  },
  'DistrictType:{"path":"/جازان/حي-مزهرة"}': {
    path: "/جازان/حي-مزهرة",
    __typename: "DistrictType",
    district_id: 170,
    name: "حي مزهرة",
    uri: "حي-مزهرة",
  },
  'DistrictType:{"path":"/صامطة/حي-الخضراء"}': {
    path: "/صامطة/حي-الخضراء",
    __typename: "DistrictType",
    district_id: 176,
    name: "حي الخضراء",
    uri: "حي-الخضراء",
  },
  'DistrictType:{"path":"/صامطة/حي-الركوبة"}': {
    path: "/صامطة/حي-الركوبة",
    __typename: "DistrictType",
    district_id: 178,
    name: "حي الركوبة",
    uri: "حي-الركوبة",
  },
  'DistrictType:{"path":"/صامطة/حي-الطريشة"}': {
    path: "/صامطة/حي-الطريشة",
    __typename: "DistrictType",
    district_id: 180,
    name: "حي الطريشة",
    uri: "حي-الطريشة",
  },
  'DistrictType:{"path":"/صبيا/حي-الحسيني"}': {
    path: "/صبيا/حي-الحسيني",
    __typename: "DistrictType",
    district_id: 188,
    name: "حي الحسيني",
    uri: "حي-الحسيني",
  },
  'DistrictType:{"path":"/صبيا/حي-الروضة"}': {
    path: "/صبيا/حي-الروضة",
    __typename: "DistrictType",
    district_id: 198,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-التعاون"}': {
    path: "/الرياض/شمال-الرياض/حي-التعاون",
    __typename: "DistrictType",
    district_id: 404,
    name: "حي التعاون",
    uri: "حي-التعاون",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الجنادرية"}': {
    path: "/الرياض/شرق-الرياض/حي-الجنادرية",
    __typename: "DistrictType",
    district_id: 410,
    name: "حي الجنادرية",
    uri: "حي-الجنادرية",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-الحزم"}': {
    path: "/الرياض/غرب-الرياض/حي-الحزم",
    __typename: "DistrictType",
    district_id: 414,
    name: "حي الحزم",
    uri: "حي-الحزم",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الحمراء"}': {
    path: "/الرياض/شرق-الرياض/حي-الحمراء",
    __typename: "DistrictType",
    district_id: 416,
    name: "حي الحمراء",
    uri: "حي-الحمراء",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-الخالدية"}': {
    path: "/الرياض/وسط-الرياض/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 418,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-الخزامى"}': {
    path: "/الرياض/غرب-الرياض/حي-الخزامى",
    __typename: "DistrictType",
    district_id: 420,
    name: "حي الخزامى",
    uri: "حي-الخزامى",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الخليج"}': {
    path: "/الرياض/شرق-الرياض/حي-الخليج",
    __typename: "DistrictType",
    district_id: 422,
    name: "حي الخليج",
    uri: "حي-الخليج",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-الدار-البيضاء"}': {
    path: "/الرياض/جنوب-الرياض/حي-الدار-البيضاء",
    __typename: "DistrictType",
    district_id: 424,
    name: "حي الدار البيضاء",
    uri: "حي-الدار-البيضاء",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-الرائد"}': {
    path: "/الرياض/غرب-الرياض/حي-الرائد",
    __typename: "DistrictType",
    district_id: 436,
    name: "حي الرائد",
    uri: "حي-الرائد",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-الرفيعة"}': {
    path: "/الرياض/غرب-الرياض/حي-الرفيعة",
    __typename: "DistrictType",
    district_id: 444,
    name: "حي الرفيعة",
    uri: "حي-الرفيعة",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الريان"}': {
    path: "/الرياض/شرق-الرياض/حي-الريان",
    __typename: "DistrictType",
    district_id: 454,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-الزهراء"}': {
    path: "/الرياض/وسط-الرياض/حي-الزهراء",
    __typename: "DistrictType",
    district_id: 456,
    name: "حي الزهراء",
    uri: "حي-الزهراء",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-السفارات"}': {
    path: "/الرياض/غرب-الرياض/حي-السفارات",
    __typename: "DistrictType",
    district_id: 462,
    name: "حي السفارات",
    uri: "حي-السفارات",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-السلي"}': {
    path: "/الرياض/جنوب-الرياض/حي-السلي",
    __typename: "DistrictType",
    district_id: 466,
    name: "حي السلي",
    uri: "حي-السلي",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-الصالحية"}': {
    path: "/الرياض/وسط-الرياض/حي-الصالحية",
    __typename: "DistrictType",
    district_id: 484,
    name: "حي الصالحية",
    uri: "حي-الصالحية",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-العريجاء"}': {
    path: "/الرياض/غرب-الرياض/حي-العريجاء",
    __typename: "DistrictType",
    district_id: 496,
    name: "حي العريجاء",
    uri: "حي-العريجاء",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-العريجاء-الوسطى"}': {
    path: "/الرياض/غرب-الرياض/حي-العريجاء-الوسطى",
    __typename: "DistrictType",
    district_id: 500,
    name: "حي العريجاء الوسطى",
    uri: "حي-العريجاء-الوسطى",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-الغنامية"}': {
    path: "/الرياض/جنوب-الرياض/حي-الغنامية",
    __typename: "DistrictType",
    district_id: 516,
    name: "حي الغنامية",
    uri: "حي-الغنامية",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-القدس"}': {
    path: "/الرياض/شرق-الرياض/حي-القدس",
    __typename: "DistrictType",
    district_id: 532,
    name: "حي القدس",
    uri: "حي-القدس",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-المحمدية"}': {
    path: "/الرياض/شمال-الرياض/حي-المحمدية",
    __typename: "DistrictType",
    district_id: 538,
    name: "حي المحمدية",
    uri: "حي-المحمدية",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-المدينة-الصناعية-الجديدة"}': {
    path: "/الرياض/جنوب-الرياض/حي-المدينة-الصناعية-الجديدة",
    __typename: "DistrictType",
    district_id: 540,
    name: "حي المدينة الصناعية الجديدة",
    uri: "حي-المدينة-الصناعية-الجديدة",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-المرسلات"}': {
    path: "/الرياض/شمال-الرياض/حي-المرسلات",
    __typename: "DistrictType",
    district_id: 544,
    name: "حي المرسلات",
    uri: "حي-المرسلات",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-المروة"}': {
    path: "/الرياض/جنوب-الرياض/حي-المروة",
    __typename: "DistrictType",
    district_id: 546,
    name: "حي المروة",
    uri: "حي-المروة",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-المروج"}': {
    path: "/الرياض/شمال-الرياض/حي-المروج",
    __typename: "DistrictType",
    district_id: 548,
    name: "حي المروج",
    uri: "حي-المروج",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-المصيف"}': {
    path: "/الرياض/شمال-الرياض/حي-المصيف",
    __typename: "DistrictType",
    district_id: 556,
    name: "حي المصيف",
    uri: "حي-المصيف",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-المعكال"}': {
    path: "/الرياض/وسط-الرياض/حي-المعكال",
    __typename: "DistrictType",
    district_id: 562,
    name: "حي المعكال",
    uri: "حي-المعكال",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-المعيزلة"}': {
    path: "/الرياض/شرق-الرياض/حي-المعيزلة",
    __typename: "DistrictType",
    district_id: 564,
    name: "حي المعيزلة",
    uri: "حي-المعيزلة",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-المؤتمرات"}': {
    path: "/الرياض/شمال-الرياض/حي-المؤتمرات",
    __typename: "DistrictType",
    district_id: 592,
    name: "حي المؤتمرات",
    uri: "حي-المؤتمرات",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-الندى"}': {
    path: "/الرياض/شمال-الرياض/حي-الندى",
    __typename: "DistrictType",
    district_id: 598,
    name: "حي الندى",
    uri: "حي-الندى",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-اليرموك"}': {
    path: "/حفر-الباطن/حي-اليرموك",
    __typename: "DistrictType",
    district_id: 1804,
    name: "حي اليرموك",
    uri: "حي-اليرموك",
  },
  'DistrictType:{"path":"/سيهات/حي-النور"}': {
    path: "/سيهات/حي-النور",
    __typename: "DistrictType",
    district_id: 1858,
    name: "حي النور",
    uri: "حي-النور",
  },
  'DistrictType:{"path":"/صفوى/حي-البدور"}': {
    path: "/صفوى/حي-البدور",
    __typename: "DistrictType",
    district_id: 1870,
    name: "حي البدور",
    uri: "حي-البدور",
  },
  'DistrictType:{"path":"/عنك/حي-الانوار"}': {
    path: "/عنك/حي-الانوار",
    __typename: "DistrictType",
    district_id: 1902,
    name: "حي الانوار",
    uri: "حي-الانوار",
  },
  'DistrictType:{"path":"/رفحاء/حي-الادارية"}': {
    path: "/رفحاء/حي-الادارية",
    __typename: "DistrictType",
    district_id: 1912,
    name: "حي الادارية",
    uri: "حي-الادارية",
  },
  'DistrictType:{"path":"/رفحاء/حي-الفيصلية"}': {
    path: "/رفحاء/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 1928,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/رفحاء/حي-المساعدية"}': {
    path: "/رفحاء/حي-المساعدية",
    __typename: "DistrictType",
    district_id: 1936,
    name: "حي المساعدية",
    uri: "حي-المساعدية",
  },
  'DistrictType:{"path":"/رفحاء/حي-جنوب-الخالدية"}': {
    path: "/رفحاء/حي-جنوب-الخالدية",
    __typename: "DistrictType",
    district_id: 1942,
    name: "حي جنوب الخالدية",
    uri: "حي-جنوب-الخالدية",
  },
  'DistrictType:{"path":"/طريف/حي-الخالدية"}': {
    path: "/طريف/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 1948,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/طريف/حي-العروبة"}': {
    path: "/طريف/حي-العروبة",
    __typename: "DistrictType",
    district_id: 1954,
    name: "حي العروبة",
    uri: "حي-العروبة",
  },
  'DistrictType:{"path":"/طريف/حي-اليرموك"}': {
    path: "/طريف/حي-اليرموك",
    __typename: "DistrictType",
    district_id: 1964,
    name: "حي اليرموك",
    uri: "حي-اليرموك",
  },
  'DistrictType:{"path":"/عرعر/حي-الخالدية"}': {
    path: "/عرعر/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 1968,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/عرعر/حي-الربوه"}': {
    path: "/عرعر/حي-الربوه",
    __typename: "DistrictType",
    district_id: 1970,
    name: "حي الربوه",
    uri: "حي-الربوه",
  },
  'DistrictType:{"path":"/عرعر/حي-الريان"}': {
    path: "/عرعر/حي-الريان",
    __typename: "DistrictType",
    district_id: 1974,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'DistrictType:{"path":"/عرعر/حي-العزيزية"}': {
    path: "/عرعر/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 1978,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/عرعر/حي-الفيصلية"}': {
    path: "/عرعر/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 1980,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/عرعر/حي-المنطقة-الصناعية"}': {
    path: "/عرعر/حي-المنطقة-الصناعية",
    __typename: "DistrictType",
    district_id: 1988,
    name: "حي المنطقة الصناعية",
    uri: "حي-المنطقة-الصناعية",
  },
  'DistrictType:{"path":"/الشنان/حي-الخليج"}': {
    path: "/الشنان/حي-الخليج",
    __typename: "DistrictType",
    district_id: 1996,
    name: "حي الخليج",
    uri: "حي-الخليج",
  },
  'DistrictType:{"path":"/صبيا/حي-الريان"}': {
    path: "/صبيا/حي-الريان",
    __typename: "DistrictType",
    district_id: 202,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'DistrictType:{"path":"/صبيا/حي-العريش"}': {
    path: "/صبيا/حي-العريش",
    __typename: "DistrictType",
    district_id: 210,
    name: "حي العريش",
    uri: "حي-العريش",
  },
  'DistrictType:{"path":"/صبيا/حي-النزهة"}': {
    path: "/صبيا/حي-النزهة",
    __typename: "DistrictType",
    district_id: 232,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/الحريق/حي-المدينة-الجديدة"}': {
    path: "/الحريق/حي-المدينة-الجديدة",
    __typename: "DistrictType",
    district_id: 242,
    name: "حي المدينة الجديدة",
    uri: "حي-المدينة-الجديدة",
  },
  'DistrictType:{"path":"/الخرج/حي-الخزامى"}': {
    path: "/الخرج/حي-الخزامى",
    __typename: "DistrictType",
    district_id: 258,
    name: "حي الخزامى",
    uri: "حي-الخزامى",
  },
  'DistrictType:{"path":"/الخرج/حي-السلام"}': {
    path: "/الخرج/حي-السلام",
    __typename: "DistrictType",
    district_id: 268,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/الخرج/حي-الفيصلية"}': {
    path: "/الخرج/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 280,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/الخرج/حي-المنيفية"}': {
    path: "/الخرج/حي-المنيفية",
    __typename: "DistrictType",
    district_id: 286,
    name: "حي المنيفية",
    uri: "حي-المنيفية",
  },
  'DistrictType:{"path":"/الخرج/حي-الناصفة"}': {
    path: "/الخرج/حي-الناصفة",
    __typename: "DistrictType",
    district_id: 288,
    name: "حي الناصفة",
    uri: "حي-الناصفة",
  },
  'DistrictType:{"path":"/الدرعية/حي-الدرعية-الجديدة"}': {
    path: "/الدرعية/حي-الدرعية-الجديدة",
    __typename: "DistrictType",
    district_id: 304,
    name: "حي الدرعية الجديدة",
    uri: "حي-الدرعية-الجديدة",
  },
  'DistrictType:{"path":"/الدرعية/حي-الروقية"}': {
    path: "/الدرعية/حي-الروقية",
    __typename: "DistrictType",
    district_id: 306,
    name: "حي الروقية",
    uri: "حي-الروقية",
  },
  'DistrictType:{"path":"/الدرعية/حي-الطريف-الجديدة"}': {
    path: "/الدرعية/حي-الطريف-الجديدة",
    __typename: "DistrictType",
    district_id: 310,
    name: "حي الطريف الجديدة",
    uri: "حي-الطريف-الجديدة",
  },
  'DistrictType:{"path":"/الدلم/حي-السماري"}': {
    path: "/الدلم/حي-السماري",
    __typename: "DistrictType",
    district_id: 330,
    name: "حي السماري",
    uri: "حي-السماري",
  },
  'DistrictType:{"path":"/الدلم/حي-العذراء"}': {
    path: "/الدلم/حي-العذراء",
    __typename: "DistrictType",
    district_id: 336,
    name: "حي العذراء",
    uri: "حي-العذراء",
  },
  'DistrictType:{"path":"/الدلم/حي-سدير"}': {
    path: "/الدلم/حي-سدير",
    __typename: "DistrictType",
    district_id: 342,
    name: "حي سدير",
    uri: "حي-سدير",
  },
  'DistrictType:{"path":"/الدوادمي/حي-الديرة"}': {
    path: "/الدوادمي/حي-الديرة",
    __typename: "DistrictType",
    district_id: 352,
    name: "حي الديرة",
    uri: "حي-الديرة",
  },
  'DistrictType:{"path":"/الدوادمي/حي-النزهة"}': {
    path: "/الدوادمي/حي-النزهة",
    __typename: "DistrictType",
    district_id: 376,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-اشبيلية"}': {
    path: "/الرياض/شرق-الرياض/حي-اشبيلية",
    __typename: "DistrictType",
    district_id: 390,
    name: "حي اشبيلية",
    uri: "حي-اشبيلية",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الازدهار"}': {
    path: "/الرياض/شرق-الرياض/حي-الازدهار",
    __typename: "DistrictType",
    district_id: 392,
    name: "حي الازدهار",
    uri: "حي-الازدهار",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-البديعة"}': {
    path: "/الرياض/غرب-الرياض/حي-البديعة",
    __typename: "DistrictType",
    district_id: 398,
    name: "حي البديعة",
    uri: "حي-البديعة",
  },
  'DistrictType:{"path":"/الجبيل/حي-سدير"}': {
    path: "/الجبيل/حي-سدير",
    __typename: "DistrictType",
    district_id: 1020,
    name: "حي سدير",
    uri: "حي-سدير",
  },
  'DistrictType:{"path":"/الجبيل/حي-مخطط-الدخل-المحدود"}': {
    path: "/الجبيل/حي-مخطط-الدخل-المحدود",
    __typename: "DistrictType",
    district_id: 1022,
    name: "حي مخطط الدخل المحدود",
    uri: "حي-مخطط-الدخل-المحدود",
  },
  'DistrictType:{"path":"/الجبيل/حي-نجد"}': {
    path: "/الجبيل/حي-نجد",
    __typename: "DistrictType",
    district_id: 1034,
    name: "حي نجد",
    uri: "حي-نجد",
  },
  'DistrictType:{"path":"/الخبر/حي-الخور"}': {
    path: "/الخبر/حي-الخور",
    __typename: "DistrictType",
    district_id: 1078,
    name: "حي الخور",
    uri: "حي-الخور",
  },
  'DistrictType:{"path":"/الخبر/حي-العقربية"}': {
    path: "/الخبر/حي-العقربية",
    __typename: "DistrictType",
    district_id: 1094,
    name: "حي العقربية",
    uri: "حي-العقربية",
  },
  'DistrictType:{"path":"/الخبر/حي-قرطبة"}': {
    path: "/الخبر/حي-قرطبة",
    __typename: "DistrictType",
    district_id: 1118,
    name: "حي قرطبة",
    uri: "حي-قرطبة",
  },
  'DistrictType:{"path":"/الخفجي/حي-ارامكو"}': {
    path: "/الخفجي/حي-ارامكو",
    __typename: "DistrictType",
    district_id: 1122,
    name: "حي ارامكو",
    uri: "حي-ارامكو",
  },
  'DistrictType:{"path":"/الخفجي/حي-الجوهرة"}': {
    path: "/الخفجي/حي-الجوهرة",
    __typename: "DistrictType",
    district_id: 1132,
    name: "حي الجوهرة",
    uri: "حي-الجوهرة",
  },
  'DistrictType:{"path":"/الخفجي/حي-العزيزية"}': {
    path: "/الخفجي/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 1152,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/الخفجي/حي-المنطقة-الصناعية-الاولى"}': {
    path: "/الخفجي/حي-المنطقة-الصناعية-الاولى",
    __typename: "DistrictType",
    district_id: 1166,
    name: "حي المنطقة الصناعية الاولى",
    uri: "حي-المنطقة-الصناعية-الاولى",
  },
  'DistrictType:{"path":"/الخفجي/حي-المنطقة-الصناعية-الثانية"}': {
    path: "/الخفجي/حي-المنطقة-الصناعية-الثانية",
    __typename: "DistrictType",
    district_id: 1168,
    name: "حي المنطقة الصناعية الثانية",
    uri: "حي-المنطقة-الصناعية-الثانية",
  },
  'DistrictType:{"path":"/الخفجي/حي-اليرموك"}': {
    path: "/الخفجي/حي-اليرموك",
    __typename: "DistrictType",
    district_id: 1176,
    name: "حي اليرموك",
    uri: "حي-اليرموك",
  },
  'DistrictType:{"path":"/الدمام/حي-ابن-خلدون"}': {
    path: "/الدمام/حي-ابن-خلدون",
    __typename: "DistrictType",
    district_id: 1178,
    name: "حي ابن خلدون",
    uri: "حي-ابن-خلدون",
  },
  'DistrictType:{"path":"/الدمام/حي-الامير-محمد-بن-سعود"}': {
    path: "/الدمام/حي-الامير-محمد-بن-سعود",
    __typename: "DistrictType",
    district_id: 1190,
    name: "حي الامير محمد بن سعود",
    uri: "حي-الامير-محمد-بن-سعود",
  },
  'DistrictType:{"path":"/الدمام/حي-الأمل"}': {
    path: "/الدمام/حي-الأمل",
    __typename: "DistrictType",
    district_id: 1194,
    name: "حي الأمل",
    uri: "حي-الأمل",
  },
  'DistrictType:{"path":"/الدمام/حي-البحيرة"}': {
    path: "/الدمام/حي-البحيرة",
    __typename: "DistrictType",
    district_id: 1198,
    name: "حي البحيرة",
    uri: "حي-البحيرة",
  },
  'DistrictType:{"path":"/القطيف/حي-الزارة"}': {
    path: "/القطيف/حي-الزارة",
    __typename: "DistrictType",
    district_id: 1426,
    name: "حي الزارة",
    uri: "حي-الزارة",
  },
  'DistrictType:{"path":"/القطيف/حي-الشريعة"}': {
    path: "/القطيف/حي-الشريعة",
    __typename: "DistrictType",
    district_id: 1434,
    name: "حي الشريعة",
    uri: "حي-الشريعة",
  },
  'DistrictType:{"path":"/القطيف/حي-الشماسيه"}': {
    path: "/القطيف/حي-الشماسيه",
    __typename: "DistrictType",
    district_id: 1436,
    name: "حي الشماسيه",
    uri: "حي-الشماسيه",
  },
  'DistrictType:{"path":"/القطيف/حي-الشهباء"}': {
    path: "/القطيف/حي-الشهباء",
    __typename: "DistrictType",
    district_id: 1438,
    name: "حي الشهباء",
    uri: "حي-الشهباء",
  },
  'DistrictType:{"path":"/القطيف/حي-المستودعات"}': {
    path: "/القطيف/حي-المستودعات",
    __typename: "DistrictType",
    district_id: 1464,
    name: "حي المستودعات",
    uri: "حي-المستودعات",
  },
  'DistrictType:{"path":"/القطيف/حي-الملاحة"}': {
    path: "/القطيف/حي-الملاحة",
    __typename: "DistrictType",
    district_id: 1470,
    name: "حي الملاحة",
    uri: "حي-الملاحة",
  },
  'DistrictType:{"path":"/القطيف/حي-النرجس"}': {
    path: "/القطيف/حي-النرجس",
    __typename: "DistrictType",
    district_id: 1474,
    name: "حي النرجس",
    uri: "حي-النرجس",
  },
  'DistrictType:{"path":"/الهفوف/حي-الاسكان-العام"}': {
    path: "/الهفوف/حي-الاسكان-العام",
    __typename: "DistrictType",
    district_id: 1516,
    name: "حي الاسكان العام",
    uri: "حي-الاسكان-العام",
  },
  'DistrictType:{"path":"/الهفوف/حي-الجرن"}': {
    path: "/الهفوف/حي-الجرن",
    __typename: "DistrictType",
    district_id: 1534,
    name: "حي الجرن",
    uri: "حي-الجرن",
  },
  'DistrictType:{"path":"/الهفوف/حي-الخالدية"}': {
    path: "/الهفوف/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 1540,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/الهفوف/حي-الراشدية"}': {
    path: "/الهفوف/حي-الراشدية",
    __typename: "DistrictType",
    district_id: 1548,
    name: "حي الراشدية",
    uri: "حي-الراشدية",
  },
  'DistrictType:{"path":"/الهفوف/حي-الروضة"}': {
    path: "/الهفوف/حي-الروضة",
    __typename: "DistrictType",
    district_id: 1558,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/الهفوف/حي-الشعبة"}': {
    path: "/الهفوف/حي-الشعبة",
    __typename: "DistrictType",
    district_id: 1572,
    name: "حي الشعبة",
    uri: "حي-الشعبة",
  },
  'DistrictType:{"path":"/الهفوف/حي-الشعبى"}': {
    path: "/الهفوف/حي-الشعبى",
    __typename: "DistrictType",
    district_id: 1574,
    name: "حي الشعبى",
    uri: "حي-الشعبى",
  },
  'DistrictType:{"path":"/الهفوف/حي-الشهابية"}': {
    path: "/الهفوف/حي-الشهابية",
    __typename: "DistrictType",
    district_id: 1576,
    name: "حي الشهابية",
    uri: "حي-الشهابية",
  },
  'DistrictType:{"path":"/الهفوف/حي-الطريبيل"}': {
    path: "/الهفوف/حي-الطريبيل",
    __typename: "DistrictType",
    district_id: 1586,
    name: "حي الطريبيل",
    uri: "حي-الطريبيل",
  },
  'DistrictType:{"path":"/الهفوف/حي-القادسية"}': {
    path: "/الهفوف/حي-القادسية",
    __typename: "DistrictType",
    district_id: 1598,
    name: "حي القادسية",
    uri: "حي-القادسية",
  },
  'DistrictType:{"path":"/المزاحمية/حي-المروج"}': {
    path: "/المزاحمية/حي-المروج",
    __typename: "DistrictType",
    district_id: 888,
    name: "حي المروج",
    uri: "حي-المروج",
  },
  'DistrictType:{"path":"/حوطة-بني-تميم/حي-الباطن"}': {
    path: "/حوطة-بني-تميم/حي-الباطن",
    __typename: "DistrictType",
    district_id: 912,
    name: "حي الباطن",
    uri: "حي-الباطن",
  },
  'DistrictType:{"path":"/حوطة-بني-تميم/حي-التضامن"}': {
    path: "/حوطة-بني-تميم/حي-التضامن",
    __typename: "DistrictType",
    district_id: 914,
    name: "حي التضامن",
    uri: "حي-التضامن",
  },
  'DistrictType:{"path":"/حوطة-بني-تميم/حي-الحلة"}': {
    path: "/حوطة-بني-تميم/حي-الحلة",
    __typename: "DistrictType",
    district_id: 916,
    name: "حي الحلة",
    uri: "حي-الحلة",
  },
  'DistrictType:{"path":"/حوطة-بني-تميم/حي-النهضة"}': {
    path: "/حوطة-بني-تميم/حي-النهضة",
    __typename: "DistrictType",
    district_id: 934,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/حوطة-بني-تميم/حي-خضار"}': {
    path: "/حوطة-بني-تميم/حي-خضار",
    __typename: "DistrictType",
    district_id: 938,
    name: "حي خضار",
    uri: "حي-خضار",
  },
  'DistrictType:{"path":"/شقراء/حي-الوشم"}': {
    path: "/شقراء/حي-الوشم",
    __typename: "DistrictType",
    district_id: 956,
    name: "حي الوشم",
    uri: "حي-الوشم",
  },
  'DistrictType:{"path":"/عفيف/حي-الاصفر"}': {
    path: "/عفيف/حي-الاصفر",
    __typename: "DistrictType",
    district_id: 964,
    name: "حي الاصفر",
    uri: "حي-الاصفر",
  },
  'DistrictType:{"path":"/الجبيل/حي-الاندلس"}': {
    path: "/الجبيل/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 986,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/الجبيل/حي-الحجاز"}': {
    path: "/الجبيل/حي-الحجاز",
    __typename: "DistrictType",
    district_id: 990,
    name: "حي الحجاز",
    uri: "حي-الحجاز",
  },
  'DistrictType:{"path":"/الدمام/حي-الرابية"}': {
    path: "/الدمام/حي-الرابية",
    __typename: "DistrictType",
    district_id: 1222,
    name: "حي الرابية",
    uri: "حي-الرابية",
  },
  'DistrictType:{"path":"/الدمام/حي-الروضة"}': {
    path: "/الدمام/حي-الروضة",
    __typename: "DistrictType",
    district_id: 1226,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/الدمام/حي-السلام"}': {
    path: "/الدمام/حي-السلام",
    __typename: "DistrictType",
    district_id: 1232,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/الدمام/حي-الشعلة"}': {
    path: "/الدمام/حي-الشعلة",
    __typename: "DistrictType",
    district_id: 1244,
    name: "حي الشعلة",
    uri: "حي-الشعلة",
  },
  'DistrictType:{"path":"/الدمام/حي-القزاز"}': {
    path: "/الدمام/حي-القزاز",
    __typename: "DistrictType",
    district_id: 1276,
    name: "حي القزاز",
    uri: "حي-القزاز",
  },
  'DistrictType:{"path":"/الدمام/حي-المحمدية"}': {
    path: "/الدمام/حي-المحمدية",
    __typename: "DistrictType",
    district_id: 1278,
    name: "حي المحمدية",
    uri: "حي-المحمدية",
  },
  'DistrictType:{"path":"/الدمام/حي-المنار"}': {
    path: "/الدمام/حي-المنار",
    __typename: "DistrictType",
    district_id: 1288,
    name: "حي المنار",
    uri: "حي-المنار",
  },
  'DistrictType:{"path":"/الدمام/حي-المها"}': {
    path: "/الدمام/حي-المها",
    __typename: "DistrictType",
    district_id: 1292,
    name: "حي المها",
    uri: "حي-المها",
  },
  'DistrictType:{"path":"/الدمام/حي-النسيم"}': {
    path: "/الدمام/حي-النسيم",
    __typename: "DistrictType",
    district_id: 1302,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/الظهران/حي-الجامعة"}': {
    path: "/الظهران/حي-الجامعة",
    __typename: "DistrictType",
    district_id: 1334,
    name: "حي الجامعة",
    uri: "حي-الجامعة",
  },
  'DistrictType:{"path":"/الظهران/حي-القصور"}': {
    path: "/الظهران/حي-القصور",
    __typename: "DistrictType",
    district_id: 1348,
    name: "حي القصور",
    uri: "حي-القصور",
  },
  'DistrictType:{"path":"/الظهران/حي-هجر"}': {
    path: "/الظهران/حي-هجر",
    __typename: "DistrictType",
    district_id: 1354,
    name: "حي هجر",
    uri: "حي-هجر",
  },
  'DistrictType:{"path":"/العيون/حي-الحصيمه"}': {
    path: "/العيون/حي-الحصيمه",
    __typename: "DistrictType",
    district_id: 1356,
    name: "حي الحصيمه",
    uri: "حي-الحصيمه",
  },
  'DistrictType:{"path":"/القطيف/حي-البحاري"}': {
    path: "/القطيف/حي-البحاري",
    __typename: "DistrictType",
    district_id: 1376,
    name: "حي البحاري",
    uri: "حي-البحاري",
  },
  'DistrictType:{"path":"/القطيف/حي-البستان"}': {
    path: "/القطيف/حي-البستان",
    __typename: "DistrictType",
    district_id: 1384,
    name: "حي البستان",
    uri: "حي-البستان",
  },
  'DistrictType:{"path":"/القطيف/حي-البوادي"}': {
    path: "/القطيف/حي-البوادي",
    __typename: "DistrictType",
    district_id: 1386,
    name: "حي البوادي",
    uri: "حي-البوادي",
  },
  'DistrictType:{"path":"/القويعية/حي-الجفونية"}': {
    path: "/القويعية/حي-الجفونية",
    __typename: "DistrictType",
    district_id: 824,
    name: "حي الجفونية",
    uri: "حي-الجفونية",
  },
  'DistrictType:{"path":"/القويعية/حي-الزهور"}': {
    path: "/القويعية/حي-الزهور",
    __typename: "DistrictType",
    district_id: 834,
    name: "حي الزهور",
    uri: "حي-الزهور",
  },
  'DistrictType:{"path":"/القويعية/حي-الصناعية"}': {
    path: "/القويعية/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 838,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/المجمعة/حي-الجامعيين"}': {
    path: "/المجمعة/حي-الجامعيين",
    __typename: "DistrictType",
    district_id: 854,
    name: "حي الجامعيين",
    uri: "حي-الجامعيين",
  },
  'DistrictType:{"path":"/المجمعة/حي-الروضة"}': {
    path: "/المجمعة/حي-الروضة",
    __typename: "DistrictType",
    district_id: 858,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/المجمعة/حي-المرقب"}': {
    path: "/المجمعة/حي-المرقب",
    __typename: "DistrictType",
    district_id: 862,
    name: "حي المرقب",
    uri: "حي-المرقب",
  },
  'DistrictType:{"path":"/المجمعة/حي-الملك-عبدالله"}': {
    path: "/المجمعة/حي-الملك-عبدالله",
    __typename: "DistrictType",
    district_id: 870,
    name: "حي الملك عبدالله",
    uri: "حي-الملك-عبدالله",
  },
  'DistrictType:{"path":"/المجمعة/حي-الملك-فهد"}': {
    path: "/المجمعة/حي-الملك-فهد",
    __typename: "DistrictType",
    district_id: 872,
    name: "حي الملك فهد",
    uri: "حي-الملك-فهد",
  },
  'DistrictType:{"path":"/المجمعة/حي-اليرموك"}': {
    path: "/المجمعة/حي-اليرموك",
    __typename: "DistrictType",
    district_id: 874,
    name: "حي اليرموك",
    uri: "حي-اليرموك",
  },
  'DistrictType:{"path":"/المزاحمية/حي-الاندلس"}': {
    path: "/المزاحمية/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 876,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/الشنان/حي-العزيزية"}': {
    path: "/الشنان/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 2004,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/الشنان/حي-الورود"}': {
    path: "/الشنان/حي-الورود",
    __typename: "DistrictType",
    district_id: 2010,
    name: "حي الورود",
    uri: "حي-الورود",
  },
  'DistrictType:{"path":"/حائل/حي-اجا"}': {
    path: "/حائل/حي-اجا",
    __typename: "DistrictType",
    district_id: 2018,
    name: "حي اجا",
    uri: "حي-اجا",
  },
  'DistrictType:{"path":"/حائل/حي-الخزامى"}': {
    path: "/حائل/حي-الخزامى",
    __typename: "DistrictType",
    district_id: 2026,
    name: "حي الخزامى",
    uri: "حي-الخزامى",
  },
  'DistrictType:{"path":"/حائل/حي-المنطقة-الصناعية"}': {
    path: "/حائل/حي-المنطقة-الصناعية",
    __typename: "DistrictType",
    district_id: 2052,
    name: "حي المنطقة الصناعية",
    uri: "حي-المنطقة-الصناعية",
  },
  'DistrictType:{"path":"/حائل/حي-النسية"}': {
    path: "/حائل/حي-النسية",
    __typename: "DistrictType",
    district_id: 2054,
    name: "حي النسية",
    uri: "حي-النسية",
  },
  'DistrictType:{"path":"/حائل/حي-سماح"}': {
    path: "/حائل/حي-سماح",
    __typename: "DistrictType",
    district_id: 2064,
    name: "حي سماح",
    uri: "حي-سماح",
  },
  'DistrictType:{"path":"/البدائع/حي-الاصفر"}': {
    path: "/البدائع/حي-الاصفر",
    __typename: "DistrictType",
    district_id: 2066,
    name: "حي الاصفر",
    uri: "حي-الاصفر",
  },
  'DistrictType:{"path":"/البدائع/حي-الدحلة"}': {
    path: "/البدائع/حي-الدحلة",
    __typename: "DistrictType",
    district_id: 2074,
    name: "حي الدحلة",
    uri: "حي-الدحلة",
  },
  'DistrictType:{"path":"/البدائع/حي-العبدلية"}': {
    path: "/البدائع/حي-العبدلية",
    __typename: "DistrictType",
    district_id: 2082,
    name: "حي العبدلية",
    uri: "حي-العبدلية",
  },
  'DistrictType:{"path":"/البدائع/حي-العليا"}': {
    path: "/البدائع/حي-العليا",
    __typename: "DistrictType",
    district_id: 2090,
    name: "حي العليا",
    uri: "حي-العليا",
  },
  'DistrictType:{"path":"/البدائع/حي-المستشفى"}': {
    path: "/البدائع/حي-المستشفى",
    __typename: "DistrictType",
    district_id: 2092,
    name: "حي المستشفى",
    uri: "حي-المستشفى",
  },
  'DistrictType:{"path":"/البكيرية/حي-الروضة"}': {
    path: "/البكيرية/حي-الروضة",
    __typename: "DistrictType",
    district_id: 2112,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/البكيرية/حي-الفهد"}': {
    path: "/البكيرية/حي-الفهد",
    __typename: "DistrictType",
    district_id: 2118,
    name: "حي الفهد",
    uri: "حي-الفهد",
  },
  'DistrictType:{"path":"/البكيرية/حي-مخطط-المحمدية"}': {
    path: "/البكيرية/حي-مخطط-المحمدية",
    __typename: "DistrictType",
    district_id: 2126,
    name: "حي مخطط المحمدية",
    uri: "حي-مخطط-المحمدية",
  },
  'DistrictType:{"path":"/الرس/حي-الاندلس"}': {
    path: "/الرس/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 2130,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/الرس/حي-الروضة"}': {
    path: "/الرس/حي-الروضة",
    __typename: "DistrictType",
    district_id: 2142,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/الرس/حي-السعادة"}': {
    path: "/الرس/حي-السعادة",
    __typename: "DistrictType",
    district_id: 2148,
    name: "حي السعادة",
    uri: "حي-السعادة",
  },
  'DistrictType:{"path":"/الرس/حي-الصناعية"}': {
    path: "/الرس/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 2152,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/الرس/حي-القادسية"}': {
    path: "/الرس/حي-القادسية",
    __typename: "DistrictType",
    district_id: 2154,
    name: "حي القادسية",
    uri: "حي-القادسية",
  },
  'DistrictType:{"path":"/الرس/حي-الملك-عبدالعزيز"}': {
    path: "/الرس/حي-الملك-عبدالعزيز",
    __typename: "DistrictType",
    district_id: 2160,
    name: "حي الملك عبدالعزيز",
    uri: "حي-الملك-عبدالعزيز",
  },
  'DistrictType:{"path":"/الشماسية/حي-البلاد"}': {
    path: "/الشماسية/حي-البلاد",
    __typename: "DistrictType",
    district_id: 2176,
    name: "حي البلاد",
    uri: "حي-البلاد",
  },
  'DistrictType:{"path":"/الشماسية/حي-الجال"}': {
    path: "/الشماسية/حي-الجال",
    __typename: "DistrictType",
    district_id: 2178,
    name: "حي الجال",
    uri: "حي-الجال",
  },
  'DistrictType:{"path":"/الشماسية/حي-الشماسية"}': {
    path: "/الشماسية/حي-الشماسية",
    __typename: "DistrictType",
    district_id: 2182,
    name: "حي الشماسية",
    uri: "حي-الشماسية",
  },
  'DistrictType:{"path":"/الشماسية/حي-الفاروق"}': {
    path: "/الشماسية/حي-الفاروق",
    __typename: "DistrictType",
    district_id: 2188,
    name: "حي الفاروق",
    uri: "حي-الفاروق",
  },
  'DistrictType:{"path":"/الشماسية/حي-القادسية"}': {
    path: "/الشماسية/حي-القادسية",
    __typename: "DistrictType",
    district_id: 2190,
    name: "حي القادسية",
    uri: "حي-القادسية",
  },
  'DistrictType:{"path":"/العلا/حي-الرزيقية"}': {
    path: "/العلا/حي-الرزيقية",
    __typename: "DistrictType",
    district_id: 2206,
    name: "حي الرزيقية",
    uri: "حي-الرزيقية",
  },
  'DistrictType:{"path":"/العلا/حي-السلام"}': {
    path: "/العلا/حي-السلام",
    __typename: "DistrictType",
    district_id: 2208,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/العلا/حي-العزيزية"}': {
    path: "/العلا/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 2212,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/المذنب/حي-الجديدة"}': {
    path: "/المذنب/حي-الجديدة",
    __typename: "DistrictType",
    district_id: 2222,
    name: "حي الجديدة",
    uri: "حي-الجديدة",
  },
  'DistrictType:{"path":"/المذنب/حي-الخزامي"}': {
    path: "/المذنب/حي-الخزامي",
    __typename: "DistrictType",
    district_id: 2228,
    name: "حي الخزامي",
    uri: "حي-الخزامي",
  },
  'DistrictType:{"path":"/المذنب/حي-السلام"}': {
    path: "/المذنب/حي-السلام",
    __typename: "DistrictType",
    district_id: 2232,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/المذنب/حي-الصناعية"}': {
    path: "/المذنب/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 2238,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/النبهانية/حي-النبهانية"}': {
    path: "/النبهانية/حي-النبهانية",
    __typename: "DistrictType",
    district_id: 2256,
    name: "حي النبهانية",
    uri: "حي-النبهانية",
  },
  'CityType:{"uri":"النبهانية"}': {
    uri: "النبهانية",
    __typename: "CityType",
    city_id: 44,
    name: "النبهانية",
    path: "/النبهانية",
  },
  'DistrictType:{"path":"/بريدة/حي-الاسكان"}': {
    path: "/بريدة/حي-الاسكان",
    __typename: "DistrictType",
    district_id: 2262,
    name: "حي الاسكان",
    uri: "حي-الاسكان",
  },
  'DistrictType:{"path":"/بريدة/حي-البشر"}': {
    path: "/بريدة/حي-البشر",
    __typename: "DistrictType",
    district_id: 2268,
    name: "حي البشر",
    uri: "حي-البشر",
  },
  'DistrictType:{"path":"/بريدة/حي-الحويقية"}': {
    path: "/بريدة/حي-الحويقية",
    __typename: "DistrictType",
    district_id: 2288,
    name: "حي الحويقية",
    uri: "حي-الحويقية",
  },
  'DistrictType:{"path":"/بريدة/حي-الدعيسة"}': {
    path: "/بريدة/حي-الدعيسة",
    __typename: "DistrictType",
    district_id: 2294,
    name: "حي الدعيسة",
    uri: "حي-الدعيسة",
  },
  'DistrictType:{"path":"/بريدة/حي-الرفيعة"}': {
    path: "/بريدة/حي-الرفيعة",
    __typename: "DistrictType",
    district_id: 2300,
    name: "حي الرفيعة",
    uri: "حي-الرفيعة",
  },
  'DistrictType:{"path":"/بريدة/حي-الشماس"}': {
    path: "/بريدة/حي-الشماس",
    __typename: "DistrictType",
    district_id: 2316,
    name: "حي الشماس",
    uri: "حي-الشماس",
  },
  'DistrictType:{"path":"/بريدة/حي-العليا"}': {
    path: "/بريدة/حي-العليا",
    __typename: "DistrictType",
    district_id: 2332,
    name: "حي العليا",
    uri: "حي-العليا",
  },
  'DistrictType:{"path":"/بريدة/حي-القصيعة"}': {
    path: "/بريدة/حي-القصيعة",
    __typename: "DistrictType",
    district_id: 2342,
    name: "حي القصيعة",
    uri: "حي-القصيعة",
  },
  'DistrictType:{"path":"/بريدة/حي-المظلل"}': {
    path: "/بريدة/حي-المظلل",
    __typename: "DistrictType",
    district_id: 2352,
    name: "حي المظلل",
    uri: "حي-المظلل",
  },
  'DistrictType:{"path":"/بريدة/حي-المنتزه-الجنوبي"}': {
    path: "/بريدة/حي-المنتزه-الجنوبي",
    __typename: "DistrictType",
    district_id: 2358,
    name: "حي المنتزه الجنوبي",
    uri: "حي-المنتزه-الجنوبي",
  },
  'DistrictType:{"path":"/بريدة/حي-الموطا"}': {
    path: "/بريدة/حي-الموطا",
    __typename: "DistrictType",
    district_id: 2360,
    name: "حي الموطا",
    uri: "حي-الموطا",
  },
  'DistrictType:{"path":"/بريدة/حي-النازية"}': {
    path: "/بريدة/حي-النازية",
    __typename: "DistrictType",
    district_id: 2362,
    name: "حي النازية",
    uri: "حي-النازية",
  },
  'DistrictType:{"path":"/بريدة/حي-النقع-الشرقية"}': {
    path: "/بريدة/حي-النقع-الشرقية",
    __typename: "DistrictType",
    district_id: 2370,
    name: "حي النقع الشرقية",
    uri: "حي-النقع-الشرقية",
  },
  'DistrictType:{"path":"/بريدة/حي-حويلان"}': {
    path: "/بريدة/حي-حويلان",
    __typename: "DistrictType",
    district_id: 2382,
    name: "حي حويلان",
    uri: "حي-حويلان",
  },
  'DistrictType:{"path":"/بريدة/حي-خب-البريدي"}': {
    path: "/بريدة/حي-خب-البريدي",
    __typename: "DistrictType",
    district_id: 2384,
    name: "حي خب البريدي",
    uri: "حي-خب-البريدي",
  },
  'DistrictType:{"path":"/بريدة/حي-خضيراء"}': {
    path: "/بريدة/حي-خضيراء",
    __typename: "DistrictType",
    district_id: 2398,
    name: "حي خضيراء",
    uri: "حي-خضيراء",
  },
  'DistrictType:{"path":"/عنيزة/حي-الوادي"}': {
    path: "/عنيزة/حي-الوادي",
    __typename: "DistrictType",
    district_id: 2608,
    name: "حي الوادي",
    uri: "حي-الوادي",
  },
  'DistrictType:{"path":"/عنيزة/حي-عكاظ"}': {
    path: "/عنيزة/حي-عكاظ",
    __typename: "DistrictType",
    district_id: 2632,
    name: "حي عكاظ",
    uri: "حي-عكاظ",
  },
  'DistrictType:{"path":"/عنيزة/حي-قرطبة"}': {
    path: "/عنيزة/حي-قرطبة",
    __typename: "DistrictType",
    district_id: 2636,
    name: "حي قرطبة",
    uri: "حي-قرطبة",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-التحلية"}': {
    path: "/دومة-الجندل/حي-التحلية",
    __typename: "DistrictType",
    district_id: 2652,
    name: "حي التحلية",
    uri: "حي-التحلية",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الجرعاوي"}': {
    path: "/دومة-الجندل/حي-الجرعاوي",
    __typename: "DistrictType",
    district_id: 2654,
    name: "حي الجرعاوي",
    uri: "حي-الجرعاوي",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-السديرية"}': {
    path: "/دومة-الجندل/حي-السديرية",
    __typename: "DistrictType",
    district_id: 2668,
    name: "حي السديرية",
    uri: "حي-السديرية",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-النسيم"}': {
    path: "/دومة-الجندل/حي-النسيم",
    __typename: "DistrictType",
    district_id: 2702,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-قراطين"}': {
    path: "/دومة-الجندل/حي-قراطين",
    __typename: "DistrictType",
    district_id: 2710,
    name: "حي قراطين",
    uri: "حي-قراطين",
  },
  'DistrictType:{"path":"/سكاكا/حي-الربوة"}': {
    path: "/سكاكا/حي-الربوة",
    __typename: "DistrictType",
    district_id: 2712,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/سكاكا/حي-الروضة"}': {
    path: "/سكاكا/حي-الروضة",
    __typename: "DistrictType",
    district_id: 2718,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/سكاكا/حي-القرعا"}': {
    path: "/سكاكا/حي-القرعا",
    __typename: "DistrictType",
    district_id: 2738,
    name: "حي القرعا",
    uri: "حي-القرعا",
  },
  'DistrictType:{"path":"/سكاكا/حي-المحمدية"}': {
    path: "/سكاكا/حي-المحمدية",
    __typename: "DistrictType",
    district_id: 2742,
    name: "حي المحمدية",
    uri: "حي-المحمدية",
  },
  'DistrictType:{"path":"/سكاكا/حي-مخطط-الزهور"}': {
    path: "/سكاكا/حي-مخطط-الزهور",
    __typename: "DistrictType",
    district_id: 2782,
    name: "حي مخطط الزهور",
    uri: "حي-مخطط-الزهور",
  },
  'DistrictType:{"path":"/سكاكا/حي-مخطط-الصناعية"}': {
    path: "/سكاكا/حي-مخطط-الصناعية",
    __typename: "DistrictType",
    district_id: 2786,
    name: "حي مخطط الصناعية",
    uri: "حي-مخطط-الصناعية",
  },
  'DistrictType:{"path":"/سكاكا/حي-مخطط-العروبة"}': {
    path: "/سكاكا/حي-مخطط-العروبة",
    __typename: "DistrictType",
    district_id: 2788,
    name: "حي مخطط العروبة",
    uri: "حي-مخطط-العروبة",
  },
  'DistrictType:{"path":"/سكاكا/حي-مخطط-القديم"}': {
    path: "/سكاكا/حي-مخطط-القديم",
    __typename: "DistrictType",
    district_id: 2794,
    name: "حي مخطط القديم",
    uri: "حي-مخطط-القديم",
  },
  'DistrictType:{"path":"/الوجه/حي-الخالدية"}': {
    path: "/الوجه/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 2806,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/املج/حي-البطحاء"}': {
    path: "/املج/حي-البطحاء",
    __typename: "DistrictType",
    district_id: 2816,
    name: "حي البطحاء",
    uri: "حي-البطحاء",
  },
  'DistrictType:{"path":"/املج/حي-النسيم"}': {
    path: "/املج/حي-النسيم",
    __typename: "DistrictType",
    district_id: 2836,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/تبوك/حي-اسكان-قوى-الامن-العام"}': {
    path: "/تبوك/حي-اسكان-قوى-الامن-العام",
    __typename: "DistrictType",
    district_id: 2840,
    name: "حي اسكان قوى الامن العام",
    uri: "حي-اسكان-قوى-الامن-العام",
  },
  'DistrictType:{"path":"/تبوك/حي-السعادة"}': {
    path: "/تبوك/حي-السعادة",
    __typename: "DistrictType",
    district_id: 2848,
    name: "حي السعادة",
    uri: "حي-السعادة",
  },
  'DistrictType:{"path":"/تبوك/حي-المروج-ب"}': {
    path: "/تبوك/حي-المروج-ب",
    __typename: "DistrictType",
    district_id: 2874,
    name: "حي المروج ب",
    uri: "حي-المروج-ب",
  },
  'DistrictType:{"path":"/تبوك/حي-المنتزه"}': {
    path: "/تبوك/حي-المنتزه",
    __typename: "DistrictType",
    district_id: 2878,
    name: "حي المنتزه",
    uri: "حي-المنتزه",
  },
  'DistrictType:{"path":"/تيماء/حي-هداج"}': {
    path: "/تيماء/حي-هداج",
    __typename: "DistrictType",
    district_id: 2916,
    name: "حي هداج",
    uri: "حي-هداج",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-ابو-بريقاء"}': {
    path: "/المدينة-المنورة/حي-ابو-بريقاء",
    __typename: "DistrictType",
    district_id: 2922,
    name: "حي ابو بريقاء",
    uri: "حي-ابو-بريقاء",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الجصة"}': {
    path: "/المدينة-المنورة/حي-الجصة",
    __typename: "DistrictType",
    district_id: 2938,
    name: "حي الجصة",
    uri: "حي-الجصة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الراية"}': {
    path: "/المدينة-المنورة/حي-الراية",
    __typename: "DistrictType",
    district_id: 2962,
    name: "حي الراية",
    uri: "حي-الراية",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الشهباء"}': {
    path: "/المدينة-المنورة/حي-الشهباء",
    __typename: "DistrictType",
    district_id: 2984,
    name: "حي الشهباء",
    uri: "حي-الشهباء",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-العزيزية"}': {
    path: "/المدينة-المنورة/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 2994,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/عنيزة/حي-الحديقة"}': {
    path: "/عنيزة/حي-الحديقة",
    __typename: "DistrictType",
    district_id: 2486,
    name: "حي الحديقة",
    uri: "حي-الحديقة",
  },
  'DistrictType:{"path":"/عنيزة/حي-الرياضى"}': {
    path: "/عنيزة/حي-الرياضى",
    __typename: "DistrictType",
    district_id: 2514,
    name: "حي الرياضى",
    uri: "حي-الرياضى",
  },
  'DistrictType:{"path":"/عنيزة/حي-الزغبية"}': {
    path: "/عنيزة/حي-الزغبية",
    __typename: "DistrictType",
    district_id: 2520,
    name: "حي الزغبية",
    uri: "حي-الزغبية",
  },
  'DistrictType:{"path":"/عنيزة/حي-السحيمية"}': {
    path: "/عنيزة/حي-السحيمية",
    __typename: "DistrictType",
    district_id: 2524,
    name: "حي السحيمية",
    uri: "حي-السحيمية",
  },
  'DistrictType:{"path":"/عنيزة/حي-الصالحية"}': {
    path: "/عنيزة/حي-الصالحية",
    __typename: "DistrictType",
    district_id: 2534,
    name: "حي الصالحية",
    uri: "حي-الصالحية",
  },
  'DistrictType:{"path":"/عنيزة/حي-العونية"}': {
    path: "/عنيزة/حي-العونية",
    __typename: "DistrictType",
    district_id: 2546,
    name: "حي العونية",
    uri: "حي-العونية",
  },
  'DistrictType:{"path":"/عنيزة/حي-الفاخرية"}': {
    path: "/عنيزة/حي-الفاخرية",
    __typename: "DistrictType",
    district_id: 2550,
    name: "حي الفاخرية",
    uri: "حي-الفاخرية",
  },
  'DistrictType:{"path":"/عنيزة/حي-الفخامة"}': {
    path: "/عنيزة/حي-الفخامة",
    __typename: "DistrictType",
    district_id: 2552,
    name: "حي الفخامة",
    uri: "حي-الفخامة",
  },
  'DistrictType:{"path":"/عنيزة/حي-القيروان"}': {
    path: "/عنيزة/حي-القيروان",
    __typename: "DistrictType",
    district_id: 2562,
    name: "حي القيروان",
    uri: "حي-القيروان",
  },
  'DistrictType:{"path":"/عنيزة/حي-المروة"}': {
    path: "/عنيزة/حي-المروة",
    __typename: "DistrictType",
    district_id: 2570,
    name: "حي المروة",
    uri: "حي-المروة",
  },
  'DistrictType:{"path":"/عنيزة/حي-الملك-فهد"}': {
    path: "/عنيزة/حي-الملك-فهد",
    __typename: "DistrictType",
    district_id: 2582,
    name: "حي الملك فهد",
    uri: "حي-الملك-فهد",
  },
  'DistrictType:{"path":"/عنيزة/حي-الندى"}': {
    path: "/عنيزة/حي-الندى",
    __typename: "DistrictType",
    district_id: 2592,
    name: "حي الندى",
    uri: "حي-الندى",
  },
  'DistrictType:{"path":"/عنيزة/حي-النرجس"}': {
    path: "/عنيزة/حي-النرجس",
    __typename: "DistrictType",
    district_id: 2594,
    name: "حي النرجس",
    uri: "حي-النرجس",
  },
  'DistrictType:{"path":"/الهفوف/حي-القديمات"}': {
    path: "/الهفوف/حي-القديمات",
    __typename: "DistrictType",
    district_id: 1602,
    name: "حي القديمات",
    uri: "حي-القديمات",
  },
  'DistrictType:{"path":"/الهفوف/حي-المزروعية"}': {
    path: "/الهفوف/حي-المزروعية",
    __typename: "DistrictType",
    district_id: 1618,
    name: "حي المزروعية",
    uri: "حي-المزروعية",
  },
  'DistrictType:{"path":"/الهفوف/حي-المنصورة"}': {
    path: "/الهفوف/حي-المنصورة",
    __typename: "DistrictType",
    district_id: 1628,
    name: "حي المنصورة",
    uri: "حي-المنصورة",
  },
  'DistrictType:{"path":"/الهفوف/حي-النايفية"}': {
    path: "/الهفوف/حي-النايفية",
    __typename: "DistrictType",
    district_id: 1632,
    name: "حي النايفية",
    uri: "حي-النايفية",
  },
  'DistrictType:{"path":"/الهفوف/حي-الواحة"}': {
    path: "/الهفوف/حي-الواحة",
    __typename: "DistrictType",
    district_id: 1640,
    name: "حي الواحة",
    uri: "حي-الواحة",
  },
  'DistrictType:{"path":"/الهفوف/حي-بني-معن"}': {
    path: "/الهفوف/حي-بني-معن",
    __typename: "DistrictType",
    district_id: 1646,
    name: "حي بني معن",
    uri: "حي-بني-معن",
  },
  'DistrictType:{"path":"/الهفوف/حي-جنوب-منسوبي-التعليم"}': {
    path: "/الهفوف/حي-جنوب-منسوبي-التعليم",
    __typename: "DistrictType",
    district_id: 1654,
    name: "حي جنوب منسوبي التعليم",
    uri: "حي-جنوب-منسوبي-التعليم",
  },
  'DistrictType:{"path":"/الهفوف/حي-جواثا"}': {
    path: "/الهفوف/حي-جواثا",
    __typename: "DistrictType",
    district_id: 1656,
    name: "حي جواثا",
    uri: "حي-جواثا",
  },
  'DistrictType:{"path":"/الهفوف/حي-مخطط-علي-الخرس-واحمد-الشهاب"}': {
    path: "/الهفوف/حي-مخطط-علي-الخرس-واحمد-الشهاب",
    __typename: "DistrictType",
    district_id: 1670,
    name: "حي مخطط علي الخرس واحمد الشهاب",
    uri: "حي-مخطط-علي-الخرس-واحمد-الشهاب",
  },
  'DistrictType:{"path":"/تاروت/حي-الجوهرة"}': {
    path: "/تاروت/حي-الجوهرة",
    __typename: "DistrictType",
    district_id: 1712,
    name: "حي الجوهرة",
    uri: "حي-الجوهرة",
  },
  'DistrictType:{"path":"/تاروت/حي-الزمرد"}': {
    path: "/تاروت/حي-الزمرد",
    __typename: "DistrictType",
    district_id: 1718,
    name: "حي الزمرد",
    uri: "حي-الزمرد",
  },
  'DistrictType:{"path":"/تاروت/حي-اللؤلؤ"}': {
    path: "/تاروت/حي-اللؤلؤ",
    __typename: "DistrictType",
    district_id: 1726,
    name: "حي اللؤلؤ",
    uri: "حي-اللؤلؤ",
  },
  'DistrictType:{"path":"/تاروت/حي-النرجس"}': {
    path: "/تاروت/حي-النرجس",
    __typename: "DistrictType",
    district_id: 1732,
    name: "حي النرجس",
    uri: "حي-النرجس",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-التعاون"}': {
    path: "/رياض-الخبراء/حي-التعاون",
    __typename: "DistrictType",
    district_id: 2420,
    name: "حي التعاون",
    uri: "حي-التعاون",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-الرفيعة"}': {
    path: "/رياض-الخبراء/حي-الرفيعة",
    __typename: "DistrictType",
    district_id: 2432,
    name: "حي الرفيعة",
    uri: "حي-الرفيعة",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-السلاح"}': {
    path: "/رياض-الخبراء/حي-السلاح",
    __typename: "DistrictType",
    district_id: 2442,
    name: "حي السلاح",
    uri: "حي-السلاح",
  },
  'DistrictType:{"path":"/عنيزة/حي-الاسكان"}': {
    path: "/عنيزة/حي-الاسكان",
    __typename: "DistrictType",
    district_id: 2462,
    name: "حي الاسكان",
    uri: "حي-الاسكان",
  },
  'DistrictType:{"path":"/عنيزة/حي-البويطن"}': {
    path: "/عنيزة/حي-البويطن",
    __typename: "DistrictType",
    district_id: 2470,
    name: "حي البويطن",
    uri: "حي-البويطن",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الاسكان"}': {
    path: "/حفر-الباطن/حي-الاسكان",
    __typename: "DistrictType",
    district_id: 1742,
    name: "حي الاسكان",
    uri: "حي-الاسكان",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الرائد"}': {
    path: "/حفر-الباطن/حي-الرائد",
    __typename: "DistrictType",
    district_id: 1758,
    name: "حي الرائد",
    uri: "حي-الرائد",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الريان"}': {
    path: "/حفر-الباطن/حي-الريان",
    __typename: "DistrictType",
    district_id: 1766,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الصفاء"}': {
    path: "/حفر-الباطن/حي-الصفاء",
    __typename: "DistrictType",
    district_id: 1772,
    name: "حي الصفاء",
    uri: "حي-الصفاء",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-النايفية"}': {
    path: "/حفر-الباطن/حي-النايفية",
    __typename: "DistrictType",
    district_id: 1790,
    name: "حي النايفية",
    uri: "حي-النايفية",
  },
  'DistrictType:{"path":"/الوجه/حي-الصفا"}': {
    path: "/الوجه/حي-الصفا",
    __typename: "DistrictType",
    district_id: 2808,
    name: "حي الصفا",
    uri: "حي-الصفا",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-المطار"}': {
    path: "/المدينة-المنورة/حي-المطار",
    __typename: "DistrictType",
    district_id: 3018,
    name: "حي المطار",
    uri: "حي-المطار",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-المغيسلة"}': {
    path: "/المدينة-المنورة/حي-المغيسلة",
    __typename: "DistrictType",
    district_id: 3020,
    name: "حي المغيسلة",
    uri: "حي-المغيسلة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-رهط"}': {
    path: "/المدينة-المنورة/حي-رهط",
    __typename: "DistrictType",
    district_id: 3060,
    name: "حي رهط",
    uri: "حي-رهط",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-مذينب"}': {
    path: "/المدينة-المنورة/حي-مذينب",
    __typename: "DistrictType",
    district_id: 3080,
    name: "حي مذينب",
    uri: "حي-مذينب",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-ورقان"}': {
    path: "/المدينة-المنورة/حي-ورقان",
    __typename: "DistrictType",
    district_id: 3088,
    name: "حي ورقان",
    uri: "حي-ورقان",
  },
  'DistrictType:{"path":"/بدر/حي-الغزوة"}': {
    path: "/بدر/حي-الغزوة",
    __typename: "DistrictType",
    district_id: 3104,
    name: "حي الغزوة",
    uri: "حي-الغزوة",
  },
  'DistrictType:{"path":"/خيبر/حي-العزيزية"}': {
    path: "/خيبر/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 3112,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/خيبر/حي-الفيصلية"}': {
    path: "/خيبر/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 3114,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/ينبع/حي-الاصالة"}': {
    path: "/ينبع/حي-الاصالة",
    __typename: "DistrictType",
    district_id: 3120,
    name: "حي الاصالة",
    uri: "حي-الاصالة",
  },
  'DistrictType:{"path":"/ينبع/حي-الخالد"}': {
    path: "/ينبع/حي-الخالد",
    __typename: "DistrictType",
    district_id: 3154,
    name: "حي الخالد",
    uri: "حي-الخالد",
  },
  'DistrictType:{"path":"/ينبع/حي-السويق"}': {
    path: "/ينبع/حي-السويق",
    __typename: "DistrictType",
    district_id: 3180,
    name: "حي السويق",
    uri: "حي-السويق",
  },
  'DistrictType:{"path":"/ينبع/حي-الشربتلي"}': {
    path: "/ينبع/حي-الشربتلي",
    __typename: "DistrictType",
    district_id: 3184,
    name: "حي الشربتلي",
    uri: "حي-الشربتلي",
  },
  'DistrictType:{"path":"/ينبع/حي-الشروق"}': {
    path: "/ينبع/حي-الشروق",
    __typename: "DistrictType",
    district_id: 3186,
    name: "حي الشروق",
    uri: "حي-الشروق",
  },
  'DistrictType:{"path":"/ينبع/حي-الصواري"}': {
    path: "/ينبع/حي-الصواري",
    __typename: "DistrictType",
    district_id: 3198,
    name: "حي الصواري",
    uri: "حي-الصواري",
  },
  'DistrictType:{"path":"/ينبع/حي-العزيزية"}': {
    path: "/ينبع/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 3202,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/ينبع/حي-الفهد"}': {
    path: "/ينبع/حي-الفهد",
    __typename: "DistrictType",
    district_id: 3210,
    name: "حي الفهد",
    uri: "حي-الفهد",
  },
  'DistrictType:{"path":"/ينبع/حي-القاد"}': {
    path: "/ينبع/حي-القاد",
    __typename: "DistrictType",
    district_id: 3214,
    name: "حي القاد",
    uri: "حي-القاد",
  },
  'DistrictType:{"path":"/ينبع/حي-المبارك"}': {
    path: "/ينبع/حي-المبارك",
    __typename: "DistrictType",
    district_id: 3218,
    name: "حي المبارك",
    uri: "حي-المبارك",
  },
  'DistrictType:{"path":"/ينبع/حي-المحارة"}': {
    path: "/ينبع/حي-المحارة",
    __typename: "DistrictType",
    district_id: 3222,
    name: "حي المحارة",
    uri: "حي-المحارة",
  },
  'DistrictType:{"path":"/ينبع/حي-المشهد"}': {
    path: "/ينبع/حي-المشهد",
    __typename: "DistrictType",
    district_id: 3228,
    name: "حي المشهد",
    uri: "حي-المشهد",
  },
  'DistrictType:{"path":"/ينبع/حي-النخيل"}': {
    path: "/ينبع/حي-النخيل",
    __typename: "DistrictType",
    district_id: 3240,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/ينبع/حي-النزهة"}': {
    path: "/ينبع/حي-النزهة",
    __typename: "DistrictType",
    district_id: 3242,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/ينبع/حي-النسيم"}': {
    path: "/ينبع/حي-النسيم",
    __typename: "DistrictType",
    district_id: 3244,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/ينبع/حي-النهضة"}': {
    path: "/ينبع/حي-النهضة",
    __typename: "DistrictType",
    district_id: 3246,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/ينبع/حي-الواحة"}': {
    path: "/ينبع/حي-الواحة",
    __typename: "DistrictType",
    district_id: 3252,
    name: "حي الواحة",
    uri: "حي-الواحة",
  },
  'DistrictType:{"path":"/ينبع/حي-الياقوت"}': {
    path: "/ينبع/حي-الياقوت",
    __typename: "DistrictType",
    district_id: 3254,
    name: "حي الياقوت",
    uri: "حي-الياقوت",
  },
  'DistrictType:{"path":"/ينبع/حي-عبائر"}': {
    path: "/ينبع/حي-عبائر",
    __typename: "DistrictType",
    district_id: 3262,
    name: "حي عبائر",
    uri: "حي-عبائر",
  },
  'DistrictType:{"path":"/الجموم/حي-السلام"}': {
    path: "/الجموم/حي-السلام",
    __typename: "DistrictType",
    district_id: 3272,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/الجموم/حي-النسيم"}': {
    path: "/الجموم/حي-النسيم",
    __typename: "DistrictType",
    district_id: 3288,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/الجموم/حي-النقابة"}': {
    path: "/الجموم/حي-النقابة",
    __typename: "DistrictType",
    district_id: 3290,
    name: "حي النقابة",
    uri: "حي-النقابة",
  },
  'DistrictType:{"path":"/الخرمة/حي-الهجرة"}': {
    path: "/الخرمة/حي-الهجرة",
    __typename: "DistrictType",
    district_id: 3316,
    name: "حي الهجرة",
    uri: "حي-الهجرة",
  },
  'DistrictType:{"path":"/الطائف/حي-الجال"}': {
    path: "/الطائف/حي-الجال",
    __typename: "DistrictType",
    district_id: 3318,
    name: "حي الجال",
    uri: "حي-الجال",
  },
  'DistrictType:{"path":"/الطائف/حي-الشرقية"}': {
    path: "/الطائف/حي-الشرقية",
    __typename: "DistrictType",
    district_id: 3328,
    name: "حي الشرقية",
    uri: "حي-الشرقية",
  },
  'DistrictType:{"path":"/الطائف/حي-العزيزية"}': {
    path: "/الطائف/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 3334,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/الطائف/حي-المنطقة-المركزية"}': {
    path: "/الطائف/حي-المنطقة-المركزية",
    __typename: "DistrictType",
    district_id: 3346,
    name: "حي المنطقة المركزية",
    uri: "حي-المنطقة-المركزية",
  },
  'DistrictType:{"path":"/الطائف/حي-الوكف"}': {
    path: "/الطائف/حي-الوكف",
    __typename: "DistrictType",
    district_id: 3354,
    name: "حي الوكف",
    uri: "حي-الوكف",
  },
  'DistrictType:{"path":"/الطائف/حي-الوكيف"}': {
    path: "/الطائف/حي-الوكيف",
    __typename: "DistrictType",
    district_id: 3356,
    name: "حي الوكيف",
    uri: "حي-الوكيف",
  },
  'DistrictType:{"path":"/الطائف/حي-الوهط"}': {
    path: "/الطائف/حي-الوهط",
    __typename: "DistrictType",
    district_id: 3358,
    name: "حي الوهط",
    uri: "حي-الوهط",
  },
  'DistrictType:{"path":"/الطائف/حي-شهار"}': {
    path: "/الطائف/حي-شهار",
    __typename: "DistrictType",
    district_id: 3368,
    name: "حي شهار",
    uri: "حي-شهار",
  },
  'DistrictType:{"path":"/الطائف/حي-عودة"}': {
    path: "/الطائف/حي-عودة",
    __typename: "DistrictType",
    district_id: 3370,
    name: "حي عودة",
    uri: "حي-عودة",
  },
  'DistrictType:{"path":"/الطائف/حي-نخب"}': {
    path: "/الطائف/حي-نخب",
    __typename: "DistrictType",
    district_id: 3378,
    name: "حي نخب",
    uri: "حي-نخب",
  },
  'DistrictType:{"path":"/الكامل/حي-الكامل"}': {
    path: "/الكامل/حي-الكامل",
    __typename: "DistrictType",
    district_id: 3394,
    name: "حي الكامل",
    uri: "حي-الكامل",
  },
  'CityType:{"uri":"الكامل"}': {
    uri: "الكامل",
    __typename: "CityType",
    city_id: 36,
    name: "الكامل",
    path: "/الكامل",
  },
  'DistrictType:{"path":"/الليث/حي-الليث"}': {
    path: "/الليث/حي-الليث",
    __typename: "DistrictType",
    district_id: 3398,
    name: "حي الليث",
    uri: "حي-الليث",
  },
  'DistrictType:{"path":"/ثول/حي-ثول"}': {
    path: "/ثول/حي-ثول",
    __typename: "DistrictType",
    district_id: 3416,
    name: "حي ثول",
    uri: "حي-ثول",
  },
  'CityType:{"uri":"ثول"}': {
    uri: "ثول",
    __typename: "CityType",
    city_id: 64,
    name: "ثول",
    path: "/ثول",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-ابحر-الجنوبية"}': {
    path: "/جدة/شمال-جدة/حي-ابحر-الجنوبية",
    __typename: "DistrictType",
    district_id: 3422,
    name: "حي ابحر الجنوبية",
    uri: "حي-ابحر-الجنوبية",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الاصالة"}': {
    path: "/جدة/شمال-جدة/حي-الاصالة",
    __typename: "DistrictType",
    district_id: 3430,
    name: "حي الاصالة",
    uri: "حي-الاصالة",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-البغدادية-الغربية"}': {
    path: "/جدة/شمال-جدة/حي-البغدادية-الغربية",
    __typename: "DistrictType",
    district_id: 3450,
    name: "حي البغدادية الغربية",
    uri: "حي-البغدادية-الغربية",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الخالدية"}': {
    path: "/جدة/شمال-جدة/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 3472,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-السبيل"}': {
    path: "/جدة/جنوب-جدة/حي-السبيل",
    __typename: "DistrictType",
    district_id: 3502,
    name: "حي السبيل",
    uri: "حي-السبيل",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-السلامة"}': {
    path: "/جدة/شمال-جدة/حي-السلامة",
    __typename: "DistrictType",
    district_id: 3508,
    name: "حي السلامة",
    uri: "حي-السلامة",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-السليمانية"}': {
    path: "/جدة/شمال-جدة/حي-السليمانية",
    __typename: "DistrictType",
    district_id: 3510,
    name: "حي السليمانية",
    uri: "حي-السليمانية",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الشاطئ"}': {
    path: "/جدة/شمال-جدة/حي-الشاطئ",
    __typename: "DistrictType",
    district_id: 3514,
    name: "حي الشاطئ",
    uri: "حي-الشاطئ",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الشرفية"}': {
    path: "/جدة/شمال-جدة/حي-الشرفية",
    __typename: "DistrictType",
    district_id: 3518,
    name: "حي الشرفية",
    uri: "حي-الشرفية",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-القريات"}': {
    path: "/جدة/جنوب-جدة/حي-القريات",
    __typename: "DistrictType",
    district_id: 3560,
    name: "حي القريات",
    uri: "حي-القريات",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الكرامة"}': {
    path: "/جدة/جنوب-جدة/حي-الكرامة",
    __typename: "DistrictType",
    district_id: 3566,
    name: "حي الكرامة",
    uri: "حي-الكرامة",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-المتنزهات"}': {
    path: "/جدة/جنوب-جدة/حي-المتنزهات",
    __typename: "DistrictType",
    district_id: 3574,
    name: "حي المتنزهات",
    uri: "حي-المتنزهات",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-المحمدية"}': {
    path: "/جدة/شمال-جدة/حي-المحمدية",
    __typename: "DistrictType",
    district_id: 3578,
    name: "حي المحمدية",
    uri: "حي-المحمدية",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-النزلة-اليمانية"}': {
    path: "/جدة/جنوب-جدة/حي-النزلة-اليمانية",
    __typename: "DistrictType",
    district_id: 3600,
    name: "حي النزلة اليمانية",
    uri: "حي-النزلة-اليمانية",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-النزهة"}': {
    path: "/جدة/شمال-جدة/حي-النزهة",
    __typename: "DistrictType",
    district_id: 3602,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-النعيم"}': {
    path: "/جدة/شمال-جدة/حي-النعيم",
    __typename: "DistrictType",
    district_id: 3606,
    name: "حي النعيم",
    uri: "حي-النعيم",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-طيبة"}': {
    path: "/جدة/شمال-جدة/حي-طيبة",
    __typename: "DistrictType",
    district_id: 3638,
    name: "حي طيبة",
    uri: "حي-طيبة",
  },
  'DistrictType:{"path":"/رابغ/حي-الصبوح"}': {
    path: "/رابغ/حي-الصبوح",
    __typename: "DistrictType",
    district_id: 3658,
    name: "حي الصبوح",
    uri: "حي-الصبوح",
  },
  'DistrictType:{"path":"/رابغ/حي-الصمد"}': {
    path: "/رابغ/حي-الصمد",
    __typename: "DistrictType",
    district_id: 3660,
    name: "حي الصمد",
    uri: "حي-الصمد",
  },
  'DistrictType:{"path":"/مدينة-الملك-عبدالله-الاقتصادية/حي-المنطقة-الصناعية-الاولى"}':
    {
      path: "/مدينة-الملك-عبدالله-الاقتصادية/حي-المنطقة-الصناعية-الاولى",
      __typename: "DistrictType",
      district_id: 3674,
      name: "حي المنطقة الصناعية الاولى",
      uri: "حي-المنطقة-الصناعية-الاولى",
    },
  'DistrictType:{"path":"/مدينة-الملك-عبدالله-الاقتصادية/حي-منطقة-المرافق"}': {
    path: "/مدينة-الملك-عبدالله-الاقتصادية/حي-منطقة-المرافق",
    __typename: "DistrictType",
    district_id: 3678,
    name: "حي منطقة المرافق",
    uri: "حي-منطقة-المرافق",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-التقوى"}': {
    path: "/مكة-المكرمة/حي-التقوى",
    __typename: "DistrictType",
    district_id: 3690,
    name: "حي التقوى",
    uri: "حي-التقوى",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الجميزة"}': {
    path: "/مكة-المكرمة/حي-الجميزة",
    __typename: "DistrictType",
    district_id: 3698,
    name: "حي الجميزة",
    uri: "حي-الجميزة",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الحجون"}': {
    path: "/مكة-المكرمة/حي-الحجون",
    __typename: "DistrictType",
    district_id: 3700,
    name: "حي الحجون",
    uri: "حي-الحجون",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الخضراء"}': {
    path: "/مكة-المكرمة/حي-الخضراء",
    __typename: "DistrictType",
    district_id: 3708,
    name: "حي الخضراء",
    uri: "حي-الخضراء",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الراشدية"}': {
    path: "/مكة-المكرمة/حي-الراشدية",
    __typename: "DistrictType",
    district_id: 3712,
    name: "حي الراشدية",
    uri: "حي-الراشدية",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الروابي"}': {
    path: "/مكة-المكرمة/حي-الروابي",
    __typename: "DistrictType",
    district_id: 3716,
    name: "حي الروابي",
    uri: "حي-الروابي",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الشهداء"}': {
    path: "/مكة-المكرمة/حي-الشهداء",
    __typename: "DistrictType",
    district_id: 3732,
    name: "حي الشهداء",
    uri: "حي-الشهداء",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-العكيشية"}': {
    path: "/مكة-المكرمة/حي-العكيشية",
    __typename: "DistrictType",
    district_id: 3748,
    name: "حي العكيشية",
    uri: "حي-العكيشية",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الكعكية"}': {
    path: "/مكة-المكرمة/حي-الكعكية",
    __typename: "DistrictType",
    district_id: 3756,
    name: "حي الكعكية",
    uri: "حي-الكعكية",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-المعابدة"}': {
    path: "/مكة-المكرمة/حي-المعابدة",
    __typename: "DistrictType",
    district_id: 3764,
    name: "حي المعابدة",
    uri: "حي-المعابدة",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-المنصور"}': {
    path: "/مكة-المكرمة/حي-المنصور",
    __typename: "DistrictType",
    district_id: 3768,
    name: "حي المنصور",
    uri: "حي-المنصور",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-النسيم"}': {
    path: "/مكة-المكرمة/حي-النسيم",
    __typename: "DistrictType",
    district_id: 3772,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-بطحاء-قريش"}': {
    path: "/مكة-المكرمة/حي-بطحاء-قريش",
    __typename: "DistrictType",
    district_id: 3782,
    name: "حي بطحاء قريش",
    uri: "حي-بطحاء-قريش",
  },
  'DistrictType:{"path":"/ابها/حي-الضباب"}': {
    path: "/ابها/حي-الضباب",
    __typename: "DistrictType",
    district_id: 3802,
    name: "حي الضباب",
    uri: "حي-الضباب",
  },
  'DistrictType:{"path":"/ابها/حي-العرين"}': {
    path: "/ابها/حي-العرين",
    __typename: "DistrictType",
    district_id: 3804,
    name: "حي العرين",
    uri: "حي-العرين",
  },
  'DistrictType:{"path":"/ابها/حي-القرى"}': {
    path: "/ابها/حي-القرى",
    __typename: "DistrictType",
    district_id: 3812,
    name: "حي القرى",
    uri: "حي-القرى",
  },
  'DistrictType:{"path":"/ابها/حي-المروج"}': {
    path: "/ابها/حي-المروج",
    __typename: "DistrictType",
    district_id: 3816,
    name: "حي المروج",
    uri: "حي-المروج",
  },
  'DistrictType:{"path":"/ابها/حي-المفتاحة"}': {
    path: "/ابها/حي-المفتاحة",
    __typename: "DistrictType",
    district_id: 3818,
    name: "حي المفتاحة",
    uri: "حي-المفتاحة",
  },
  'DistrictType:{"path":"/ابها/حي-المنهل"}': {
    path: "/ابها/حي-المنهل",
    __typename: "DistrictType",
    district_id: 3820,
    name: "حي المنهل",
    uri: "حي-المنهل",
  },
  'DistrictType:{"path":"/ابها/حي-النزهة"}': {
    path: "/ابها/حي-النزهة",
    __typename: "DistrictType",
    district_id: 3822,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/ابها/حي-ذرة"}': {
    path: "/ابها/حي-ذرة",
    __typename: "DistrictType",
    district_id: 3834,
    name: "حي ذرة",
    uri: "حي-ذرة",
  },
  'DistrictType:{"path":"/ابها/حي-شمسان"}': {
    path: "/ابها/حي-شمسان",
    __typename: "DistrictType",
    district_id: 3836,
    name: "حي شمسان",
    uri: "حي-شمسان",
  },
  'DistrictType:{"path":"/احد-رفيده/حي-الرونه"}': {
    path: "/احد-رفيده/حي-الرونه",
    __typename: "DistrictType",
    district_id: 3844,
    name: "حي الرونه",
    uri: "حي-الرونه",
  },
  'DistrictType:{"path":"/احد-رفيده/حي-السلامة"}': {
    path: "/احد-رفيده/حي-السلامة",
    __typename: "DistrictType",
    district_id: 3850,
    name: "حي السلامة",
    uri: "حي-السلامة",
  },
  'DistrictType:{"path":"/احد-رفيده/حي-المدينة-العسكرية"}': {
    path: "/احد-رفيده/حي-المدينة-العسكرية",
    __typename: "DistrictType",
    district_id: 3856,
    name: "حي المدينة العسكرية",
    uri: "حي-المدينة-العسكرية",
  },
  'DistrictType:{"path":"/احد-رفيده/حي-وسط-البلد"}': {
    path: "/احد-رفيده/حي-وسط-البلد",
    __typename: "DistrictType",
    district_id: 3866,
    name: "حي وسط البلد",
    uri: "حي-وسط-البلد",
  },
  'DistrictType:{"path":"/المجاردة/حي-الفيصلية"}': {
    path: "/المجاردة/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 3886,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/بللسمر/حي-الزيتون"}': {
    path: "/بللسمر/حي-الزيتون",
    __typename: "DistrictType",
    district_id: 3904,
    name: "حي الزيتون",
    uri: "حي-الزيتون",
  },
  'DistrictType:{"path":"/بللسمر/حي-الشفا"}': {
    path: "/بللسمر/حي-الشفا",
    __typename: "DistrictType",
    district_id: 3914,
    name: "حي الشفا",
    uri: "حي-الشفا",
  },
  'DistrictType:{"path":"/بللسمر/حي-العزيزية"}': {
    path: "/بللسمر/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 3916,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/بيشة/حي-الروضة"}': {
    path: "/بيشة/حي-الروضة",
    __typename: "DistrictType",
    district_id: 3942,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/بيشة/حي-الشفاء"}': {
    path: "/بيشة/حي-الشفاء",
    __typename: "DistrictType",
    district_id: 3948,
    name: "حي الشفاء",
    uri: "حي-الشفاء",
  },
  'DistrictType:{"path":"/بيشة/حي-الصفا"}': {
    path: "/بيشة/حي-الصفا",
    __typename: "DistrictType",
    district_id: 3950,
    name: "حي الصفا",
    uri: "حي-الصفا",
  },
  'DistrictType:{"path":"/بيشة/حي-الفيحاء"}': {
    path: "/بيشة/حي-الفيحاء",
    __typename: "DistrictType",
    district_id: 3958,
    name: "حي الفيحاء",
    uri: "حي-الفيحاء",
  },
  'DistrictType:{"path":"/بيشة/حي-المطار"}': {
    path: "/بيشة/حي-المطار",
    __typename: "DistrictType",
    district_id: 3964,
    name: "حي المطار",
    uri: "حي-المطار",
  },
  'DistrictType:{"path":"/بيشة/حي-النهضة"}': {
    path: "/بيشة/حي-النهضة",
    __typename: "DistrictType",
    district_id: 3974,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/تثليث/حي-الحجاز"}': {
    path: "/تثليث/حي-الحجاز",
    __typename: "DistrictType",
    district_id: 3982,
    name: "حي الحجاز",
    uri: "حي-الحجاز",
  },
  'DistrictType:{"path":"/تثليث/حي-النخيل"}': {
    path: "/تثليث/حي-النخيل",
    __typename: "DistrictType",
    district_id: 3998,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-البوادي"}': {
    path: "/خميس-مشيط/حي-البوادي",
    __typename: "DistrictType",
    district_id: 4004,
    name: "حي البوادي",
    uri: "حي-البوادي",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-الجزيرة"}': {
    path: "/خميس-مشيط/حي-الجزيرة",
    __typename: "DistrictType",
    district_id: 4006,
    name: "حي الجزيرة",
    uri: "حي-الجزيرة",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-العرق-الشمالي"}': {
    path: "/خميس-مشيط/حي-العرق-الشمالي",
    __typename: "DistrictType",
    district_id: 4034,
    name: "حي العرق الشمالي",
    uri: "حي-العرق-الشمالي",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-النخيل"}': {
    path: "/خميس-مشيط/حي-النخيل",
    __typename: "DistrictType",
    district_id: 4052,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-ذلالة"}': {
    path: "/خميس-مشيط/حي-ذلالة",
    __typename: "DistrictType",
    district_id: 4068,
    name: "حي ذلالة",
    uri: "حي-ذلالة",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-سكن-المدينة-العسكرية"}': {
    path: "/خميس-مشيط/حي-سكن-المدينة-العسكرية",
    __typename: "DistrictType",
    district_id: 4072,
    name: "حي سكن المدينة العسكرية",
    uri: "حي-سكن-المدينة-العسكرية",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-طيب-الاسم"}': {
    path: "/خميس-مشيط/حي-طيب-الاسم",
    __typename: "DistrictType",
    district_id: 4080,
    name: "حي طيب الاسم",
    uri: "حي-طيب-الاسم",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-عتود"}': {
    path: "/خميس-مشيط/حي-عتود",
    __typename: "DistrictType",
    district_id: 4082,
    name: "حي عتود",
    uri: "حي-عتود",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-مخطط-الموسى"}': {
    path: "/خميس-مشيط/حي-مخطط-الموسى",
    __typename: "DistrictType",
    district_id: 4086,
    name: "حي مخطط الموسى",
    uri: "حي-مخطط-الموسى",
  },
  'DistrictType:{"path":"/محايل/حي-الخالدية"}': {
    path: "/محايل/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 4098,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/محايل/حي-السلامة"}': {
    path: "/محايل/حي-السلامة",
    __typename: "DistrictType",
    district_id: 4104,
    name: "حي السلامة",
    uri: "حي-السلامة",
  },
  'DistrictType:{"path":"/الوديعة/حي-الوديعة"}': {
    path: "/الوديعة/حي-الوديعة",
    __typename: "DistrictType",
    district_id: 4342,
    name: "حي الوديعة",
    uri: "حي-الوديعة",
  },
  'CityType:{"uri":"الوديعة"}': {
    uri: "الوديعة",
    __typename: "CityType",
    city_id: 49,
    name: "الوديعة",
    path: "/الوديعة",
  },
  'DistrictType:{"path":"/شرورة/حي-جنوب-المستشفى-العسكري"}': {
    path: "/شرورة/حي-جنوب-المستشفى-العسكري",
    __typename: "DistrictType",
    district_id: 4358,
    name: "حي جنوب المستشفى العسكري",
    uri: "حي-جنوب-المستشفى-العسكري",
  },
  'DistrictType:{"path":"/شرورة/حي-مخطط-ب"}': {
    path: "/شرورة/حي-مخطط-ب",
    __typename: "DistrictType",
    district_id: 4364,
    name: "حي مخطط ب",
    uri: "حي-مخطط-ب",
  },
  'DistrictType:{"path":"/نجران/حي-الحضن"}': {
    path: "/نجران/حي-الحضن",
    __typename: "DistrictType",
    district_id: 4372,
    name: "حي الحضن",
    uri: "حي-الحضن",
  },
  'DistrictType:{"path":"/نجران/حي-المخيم"}': {
    path: "/نجران/حي-المخيم",
    __typename: "DistrictType",
    district_id: 4384,
    name: "حي المخيم",
    uri: "حي-المخيم",
  },
  'DistrictType:{"path":"/نجران/حي-شرق-الضباط"}': {
    path: "/نجران/حي-شرق-الضباط",
    __typename: "DistrictType",
    district_id: 4392,
    name: "حي شرق الضباط",
    uri: "حي-شرق-الضباط",
  },
  'DistrictType:{"path":"/نجران/حي-شمال-الفهد"}': {
    path: "/نجران/حي-شمال-الفهد",
    __typename: "DistrictType",
    district_id: 4396,
    name: "حي شمال الفهد",
    uri: "حي-شمال-الفهد",
  },
  'DistrictType:{"path":"/نجران/حي-مخطط-الحصين-الزراعي"}': {
    path: "/نجران/حي-مخطط-الحصين-الزراعي",
    __typename: "DistrictType",
    district_id: 4402,
    name: "حي مخطط الحصين الزراعي",
    uri: "حي-مخطط-الحصين-الزراعي",
  },
  'DistrictType:{"path":"/الباحة/حي-الحازم"}': {
    path: "/الباحة/حي-الحازم",
    __typename: "DistrictType",
    district_id: 4422,
    name: "حي الحازم",
    uri: "حي-الحازم",
  },
  'DistrictType:{"path":"/الباحة/حي-الحاوية"}': {
    path: "/الباحة/حي-الحاوية",
    __typename: "DistrictType",
    district_id: 4424,
    name: "حي الحاوية",
    uri: "حي-الحاوية",
  },
  'DistrictType:{"path":"/الغاط/حي-المروج"}': {
    path: "/الغاط/حي-المروج",
    __typename: "DistrictType",
    district_id: 804,
    name: "حي المروج",
    uri: "حي-المروج",
  },
  'DistrictType:{"path":"/الغاط/حي-الياسمين"}': {
    path: "/الغاط/حي-الياسمين",
    __typename: "DistrictType",
    district_id: 814,
    name: "حي الياسمين",
    uri: "حي-الياسمين",
  },
  'DistrictType:{"path":"/القويعية/حي-المروج"}': {
    path: "/القويعية/حي-المروج",
    __typename: "DistrictType",
    district_id: 842,
    name: "حي المروج",
    uri: "حي-المروج",
  },
  'DistrictType:{"path":"/المجمعة/حي-الرفيعة"}': {
    path: "/المجمعة/حي-الرفيعة",
    __typename: "DistrictType",
    district_id: 856,
    name: "حي الرفيعة",
    uri: "حي-الرفيعة",
  },
  'DistrictType:{"path":"/المجمعة/حي-المطار"}': {
    path: "/المجمعة/حي-المطار",
    __typename: "DistrictType",
    district_id: 866,
    name: "حي المطار",
    uri: "حي-المطار",
  },
  'DistrictType:{"path":"/المزاحمية/حي-الحزيمية"}': {
    path: "/المزاحمية/حي-الحزيمية",
    __typename: "DistrictType",
    district_id: 878,
    name: "حي الحزيمية",
    uri: "حي-الحزيمية",
  },
  'DistrictType:{"path":"/المزاحمية/حي-الصناعية"}': {
    path: "/المزاحمية/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 882,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/المزاحمية/حي-غرناطة"}': {
    path: "/المزاحمية/حي-غرناطة",
    __typename: "DistrictType",
    district_id: 896,
    name: "حي غرناطة",
    uri: "حي-غرناطة",
  },
  'DistrictType:{"path":"/ثادق/حي-الجنادرية"}': {
    path: "/ثادق/حي-الجنادرية",
    __typename: "DistrictType",
    district_id: 902,
    name: "حي الجنادرية",
    uri: "حي-الجنادرية",
  },
  'CityType:{"uri":"ثادق"}': {
    uri: "ثادق",
    __typename: "CityType",
    city_id: 63,
    name: "ثادق",
    path: "/ثادق",
  },
  'DistrictType:{"path":"/ثادق/حي-الخالدية"}': {
    path: "/ثادق/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 904,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/ثادق/حي-الفيصلية"}': {
    path: "/ثادق/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 910,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/حوطة-بني-تميم/حي-الشعيب"}': {
    path: "/حوطة-بني-تميم/حي-الشعيب",
    __typename: "DistrictType",
    district_id: 920,
    name: "حي الشعيب",
    uri: "حي-الشعيب",
  },
  'DistrictType:{"path":"/حوطة-بني-تميم/حي-الفرعة"}': {
    path: "/حوطة-بني-تميم/حي-الفرعة",
    __typename: "DistrictType",
    district_id: 924,
    name: "حي الفرعة",
    uri: "حي-الفرعة",
  },
  'DistrictType:{"path":"/حوطة-بني-تميم/حي-المجد"}': {
    path: "/حوطة-بني-تميم/حي-المجد",
    __typename: "DistrictType",
    district_id: 926,
    name: "حي المجد",
    uri: "حي-المجد",
  },
  'DistrictType:{"path":"/حوطة-بني-تميم/حي-المنار"}': {
    path: "/حوطة-بني-تميم/حي-المنار",
    __typename: "DistrictType",
    district_id: 932,
    name: "حي المنار",
    uri: "حي-المنار",
  },
  'DistrictType:{"path":"/حوطة-بني-تميم/حي-زياد"}': {
    path: "/حوطة-بني-تميم/حي-زياد",
    __typename: "DistrictType",
    district_id: 940,
    name: "حي زياد",
    uri: "حي-زياد",
  },
  'DistrictType:{"path":"/شقراء/حي-الروضة"}': {
    path: "/شقراء/حي-الروضة",
    __typename: "DistrictType",
    district_id: 946,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/شقراء/حي-غسلة"}': {
    path: "/شقراء/حي-غسلة",
    __typename: "DistrictType",
    district_id: 960,
    name: "حي غسلة",
    uri: "حي-غسلة",
  },
  'DistrictType:{"path":"/عفيف/حي-الحجاج"}': {
    path: "/عفيف/حي-الحجاج",
    __typename: "DistrictType",
    district_id: 966,
    name: "حي الحجاج",
    uri: "حي-الحجاج",
  },
  'DistrictType:{"path":"/عفيف/حي-العود"}': {
    path: "/عفيف/حي-العود",
    __typename: "DistrictType",
    district_id: 976,
    name: "حي العود",
    uri: "حي-العود",
  },
  'DistrictType:{"path":"/الجبيل/حي-الحويلات"}': {
    path: "/الجبيل/حي-الحويلات",
    __typename: "DistrictType",
    district_id: 992,
    name: "حي الحويلات",
    uri: "حي-الحويلات",
  },
  'DistrictType:{"path":"/الجبيل/حي-الفردوس"}': {
    path: "/الجبيل/حي-الفردوس",
    __typename: "DistrictType",
    district_id: 1000,
    name: "حي الفردوس",
    uri: "حي-الفردوس",
  },
  'DistrictType:{"path":"/الجبيل/حي-جلمودة"}': {
    path: "/الجبيل/حي-جلمودة",
    __typename: "DistrictType",
    district_id: 1016,
    name: "حي جلمودة",
    uri: "حي-جلمودة",
  },
  'DistrictType:{"path":"/الجبيل/حي-مخطط-عبداللطيف-جميل"}': {
    path: "/الجبيل/حي-مخطط-عبداللطيف-جميل",
    __typename: "DistrictType",
    district_id: 1026,
    name: "حي مخطط عبداللطيف جميل",
    uri: "حي-مخطط-عبداللطيف-جميل",
  },
  'DistrictType:{"path":"/الخبر/حي-ابن-سينا"}': {
    path: "/الخبر/حي-ابن-سينا",
    __typename: "DistrictType",
    district_id: 1038,
    name: "حي ابن سينا",
    uri: "حي-ابن-سينا",
  },
  'DistrictType:{"path":"/الخبر/حي-الحزام-الاخضر"}': {
    path: "/الخبر/حي-الحزام-الاخضر",
    __typename: "DistrictType",
    district_id: 1066,
    name: "حي الحزام الاخضر",
    uri: "حي-الحزام-الاخضر",
  },
  'DistrictType:{"path":"/الخبر/حي-الخبر-الجنوبية"}': {
    path: "/الخبر/حي-الخبر-الجنوبية",
    __typename: "DistrictType",
    district_id: 1072,
    name: "حي الخبر الجنوبية",
    uri: "حي-الخبر-الجنوبية",
  },
  'DistrictType:{"path":"/الخبر/حي-الصواري"}': {
    path: "/الخبر/حي-الصواري",
    __typename: "DistrictType",
    district_id: 1092,
    name: "حي الصواري",
    uri: "حي-الصواري",
  },
  'DistrictType:{"path":"/الخبر/حي-المدينة-الرياضية"}': {
    path: "/الخبر/حي-المدينة-الرياضية",
    __typename: "DistrictType",
    district_id: 1106,
    name: "حي المدينة الرياضية",
    uri: "حي-المدينة-الرياضية",
  },
  'DistrictType:{"path":"/الخبر/حي-المرجان"}': {
    path: "/الخبر/حي-المرجان",
    __typename: "DistrictType",
    district_id: 1108,
    name: "حي المرجان",
    uri: "حي-المرجان",
  },
  'DistrictType:{"path":"/الخبر/حي-اليرموك"}': {
    path: "/الخبر/حي-اليرموك",
    __typename: "DistrictType",
    district_id: 1114,
    name: "حي اليرموك",
    uri: "حي-اليرموك",
  },
  'DistrictType:{"path":"/الخفجي/حي-التعاون"}': {
    path: "/الخفجي/حي-التعاون",
    __typename: "DistrictType",
    district_id: 1130,
    name: "حي التعاون",
    uri: "حي-التعاون",
  },
  'DistrictType:{"path":"/الخفجي/حي-الحمراء"}': {
    path: "/الخفجي/حي-الحمراء",
    __typename: "DistrictType",
    district_id: 1134,
    name: "حي الحمراء",
    uri: "حي-الحمراء",
  },
  'DistrictType:{"path":"/الخفجي/حي-الخزامى"}': {
    path: "/الخفجي/حي-الخزامى",
    __typename: "DistrictType",
    district_id: 1138,
    name: "حي الخزامى",
    uri: "حي-الخزامى",
  },
  'DistrictType:{"path":"/الخفجي/حي-الدوائر-الحكومية"}': {
    path: "/الخفجي/حي-الدوائر-الحكومية",
    __typename: "DistrictType",
    district_id: 1140,
    name: "حي الدوائر الحكومية",
    uri: "حي-الدوائر-الحكومية",
  },
  'DistrictType:{"path":"/الخفجي/حي-الروضة"}': {
    path: "/الخفجي/حي-الروضة",
    __typename: "DistrictType",
    district_id: 1142,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/الخفجي/حي-الريان"}': {
    path: "/الخفجي/حي-الريان",
    __typename: "DistrictType",
    district_id: 1144,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'DistrictType:{"path":"/الدمام/حي-احد"}': {
    path: "/الدمام/حي-احد",
    __typename: "DistrictType",
    district_id: 1180,
    name: "حي احد",
    uri: "حي-احد",
  },
  'DistrictType:{"path":"/الدمام/حي-اسكان-الدمام"}': {
    path: "/الدمام/حي-اسكان-الدمام",
    __typename: "DistrictType",
    district_id: 1182,
    name: "حي اسكان الدمام",
    uri: "حي-اسكان-الدمام",
  },
  'DistrictType:{"path":"/الدمام/حي-الامانة"}': {
    path: "/الدمام/حي-الامانة",
    __typename: "DistrictType",
    district_id: 1188,
    name: "حي الامانة",
    uri: "حي-الامانة",
  },
  'DistrictType:{"path":"/الدمام/حي-الانوار"}': {
    path: "/الدمام/حي-الانوار",
    __typename: "DistrictType",
    district_id: 1192,
    name: "حي الانوار",
    uri: "حي-الانوار",
  },
  'DistrictType:{"path":"/الدمام/حي-البادية"}': {
    path: "/الدمام/حي-البادية",
    __typename: "DistrictType",
    district_id: 1196,
    name: "حي البادية",
    uri: "حي-البادية",
  },
  'DistrictType:{"path":"/الدمام/حي-البساتين"}': {
    path: "/الدمام/حي-البساتين",
    __typename: "DistrictType",
    district_id: 1202,
    name: "حي البساتين",
    uri: "حي-البساتين",
  },
  'DistrictType:{"path":"/الدمام/حي-الجامعيين"}': {
    path: "/الدمام/حي-الجامعيين",
    __typename: "DistrictType",
    district_id: 1204,
    name: "حي الجامعيين",
    uri: "حي-الجامعيين",
  },
  'DistrictType:{"path":"/الدمام/حي-الربيع"}': {
    path: "/الدمام/حي-الربيع",
    __typename: "DistrictType",
    district_id: 1224,
    name: "حي الربيع",
    uri: "حي-الربيع",
  },
  'DistrictType:{"path":"/الدمام/حي-الصناعية"}': {
    path: "/الدمام/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 1248,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/الدمام/حي-الصناعية-الاولى"}': {
    path: "/الدمام/حي-الصناعية-الاولى",
    __typename: "DistrictType",
    district_id: 1250,
    name: "حي الصناعية الاولى",
    uri: "حي-الصناعية-الاولى",
  },
  'DistrictType:{"path":"/الدمام/حي-الضباب"}': {
    path: "/الدمام/حي-الضباب",
    __typename: "DistrictType",
    district_id: 1252,
    name: "حي الضباب",
    uri: "حي-الضباب",
  },
  'DistrictType:{"path":"/الدمام/حي-الفرسان"}': {
    path: "/الدمام/حي-الفرسان",
    __typename: "DistrictType",
    district_id: 1266,
    name: "حي الفرسان",
    uri: "حي-الفرسان",
  },
  'DistrictType:{"path":"/الدمام/حي-الفيحاء"}': {
    path: "/الدمام/حي-الفيحاء",
    __typename: "DistrictType",
    district_id: 1270,
    name: "حي الفيحاء",
    uri: "حي-الفيحاء",
  },
  'DistrictType:{"path":"/الدمام/حي-الفيصلية"}': {
    path: "/الدمام/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 1272,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/الدمام/حي-المدينة-الصناعية-الثانية"}': {
    path: "/الدمام/حي-المدينة-الصناعية-الثانية",
    __typename: "DistrictType",
    district_id: 1280,
    name: "حي المدينة الصناعية الثانية",
    uri: "حي-المدينة-الصناعية-الثانية",
  },
  'DistrictType:{"path":"/الدمام/حي-النخيل"}': {
    path: "/الدمام/حي-النخيل",
    __typename: "DistrictType",
    district_id: 1296,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/الدمام/حي-قصر-الخليج"}': {
    path: "/الدمام/حي-قصر-الخليج",
    __typename: "DistrictType",
    district_id: 1324,
    name: "حي قصر الخليج",
    uri: "حي-قصر-الخليج",
  },
  'DistrictType:{"path":"/الظهران/حي-الدوحة-الشمالية"}': {
    path: "/الظهران/حي-الدوحة-الشمالية",
    __typename: "DistrictType",
    district_id: 1344,
    name: "حي الدوحة الشمالية",
    uri: "حي-الدوحة-الشمالية",
  },
  'DistrictType:{"path":"/الظهران/حي-جامعة-الملك-فهد-للبترول-والمعادن"}': {
    path: "/الظهران/حي-جامعة-الملك-فهد-للبترول-والمعادن",
    __typename: "DistrictType",
    district_id: 1352,
    name: "حي جامعة الملك فهد للبترول والمعادن",
    uri: "حي-جامعة-الملك-فهد-للبترول-والمعادن",
  },
  'DistrictType:{"path":"/القطيف/حي-البحر"}': {
    path: "/القطيف/حي-البحر",
    __typename: "DistrictType",
    district_id: 1378,
    name: "حي البحر",
    uri: "حي-البحر",
  },
  'DistrictType:{"path":"/القطيف/حي-الجزيرة"}': {
    path: "/القطيف/حي-الجزيرة",
    __typename: "DistrictType",
    district_id: 1396,
    name: "حي الجزيرة",
    uri: "حي-الجزيرة",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-النظيم"}': {
    path: "/الرياض/شرق-الرياض/حي-النظيم",
    __typename: "DistrictType",
    district_id: 608,
    name: "حي النظيم",
    uri: "حي-النظيم",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-الوزارات"}': {
    path: "/الرياض/وسط-الرياض/حي-الوزارات",
    __typename: "DistrictType",
    district_id: 626,
    name: "حي الوزارات",
    uri: "حي-الوزارات",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-اليمامة"}': {
    path: "/الرياض/وسط-الرياض/حي-اليمامة",
    __typename: "DistrictType",
    district_id: 636,
    name: "حي اليمامة",
    uri: "حي-اليمامة",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-بنبان"}': {
    path: "/الرياض/شمال-الرياض/حي-بنبان",
    __typename: "DistrictType",
    district_id: 650,
    name: "حي بنبان",
    uri: "حي-بنبان",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-جامعة-الملك-سعود"}': {
    path: "/الرياض/شمال-الرياض/حي-جامعة-الملك-سعود",
    __typename: "DistrictType",
    district_id: 658,
    name: "حي جامعة الملك سعود",
    uri: "حي-جامعة-الملك-سعود",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-جبرة"}': {
    path: "/الرياض/وسط-الرياض/حي-جبرة",
    __typename: "DistrictType",
    district_id: 660,
    name: "حي جبرة",
    uri: "حي-جبرة",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-عتيقة"}': {
    path: "/الرياض/وسط-الرياض/حي-عتيقة",
    __typename: "DistrictType",
    district_id: 692,
    name: "حي عتيقة",
    uri: "حي-عتيقة",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-عليشة"}': {
    path: "/الرياض/غرب-الرياض/حي-عليشة",
    __typename: "DistrictType",
    district_id: 700,
    name: "حي عليشة",
    uri: "حي-عليشة",
  },
  'DistrictType:{"path":"/الزلفي/حي-الخالدية"}': {
    path: "/الزلفي/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 726,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/الزلفي/حي-عريعرة"}': {
    path: "/الزلفي/حي-عريعرة",
    __typename: "DistrictType",
    district_id: 770,
    name: "حي عريعرة",
    uri: "حي-عريعرة",
  },
  'DistrictType:{"path":"/السليل/حي-الروضة"}': {
    path: "/السليل/حي-الروضة",
    __typename: "DistrictType",
    district_id: 780,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/الغاط/حي-الاندلس"}': {
    path: "/الغاط/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 790,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/الغاط/حي-الخزامي"}': {
    path: "/الغاط/حي-الخزامي",
    __typename: "DistrictType",
    district_id: 794,
    name: "حي الخزامي",
    uri: "حي-الخزامي",
  },
  'DistrictType:{"path":"/الغاط/حي-الربيع"}': {
    path: "/الغاط/حي-الربيع",
    __typename: "DistrictType",
    district_id: 796,
    name: "حي الربيع",
    uri: "حي-الربيع",
  },
  'DistrictType:{"path":"/الغاط/حي-الزهور"}': {
    path: "/الغاط/حي-الزهور",
    __typename: "DistrictType",
    district_id: 798,
    name: "حي الزهور",
    uri: "حي-الزهور",
  },
  'DistrictType:{"path":"/صبيا/حي-الفردوس"}': {
    path: "/صبيا/حي-الفردوس",
    __typename: "DistrictType",
    district_id: 216,
    name: "حي الفردوس",
    uri: "حي-الفردوس",
  },
  'DistrictType:{"path":"/الخرج/حي-الزاهر"}': {
    path: "/الخرج/حي-الزاهر",
    __typename: "DistrictType",
    district_id: 266,
    name: "حي الزاهر",
    uri: "حي-الزاهر",
  },
  'DistrictType:{"path":"/الخرج/حي-النهضة"}': {
    path: "/الخرج/حي-النهضة",
    __typename: "DistrictType",
    district_id: 292,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/الخرج/حي-اليمامة"}': {
    path: "/الخرج/حي-اليمامة",
    __typename: "DistrictType",
    district_id: 294,
    name: "حي اليمامة",
    uri: "حي-اليمامة",
  },
  'DistrictType:{"path":"/الخرج/حي-مشرف"}': {
    path: "/الخرج/حي-مشرف",
    __typename: "DistrictType",
    district_id: 296,
    name: "حي مشرف",
    uri: "حي-مشرف",
  },
  'DistrictType:{"path":"/الدرعية/حي-الفيصلية"}': {
    path: "/الدرعية/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 312,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/الدرعية/حي-جنوب-الدرعية"}': {
    path: "/الدرعية/حي-جنوب-الدرعية",
    __typename: "DistrictType",
    district_id: 316,
    name: "حي جنوب الدرعية",
    uri: "حي-جنوب-الدرعية",
  },
  'DistrictType:{"path":"/الدلم/حي-السليمانية"}': {
    path: "/الدلم/حي-السليمانية",
    __typename: "DistrictType",
    district_id: 328,
    name: "حي السليمانية",
    uri: "حي-السليمانية",
  },
  'DistrictType:{"path":"/الدوادمي/حي-الخالدية"}': {
    path: "/الدوادمي/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 346,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/الدوادمي/حي-الربوة"}': {
    path: "/الدوادمي/حي-الربوة",
    __typename: "DistrictType",
    district_id: 354,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/الدوادمي/حي-الريان"}': {
    path: "/الدوادمي/حي-الريان",
    __typename: "DistrictType",
    district_id: 358,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'DistrictType:{"path":"/الدوادمي/حي-السلام"}': {
    path: "/الدوادمي/حي-السلام",
    __typename: "DistrictType",
    district_id: 360,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/الدوادمي/حي-الصناعية"}': {
    path: "/الدوادمي/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 364,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-الحائر"}': {
    path: "/الرياض/جنوب-الرياض/حي-الحائر",
    __typename: "DistrictType",
    district_id: 412,
    name: "حي الحائر",
    uri: "حي-الحائر",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-الدفاع"}': {
    path: "/الرياض/جنوب-الرياض/حي-الدفاع",
    __typename: "DistrictType",
    district_id: 430,
    name: "حي الدفاع",
    uri: "حي-الدفاع",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الرماية"}': {
    path: "/الرياض/شرق-الرياض/حي-الرماية",
    __typename: "DistrictType",
    district_id: 448,
    name: "حي الرماية",
    uri: "حي-الرماية",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-السلام"}': {
    path: "/الرياض/شرق-الرياض/حي-السلام",
    __typename: "DistrictType",
    district_id: 464,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-السويدي-الغربي"}': {
    path: "/الرياض/غرب-الرياض/حي-السويدي-الغربي",
    __typename: "DistrictType",
    district_id: 472,
    name: "حي السويدي الغربي",
    uri: "حي-السويدي-الغربي",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-الشرفية"}': {
    path: "/الرياض/غرب-الرياض/حي-الشرفية",
    __typename: "DistrictType",
    district_id: 474,
    name: "حي الشرفية",
    uri: "حي-الشرفية",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الشرق"}': {
    path: "/الرياض/شرق-الرياض/حي-الشرق",
    __typename: "DistrictType",
    district_id: 476,
    name: "حي الشرق",
    uri: "حي-الشرق",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-الضباط"}': {
    path: "/الرياض/وسط-الرياض/حي-الضباط",
    __typename: "DistrictType",
    district_id: 492,
    name: "حي الضباط",
    uri: "حي-الضباط",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-العريجاء-الغربية"}': {
    path: "/الرياض/غرب-الرياض/حي-العريجاء-الغربية",
    __typename: "DistrictType",
    district_id: 498,
    name: "حي العريجاء الغربية",
    uri: "حي-العريجاء-الغربية",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-القادسية"}': {
    path: "/الرياض/شرق-الرياض/حي-القادسية",
    __typename: "DistrictType",
    district_id: 530,
    name: "حي القادسية",
    uri: "حي-القادسية",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-القيروان"}': {
    path: "/الرياض/شمال-الرياض/حي-القيروان",
    __typename: "DistrictType",
    district_id: 536,
    name: "حي القيروان",
    uri: "حي-القيروان",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-المشاعل"}': {
    path: "/الرياض/جنوب-الرياض/حي-المشاعل",
    __typename: "DistrictType",
    district_id: 550,
    name: "حي المشاعل",
    uri: "حي-المشاعل",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-الملقا"}': {
    path: "/الرياض/شمال-الرياض/حي-الملقا",
    __typename: "DistrictType",
    district_id: 570,
    name: "حي الملقا",
    uri: "حي-الملقا",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-المنصورة"}': {
    path: "/الرياض/وسط-الرياض/حي-المنصورة",
    __typename: "DistrictType",
    district_id: 584,
    name: "حي المنصورة",
    uri: "حي-المنصورة",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-المونسية"}': {
    path: "/الرياض/شرق-الرياض/حي-المونسية",
    __typename: "DistrictType",
    district_id: 590,
    name: "حي المونسية",
    uri: "حي-المونسية",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-الناصرية"}': {
    path: "/الرياض/غرب-الرياض/حي-الناصرية",
    __typename: "DistrictType",
    district_id: 594,
    name: "حي الناصرية",
    uri: "حي-الناصرية",
  },
  'DistrictType:{"path":"/القطيف/حي-الحسين"}': {
    path: "/القطيف/حي-الحسين",
    __typename: "DistrictType",
    district_id: 1404,
    name: "حي الحسين",
    uri: "حي-الحسين",
  },
  'DistrictType:{"path":"/القطيف/حي-الخامسة"}': {
    path: "/القطيف/حي-الخامسة",
    __typename: "DistrictType",
    district_id: 1406,
    name: "حي الخامسة",
    uri: "حي-الخامسة",
  },
  'DistrictType:{"path":"/القطيف/حي-الرضا"}': {
    path: "/القطيف/حي-الرضا",
    __typename: "DistrictType",
    district_id: 1420,
    name: "حي الرضا",
    uri: "حي-الرضا",
  },
  'DistrictType:{"path":"/القطيف/حي-الزمرد"}': {
    path: "/القطيف/حي-الزمرد",
    __typename: "DistrictType",
    district_id: 1428,
    name: "حي الزمرد",
    uri: "حي-الزمرد",
  },
  'DistrictType:{"path":"/القطيف/حي-المدني"}': {
    path: "/القطيف/حي-المدني",
    __typename: "DistrictType",
    district_id: 1460,
    name: "حي المدني",
    uri: "حي-المدني",
  },
  'DistrictType:{"path":"/القطيف/حي-ام-الجزم"}': {
    path: "/القطيف/حي-ام-الجزم",
    __typename: "DistrictType",
    district_id: 1486,
    name: "حي ام الجزم",
    uri: "حي-ام-الجزم",
  },
  'DistrictType:{"path":"/القطيف/حي-باب-الساب"}': {
    path: "/القطيف/حي-باب-الساب",
    __typename: "DistrictType",
    district_id: 1490,
    name: "حي باب الساب",
    uri: "حي-باب-الساب",
  },
  'DistrictType:{"path":"/القطيف/حي-مياس"}': {
    path: "/القطيف/حي-مياس",
    __typename: "DistrictType",
    district_id: 1496,
    name: "حي مياس",
    uri: "حي-مياس",
  },
  'DistrictType:{"path":"/الهفوف/حي-البصيرة"}': {
    path: "/الهفوف/حي-البصيرة",
    __typename: "DistrictType",
    district_id: 1522,
    name: "حي البصيرة",
    uri: "حي-البصيرة",
  },
  'DistrictType:{"path":"/الهفوف/حي-التويثير"}': {
    path: "/الهفوف/حي-التويثير",
    __typename: "DistrictType",
    district_id: 1528,
    name: "حي التويثير",
    uri: "حي-التويثير",
  },
  'DistrictType:{"path":"/الهفوف/حي-الجامعيين"}': {
    path: "/الهفوف/حي-الجامعيين",
    __typename: "DistrictType",
    district_id: 1530,
    name: "حي الجامعيين",
    uri: "حي-الجامعيين",
  },
  'DistrictType:{"path":"/الهفوف/حي-الجبيل"}': {
    path: "/الهفوف/حي-الجبيل",
    __typename: "DistrictType",
    district_id: 1532,
    name: "حي الجبيل",
    uri: "حي-الجبيل",
  },
  'DistrictType:{"path":"/الهفوف/حي-الرابية"}': {
    path: "/الهفوف/حي-الرابية",
    __typename: "DistrictType",
    district_id: 1546,
    name: "حي الرابية",
    uri: "حي-الرابية",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-الربيع"}': {
    path: "/ابو-عريش/حي-الربيع",
    __typename: "DistrictType",
    district_id: 16,
    name: "حي الربيع",
    uri: "حي-الربيع",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-الروضة"}': {
    path: "/ابو-عريش/حي-الروضة",
    __typename: "DistrictType",
    district_id: 18,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-الشابطة"}': {
    path: "/ابو-عريش/حي-الشابطة",
    __typename: "DistrictType",
    district_id: 28,
    name: "حي الشابطة",
    uri: "حي-الشابطة",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-المشايخ"}': {
    path: "/ابو-عريش/حي-المشايخ",
    __typename: "DistrictType",
    district_id: 46,
    name: "حي المشايخ",
    uri: "حي-المشايخ",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-الوسيعة"}': {
    path: "/ابو-عريش/حي-الوسيعة",
    __typename: "DistrictType",
    district_id: 66,
    name: "حي الوسيعة",
    uri: "حي-الوسيعة",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-حاكمة-ابوعريش"}': {
    path: "/ابو-عريش/حي-حاكمة-ابوعريش",
    __typename: "DistrictType",
    district_id: 72,
    name: "حي حاكمة ابوعريش",
    uri: "حي-حاكمة-ابوعريش",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-قامرة"}': {
    path: "/ابو-عريش/حي-قامرة",
    __typename: "DistrictType",
    district_id: 86,
    name: "حي قامرة",
    uri: "حي-قامرة",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-الغصينية"}': {
    path: "/احد-المسارحة/حي-الغصينية",
    __typename: "DistrictType",
    district_id: 112,
    name: "حي الغصينية",
    uri: "حي-الغصينية",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-الواسط"}': {
    path: "/احد-المسارحة/حي-الواسط",
    __typename: "DistrictType",
    district_id: 124,
    name: "حي الواسط",
    uri: "حي-الواسط",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-حكامية-العز"}': {
    path: "/احد-المسارحة/حي-حكامية-العز",
    __typename: "DistrictType",
    district_id: 128,
    name: "حي حكامية العز",
    uri: "حي-حكامية-العز",
  },
  'DistrictType:{"path":"/بيش/حي-بيش"}': {
    path: "/بيش/حي-بيش",
    __typename: "DistrictType",
    district_id: 138,
    name: "حي بيش",
    uri: "حي-بيش",
  },
  'CityType:{"uri":"بيش"}': {
    uri: "بيش",
    __typename: "CityType",
    city_id: 56,
    name: "بيش",
    path: "/بيش",
  },
  'DistrictType:{"path":"/جازان/حي-الاراك"}': {
    path: "/جازان/حي-الاراك",
    __typename: "DistrictType",
    district_id: 140,
    name: "حي الاراك",
    uri: "حي-الاراك",
  },
  'DistrictType:{"path":"/جازان/حي-الصفا"}': {
    path: "/جازان/حي-الصفا",
    __typename: "DistrictType",
    district_id: 158,
    name: "حي الصفا",
    uri: "حي-الصفا",
  },
  'DistrictType:{"path":"/الجبيل/حي-الفيحاء"}': {
    path: "/الجبيل/حي-الفيحاء",
    __typename: "DistrictType",
    district_id: 1002,
    name: "حي الفيحاء",
    uri: "حي-الفيحاء",
  },
  'DistrictType:{"path":"/الجبيل/حي-المنطقة-الصناعية-الثالثة"}': {
    path: "/الجبيل/حي-المنطقة-الصناعية-الثالثة",
    __typename: "DistrictType",
    district_id: 1012,
    name: "حي المنطقة الصناعية الثالثة",
    uri: "حي-المنطقة-الصناعية-الثالثة",
  },
  'DistrictType:{"path":"/الدوادمي/حي-مشرفة"}': {
    path: "/الدوادمي/حي-مشرفة",
    __typename: "DistrictType",
    district_id: 384,
    name: "حي مشرفة",
    uri: "حي-مشرفة",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-الاسكان"}': {
    path: "/الرياض/جنوب-الرياض/حي-الاسكان",
    __typename: "DistrictType",
    district_id: 394,
    name: "حي الاسكان",
    uri: "حي-الاسكان",
  },
  'DistrictType:{"path":"/الوجه/حي-العزيزية"}': {
    path: "/الوجه/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 2810,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/املج/حي-الجبنون"}': {
    path: "/املج/حي-الجبنون",
    __typename: "DistrictType",
    district_id: 2822,
    name: "حي الجبنون",
    uri: "حي-الجبنون",
  },
  'DistrictType:{"path":"/تبوك/حي-الرويعيات"}': {
    path: "/تبوك/حي-الرويعيات",
    __typename: "DistrictType",
    district_id: 2846,
    name: "حي الرويعيات",
    uri: "حي-الرويعيات",
  },
  'DistrictType:{"path":"/تبوك/حي-العليا"}': {
    path: "/تبوك/حي-العليا",
    __typename: "DistrictType",
    district_id: 2864,
    name: "حي العليا",
    uri: "حي-العليا",
  },
  'DistrictType:{"path":"/تبوك/حي-المنشية-الجديدة"}': {
    path: "/تبوك/حي-المنشية-الجديدة",
    __typename: "DistrictType",
    district_id: 2880,
    name: "حي المنشية الجديدة",
    uri: "حي-المنشية-الجديدة",
  },
  'DistrictType:{"path":"/تبوك/حي-الهضيبة"}': {
    path: "/تبوك/حي-الهضيبة",
    __typename: "DistrictType",
    district_id: 2888,
    name: "حي الهضيبة",
    uri: "حي-الهضيبة",
  },
  'DistrictType:{"path":"/تبوك/حي-بترومين"}': {
    path: "/تبوك/حي-بترومين",
    __typename: "DistrictType",
    district_id: 2892,
    name: "حي بترومين",
    uri: "حي-بترومين",
  },
  'DistrictType:{"path":"/تيماء/حي-الصفا"}': {
    path: "/تيماء/حي-الصفا",
    __typename: "DistrictType",
    district_id: 2910,
    name: "حي الصفا",
    uri: "حي-الصفا",
  },
  'DistrictType:{"path":"/تيماء/حي-القاع"}': {
    path: "/تيماء/حي-القاع",
    __typename: "DistrictType",
    district_id: 2912,
    name: "حي القاع",
    uri: "حي-القاع",
  },
  'DistrictType:{"path":"/ضبا/حي-البلد"}': {
    path: "/ضبا/حي-البلد",
    __typename: "DistrictType",
    district_id: 2918,
    name: "حي البلد",
    uri: "حي-البلد",
  },
  'CityType:{"uri":"ضبا"}': {
    uri: "ضبا",
    __typename: "CityType",
    city_id: 86,
    name: "ضبا",
    path: "/ضبا",
  },
  'DistrictType:{"path":"/الحناكية/حي-الحناكية"}': {
    path: "/الحناكية/حي-الحناكية",
    __typename: "DistrictType",
    district_id: 2920,
    name: "حي الحناكية",
    uri: "حي-الحناكية",
  },
  'CityType:{"uri":"الحناكية"}': {
    uri: "الحناكية",
    __typename: "CityType",
    city_id: 11,
    name: "الحناكية",
    path: "/الحناكية",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-ابو-كبير"}': {
    path: "/المدينة-المنورة/حي-ابو-كبير",
    __typename: "DistrictType",
    district_id: 2924,
    name: "حي ابو كبير",
    uri: "حي-ابو-كبير",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الاسكان"}': {
    path: "/المدينة-المنورة/حي-الاسكان",
    __typename: "DistrictType",
    district_id: 2926,
    name: "حي الاسكان",
    uri: "حي-الاسكان",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الاصيفرين"}': {
    path: "/المدينة-المنورة/حي-الاصيفرين",
    __typename: "DistrictType",
    district_id: 2928,
    name: "حي الاصيفرين",
    uri: "حي-الاصيفرين",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-البلقاء"}': {
    path: "/المدينة-المنورة/حي-البلقاء",
    __typename: "DistrictType",
    district_id: 2932,
    name: "حي البلقاء",
    uri: "حي-البلقاء",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الجابرة"}': {
    path: "/المدينة-المنورة/حي-الجابرة",
    __typename: "DistrictType",
    district_id: 2934,
    name: "حي الجابرة",
    uri: "حي-الجابرة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الجمعة"}': {
    path: "/المدينة-المنورة/حي-الجمعة",
    __typename: "DistrictType",
    district_id: 2942,
    name: "حي الجمعة",
    uri: "حي-الجمعة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الدويخلة"}': {
    path: "/المدينة-المنورة/حي-الدويخلة",
    __typename: "DistrictType",
    district_id: 2956,
    name: "حي الدويخلة",
    uri: "حي-الدويخلة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الدويمة"}': {
    path: "/المدينة-المنورة/حي-الدويمة",
    __typename: "DistrictType",
    district_id: 2958,
    name: "حي الدويمة",
    uri: "حي-الدويمة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الروابي"}': {
    path: "/المدينة-المنورة/حي-الروابي",
    __typename: "DistrictType",
    district_id: 2966,
    name: "حي الروابي",
    uri: "حي-الروابي",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-السد"}': {
    path: "/المدينة-المنورة/حي-السد",
    __typename: "DistrictType",
    district_id: 2970,
    name: "حي السد",
    uri: "حي-السد",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-السقيا"}': {
    path: "/المدينة-المنورة/حي-السقيا",
    __typename: "DistrictType",
    district_id: 2972,
    name: "حي السقيا",
    uri: "حي-السقيا",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-السلام"}': {
    path: "/المدينة-المنورة/حي-السلام",
    __typename: "DistrictType",
    district_id: 2978,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الشريبات"}': {
    path: "/المدينة-المنورة/حي-الشريبات",
    __typename: "DistrictType",
    district_id: 2982,
    name: "حي الشريبات",
    uri: "حي-الشريبات",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-العصبة"}': {
    path: "/المدينة-المنورة/حي-العصبة",
    __typename: "DistrictType",
    district_id: 2996,
    name: "حي العصبة",
    uri: "حي-العصبة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-العيون"}': {
    path: "/المدينة-المنورة/حي-العيون",
    __typename: "DistrictType",
    district_id: 3000,
    name: "حي العيون",
    uri: "حي-العيون",
  },
  'DistrictType:{"path":"/عنيزة/حي-الوسطى"}': {
    path: "/عنيزة/حي-الوسطى",
    __typename: "DistrictType",
    district_id: 2610,
    name: "حي الوسطى",
    uri: "حي-الوسطى",
  },
  'DistrictType:{"path":"/عنيزة/حي-ربوة-الحاجب"}': {
    path: "/عنيزة/حي-ربوة-الحاجب",
    __typename: "DistrictType",
    district_id: 2626,
    name: "حي ربوة الحاجب",
    uri: "حي-ربوة-الحاجب",
  },
  'DistrictType:{"path":"/عنيزة/حي-سنام"}': {
    path: "/عنيزة/حي-سنام",
    __typename: "DistrictType",
    district_id: 2628,
    name: "حي سنام",
    uri: "حي-سنام",
  },
  'DistrictType:{"path":"/القريات/حي-الخالدية"}': {
    path: "/القريات/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 2642,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الاداري"}': {
    path: "/دومة-الجندل/حي-الاداري",
    __typename: "DistrictType",
    district_id: 2646,
    name: "حي الاداري",
    uri: "حي-الاداري",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-التحكيم"}': {
    path: "/دومة-الجندل/حي-التحكيم",
    __typename: "DistrictType",
    district_id: 2650,
    name: "حي التحكيم",
    uri: "حي-التحكيم",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الربوة"}': {
    path: "/دومة-الجندل/حي-الربوة",
    __typename: "DistrictType",
    district_id: 2662,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الشفاء"}': {
    path: "/دومة-الجندل/حي-الشفاء",
    __typename: "DistrictType",
    district_id: 2672,
    name: "حي الشفاء",
    uri: "حي-الشفاء",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الملك-فهد"}': {
    path: "/دومة-الجندل/حي-الملك-فهد",
    __typename: "DistrictType",
    district_id: 2696,
    name: "حي الملك فهد",
    uri: "حي-الملك-فهد",
  },
  'DistrictType:{"path":"/سكاكا/حي-الطوير"}': {
    path: "/سكاكا/حي-الطوير",
    __typename: "DistrictType",
    district_id: 2730,
    name: "حي الطوير",
    uri: "حي-الطوير",
  },
  'DistrictType:{"path":"/سكاكا/حي-المحمدية-ب"}': {
    path: "/سكاكا/حي-المحمدية-ب",
    __typename: "DistrictType",
    district_id: 2744,
    name: "حي المحمدية ب",
    uri: "حي-المحمدية-ب",
  },
  'DistrictType:{"path":"/سكاكا/حي-المحمدية-د"}': {
    path: "/سكاكا/حي-المحمدية-د",
    __typename: "DistrictType",
    district_id: 2746,
    name: "حي المحمدية د",
    uri: "حي-المحمدية-د",
  },
  'DistrictType:{"path":"/سكاكا/حي-المحمديه-ه"}': {
    path: "/سكاكا/حي-المحمديه-ه",
    __typename: "DistrictType",
    district_id: 2754,
    name: "حي المحمديه ه",
    uri: "حي-المحمديه-ه",
  },
  'DistrictType:{"path":"/سكاكا/حي-المروج"}': {
    path: "/سكاكا/حي-المروج",
    __typename: "DistrictType",
    district_id: 2756,
    name: "حي المروج",
    uri: "حي-المروج",
  },
  'DistrictType:{"path":"/سكاكا/حي-جنوب-غرب-قارا"}': {
    path: "/سكاكا/حي-جنوب-غرب-قارا",
    __typename: "DistrictType",
    district_id: 2768,
    name: "حي جنوب غرب قارا",
    uri: "حي-جنوب-غرب-قارا",
  },
  'DistrictType:{"path":"/سكاكا/حي-حي-الصوالحة"}': {
    path: "/سكاكا/حي-حي-الصوالحة",
    __typename: "DistrictType",
    district_id: 2770,
    name: "حي حي الصوالحة",
    uri: "حي-حي-الصوالحة",
  },
  'DistrictType:{"path":"/سكاكا/حي-حي-المرازيق"}': {
    path: "/سكاكا/حي-حي-المرازيق",
    __typename: "DistrictType",
    district_id: 2772,
    name: "حي حي المرازيق",
    uri: "حي-حي-المرازيق",
  },
  'DistrictType:{"path":"/سكاكا/حي-قارا"}': {
    path: "/سكاكا/حي-قارا",
    __typename: "DistrictType",
    district_id: 2778,
    name: "حي قارا",
    uri: "حي-قارا",
  },
  'DistrictType:{"path":"/سكاكا/حي-مخطط-الامل"}': {
    path: "/سكاكا/حي-مخطط-الامل",
    __typename: "DistrictType",
    district_id: 2780,
    name: "حي مخطط الامل",
    uri: "حي-مخطط-الامل",
  },
  'DistrictType:{"path":"/سكاكا/حي-مخطط-شرق-الاقليمي"}': {
    path: "/سكاكا/حي-مخطط-شرق-الاقليمي",
    __typename: "DistrictType",
    district_id: 2798,
    name: "حي مخطط شرق الاقليمي",
    uri: "حي-مخطط-شرق-الاقليمي",
  },
  'DistrictType:{"path":"/بريدة/حي-واسط"}': {
    path: "/بريدة/حي-واسط",
    __typename: "DistrictType",
    district_id: 2412,
    name: "حي واسط",
    uri: "حي-واسط",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-الافراح"}': {
    path: "/رياض-الخبراء/حي-الافراح",
    __typename: "DistrictType",
    district_id: 2416,
    name: "حي الافراح",
    uri: "حي-الافراح",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-الربوة"}': {
    path: "/رياض-الخبراء/حي-الربوة",
    __typename: "DistrictType",
    district_id: 2428,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-الربيع"}': {
    path: "/رياض-الخبراء/حي-الربيع",
    __typename: "DistrictType",
    district_id: 2430,
    name: "حي الربيع",
    uri: "حي-الربيع",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-السحابين-الشمالي"}': {
    path: "/رياض-الخبراء/حي-السحابين-الشمالي",
    __typename: "DistrictType",
    district_id: 2440,
    name: "حي السحابين الشمالي",
    uri: "حي-السحابين-الشمالي",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-الصناعية"}': {
    path: "/رياض-الخبراء/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 2444,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-زبيدة"}': {
    path: "/رياض-الخبراء/حي-زبيدة",
    __typename: "DistrictType",
    district_id: 2458,
    name: "حي زبيدة",
    uri: "حي-زبيدة",
  },
  'DistrictType:{"path":"/عنيزة/حي-البديعة"}': {
    path: "/عنيزة/حي-البديعة",
    __typename: "DistrictType",
    district_id: 2466,
    name: "حي البديعة",
    uri: "حي-البديعة",
  },
  'DistrictType:{"path":"/عنيزة/حي-الجلده"}': {
    path: "/عنيزة/حي-الجلده",
    __typename: "DistrictType",
    district_id: 2480,
    name: "حي الجلده",
    uri: "حي-الجلده",
  },
  'DistrictType:{"path":"/عنيزة/حي-الحزم"}': {
    path: "/عنيزة/حي-الحزم",
    __typename: "DistrictType",
    district_id: 2488,
    name: "حي الحزم",
    uri: "حي-الحزم",
  },
  'DistrictType:{"path":"/عنيزة/حي-الخالدية"}': {
    path: "/عنيزة/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 2494,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/عنيزة/حي-الدوحة"}': {
    path: "/عنيزة/حي-الدوحة",
    __typename: "DistrictType",
    district_id: 2500,
    name: "حي الدوحة",
    uri: "حي-الدوحة",
  },
  'DistrictType:{"path":"/عنيزة/حي-العبسة"}': {
    path: "/عنيزة/حي-العبسة",
    __typename: "DistrictType",
    district_id: 2540,
    name: "حي العبسة",
    uri: "حي-العبسة",
  },
  'DistrictType:{"path":"/عنيزة/حي-القصور"}': {
    path: "/عنيزة/حي-القصور",
    __typename: "DistrictType",
    district_id: 2560,
    name: "حي القصور",
    uri: "حي-القصور",
  },
  'DistrictType:{"path":"/عنيزة/حي-المباركية"}': {
    path: "/عنيزة/حي-المباركية",
    __typename: "DistrictType",
    district_id: 2564,
    name: "حي المباركية",
    uri: "حي-المباركية",
  },
  'DistrictType:{"path":"/عنيزة/حي-المنتزة"}': {
    path: "/عنيزة/حي-المنتزة",
    __typename: "DistrictType",
    district_id: 2586,
    name: "حي المنتزة",
    uri: "حي-المنتزة",
  },
  'DistrictType:{"path":"/عنيزة/حي-النفود"}': {
    path: "/عنيزة/حي-النفود",
    __typename: "DistrictType",
    district_id: 2600,
    name: "حي النفود",
    uri: "حي-النفود",
  },
  'DistrictType:{"path":"/عنيزة/حي-النقيلية"}': {
    path: "/عنيزة/حي-النقيلية",
    __typename: "DistrictType",
    district_id: 2602,
    name: "حي النقيلية",
    uri: "حي-النقيلية",
  },
  'DistrictType:{"path":"/الشنان/حي-النهضة"}': {
    path: "/الشنان/حي-النهضة",
    __typename: "DistrictType",
    district_id: 2008,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/حائل/حي-البحيرة"}': {
    path: "/حائل/حي-البحيرة",
    __typename: "DistrictType",
    district_id: 2020,
    name: "حي البحيرة",
    uri: "حي-البحيرة",
  },
  'DistrictType:{"path":"/حائل/حي-الزبارة"}': {
    path: "/حائل/حي-الزبارة",
    __typename: "DistrictType",
    district_id: 2030,
    name: "حي الزبارة",
    uri: "حي-الزبارة",
  },
  'DistrictType:{"path":"/حائل/حي-الزهراء"}': {
    path: "/حائل/حي-الزهراء",
    __typename: "DistrictType",
    district_id: 2032,
    name: "حي الزهراء",
    uri: "حي-الزهراء",
  },
  'DistrictType:{"path":"/حائل/حي-المحطة"}': {
    path: "/حائل/حي-المحطة",
    __typename: "DistrictType",
    district_id: 2040,
    name: "حي المحطة",
    uri: "حي-المحطة",
  },
  'DistrictType:{"path":"/حائل/حي-المزعبر"}': {
    path: "/حائل/حي-المزعبر",
    __typename: "DistrictType",
    district_id: 2042,
    name: "حي المزعبر",
    uri: "حي-المزعبر",
  },
  'DistrictType:{"path":"/حائل/حي-المصيف"}': {
    path: "/حائل/حي-المصيف",
    __typename: "DistrictType",
    district_id: 2044,
    name: "حي المصيف",
    uri: "حي-المصيف",
  },
  'DistrictType:{"path":"/حائل/حي-برزان"}': {
    path: "/حائل/حي-برزان",
    __typename: "DistrictType",
    district_id: 2060,
    name: "حي برزان",
    uri: "حي-برزان",
  },
  'DistrictType:{"path":"/البدائع/حي-الاندلس"}': {
    path: "/البدائع/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 2068,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/البكيرية/حي-ابن-خلدون"}': {
    path: "/البكيرية/حي-ابن-خلدون",
    __typename: "DistrictType",
    district_id: 2104,
    name: "حي ابن خلدون",
    uri: "حي-ابن-خلدون",
  },
  'DistrictType:{"path":"/البكيرية/حي-الخالدية"}': {
    path: "/البكيرية/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 2110,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/البكيرية/حي-القادسية"}': {
    path: "/البكيرية/حي-القادسية",
    __typename: "DistrictType",
    district_id: 2120,
    name: "حي القادسية",
    uri: "حي-القادسية",
  },
  'DistrictType:{"path":"/الرس/حي-الاحتفالات"}': {
    path: "/الرس/حي-الاحتفالات",
    __typename: "DistrictType",
    district_id: 2128,
    name: "حي الاحتفالات",
    uri: "حي-الاحتفالات",
  },
  'DistrictType:{"path":"/الرس/حي-التعليم"}': {
    path: "/الرس/حي-التعليم",
    __typename: "DistrictType",
    district_id: 2132,
    name: "حي التعليم",
    uri: "حي-التعليم",
  },
  'DistrictType:{"path":"/الرس/حي-الريان"}': {
    path: "/الرس/حي-الريان",
    __typename: "DistrictType",
    district_id: 2144,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'DistrictType:{"path":"/الرس/حي-الملك-فهد"}': {
    path: "/الرس/حي-الملك-فهد",
    __typename: "DistrictType",
    district_id: 2162,
    name: "حي الملك فهد",
    uri: "حي-الملك-فهد",
  },
  'DistrictType:{"path":"/الشماسية/حي-الاندلس"}': {
    path: "/الشماسية/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 2172,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/الشماسية/حي-المتوكل"}': {
    path: "/الشماسية/حي-المتوكل",
    __typename: "DistrictType",
    district_id: 2194,
    name: "حي المتوكل",
    uri: "حي-المتوكل",
  },
  'DistrictType:{"path":"/الهفوف/حي-القرين"}': {
    path: "/الهفوف/حي-القرين",
    __typename: "DistrictType",
    district_id: 1604,
    name: "حي القرين",
    uri: "حي-القرين",
  },
  'DistrictType:{"path":"/الهفوف/حي-المثلث"}': {
    path: "/الهفوف/حي-المثلث",
    __typename: "DistrictType",
    district_id: 1608,
    name: "حي المثلث",
    uri: "حي-المثلث",
  },
  'DistrictType:{"path":"/الهفوف/حي-المعلمين-الشرقية"}': {
    path: "/الهفوف/حي-المعلمين-الشرقية",
    __typename: "DistrictType",
    district_id: 1622,
    name: "حي المعلمين الشرقية",
    uri: "حي-المعلمين-الشرقية",
  },
  'DistrictType:{"path":"/الهفوف/حي-المعلمين-الغربية"}': {
    path: "/الهفوف/حي-المعلمين-الغربية",
    __typename: "DistrictType",
    district_id: 1624,
    name: "حي المعلمين الغربية",
    uri: "حي-المعلمين-الغربية",
  },
  'DistrictType:{"path":"/الهفوف/حي-النسيم"}': {
    path: "/الهفوف/حي-النسيم",
    __typename: "DistrictType",
    district_id: 1636,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/الهفوف/حي-محاسن-ارامكو"}': {
    path: "/الهفوف/حي-محاسن-ارامكو",
    __typename: "DistrictType",
    district_id: 1662,
    name: "حي محاسن ارامكو",
    uri: "حي-محاسن-ارامكو",
  },
  'DistrictType:{"path":"/الهفوف/حي-محمد-العيسى"}': {
    path: "/الهفوف/حي-محمد-العيسى",
    __typename: "DistrictType",
    district_id: 1666,
    name: "حي محمد العيسى",
    uri: "حي-محمد-العيسى",
  },
  'DistrictType:{"path":"/الهفوف/حي-مدينة-العمران"}': {
    path: "/الهفوف/حي-مدينة-العمران",
    __typename: "DistrictType",
    district_id: 1674,
    name: "حي مدينة العمران",
    uri: "حي-مدينة-العمران",
  },
  'DistrictType:{"path":"/بقيق/حي-المدينة"}': {
    path: "/بقيق/حي-المدينة",
    __typename: "DistrictType",
    district_id: 1694,
    name: "حي المدينة",
    uri: "حي-المدينة",
  },
  'DistrictType:{"path":"/بقيق/حي-غرناطة"}': {
    path: "/بقيق/حي-غرناطة",
    __typename: "DistrictType",
    district_id: 1702,
    name: "حي غرناطة",
    uri: "حي-غرناطة",
  },
  'DistrictType:{"path":"/بقيق/حي-قرطبة"}': {
    path: "/بقيق/حي-قرطبة",
    __typename: "DistrictType",
    district_id: 1704,
    name: "حي قرطبة",
    uri: "حي-قرطبة",
  },
  'DistrictType:{"path":"/تاروت/حي-الاندلس"}': {
    path: "/تاروت/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 1706,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/تاروت/حي-النخيل"}': {
    path: "/تاروت/حي-النخيل",
    __typename: "DistrictType",
    district_id: 1730,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الباطن"}': {
    path: "/حفر-الباطن/حي-الباطن",
    __typename: "DistrictType",
    district_id: 1744,
    name: "حي الباطن",
    uri: "حي-الباطن",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الجامعة"}': {
    path: "/حفر-الباطن/حي-الجامعة",
    __typename: "DistrictType",
    district_id: 1750,
    name: "حي الجامعة",
    uri: "حي-الجامعة",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الشفاء"}': {
    path: "/حفر-الباطن/حي-الشفاء",
    __typename: "DistrictType",
    district_id: 1770,
    name: "حي الشفاء",
    uri: "حي-الشفاء",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الوادي"}': {
    path: "/حفر-الباطن/حي-الوادي",
    __typename: "DistrictType",
    district_id: 1800,
    name: "حي الوادي",
    uri: "حي-الوادي",
  },
  'DistrictType:{"path":"/المذنب/حي-الصالحية"}': {
    path: "/المذنب/حي-الصالحية",
    __typename: "DistrictType",
    district_id: 2234,
    name: "حي الصالحية",
    uri: "حي-الصالحية",
  },
  'DistrictType:{"path":"/المذنب/حي-المنتزه"}': {
    path: "/المذنب/حي-المنتزه",
    __typename: "DistrictType",
    district_id: 2244,
    name: "حي المنتزه",
    uri: "حي-المنتزه",
  },
  'DistrictType:{"path":"/بريدة/حي-الجردة"}': {
    path: "/بريدة/حي-الجردة",
    __typename: "DistrictType",
    district_id: 2280,
    name: "حي الجردة",
    uri: "حي-الجردة",
  },
  'DistrictType:{"path":"/بريدة/حي-الحصاة"}': {
    path: "/بريدة/حي-الحصاة",
    __typename: "DistrictType",
    district_id: 2282,
    name: "حي الحصاة",
    uri: "حي-الحصاة",
  },
  'DistrictType:{"path":"/بريدة/حي-العريمضي"}': {
    path: "/بريدة/حي-العريمضي",
    __typename: "DistrictType",
    district_id: 2330,
    name: "حي العريمضي",
    uri: "حي-العريمضي",
  },
  'DistrictType:{"path":"/بريدة/حي-الغماس"}': {
    path: "/بريدة/حي-الغماس",
    __typename: "DistrictType",
    district_id: 2334,
    name: "حي الغماس",
    uri: "حي-الغماس",
  },
  'DistrictType:{"path":"/بريدة/حي-الفاخرية"}': {
    path: "/بريدة/حي-الفاخرية",
    __typename: "DistrictType",
    district_id: 2336,
    name: "حي الفاخرية",
    uri: "حي-الفاخرية",
  },
  'DistrictType:{"path":"/بريدة/حي-القويع"}': {
    path: "/بريدة/حي-القويع",
    __typename: "DistrictType",
    district_id: 2344,
    name: "حي القويع",
    uri: "حي-القويع",
  },
  'DistrictType:{"path":"/بريدة/حي-الهلال"}': {
    path: "/بريدة/حي-الهلال",
    __typename: "DistrictType",
    district_id: 2374,
    name: "حي الهلال",
    uri: "حي-الهلال",
  },
  'DistrictType:{"path":"/بريدة/حي-خب-الجطيبي"}': {
    path: "/بريدة/حي-خب-الجطيبي",
    __typename: "DistrictType",
    district_id: 2386,
    name: "حي خب الجطيبي",
    uri: "حي-خب-الجطيبي",
  },
  'DistrictType:{"path":"/بريدة/حي-خب-العكرش"}': {
    path: "/بريدة/حي-خب-العكرش",
    __typename: "DistrictType",
    district_id: 2388,
    name: "حي خب العكرش",
    uri: "حي-خب-العكرش",
  },
  'DistrictType:{"path":"/بريدة/حي-خب-القبر"}': {
    path: "/بريدة/حي-خب-القبر",
    __typename: "DistrictType",
    district_id: 2390,
    name: "حي خب القبر",
    uri: "حي-خب-القبر",
  },
  'DistrictType:{"path":"/بريدة/حي-خب-القصبا"}': {
    path: "/بريدة/حي-خب-القصبا",
    __typename: "DistrictType",
    district_id: 2392,
    name: "حي خب القصبا",
    uri: "حي-خب-القصبا",
  },
  'DistrictType:{"path":"/بريدة/حي-رواق"}': {
    path: "/بريدة/حي-رواق",
    __typename: "DistrictType",
    district_id: 2400,
    name: "حي رواق",
    uri: "حي-رواق",
  },
  'DistrictType:{"path":"/راس-تنورة/حي-الاندلس"}': {
    path: "/راس-تنورة/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 1812,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/راس-تنورة/حي-الروضة"}': {
    path: "/راس-تنورة/حي-الروضة",
    __typename: "DistrictType",
    district_id: 1816,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/راس-تنورة/حي-الزهور"}': {
    path: "/راس-تنورة/حي-الزهور",
    __typename: "DistrictType",
    district_id: 1818,
    name: "حي الزهور",
    uri: "حي-الزهور",
  },
  'DistrictType:{"path":"/راس-تنورة/حي-الصناعية"}': {
    path: "/راس-تنورة/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 1820,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/راس-تنورة/حي-قرطبة"}': {
    path: "/راس-تنورة/حي-قرطبة",
    __typename: "DistrictType",
    district_id: 1828,
    name: "حي قرطبة",
    uri: "حي-قرطبة",
  },
  'DistrictType:{"path":"/سيهات/حي-الخليج"}': {
    path: "/سيهات/حي-الخليج",
    __typename: "DistrictType",
    district_id: 1832,
    name: "حي الخليج",
    uri: "حي-الخليج",
  },
  'DistrictType:{"path":"/سيهات/حي-الزهور"}': {
    path: "/سيهات/حي-الزهور",
    __typename: "DistrictType",
    district_id: 1836,
    name: "حي الزهور",
    uri: "حي-الزهور",
  },
  'DistrictType:{"path":"/سيهات/حي-الكوثر"}': {
    path: "/سيهات/حي-الكوثر",
    __typename: "DistrictType",
    district_id: 1848,
    name: "حي الكوثر",
    uri: "حي-الكوثر",
  },
  'DistrictType:{"path":"/سيهات/حي-النقى"}': {
    path: "/سيهات/حي-النقى",
    __typename: "DistrictType",
    district_id: 1856,
    name: "حي النقى",
    uri: "حي-النقى",
  },
  'DistrictType:{"path":"/صفوى/حي-الريحان"}': {
    path: "/صفوى/حي-الريحان",
    __typename: "DistrictType",
    district_id: 1882,
    name: "حي الريحان",
    uri: "حي-الريحان",
  },
  'DistrictType:{"path":"/صفوى/حي-العروبة"}': {
    path: "/صفوى/حي-العروبة",
    __typename: "DistrictType",
    district_id: 1888,
    name: "حي العروبة",
    uri: "حي-العروبة",
  },
  'DistrictType:{"path":"/رفحاء/حي-الجميماء"}': {
    path: "/رفحاء/حي-الجميماء",
    __typename: "DistrictType",
    district_id: 1916,
    name: "حي الجميماء",
    uri: "حي-الجميماء",
  },
  'DistrictType:{"path":"/رفحاء/حي-الشمالي"}': {
    path: "/رفحاء/حي-الشمالي",
    __typename: "DistrictType",
    district_id: 1920,
    name: "حي الشمالي",
    uri: "حي-الشمالي",
  },
  'DistrictType:{"path":"/رفحاء/حي-اليرموك"}': {
    path: "/رفحاء/حي-اليرموك",
    __typename: "DistrictType",
    district_id: 1940,
    name: "حي اليرموك",
    uri: "حي-اليرموك",
  },
  'DistrictType:{"path":"/طريف/حي-الصالحية"}': {
    path: "/طريف/حي-الصالحية",
    __typename: "DistrictType",
    district_id: 1952,
    name: "حي الصالحية",
    uri: "حي-الصالحية",
  },
  'DistrictType:{"path":"/طريف/حي-الفيصلية"}': {
    path: "/طريف/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 1958,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/طريف/حي-المساعدية"}': {
    path: "/طريف/حي-المساعدية",
    __typename: "DistrictType",
    district_id: 1960,
    name: "حي المساعدية",
    uri: "حي-المساعدية",
  },
  'DistrictType:{"path":"/طريف/حي-سلطانة"}': {
    path: "/طريف/حي-سلطانة",
    __typename: "DistrictType",
    district_id: 1966,
    name: "حي سلطانة",
    uri: "حي-سلطانة",
  },
  'DistrictType:{"path":"/الشنان/حي-الحمراء"}': {
    path: "/الشنان/حي-الحمراء",
    __typename: "DistrictType",
    district_id: 1994,
    name: "حي الحمراء",
    uri: "حي-الحمراء",
  },
  'DistrictType:{"path":"/الشنان/حي-السلام"}': {
    path: "/الشنان/حي-السلام",
    __typename: "DistrictType",
    district_id: 1998,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/الشماسية/حي-برزة"}': {
    path: "/الشماسية/حي-برزة",
    __typename: "DistrictType",
    district_id: 2202,
    name: "حي برزة",
    uri: "حي-برزة",
  },
  'DistrictType:{"path":"/المذنب/حي-الحزم"}': {
    path: "/المذنب/حي-الحزم",
    __typename: "DistrictType",
    district_id: 2224,
    name: "حي الحزم",
    uri: "حي-الحزم",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الملك-فهد"}': {
    path: "/المدينة-المنورة/حي-الملك-فهد",
    __typename: "DistrictType",
    district_id: 3022,
    name: "حي الملك فهد",
    uri: "حي-الملك-فهد",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-النخيل"}': {
    path: "/المدينة-المنورة/حي-النخيل",
    __typename: "DistrictType",
    district_id: 3026,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-بني-عبدالاشهل"}': {
    path: "/المدينة-المنورة/حي-بني-عبدالاشهل",
    __typename: "DistrictType",
    district_id: 3042,
    name: "حي بني عبدالاشهل",
    uri: "حي-بني-عبدالاشهل",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-عين-الخيف"}': {
    path: "/المدينة-المنورة/حي-عين-الخيف",
    __typename: "DistrictType",
    district_id: 3072,
    name: "حي عين الخيف",
    uri: "حي-عين-الخيف",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-قلعة-مخيط"}': {
    path: "/المدينة-المنورة/حي-قلعة-مخيط",
    __typename: "DistrictType",
    district_id: 3076,
    name: "حي قلعة مخيط",
    uri: "حي-قلعة-مخيط",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-مسجد-الدرع"}': {
    path: "/المدينة-المنورة/حي-مسجد-الدرع",
    __typename: "DistrictType",
    district_id: 3082,
    name: "حي مسجد الدرع",
    uri: "حي-مسجد-الدرع",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-مهزور"}': {
    path: "/المدينة-المنورة/حي-مهزور",
    __typename: "DistrictType",
    district_id: 3084,
    name: "حي مهزور",
    uri: "حي-مهزور",
  },
  'DistrictType:{"path":"/بدر/حي-ادمان"}': {
    path: "/بدر/حي-ادمان",
    __typename: "DistrictType",
    district_id: 3092,
    name: "حي ادمان",
    uri: "حي-ادمان",
  },
  'DistrictType:{"path":"/بدر/حي-العدوة"}': {
    path: "/بدر/حي-العدوة",
    __typename: "DistrictType",
    district_id: 3100,
    name: "حي العدوة",
    uri: "حي-العدوة",
  },
  'DistrictType:{"path":"/خيبر/حي-الروضة"}': {
    path: "/خيبر/حي-الروضة",
    __typename: "DistrictType",
    district_id: 3110,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/خيبر/حي-سلطانة"}': {
    path: "/خيبر/حي-سلطانة",
    __typename: "DistrictType",
    district_id: 3116,
    name: "حي سلطانة",
    uri: "حي-سلطانة",
  },
  'DistrictType:{"path":"/ينبع/حي-البندر"}': {
    path: "/ينبع/حي-البندر",
    __typename: "DistrictType",
    district_id: 3130,
    name: "حي البندر",
    uri: "حي-البندر",
  },
  'DistrictType:{"path":"/ينبع/حي-البهجة"}': {
    path: "/ينبع/حي-البهجة",
    __typename: "DistrictType",
    district_id: 3132,
    name: "حي البهجة",
    uri: "حي-البهجة",
  },
  'DistrictType:{"path":"/ينبع/حي-التعاون"}': {
    path: "/ينبع/حي-التعاون",
    __typename: "DistrictType",
    district_id: 3136,
    name: "حي التعاون",
    uri: "حي-التعاون",
  },
  'DistrictType:{"path":"/ينبع/حي-الجابرية"}': {
    path: "/ينبع/حي-الجابرية",
    __typename: "DistrictType",
    district_id: 3138,
    name: "حي الجابرية",
    uri: "حي-الجابرية",
  },
  'DistrictType:{"path":"/ينبع/حي-الجار"}': {
    path: "/ينبع/حي-الجار",
    __typename: "DistrictType",
    district_id: 3142,
    name: "حي الجار",
    uri: "حي-الجار",
  },
  'DistrictType:{"path":"/ينبع/حي-الربيع"}': {
    path: "/ينبع/حي-الربيع",
    __typename: "DistrictType",
    district_id: 3164,
    name: "حي الربيع",
    uri: "حي-الربيع",
  },
  'DistrictType:{"path":"/ينبع/حي-الريان"}': {
    path: "/ينبع/حي-الريان",
    __typename: "DistrictType",
    district_id: 3166,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'DistrictType:{"path":"/ينبع/حي-الصاعدية"}': {
    path: "/ينبع/حي-الصاعدية",
    __typename: "DistrictType",
    district_id: 3188,
    name: "حي الصاعدية",
    uri: "حي-الصاعدية",
  },
  'DistrictType:{"path":"/ينبع/حي-المجد"}': {
    path: "/ينبع/حي-المجد",
    __typename: "DistrictType",
    district_id: 3220,
    name: "حي المجد",
    uri: "حي-المجد",
  },
  'DistrictType:{"path":"/ينبع/حي-المرجان"}': {
    path: "/ينبع/حي-المرجان",
    __typename: "DistrictType",
    district_id: 3224,
    name: "حي المرجان",
    uri: "حي-المرجان",
  },
  'DistrictType:{"path":"/ينبع/حي-المسرة"}': {
    path: "/ينبع/حي-المسرة",
    __typename: "DistrictType",
    district_id: 3226,
    name: "حي المسرة",
    uri: "حي-المسرة",
  },
  'DistrictType:{"path":"/ينبع/حي-المنطقة-الصناعية"}': {
    path: "/ينبع/حي-المنطقة-الصناعية",
    __typename: "DistrictType",
    district_id: 3234,
    name: "حي المنطقة الصناعية",
    uri: "حي-المنطقة-الصناعية",
  },
  'DistrictType:{"path":"/الجموم/حي-ابو-شعيب"}': {
    path: "/الجموم/حي-ابو-شعيب",
    __typename: "DistrictType",
    district_id: 3264,
    name: "حي ابو شعيب",
    uri: "حي-ابو-شعيب",
  },
  'DistrictType:{"path":"/الخرمة/حي-الحديقة"}': {
    path: "/الخرمة/حي-الحديقة",
    __typename: "DistrictType",
    district_id: 3296,
    name: "حي الحديقة",
    uri: "حي-الحديقة",
  },
  'DistrictType:{"path":"/الطائف/حي-السداد"}': {
    path: "/الطائف/حي-السداد",
    __typename: "DistrictType",
    district_id: 3324,
    name: "حي السداد",
    uri: "حي-السداد",
  },
  'DistrictType:{"path":"/الطائف/حي-السلامة"}': {
    path: "/الطائف/حي-السلامة",
    __typename: "DistrictType",
    district_id: 3326,
    name: "حي السلامة",
    uri: "حي-السلامة",
  },
  'DistrictType:{"path":"/الطائف/حي-الشهداء-الشمالية"}': {
    path: "/الطائف/حي-الشهداء-الشمالية",
    __typename: "DistrictType",
    district_id: 3332,
    name: "حي الشهداء الشمالية",
    uri: "حي-الشهداء-الشمالية",
  },
  'DistrictType:{"path":"/الطائف/حي-الفيصلية"}': {
    path: "/الطائف/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 3338,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/الطائف/حي-المثناه"}': {
    path: "/الطائف/حي-المثناه",
    __typename: "DistrictType",
    district_id: 3344,
    name: "حي المثناه",
    uri: "حي-المثناه",
  },
  'DistrictType:{"path":"/الطائف/حي-جبرة"}': {
    path: "/الطائف/حي-جبرة",
    __typename: "DistrictType",
    district_id: 3362,
    name: "حي جبرة",
    uri: "حي-جبرة",
  },
  'DistrictType:{"path":"/الطائف/حي-حوايا"}': {
    path: "/الطائف/حي-حوايا",
    __typename: "DistrictType",
    district_id: 3364,
    name: "حي حوايا",
    uri: "حي-حوايا",
  },
  'DistrictType:{"path":"/الطائف/حي-مسره"}': {
    path: "/الطائف/حي-مسره",
    __typename: "DistrictType",
    district_id: 3374,
    name: "حي مسره",
    uri: "حي-مسره",
  },
  'DistrictType:{"path":"/الطائف/حي-معشي"}': {
    path: "/الطائف/حي-معشي",
    __typename: "DistrictType",
    district_id: 3376,
    name: "حي معشي",
    uri: "حي-معشي",
  },
  'DistrictType:{"path":"/القنفذة/حي-الخالدية"}': {
    path: "/القنفذة/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 3382,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/القنفذة/حي-الشامية"}': {
    path: "/القنفذة/حي-الشامية",
    __typename: "DistrictType",
    district_id: 3386,
    name: "حي الشامية",
    uri: "حي-الشامية",
  },
  'DistrictType:{"path":"/القنفذة/حي-الغربي"}': {
    path: "/القنفذة/حي-الغربي",
    __typename: "DistrictType",
    district_id: 3390,
    name: "حي الغربي",
    uri: "حي-الغربي",
  },
  'DistrictType:{"path":"/تربه/حي-البلد"}': {
    path: "/تربه/حي-البلد",
    __typename: "DistrictType",
    district_id: 3400,
    name: "حي البلد",
    uri: "حي-البلد",
  },
  'DistrictType:{"path":"/ثول/حي-القضيمة"}': {
    path: "/ثول/حي-القضيمة",
    __typename: "DistrictType",
    district_id: 3414,
    name: "حي القضيمة",
    uri: "حي-القضيمة",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-البركة"}': {
    path: "/جدة/جنوب-جدة/حي-البركة",
    __typename: "DistrictType",
    district_id: 3442,
    name: "حي البركة",
    uri: "حي-البركة",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-البساتين"}': {
    path: "/جدة/شمال-جدة/حي-البساتين",
    __typename: "DistrictType",
    district_id: 3444,
    name: "حي البساتين",
    uri: "حي-البساتين",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-البشائر"}': {
    path: "/جدة/شمال-جدة/حي-البشائر",
    __typename: "DistrictType",
    district_id: 3446,
    name: "حي البشائر",
    uri: "حي-البشائر",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-البلد"}': {
    path: "/جدة/شمال-جدة/حي-البلد",
    __typename: "DistrictType",
    district_id: 3452,
    name: "حي البلد",
    uri: "حي-البلد",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-البوادي"}': {
    path: "/جدة/شمال-جدة/حي-البوادي",
    __typename: "DistrictType",
    district_id: 3454,
    name: "حي البوادي",
    uri: "حي-البوادي",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-التضامن"}': {
    path: "/جدة/جنوب-جدة/حي-التضامن",
    __typename: "DistrictType",
    district_id: 3456,
    name: "حي التضامن",
    uri: "حي-التضامن",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الثعالبة"}': {
    path: "/جدة/جنوب-جدة/حي-الثعالبة",
    __typename: "DistrictType",
    district_id: 3460,
    name: "حي الثعالبة",
    uri: "حي-الثعالبة",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الحمدانية"}': {
    path: "/جدة/شمال-جدة/حي-الحمدانية",
    __typename: "DistrictType",
    district_id: 3468,
    name: "حي الحمدانية",
    uri: "حي-الحمدانية",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الرحاب"}': {
    path: "/جدة/شمال-جدة/حي-الرحاب",
    __typename: "DistrictType",
    district_id: 3478,
    name: "حي الرحاب",
    uri: "حي-الرحاب",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الرحمانية"}': {
    path: "/جدة/شمال-جدة/حي-الرحمانية",
    __typename: "DistrictType",
    district_id: 3480,
    name: "حي الرحمانية",
    uri: "حي-الرحمانية",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الروضة"}': {
    path: "/جدة/شمال-جدة/حي-الروضة",
    __typename: "DistrictType",
    district_id: 3486,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الرويس"}': {
    path: "/جدة/شمال-جدة/حي-الرويس",
    __typename: "DistrictType",
    district_id: 3488,
    name: "حي الرويس",
    uri: "حي-الرويس",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الساحل"}': {
    path: "/جدة/جنوب-جدة/حي-الساحل",
    __typename: "DistrictType",
    district_id: 3498,
    name: "حي الساحل",
    uri: "حي-الساحل",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-السامر"}': {
    path: "/جدة/شمال-جدة/حي-السامر",
    __typename: "DistrictType",
    district_id: 3500,
    name: "حي السامر",
    uri: "حي-السامر",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الشراع"}': {
    path: "/جدة/شمال-جدة/حي-الشراع",
    __typename: "DistrictType",
    district_id: 3516,
    name: "حي الشراع",
    uri: "حي-الشراع",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الشفا"}': {
    path: "/جدة/جنوب-جدة/حي-الشفا",
    __typename: "DistrictType",
    district_id: 3522,
    name: "حي الشفا",
    uri: "حي-الشفا",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الصالحية"}': {
    path: "/جدة/شمال-جدة/حي-الصالحية",
    __typename: "DistrictType",
    district_id: 3524,
    name: "حي الصالحية",
    uri: "حي-الصالحية",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-العزيزية"}': {
    path: "/جدة/شمال-جدة/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 3538,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الغليل"}': {
    path: "/جدة/جنوب-جدة/حي-الغليل",
    __typename: "DistrictType",
    district_id: 3542,
    name: "حي الغليل",
    uri: "حي-الغليل",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الفيصلية"}': {
    path: "/جدة/شمال-جدة/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 3558,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-القوزين"}': {
    path: "/جدة/جنوب-جدة/حي-القوزين",
    __typename: "DistrictType",
    district_id: 3564,
    name: "حي القوزين",
    uri: "حي-القوزين",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-المدينة-الصناعية-الثالثة"}': {
    path: "/جدة/جنوب-جدة/حي-المدينة-الصناعية-الثالثة",
    __typename: "DistrictType",
    district_id: 3580,
    name: "حي المدينة الصناعية الثالثة",
    uri: "حي-المدينة-الصناعية-الثالثة",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-المليساء"}': {
    path: "/جدة/جنوب-جدة/حي-المليساء",
    __typename: "DistrictType",
    district_id: 3590,
    name: "حي المليساء",
    uri: "حي-المليساء",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-المنار"}': {
    path: "/جدة/شمال-جدة/حي-المنار",
    __typename: "DistrictType",
    district_id: 3592,
    name: "حي المنار",
    uri: "حي-المنار",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-النزلة-الشرقية"}': {
    path: "/جدة/جنوب-جدة/حي-النزلة-الشرقية",
    __typename: "DistrictType",
    district_id: 3598,
    name: "حي النزلة الشرقية",
    uri: "حي-النزلة-الشرقية",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الوادي"}': {
    path: "/جدة/جنوب-جدة/حي-الوادي",
    __typename: "DistrictType",
    district_id: 3616,
    name: "حي الوادي",
    uri: "حي-الوادي",
  },
  'DistrictType:{"path":"/مدينة-الملك-عبدالله-الاقتصادية/حي-ازميرالدا"}': {
    path: "/مدينة-الملك-عبدالله-الاقتصادية/حي-ازميرالدا",
    __typename: "DistrictType",
    district_id: 3668,
    name: "حي ازميرالدا",
    uri: "حي-ازميرالدا",
  },
  'DistrictType:{"path":"/مدينة-الملك-عبدالله-الاقتصادية/حي-المنطقة-الحرة"}': {
    path: "/مدينة-الملك-عبدالله-الاقتصادية/حي-المنطقة-الحرة",
    __typename: "DistrictType",
    district_id: 3672,
    name: "حي المنطقة الحرة",
    uri: "حي-المنطقة-الحرة",
  },
  'DistrictType:{"path":"/مدينة-الملك-عبدالله-الاقتصادية/حي-الميناء"}': {
    path: "/مدينة-الملك-عبدالله-الاقتصادية/حي-الميناء",
    __typename: "DistrictType",
    district_id: 3676,
    name: "حي الميناء",
    uri: "حي-الميناء",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-البيبان"}': {
    path: "/مكة-المكرمة/حي-البيبان",
    __typename: "DistrictType",
    district_id: 3688,
    name: "حي البيبان",
    uri: "حي-البيبان",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-السلامة"}': {
    path: "/مكة-المكرمة/حي-السلامة",
    __typename: "DistrictType",
    district_id: 3724,
    name: "حي السلامة",
    uri: "حي-السلامة",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الشرائع"}': {
    path: "/مكة-المكرمة/حي-الشرائع",
    __typename: "DistrictType",
    district_id: 3730,
    name: "حي الشرائع",
    uri: "حي-الشرائع",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الطندباوي"}': {
    path: "/مكة-المكرمة/حي-الطندباوي",
    __typename: "DistrictType",
    district_id: 3738,
    name: "حي الطندباوي",
    uri: "حي-الطندباوي",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-العدل"}': {
    path: "/مكة-المكرمة/حي-العدل",
    __typename: "DistrictType",
    district_id: 3742,
    name: "حي العدل",
    uri: "حي-العدل",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-المشاعر"}': {
    path: "/مكة-المكرمة/حي-المشاعر",
    __typename: "DistrictType",
    district_id: 3762,
    name: "حي المشاعر",
    uri: "حي-المشاعر",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-النزهة"}': {
    path: "/مكة-المكرمة/حي-النزهة",
    __typename: "DistrictType",
    district_id: 3770,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الهجرة"}': {
    path: "/مكة-المكرمة/حي-الهجرة",
    __typename: "DistrictType",
    district_id: 3776,
    name: "حي الهجرة",
    uri: "حي-الهجرة",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الهنداوية"}': {
    path: "/مكة-المكرمة/حي-الهنداوية",
    __typename: "DistrictType",
    district_id: 3780,
    name: "حي الهنداوية",
    uri: "حي-الهنداوية",
  },
  'DistrictType:{"path":"/ابها/حي-الاندلس"}': {
    path: "/ابها/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 3786,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/ابها/حي-الخشع"}': {
    path: "/ابها/حي-الخشع",
    __typename: "DistrictType",
    district_id: 3790,
    name: "حي الخشع",
    uri: "حي-الخشع",
  },
  'DistrictType:{"path":"/ابها/حي-النسيم"}': {
    path: "/ابها/حي-النسيم",
    __typename: "DistrictType",
    district_id: 3824,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/ابها/حي-النصب"}': {
    path: "/ابها/حي-النصب",
    __typename: "DistrictType",
    district_id: 3826,
    name: "حي النصب",
    uri: "حي-النصب",
  },
  'DistrictType:{"path":"/ابها/حي-الوردتين"}': {
    path: "/ابها/حي-الوردتين",
    __typename: "DistrictType",
    district_id: 3828,
    name: "حي الوردتين",
    uri: "حي-الوردتين",
  },
  'DistrictType:{"path":"/احد-رفيده/حي-الزيتون"}': {
    path: "/احد-رفيده/حي-الزيتون",
    __typename: "DistrictType",
    district_id: 3848,
    name: "حي الزيتون",
    uri: "حي-الزيتون",
  },
  'DistrictType:{"path":"/احد-رفيده/حي-النهضة"}': {
    path: "/احد-رفيده/حي-النهضة",
    __typename: "DistrictType",
    district_id: 3860,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/المجاردة/حي-الخليج"}': {
    path: "/المجاردة/حي-الخليج",
    __typename: "DistrictType",
    district_id: 3874,
    name: "حي الخليج",
    uri: "حي-الخليج",
  },
  'DistrictType:{"path":"/المجاردة/حي-الربيع"}': {
    path: "/المجاردة/حي-الربيع",
    __typename: "DistrictType",
    district_id: 3876,
    name: "حي الربيع",
    uri: "حي-الربيع",
  },
  'DistrictType:{"path":"/المجاردة/حي-الشرق"}': {
    path: "/المجاردة/حي-الشرق",
    __typename: "DistrictType",
    district_id: 3880,
    name: "حي الشرق",
    uri: "حي-الشرق",
  },
  'DistrictType:{"path":"/المجاردة/حي-العدالة"}': {
    path: "/المجاردة/حي-العدالة",
    __typename: "DistrictType",
    district_id: 3884,
    name: "حي العدالة",
    uri: "حي-العدالة",
  },
  'DistrictType:{"path":"/بللسمر/حي-الربيع"}': {
    path: "/بللسمر/حي-الربيع",
    __typename: "DistrictType",
    district_id: 3898,
    name: "حي الربيع",
    uri: "حي-الربيع",
  },
  'DistrictType:{"path":"/بللسمر/حي-النزهة"}': {
    path: "/بللسمر/حي-النزهة",
    __typename: "DistrictType",
    district_id: 3920,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/بيشة/حي-الامير-سلطان"}': {
    path: "/بيشة/حي-الامير-سلطان",
    __typename: "DistrictType",
    district_id: 3924,
    name: "حي الامير سلطان",
    uri: "حي-الامير-سلطان",
  },
  'DistrictType:{"path":"/بيشة/حي-الربيع"}': {
    path: "/بيشة/حي-الربيع",
    __typename: "DistrictType",
    district_id: 3938,
    name: "حي الربيع",
    uri: "حي-الربيع",
  },
  'DistrictType:{"path":"/بيشة/حي-الصواير"}': {
    path: "/بيشة/حي-الصواير",
    __typename: "DistrictType",
    district_id: 3954,
    name: "حي الصواير",
    uri: "حي-الصواير",
  },
  'DistrictType:{"path":"/بيشة/حي-المروج"}': {
    path: "/بيشة/حي-المروج",
    __typename: "DistrictType",
    district_id: 3962,
    name: "حي المروج",
    uri: "حي-المروج",
  },
  'DistrictType:{"path":"/بيشة/حي-النخيل"}': {
    path: "/بيشة/حي-النخيل",
    __typename: "DistrictType",
    district_id: 3968,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/تثليث/حي-التعاون"}': {
    path: "/تثليث/حي-التعاون",
    __typename: "DistrictType",
    district_id: 3980,
    name: "حي التعاون",
    uri: "حي-التعاون",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-الخزان"}': {
    path: "/خميس-مشيط/حي-الخزان",
    __typename: "DistrictType",
    district_id: 4010,
    name: "حي الخزان",
    uri: "حي-الخزان",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-اللواء-الرابع-عشر"}': {
    path: "/خميس-مشيط/حي-اللواء-الرابع-عشر",
    __typename: "DistrictType",
    district_id: 4042,
    name: "حي اللواء الرابع عشر",
    uri: "حي-اللواء-الرابع-عشر",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-النهضة"}': {
    path: "/خميس-مشيط/حي-النهضة",
    __typename: "DistrictType",
    district_id: 4058,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-ام-سرور"}': {
    path: "/خميس-مشيط/حي-ام-سرور",
    __typename: "DistrictType",
    district_id: 4066,
    name: "حي ام سرور",
    uri: "حي-ام-سرور",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-سكن-القاعدة-الجوية"}': {
    path: "/خميس-مشيط/حي-سكن-القاعدة-الجوية",
    __typename: "DistrictType",
    district_id: 4070,
    name: "حي سكن القاعدة الجوية",
    uri: "حي-سكن-القاعدة-الجوية",
  },
  'DistrictType:{"path":"/محايل/حي-البلد"}': {
    path: "/محايل/حي-البلد",
    __typename: "DistrictType",
    district_id: 4090,
    name: "حي البلد",
    uri: "حي-البلد",
  },
  'DistrictType:{"path":"/محايل/حي-الجنادرية"}': {
    path: "/محايل/حي-الجنادرية",
    __typename: "DistrictType",
    district_id: 4092,
    name: "حي الجنادرية",
    uri: "حي-الجنادرية",
  },
  'DistrictType:{"path":"/محايل/حي-الحيلة-الغربي"}': {
    path: "/محايل/حي-الحيلة-الغربي",
    __typename: "DistrictType",
    district_id: 4096,
    name: "حي الحيلة الغربي",
    uri: "حي-الحيلة-الغربي",
  },
  'DistrictType:{"path":"/محايل/حي-الروضة"}': {
    path: "/محايل/حي-الروضة",
    __typename: "DistrictType",
    district_id: 4100,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/محايل/حي-الزهراء"}': {
    path: "/محايل/حي-الزهراء",
    __typename: "DistrictType",
    district_id: 4102,
    name: "حي الزهراء",
    uri: "حي-الزهراء",
  },
  'DistrictType:{"path":"/شرورة/حي-الصناعية"}': {
    path: "/شرورة/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 4350,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/شرورة/حي-الفيصلية"}': {
    path: "/شرورة/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 4354,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/نجران/حي-الاملاح"}': {
    path: "/نجران/حي-الاملاح",
    __typename: "DistrictType",
    district_id: 4368,
    name: "حي الاملاح",
    uri: "حي-الاملاح",
  },
  'DistrictType:{"path":"/نجران/حي-المفرق"}': {
    path: "/نجران/حي-المفرق",
    __typename: "DistrictType",
    district_id: 4386,
    name: "حي المفرق",
    uri: "حي-المفرق",
  },
  'DistrictType:{"path":"/نجران/حي-مخطط-الصهبان"}': {
    path: "/نجران/حي-مخطط-الصهبان",
    __typename: "DistrictType",
    district_id: 4404,
    name: "حي مخطط الصهبان",
    uri: "حي-مخطط-الصهبان",
  },
  'DistrictType:{"path":"/نجران/حي-مخطط-العريسة-الجنوبي"}': {
    path: "/نجران/حي-مخطط-العريسة-الجنوبي",
    __typename: "DistrictType",
    district_id: 4406,
    name: "حي مخطط العريسة الجنوبي",
    uri: "حي-مخطط-العريسة-الجنوبي",
  },
  'DistrictType:{"path":"/الباحة/حي-الباهر"}': {
    path: "/الباحة/حي-الباهر",
    __typename: "DistrictType",
    district_id: 4420,
    name: "حي الباهر",
    uri: "حي-الباهر",
  },
  'DistrictType:{"path":"/الباحة/حي-الظفير"}': {
    path: "/الباحة/حي-الظفير",
    __typename: "DistrictType",
    district_id: 4430,
    name: "حي الظفير",
    uri: "حي-الظفير",
  },
  'DistrictType:{"path":"/الباحة/حي-وسط-المدينة"}': {
    path: "/الباحة/حي-وسط-المدينة",
    __typename: "DistrictType",
    district_id: 4436,
    name: "حي وسط المدينة",
    uri: "حي-وسط-المدينة",
  },
  'DistrictType:{"path":"/الدمام/حي-الجوهرة"}': {
    path: "/الدمام/حي-الجوهرة",
    __typename: "DistrictType",
    district_id: 1208,
    name: "حي الجوهرة",
    uri: "حي-الجوهرة",
  },
  'DistrictType:{"path":"/الدمام/حي-الدانة"}': {
    path: "/الدمام/حي-الدانة",
    __typename: "DistrictType",
    district_id: 1218,
    name: "حي الدانة",
    uri: "حي-الدانة",
  },
  'DistrictType:{"path":"/الدمام/حي-الريان"}': {
    path: "/الدمام/حي-الريان",
    __typename: "DistrictType",
    district_id: 1228,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'DistrictType:{"path":"/الدمام/حي-السوق"}': {
    path: "/الدمام/حي-السوق",
    __typename: "DistrictType",
    district_id: 1234,
    name: "حي السوق",
    uri: "حي-السوق",
  },
  'DistrictType:{"path":"/الدمام/حي-السيف"}': {
    path: "/الدمام/حي-السيف",
    __typename: "DistrictType",
    district_id: 1236,
    name: "حي السيف",
    uri: "حي-السيف",
  },
  'DistrictType:{"path":"/الدمام/حي-الشاطئ-الغربي"}': {
    path: "/الدمام/حي-الشاطئ-الغربي",
    __typename: "DistrictType",
    district_id: 1240,
    name: "حي الشاطئ الغربي",
    uri: "حي-الشاطئ-الغربي",
  },
  'DistrictType:{"path":"/الدمام/حي-الشرق"}': {
    path: "/الدمام/حي-الشرق",
    __typename: "DistrictType",
    district_id: 1242,
    name: "حي الشرق",
    uri: "حي-الشرق",
  },
  'DistrictType:{"path":"/الدمام/حي-العمامرة"}': {
    path: "/الدمام/حي-العمامرة",
    __typename: "DistrictType",
    district_id: 1260,
    name: "حي العمامرة",
    uri: "حي-العمامرة",
  },
  'DistrictType:{"path":"/الدمام/حي-المريكبات"}': {
    path: "/الدمام/حي-المريكبات",
    __typename: "DistrictType",
    district_id: 1282,
    name: "حي المريكبات",
    uri: "حي-المريكبات",
  },
  'DistrictType:{"path":"/الدمام/حي-المزروعية"}': {
    path: "/الدمام/حي-المزروعية",
    __typename: "DistrictType",
    district_id: 1284,
    name: "حي المزروعية",
    uri: "حي-المزروعية",
  },
  'DistrictType:{"path":"/الدمام/حي-المطار"}': {
    path: "/الدمام/حي-المطار",
    __typename: "DistrictType",
    district_id: 1286,
    name: "حي المطار",
    uri: "حي-المطار",
  },
  'DistrictType:{"path":"/الدمام/حي-الناصرية"}': {
    path: "/الدمام/حي-الناصرية",
    __typename: "DistrictType",
    district_id: 1294,
    name: "حي الناصرية",
    uri: "حي-الناصرية",
  },
  'DistrictType:{"path":"/الدمام/حي-الندى"}': {
    path: "/الدمام/حي-الندى",
    __typename: "DistrictType",
    district_id: 1298,
    name: "حي الندى",
    uri: "حي-الندى",
  },
  'DistrictType:{"path":"/الدمام/حي-النزهة"}': {
    path: "/الدمام/حي-النزهة",
    __typename: "DistrictType",
    district_id: 1300,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/الدمام/حي-النهضة"}': {
    path: "/الدمام/حي-النهضة",
    __typename: "DistrictType",
    district_id: 1304,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/الدمام/حي-النور"}': {
    path: "/الدمام/حي-النور",
    __typename: "DistrictType",
    district_id: 1306,
    name: "حي النور",
    uri: "حي-النور",
  },
  'DistrictType:{"path":"/الدمام/حي-الهضبة"}': {
    path: "/الدمام/حي-الهضبة",
    __typename: "DistrictType",
    district_id: 1310,
    name: "حي الهضبة",
    uri: "حي-الهضبة",
  },
  'DistrictType:{"path":"/الدمام/حي-طيبة"}': {
    path: "/الدمام/حي-طيبة",
    __typename: "DistrictType",
    district_id: 1318,
    name: "حي طيبة",
    uri: "حي-طيبة",
  },
  'DistrictType:{"path":"/الدمام/حي-مطار-الملك-فهد-الدولي"}': {
    path: "/الدمام/حي-مطار-الملك-فهد-الدولي",
    __typename: "DistrictType",
    district_id: 1328,
    name: "حي مطار الملك فهد الدولي",
    uri: "حي-مطار-الملك-فهد-الدولي",
  },
  'DistrictType:{"path":"/الظهران/حي-الدانة-الجنوبية"}': {
    path: "/الظهران/حي-الدانة-الجنوبية",
    __typename: "DistrictType",
    district_id: 1338,
    name: "حي الدانة الجنوبية",
    uri: "حي-الدانة-الجنوبية",
  },
  'DistrictType:{"path":"/الظهران/حي-الدانة-الشمالية"}': {
    path: "/الظهران/حي-الدانة-الشمالية",
    __typename: "DistrictType",
    district_id: 1340,
    name: "حي الدانة الشمالية",
    uri: "حي-الدانة-الشمالية",
  },
  'DistrictType:{"path":"/الظهران/حي-القشلة"}': {
    path: "/الظهران/حي-القشلة",
    __typename: "DistrictType",
    district_id: 1346,
    name: "حي القشلة",
    uri: "حي-القشلة",
  },
  'DistrictType:{"path":"/العيون/حي-الديرة-القديمة"}': {
    path: "/العيون/حي-الديرة-القديمة",
    __typename: "DistrictType",
    district_id: 1358,
    name: "حي الديرة القديمة",
    uri: "حي-الديرة-القديمة",
  },
  'DistrictType:{"path":"/العيون/حي-الرابية"}': {
    path: "/العيون/حي-الرابية",
    __typename: "DistrictType",
    district_id: 1360,
    name: "حي الرابية",
    uri: "حي-الرابية",
  },
  'DistrictType:{"path":"/العيون/حي-السلطانية"}': {
    path: "/العيون/حي-السلطانية",
    __typename: "DistrictType",
    district_id: 1362,
    name: "حي السلطانية",
    uri: "حي-السلطانية",
  },
  'DistrictType:{"path":"/العيون/حي-المراح"}': {
    path: "/العيون/حي-المراح",
    __typename: "DistrictType",
    district_id: 1366,
    name: "حي المراح",
    uri: "حي-المراح",
  },
  'DistrictType:{"path":"/العيون/حي-المعيزل"}': {
    path: "/العيون/حي-المعيزل",
    __typename: "DistrictType",
    district_id: 1368,
    name: "حي المعيزل",
    uri: "حي-المعيزل",
  },
  'DistrictType:{"path":"/العيون/حي-النسيم-1"}': {
    path: "/العيون/حي-النسيم-1",
    __typename: "DistrictType",
    district_id: 1370,
    name: "حي النسيم 1",
    uri: "حي-النسيم-1",
  },
  'DistrictType:{"path":"/العيون/حي-النسيم-2"}': {
    path: "/العيون/حي-النسيم-2",
    __typename: "DistrictType",
    district_id: 1372,
    name: "حي النسيم 2",
    uri: "حي-النسيم-2",
  },
  'DistrictType:{"path":"/العيون/حي-مدينة-العيون-الصناعية"}': {
    path: "/العيون/حي-مدينة-العيون-الصناعية",
    __typename: "DistrictType",
    district_id: 1374,
    name: "حي مدينة العيون الصناعية",
    uri: "حي-مدينة-العيون-الصناعية",
  },
  'DistrictType:{"path":"/الجبيل/حي-المنطقة-الصناعية-الثانية"}': {
    path: "/الجبيل/حي-المنطقة-الصناعية-الثانية",
    __typename: "DistrictType",
    district_id: 1014,
    name: "حي المنطقة الصناعية الثانية",
    uri: "حي-المنطقة-الصناعية-الثانية",
  },
  'DistrictType:{"path":"/الجبيل/حي-دارين"}': {
    path: "/الجبيل/حي-دارين",
    __typename: "DistrictType",
    district_id: 1018,
    name: "حي دارين",
    uri: "حي-دارين",
  },
  'DistrictType:{"path":"/الجبيل/حي-مخطط-السروات"}': {
    path: "/الجبيل/حي-مخطط-السروات",
    __typename: "DistrictType",
    district_id: 1024,
    name: "حي مخطط السروات",
    uri: "حي-مخطط-السروات",
  },
  'DistrictType:{"path":"/الجبيل/حي-مخطط-غرب-المزارع"}': {
    path: "/الجبيل/حي-مخطط-غرب-المزارع",
    __typename: "DistrictType",
    district_id: 1028,
    name: "حي مخطط غرب المزارع",
    uri: "حي-مخطط-غرب-المزارع",
  },
  'DistrictType:{"path":"/الجبيل/حي-مكة"}': {
    path: "/الجبيل/حي-مكة",
    __typename: "DistrictType",
    district_id: 1030,
    name: "حي مكة",
    uri: "حي-مكة",
  },
  'DistrictType:{"path":"/الخبر/حي-اشبيليا"}': {
    path: "/الخبر/حي-اشبيليا",
    __typename: "DistrictType",
    district_id: 1040,
    name: "حي اشبيليا",
    uri: "حي-اشبيليا",
  },
  'DistrictType:{"path":"/الخبر/حي-الاندلس"}': {
    path: "/الخبر/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 1046,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/الخبر/حي-البحر"}': {
    path: "/الخبر/حي-البحر",
    __typename: "DistrictType",
    district_id: 1048,
    name: "حي البحر",
    uri: "حي-البحر",
  },
  'DistrictType:{"path":"/الخبر/حي-التحلية"}': {
    path: "/الخبر/حي-التحلية",
    __typename: "DistrictType",
    district_id: 1056,
    name: "حي التحلية",
    uri: "حي-التحلية",
  },
  'DistrictType:{"path":"/الخبر/حي-التعاون"}': {
    path: "/الخبر/حي-التعاون",
    __typename: "DistrictType",
    district_id: 1058,
    name: "حي التعاون",
    uri: "حي-التعاون",
  },
  'DistrictType:{"path":"/الخبر/حي-الجسر"}': {
    path: "/الخبر/حي-الجسر",
    __typename: "DistrictType",
    district_id: 1062,
    name: "حي الجسر",
    uri: "حي-الجسر",
  },
  'DistrictType:{"path":"/الخبر/حي-الحزام-الذهبي"}': {
    path: "/الخبر/حي-الحزام-الذهبي",
    __typename: "DistrictType",
    district_id: 1068,
    name: "حي الحزام الذهبي",
    uri: "حي-الحزام-الذهبي",
  },
  'DistrictType:{"path":"/الخبر/حي-الخبر-الشمالية"}': {
    path: "/الخبر/حي-الخبر-الشمالية",
    __typename: "DistrictType",
    district_id: 1074,
    name: "حي الخبر الشمالية",
    uri: "حي-الخبر-الشمالية",
  },
  'DistrictType:{"path":"/الخبر/حي-الراكة-الجنوبية"}': {
    path: "/الخبر/حي-الراكة-الجنوبية",
    __typename: "DistrictType",
    district_id: 1080,
    name: "حي الراكة الجنوبية",
    uri: "حي-الراكة-الجنوبية",
  },
  'DistrictType:{"path":"/الخبر/حي-الساحل"}': {
    path: "/الخبر/حي-الساحل",
    __typename: "DistrictType",
    district_id: 1086,
    name: "حي الساحل",
    uri: "حي-الساحل",
  },
  'DistrictType:{"path":"/الخبر/حي-العقيق"}': {
    path: "/الخبر/حي-العقيق",
    __typename: "DistrictType",
    district_id: 1096,
    name: "حي العقيق",
    uri: "حي-العقيق",
  },
  'DistrictType:{"path":"/الخبر/حي-العليا"}': {
    path: "/الخبر/حي-العليا",
    __typename: "DistrictType",
    district_id: 1098,
    name: "حي العليا",
    uri: "حي-العليا",
  },
  'DistrictType:{"path":"/الخبر/حي-صناعية-الثقبة"}': {
    path: "/الخبر/حي-صناعية-الثقبة",
    __typename: "DistrictType",
    district_id: 1116,
    name: "حي صناعية الثقبة",
    uri: "حي-صناعية-الثقبة",
  },
  'DistrictType:{"path":"/الخبر/حي-مدينة-العمال"}': {
    path: "/الخبر/حي-مدينة-العمال",
    __typename: "DistrictType",
    district_id: 1120,
    name: "حي مدينة العمال",
    uri: "حي-مدينة-العمال",
  },
  'DistrictType:{"path":"/الخفجي/حي-الامير-فهد-بن-سلمان"}': {
    path: "/الخفجي/حي-الامير-فهد-بن-سلمان",
    __typename: "DistrictType",
    district_id: 1126,
    name: "حي الامير فهد بن سلمان",
    uri: "حي-الامير-فهد-بن-سلمان",
  },
  'DistrictType:{"path":"/الخفجي/حي-السلام"}': {
    path: "/الخفجي/حي-السلام",
    __typename: "DistrictType",
    district_id: 1148,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/الخفجي/حي-الشاطئ"}': {
    path: "/الخفجي/حي-الشاطئ",
    __typename: "DistrictType",
    district_id: 1150,
    name: "حي الشاطئ",
    uri: "حي-الشاطئ",
  },
  'DistrictType:{"path":"/الخفجي/حي-الفيحاء"}': {
    path: "/الخفجي/حي-الفيحاء",
    __typename: "DistrictType",
    district_id: 1154,
    name: "حي الفيحاء",
    uri: "حي-الفيحاء",
  },
  'DistrictType:{"path":"/الخفجي/حي-المروج"}': {
    path: "/الخفجي/حي-المروج",
    __typename: "DistrictType",
    district_id: 1162,
    name: "حي المروج",
    uri: "حي-المروج",
  },
  'DistrictType:{"path":"/الخفجي/حي-النزهة"}': {
    path: "/الخفجي/حي-النزهة",
    __typename: "DistrictType",
    district_id: 1170,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/الدمام/حي-الاتصالات"}': {
    path: "/الدمام/حي-الاتصالات",
    __typename: "DistrictType",
    district_id: 1184,
    name: "حي الاتصالات",
    uri: "حي-الاتصالات",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-النسيم-الشرقي"}': {
    path: "/الرياض/شرق-الرياض/حي-النسيم-الشرقي",
    __typename: "DistrictType",
    district_id: 604,
    name: "حي النسيم الشرقي",
    uri: "حي-النسيم-الشرقي",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-النسيم-الغربي"}': {
    path: "/الرياض/شرق-الرياض/حي-النسيم-الغربي",
    __typename: "DistrictType",
    district_id: 606,
    name: "حي النسيم الغربي",
    uri: "حي-النسيم-الغربي",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-النموذجية"}': {
    path: "/الرياض/وسط-الرياض/حي-النموذجية",
    __typename: "DistrictType",
    district_id: 612,
    name: "حي النموذجية",
    uri: "حي-النموذجية",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-النهضة"}': {
    path: "/الرياض/شرق-الرياض/حي-النهضة",
    __typename: "DistrictType",
    district_id: 614,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-الوادي"}': {
    path: "/الرياض/شمال-الرياض/حي-الوادي",
    __typename: "DistrictType",
    district_id: 622,
    name: "حي الوادي",
    uri: "حي-الوادي",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-الوسيطا"}': {
    path: "/الرياض/وسط-الرياض/حي-الوسيطا",
    __typename: "DistrictType",
    district_id: 628,
    name: "حي الوسيطا",
    uri: "حي-الوسيطا",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-الياسمين"}': {
    path: "/الرياض/شمال-الرياض/حي-الياسمين",
    __typename: "DistrictType",
    district_id: 632,
    name: "حي الياسمين",
    uri: "حي-الياسمين",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-اليرموك"}': {
    path: "/الرياض/شرق-الرياض/حي-اليرموك",
    __typename: "DistrictType",
    district_id: 634,
    name: "حي اليرموك",
    uri: "حي-اليرموك",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-ام-الشعال"}': {
    path: "/الرياض/جنوب-الرياض/حي-ام-الشعال",
    __typename: "DistrictType",
    district_id: 642,
    name: "حي ام الشعال",
    uri: "حي-ام-الشعال",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-ثليم"}': {
    path: "/الرياض/وسط-الرياض/حي-ثليم",
    __typename: "DistrictType",
    district_id: 652,
    name: "حي ثليم",
    uri: "حي-ثليم",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-حطين"}': {
    path: "/الرياض/شمال-الرياض/حي-حطين",
    __typename: "DistrictType",
    district_id: 664,
    name: "حي حطين",
    uri: "حي-حطين",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-سكيرينة"}': {
    path: "/الرياض/وسط-الرياض/حي-سكيرينة",
    __typename: "DistrictType",
    district_id: 670,
    name: "حي سكيرينة",
    uri: "حي-سكيرينة",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-صلاح-الدين"}': {
    path: "/الرياض/شمال-الرياض/حي-صلاح-الدين",
    __typename: "DistrictType",
    district_id: 676,
    name: "حي صلاح الدين",
    uri: "حي-صلاح-الدين",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-ضاحية-نمار"}': {
    path: "/الرياض/غرب-الرياض/حي-ضاحية-نمار",
    __typename: "DistrictType",
    district_id: 680,
    name: "حي ضاحية نمار",
    uri: "حي-ضاحية-نمار",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-ظهرة-البديعة"}': {
    path: "/الرياض/غرب-الرياض/حي-ظهرة-البديعة",
    __typename: "DistrictType",
    district_id: 686,
    name: "حي ظهرة البديعة",
    uri: "حي-ظهرة-البديعة",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-قرطبة"}': {
    path: "/الرياض/شرق-الرياض/حي-قرطبة",
    __typename: "DistrictType",
    district_id: 706,
    name: "حي قرطبة",
    uri: "حي-قرطبة",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-منفوحة-الجديدة"}': {
    path: "/الرياض/وسط-الرياض/حي-منفوحة-الجديدة",
    __typename: "DistrictType",
    district_id: 716,
    name: "حي منفوحة الجديدة",
    uri: "حي-منفوحة-الجديدة",
  },
  'DistrictType:{"path":"/الزلفي/حي-الروضة"}': {
    path: "/الزلفي/حي-الروضة",
    __typename: "DistrictType",
    district_id: 732,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/الزلفي/حي-السلام"}': {
    path: "/الزلفي/حي-السلام",
    __typename: "DistrictType",
    district_id: 736,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/الزلفي/حي-الفاروق"}': {
    path: "/الزلفي/حي-الفاروق",
    __typename: "DistrictType",
    district_id: 746,
    name: "حي الفاروق",
    uri: "حي-الفاروق",
  },
  'DistrictType:{"path":"/الزلفي/حي-اليرموك"}': {
    path: "/الزلفي/حي-اليرموك",
    __typename: "DistrictType",
    district_id: 758,
    name: "حي اليرموك",
    uri: "حي-اليرموك",
  },
  'DistrictType:{"path":"/الزلفي/حي-اليمامة"}': {
    path: "/الزلفي/حي-اليمامة",
    __typename: "DistrictType",
    district_id: 760,
    name: "حي اليمامة",
    uri: "حي-اليمامة",
  },
  'DistrictType:{"path":"/الزلفي/حي-سمنان"}': {
    path: "/الزلفي/حي-سمنان",
    __typename: "DistrictType",
    district_id: 766,
    name: "حي سمنان",
    uri: "حي-سمنان",
  },
  'DistrictType:{"path":"/الزلفي/حي-علقة"}': {
    path: "/الزلفي/حي-علقة",
    __typename: "DistrictType",
    district_id: 772,
    name: "حي علقة",
    uri: "حي-علقة",
  },
  'DistrictType:{"path":"/الزلفي/حي-قرطبة"}': {
    path: "/الزلفي/حي-قرطبة",
    __typename: "DistrictType",
    district_id: 774,
    name: "حي قرطبة",
    uri: "حي-قرطبة",
  },
  'DistrictType:{"path":"/صبيا/حي-العزيزية"}': {
    path: "/صبيا/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 212,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/صبيا/حي-الفلاح"}': {
    path: "/صبيا/حي-الفلاح",
    __typename: "DistrictType",
    district_id: 218,
    name: "حي الفلاح",
    uri: "حي-الفلاح",
  },
  'DistrictType:{"path":"/صبيا/حي-الملك-فهد"}': {
    path: "/صبيا/حي-الملك-فهد",
    __typename: "DistrictType",
    district_id: 228,
    name: "حي الملك فهد",
    uri: "حي-الملك-فهد",
  },
  'DistrictType:{"path":"/صبيا/حي-النخيل"}': {
    path: "/صبيا/حي-النخيل",
    __typename: "DistrictType",
    district_id: 230,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/الحريق/حي-الحزيمية"}': {
    path: "/الحريق/حي-الحزيمية",
    __typename: "DistrictType",
    district_id: 234,
    name: "حي الحزيمية",
    uri: "حي-الحزيمية",
  },
  'DistrictType:{"path":"/الحريق/حي-وسط-المدينة"}': {
    path: "/الحريق/حي-وسط-المدينة",
    __typename: "DistrictType",
    district_id: 246,
    name: "حي وسط المدينة",
    uri: "حي-وسط-المدينة",
  },
  'DistrictType:{"path":"/الخرج/حي-البديعة"}': {
    path: "/الخرج/حي-البديعة",
    __typename: "DistrictType",
    district_id: 250,
    name: "حي البديعة",
    uri: "حي-البديعة",
  },
  'DistrictType:{"path":"/الخرج/حي-البرج"}': {
    path: "/الخرج/حي-البرج",
    __typename: "DistrictType",
    district_id: 252,
    name: "حي البرج",
    uri: "حي-البرج",
  },
  'DistrictType:{"path":"/الخرج/حي-الصفاء"}': {
    path: "/الخرج/حي-الصفاء",
    __typename: "DistrictType",
    district_id: 272,
    name: "حي الصفاء",
    uri: "حي-الصفاء",
  },
  'DistrictType:{"path":"/الخرج/حي-المنصورة"}': {
    path: "/الخرج/حي-المنصورة",
    __typename: "DistrictType",
    district_id: 284,
    name: "حي المنصورة",
    uri: "حي-المنصورة",
  },
  'DistrictType:{"path":"/الخرج/حي-النزهة"}': {
    path: "/الخرج/حي-النزهة",
    __typename: "DistrictType",
    district_id: 290,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/الخرج/حي-منطقة-صناعية"}': {
    path: "/الخرج/حي-منطقة-صناعية",
    __typename: "DistrictType",
    district_id: 298,
    name: "حي منطقة صناعية",
    uri: "حي-منطقة-صناعية",
  },
  'DistrictType:{"path":"/الدرعية/حي-الطريف"}': {
    path: "/الدرعية/حي-الطريف",
    __typename: "DistrictType",
    district_id: 308,
    name: "حي الطريف",
    uri: "حي-الطريف",
  },
  'DistrictType:{"path":"/الدرعية/حي-سمحان"}': {
    path: "/الدرعية/حي-سمحان",
    __typename: "DistrictType",
    district_id: 318,
    name: "حي سمحان",
    uri: "حي-سمحان",
  },
  'DistrictType:{"path":"/الدرعية/حي-شمال-الدرعية"}': {
    path: "/الدرعية/حي-شمال-الدرعية",
    __typename: "DistrictType",
    district_id: 320,
    name: "حي شمال الدرعية",
    uri: "حي-شمال-الدرعية",
  },
  'DistrictType:{"path":"/الدلم/حي-السعيدان"}': {
    path: "/الدلم/حي-السعيدان",
    __typename: "DistrictType",
    district_id: 326,
    name: "حي السعيدان",
    uri: "حي-السعيدان",
  },
  'DistrictType:{"path":"/الدلم/حي-الصحنة"}': {
    path: "/الدلم/حي-الصحنة",
    __typename: "DistrictType",
    district_id: 334,
    name: "حي الصحنة",
    uri: "حي-الصحنة",
  },
  'DistrictType:{"path":"/الدوادمي/حي-الخليج"}': {
    path: "/الدوادمي/حي-الخليج",
    __typename: "DistrictType",
    district_id: 348,
    name: "حي الخليج",
    uri: "حي-الخليج",
  },
  'DistrictType:{"path":"/الدوادمي/حي-الفيصلية"}': {
    path: "/الدوادمي/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 370,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/الدوادمي/حي-بدر"}': {
    path: "/الدوادمي/حي-بدر",
    __typename: "DistrictType",
    district_id: 380,
    name: "حي بدر",
    uri: "حي-بدر",
  },
  'DistrictType:{"path":"/الدوادمي/حي-حطين"}': {
    path: "/الدوادمي/حي-حطين",
    __typename: "DistrictType",
    district_id: 382,
    name: "حي حطين",
    uri: "حي-حطين",
  },
  'DistrictType:{"path":"/الدوادمي/حي-منطقة-الاستراحات"}': {
    path: "/الدوادمي/حي-منطقة-الاستراحات",
    __typename: "DistrictType",
    district_id: 388,
    name: "حي منطقة الاستراحات",
    uri: "حي-منطقة-الاستراحات",
  },
  'DistrictType:{"path":"/القطيف/حي-الرابعة"}': {
    path: "/القطيف/حي-الرابعة",
    __typename: "DistrictType",
    district_id: 1416,
    name: "حي الرابعة",
    uri: "حي-الرابعة",
  },
  'DistrictType:{"path":"/القطيف/حي-الرامس"}': {
    path: "/القطيف/حي-الرامس",
    __typename: "DistrictType",
    district_id: 1418,
    name: "حي الرامس",
    uri: "حي-الرامس",
  },
  'DistrictType:{"path":"/القطيف/حي-الريف"}': {
    path: "/القطيف/حي-الريف",
    __typename: "DistrictType",
    district_id: 1424,
    name: "حي الريف",
    uri: "حي-الريف",
  },
  'DistrictType:{"path":"/القطيف/حي-الصناعية"}': {
    path: "/القطيف/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 1442,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/القطيف/حي-القلعة"}': {
    path: "/القطيف/حي-القلعة",
    __typename: "DistrictType",
    district_id: 1452,
    name: "حي القلعة",
    uri: "حي-القلعة",
  },
  'DistrictType:{"path":"/القطيف/حي-الكويكب"}': {
    path: "/القطيف/حي-الكويكب",
    __typename: "DistrictType",
    district_id: 1454,
    name: "حي الكويكب",
    uri: "حي-الكويكب",
  },
  'DistrictType:{"path":"/القطيف/حي-المسعودية"}': {
    path: "/القطيف/حي-المسعودية",
    __typename: "DistrictType",
    district_id: 1466,
    name: "حي المسعودية",
    uri: "حي-المسعودية",
  },
  'DistrictType:{"path":"/القطيف/حي-الناصرة"}': {
    path: "/القطيف/حي-الناصرة",
    __typename: "DistrictType",
    district_id: 1472,
    name: "حي الناصرة",
    uri: "حي-الناصرة",
  },
  'DistrictType:{"path":"/القطيف/حي-الواحة"}': {
    path: "/القطيف/حي-الواحة",
    __typename: "DistrictType",
    district_id: 1476,
    name: "حي الواحة",
    uri: "حي-الواحة",
  },
  'DistrictType:{"path":"/القطيف/حي-باب-الشمال"}': {
    path: "/القطيف/حي-باب-الشمال",
    __typename: "DistrictType",
    district_id: 1492,
    name: "حي باب الشمال",
    uri: "حي-باب-الشمال",
  },
  'DistrictType:{"path":"/النعيرية/حي-التشاليح"}': {
    path: "/النعيرية/حي-التشاليح",
    __typename: "DistrictType",
    district_id: 1500,
    name: "حي التشاليح",
    uri: "حي-التشاليح",
  },
  'DistrictType:{"path":"/النعيرية/حي-الربيع"}': {
    path: "/النعيرية/حي-الربيع",
    __typename: "DistrictType",
    district_id: 1504,
    name: "حي الربيع",
    uri: "حي-الربيع",
  },
  'DistrictType:{"path":"/النعيرية/حي-الصناعية"}': {
    path: "/النعيرية/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 1506,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/النعيرية/حي-الفيصلية"}': {
    path: "/النعيرية/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 1510,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/النعيرية/حي-المحمدية"}': {
    path: "/النعيرية/حي-المحمدية",
    __typename: "DistrictType",
    district_id: 1512,
    name: "حي المحمدية",
    uri: "حي-المحمدية",
  },
  'DistrictType:{"path":"/الهفوف/حي-الرميله"}': {
    path: "/الهفوف/حي-الرميله",
    __typename: "DistrictType",
    district_id: 1556,
    name: "حي الرميله",
    uri: "حي-الرميله",
  },
  'DistrictType:{"path":"/الهفوف/حي-السلمانية-الجنوبية"}': {
    path: "/الهفوف/حي-السلمانية-الجنوبية",
    __typename: "DistrictType",
    district_id: 1562,
    name: "حي السلمانية الجنوبية",
    uri: "حي-السلمانية-الجنوبية",
  },
  'DistrictType:{"path":"/الهفوف/حي-الشروفية"}': {
    path: "/الهفوف/حي-الشروفية",
    __typename: "DistrictType",
    district_id: 1568,
    name: "حي الشروفية",
    uri: "حي-الشروفية",
  },
  'DistrictType:{"path":"/الهفوف/حي-الصيهد"}': {
    path: "/الهفوف/حي-الصيهد",
    __typename: "DistrictType",
    district_id: 1582,
    name: "حي الصيهد",
    uri: "حي-الصيهد",
  },
  'DistrictType:{"path":"/الهفوف/حي-الطرف"}': {
    path: "/الهفوف/حي-الطرف",
    __typename: "DistrictType",
    district_id: 1584,
    name: "حي الطرف",
    uri: "حي-الطرف",
  },
  'DistrictType:{"path":"/الهفوف/حي-الفاضلية"}': {
    path: "/الهفوف/حي-الفاضلية",
    __typename: "DistrictType",
    district_id: 1596,
    name: "حي الفاضلية",
    uri: "حي-الفاضلية",
  },
  'DistrictType:{"path":"/الهفوف/حي-القارة"}': {
    path: "/الهفوف/حي-القارة",
    __typename: "DistrictType",
    district_id: 1600,
    name: "حي القارة",
    uri: "حي-القارة",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-المصايدة"}': {
    path: "/ابو-عريش/حي-المصايدة",
    __typename: "DistrictType",
    district_id: 50,
    name: "حي المصايدة",
    uri: "حي-المصايدة",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-المهدج"}': {
    path: "/ابو-عريش/حي-المهدج",
    __typename: "DistrictType",
    district_id: 56,
    name: "حي المهدج",
    uri: "حي-المهدج",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-النزهة"}': {
    path: "/ابو-عريش/حي-النزهة",
    __typename: "DistrictType",
    district_id: 58,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-الورود"}': {
    path: "/ابو-عريش/حي-الورود",
    __typename: "DistrictType",
    district_id: 64,
    name: "حي الورود",
    uri: "حي-الورود",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-بحرة"}': {
    path: "/ابو-عريش/حي-بحرة",
    __typename: "DistrictType",
    district_id: 68,
    name: "حي بحرة",
    uri: "حي-بحرة",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-رح-الحجاجة"}': {
    path: "/ابو-عريش/حي-رح-الحجاجة",
    __typename: "DistrictType",
    district_id: 74,
    name: "حي رح الحجاجة",
    uri: "حي-رح-الحجاجة",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-رح-صعبة"}': {
    path: "/ابو-عريش/حي-رح-صعبة",
    __typename: "DistrictType",
    district_id: 76,
    name: "حي رح صعبة",
    uri: "حي-رح-صعبة",
  },
  'DistrictType:{"path":"/ابو-عريش/حي-مبترية"}': {
    path: "/ابو-عريش/حي-مبترية",
    __typename: "DistrictType",
    district_id: 90,
    name: "حي مبترية",
    uri: "حي-مبترية",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-الدغادير"}': {
    path: "/احد-المسارحة/حي-الدغادير",
    __typename: "DistrictType",
    district_id: 102,
    name: "حي الدغادير",
    uri: "حي-الدغادير",
  },
  'DistrictType:{"path":"/احد-المسارحة/حي-الميزاب"}': {
    path: "/احد-المسارحة/حي-الميزاب",
    __typename: "DistrictType",
    district_id: 122,
    name: "حي الميزاب",
    uri: "حي-الميزاب",
  },
  'DistrictType:{"path":"/جازان/حي-الروضة"}': {
    path: "/جازان/حي-الروضة",
    __typename: "DistrictType",
    district_id: 148,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/جازان/حي-السويس"}': {
    path: "/جازان/حي-السويس",
    __typename: "DistrictType",
    district_id: 152,
    name: "حي السويس",
    uri: "حي-السويس",
  },
  'DistrictType:{"path":"/جازان/حي-الشاطئ"}': {
    path: "/جازان/حي-الشاطئ",
    __typename: "DistrictType",
    district_id: 154,
    name: "حي الشاطئ",
    uri: "حي-الشاطئ",
  },
  'DistrictType:{"path":"/جازان/حي-الشامية"}': {
    path: "/جازان/حي-الشامية",
    __typename: "DistrictType",
    district_id: 156,
    name: "حي الشامية",
    uri: "حي-الشامية",
  },
  'DistrictType:{"path":"/صامطة/حي-الجردية"}': {
    path: "/صامطة/حي-الجردية",
    __typename: "DistrictType",
    district_id: 174,
    name: "حي الجردية",
    uri: "حي-الجردية",
  },
  'DistrictType:{"path":"/صامطة/حي-صامطة"}': {
    path: "/صامطة/حي-صامطة",
    __typename: "DistrictType",
    district_id: 182,
    name: "حي صامطة",
    uri: "حي-صامطة",
  },
  'DistrictType:{"path":"/صامطة/حي-مجعر"}': {
    path: "/صامطة/حي-مجعر",
    __typename: "DistrictType",
    district_id: 184,
    name: "حي مجعر",
    uri: "حي-مجعر",
  },
  'DistrictType:{"path":"/صبيا/حي-الباحر"}': {
    path: "/صبيا/حي-الباحر",
    __typename: "DistrictType",
    district_id: 186,
    name: "حي الباحر",
    uri: "حي-الباحر",
  },
  'DistrictType:{"path":"/صبيا/حي-الخالدية"}': {
    path: "/صبيا/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 192,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/صبيا/حي-الربيع"}': {
    path: "/صبيا/حي-الربيع",
    __typename: "DistrictType",
    district_id: 194,
    name: "حي الربيع",
    uri: "حي-الربيع",
  },
  'DistrictType:{"path":"/صبيا/حي-الرحاب"}': {
    path: "/صبيا/حي-الرحاب",
    __typename: "DistrictType",
    district_id: 196,
    name: "حي الرحاب",
    uri: "حي-الرحاب",
  },
  'DistrictType:{"path":"/الغاط/حي-الغدير"}': {
    path: "/الغاط/حي-الغدير",
    __typename: "DistrictType",
    district_id: 802,
    name: "حي الغدير",
    uri: "حي-الغدير",
  },
  'DistrictType:{"path":"/الغاط/حي-الورود"}': {
    path: "/الغاط/حي-الورود",
    __typename: "DistrictType",
    district_id: 812,
    name: "حي الورود",
    uri: "حي-الورود",
  },
  'DistrictType:{"path":"/الغاط/حي-غرناطة"}': {
    path: "/الغاط/حي-غرناطة",
    __typename: "DistrictType",
    district_id: 816,
    name: "حي غرناطة",
    uri: "حي-غرناطة",
  },
  'DistrictType:{"path":"/المجمعة/حي-الاندلس"}': {
    path: "/المجمعة/حي-الاندلس",
    __typename: "DistrictType",
    district_id: 850,
    name: "حي الاندلس",
    uri: "حي-الاندلس",
  },
  'DistrictType:{"path":"/المجمعة/حي-الملك-عبدالعزيز"}': {
    path: "/المجمعة/حي-الملك-عبدالعزيز",
    __typename: "DistrictType",
    district_id: 868,
    name: "حي الملك عبدالعزيز",
    uri: "حي-الملك-عبدالعزيز",
  },
  'DistrictType:{"path":"/المزاحمية/حي-طويق"}': {
    path: "/المزاحمية/حي-طويق",
    __typename: "DistrictType",
    district_id: 894,
    name: "حي طويق",
    uri: "حي-طويق",
  },
  'DistrictType:{"path":"/ثادق/حي-الديرة-القديمة"}': {
    path: "/ثادق/حي-الديرة-القديمة",
    __typename: "DistrictType",
    district_id: 906,
    name: "حي الديرة القديمة",
    uri: "حي-الديرة-القديمة",
  },
  'DistrictType:{"path":"/ثادق/حي-العزيزية"}': {
    path: "/ثادق/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 908,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/حوطة-بني-تميم/حي-السلام"}': {
    path: "/حوطة-بني-تميم/حي-السلام",
    __typename: "DistrictType",
    district_id: 918,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/حوطة-بني-تميم/حي-المحمدية"}': {
    path: "/حوطة-بني-تميم/حي-المحمدية",
    __typename: "DistrictType",
    district_id: 928,
    name: "حي المحمدية",
    uri: "حي-المحمدية",
  },
  'DistrictType:{"path":"/حوطة-بني-تميم/حي-الورود"}': {
    path: "/حوطة-بني-تميم/حي-الورود",
    __typename: "DistrictType",
    district_id: 936,
    name: "حي الورود",
    uri: "حي-الورود",
  },
  'DistrictType:{"path":"/شقراء/حي-الملك-فهد"}': {
    path: "/شقراء/حي-الملك-فهد",
    __typename: "DistrictType",
    district_id: 950,
    name: "حي الملك فهد",
    uri: "حي-الملك-فهد",
  },
  'DistrictType:{"path":"/شقراء/حي-النسيم"}': {
    path: "/شقراء/حي-النسيم",
    __typename: "DistrictType",
    district_id: 954,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/عفيف/حي-الاذاعة"}': {
    path: "/عفيف/حي-الاذاعة",
    __typename: "DistrictType",
    district_id: 962,
    name: "حي الاذاعة",
    uri: "حي-الاذاعة",
  },
  'DistrictType:{"path":"/عفيف/حي-الخزان"}': {
    path: "/عفيف/حي-الخزان",
    __typename: "DistrictType",
    district_id: 968,
    name: "حي الخزان",
    uri: "حي-الخزان",
  },
  'DistrictType:{"path":"/عفيف/حي-السليمانية"}': {
    path: "/عفيف/حي-السليمانية",
    __typename: "DistrictType",
    district_id: 970,
    name: "حي السليمانية",
    uri: "حي-السليمانية",
  },
  'DistrictType:{"path":"/عفيف/حي-المعارض"}': {
    path: "/عفيف/حي-المعارض",
    __typename: "DistrictType",
    district_id: 978,
    name: "حي المعارض",
    uri: "حي-المعارض",
  },
  'DistrictType:{"path":"/الجبيل/حي-الجبيل-البلد"}': {
    path: "/الجبيل/حي-الجبيل-البلد",
    __typename: "DistrictType",
    district_id: 988,
    name: "حي الجبيل البلد",
    uri: "حي-الجبيل-البلد",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-فليج"}': {
    path: "/حفر-الباطن/حي-فليج",
    __typename: "DistrictType",
    district_id: 1808,
    name: "حي فليج",
    uri: "حي-فليج",
  },
  'DistrictType:{"path":"/راس-تنورة/حي-الفيحاء"}': {
    path: "/راس-تنورة/حي-الفيحاء",
    __typename: "DistrictType",
    district_id: 1822,
    name: "حي الفيحاء",
    uri: "حي-الفيحاء",
  },
  'DistrictType:{"path":"/راس-تنورة/حي-النعيم"}': {
    path: "/راس-تنورة/حي-النعيم",
    __typename: "DistrictType",
    district_id: 1826,
    name: "حي النعيم",
    uri: "حي-النعيم",
  },
  'DistrictType:{"path":"/سيهات/حي-الخصاب"}': {
    path: "/سيهات/حي-الخصاب",
    __typename: "DistrictType",
    district_id: 1830,
    name: "حي الخصاب",
    uri: "حي-الخصاب",
  },
  'DistrictType:{"path":"/سيهات/حي-الطف"}': {
    path: "/سيهات/حي-الطف",
    __typename: "DistrictType",
    district_id: 1842,
    name: "حي الطف",
    uri: "حي-الطف",
  },
  'DistrictType:{"path":"/سيهات/حي-الفردوس"}': {
    path: "/سيهات/حي-الفردوس",
    __typename: "DistrictType",
    district_id: 1846,
    name: "حي الفردوس",
    uri: "حي-الفردوس",
  },
  'DistrictType:{"path":"/سيهات/حي-النسيم"}': {
    path: "/سيهات/حي-النسيم",
    __typename: "DistrictType",
    district_id: 1854,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/سيهات/حي-غرب-النابية"}': {
    path: "/سيهات/حي-غرب-النابية",
    __typename: "DistrictType",
    district_id: 1860,
    name: "حي غرب النابية",
    uri: "حي-غرب-النابية",
  },
  'DistrictType:{"path":"/سيهات/حي-غرناطة"}': {
    path: "/سيهات/حي-غرناطة",
    __typename: "DistrictType",
    district_id: 1862,
    name: "حي غرناطة",
    uri: "حي-غرناطة",
  },
  'DistrictType:{"path":"/صفوى/حي-التلال"}': {
    path: "/صفوى/حي-التلال",
    __typename: "DistrictType",
    district_id: 1872,
    name: "حي التلال",
    uri: "حي-التلال",
  },
  'DistrictType:{"path":"/صفوى/حي-الرويحة"}': {
    path: "/صفوى/حي-الرويحة",
    __typename: "DistrictType",
    district_id: 1880,
    name: "حي الرويحة",
    uri: "حي-الرويحة",
  },
  'DistrictType:{"path":"/صفوى/حي-الشورى"}': {
    path: "/صفوى/حي-الشورى",
    __typename: "DistrictType",
    district_id: 1884,
    name: "حي الشورى",
    uri: "حي-الشورى",
  },
  'DistrictType:{"path":"/صفوى/حي-النهضة"}': {
    path: "/صفوى/حي-النهضة",
    __typename: "DistrictType",
    district_id: 1896,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/عنك/حي-البدر"}': {
    path: "/عنك/حي-البدر",
    __typename: "DistrictType",
    district_id: 1904,
    name: "حي البدر",
    uri: "حي-البدر",
  },
  'DistrictType:{"path":"/عنك/حي-البستان"}': {
    path: "/عنك/حي-البستان",
    __typename: "DistrictType",
    district_id: 1906,
    name: "حي البستان",
    uri: "حي-البستان",
  },
  'DistrictType:{"path":"/رفحاء/حي-الروضة"}': {
    path: "/رفحاء/حي-الروضة",
    __typename: "DistrictType",
    district_id: 1918,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-الدحو"}': {
    path: "/الرياض/وسط-الرياض/حي-الدحو",
    __typename: "DistrictType",
    district_id: 426,
    name: "حي الدحو",
    uri: "حي-الدحو",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-الدريهمية"}': {
    path: "/الرياض/غرب-الرياض/حي-الدريهمية",
    __typename: "DistrictType",
    district_id: 428,
    name: "حي الدريهمية",
    uri: "حي-الدريهمية",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-الديرة"}': {
    path: "/الرياض/وسط-الرياض/حي-الديرة",
    __typename: "DistrictType",
    district_id: 434,
    name: "حي الديرة",
    uri: "حي-الديرة",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-الربيع"}': {
    path: "/الرياض/شمال-الرياض/حي-الربيع",
    __typename: "DistrictType",
    district_id: 440,
    name: "حي الربيع",
    uri: "حي-الربيع",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-الرحمانية"}': {
    path: "/الرياض/شمال-الرياض/حي-الرحمانية",
    __typename: "DistrictType",
    district_id: 442,
    name: "حي الرحمانية",
    uri: "حي-الرحمانية",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الرمال"}': {
    path: "/الرياض/شرق-الرياض/حي-الرمال",
    __typename: "DistrictType",
    district_id: 446,
    name: "حي الرمال",
    uri: "حي-الرمال",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الصفا"}': {
    path: "/الرياض/شرق-الرياض/حي-الصفا",
    __typename: "DistrictType",
    district_id: 488,
    name: "حي الصفا",
    uri: "حي-الصفا",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-العزيزية"}': {
    path: "/الرياض/جنوب-الرياض/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 502,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-العقيق"}': {
    path: "/الرياض/شمال-الرياض/حي-العقيق",
    __typename: "DistrictType",
    district_id: 504,
    name: "حي العقيق",
    uri: "حي-العقيق",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-العليا"}': {
    path: "/الرياض/شمال-الرياض/حي-العليا",
    __typename: "DistrictType",
    district_id: 506,
    name: "حي العليا",
    uri: "حي-العليا",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-العمل"}': {
    path: "/الرياض/وسط-الرياض/حي-العمل",
    __typename: "DistrictType",
    district_id: 510,
    name: "حي العمل",
    uri: "حي-العمل",
  },
  'DistrictType:{"path":"/الرياض/غرب-الرياض/حي-الفاخرية"}': {
    path: "/الرياض/غرب-الرياض/حي-الفاخرية",
    __typename: "DistrictType",
    district_id: 518,
    name: "حي الفاخرية",
    uri: "حي-الفاخرية",
  },
  'DistrictType:{"path":"/الرياض/وسط-الرياض/حي-المربع"}': {
    path: "/الرياض/وسط-الرياض/حي-المربع",
    __typename: "DistrictType",
    district_id: 542,
    name: "حي المربع",
    uri: "حي-المربع",
  },
  'DistrictType:{"path":"/الرياض/شمال-الرياض/حي-المعذر-الشمالي"}': {
    path: "/الرياض/شمال-الرياض/حي-المعذر-الشمالي",
    __typename: "DistrictType",
    district_id: 560,
    name: "حي المعذر الشمالي",
    uri: "حي-المعذر-الشمالي",
  },
  'DistrictType:{"path":"/الرياض/شرق-الرياض/حي-الملك-فيصل"}': {
    path: "/الرياض/شرق-الرياض/حي-الملك-فيصل",
    __typename: "DistrictType",
    district_id: 578,
    name: "حي الملك فيصل",
    uri: "حي-الملك-فيصل",
  },
  'DistrictType:{"path":"/الرياض/جنوب-الرياض/حي-المنصورية"}': {
    path: "/الرياض/جنوب-الرياض/حي-المنصورية",
    __typename: "DistrictType",
    district_id: 586,
    name: "حي المنصورية",
    uri: "حي-المنصورية",
  },
  'DistrictType:{"path":"/القطيف/حي-البديع"}': {
    path: "/القطيف/حي-البديع",
    __typename: "DistrictType",
    district_id: 1380,
    name: "حي البديع",
    uri: "حي-البديع",
  },
  'DistrictType:{"path":"/القطيف/حي-البديعة"}': {
    path: "/القطيف/حي-البديعة",
    __typename: "DistrictType",
    district_id: 1382,
    name: "حي البديعة",
    uri: "حي-البديعة",
  },
  'DistrictType:{"path":"/القطيف/حي-الجراري"}': {
    path: "/القطيف/حي-الجراري",
    __typename: "DistrictType",
    district_id: 1394,
    name: "حي الجراري",
    uri: "حي-الجراري",
  },
  'DistrictType:{"path":"/القطيف/حي-الجش"}': {
    path: "/القطيف/حي-الجش",
    __typename: "DistrictType",
    district_id: 1398,
    name: "حي الجش",
    uri: "حي-الجش",
  },
  'DistrictType:{"path":"/الغزالة/حي-الغزالة"}': {
    path: "/الغزالة/حي-الغزالة",
    __typename: "DistrictType",
    district_id: 2012,
    name: "حي الغزالة",
    uri: "حي-الغزالة",
  },
  'CityType:{"uri":"الغزالة"}': {
    uri: "الغزالة",
    __typename: "CityType",
    city_id: 31,
    name: "الغزالة",
    path: "/الغزالة",
  },
  'DistrictType:{"path":"/بقعاء/حي-بقعاء"}': {
    path: "/بقعاء/حي-بقعاء",
    __typename: "DistrictType",
    district_id: 2014,
    name: "حي بقعاء",
    uri: "حي-بقعاء",
  },
  'CityType:{"uri":"بقعاء"}': {
    uri: "بقعاء",
    __typename: "CityType",
    city_id: 53,
    name: "بقعاء",
    path: "/بقعاء",
  },
  'DistrictType:{"path":"/حائل/حي-السمراء"}': {
    path: "/حائل/حي-السمراء",
    __typename: "DistrictType",
    district_id: 2034,
    name: "حي السمراء",
    uri: "حي-السمراء",
  },
  'DistrictType:{"path":"/حائل/حي-العزيزية"}': {
    path: "/حائل/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 2038,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/حائل/حي-المطار"}': {
    path: "/حائل/حي-المطار",
    __typename: "DistrictType",
    district_id: 2046,
    name: "حي المطار",
    uri: "حي-المطار",
  },
  'DistrictType:{"path":"/حائل/حي-المنتزه-الشرقي"}': {
    path: "/حائل/حي-المنتزه-الشرقي",
    __typename: "DistrictType",
    district_id: 2048,
    name: "حي المنتزه الشرقي",
    uri: "حي-المنتزه-الشرقي",
  },
  'DistrictType:{"path":"/حائل/حي-النقرة"}': {
    path: "/حائل/حي-النقرة",
    __typename: "DistrictType",
    district_id: 2056,
    name: "حي النقرة",
    uri: "حي-النقرة",
  },
  'DistrictType:{"path":"/حائل/حي-الوسيطاء"}': {
    path: "/حائل/حي-الوسيطاء",
    __typename: "DistrictType",
    district_id: 2058,
    name: "حي الوسيطاء",
    uri: "حي-الوسيطاء",
  },
  'DistrictType:{"path":"/حائل/حي-حدري-البلاد"}': {
    path: "/حائل/حي-حدري-البلاد",
    __typename: "DistrictType",
    district_id: 2062,
    name: "حي حدري البلاد",
    uri: "حي-حدري-البلاد",
  },
  'DistrictType:{"path":"/البدائع/حي-التعليم"}': {
    path: "/البدائع/حي-التعليم",
    __typename: "DistrictType",
    district_id: 2072,
    name: "حي التعليم",
    uri: "حي-التعليم",
  },
  'DistrictType:{"path":"/البدائع/حي-الرمة"}': {
    path: "/البدائع/حي-الرمة",
    __typename: "DistrictType",
    district_id: 2076,
    name: "حي الرمة",
    uri: "حي-الرمة",
  },
  'DistrictType:{"path":"/البدائع/حي-الشيرمي"}': {
    path: "/البدائع/حي-الشيرمي",
    __typename: "DistrictType",
    district_id: 2078,
    name: "حي الشيرمي",
    uri: "حي-الشيرمي",
  },
  'DistrictType:{"path":"/البدائع/حي-الصناعية"}': {
    path: "/البدائع/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 2080,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/البدائع/حي-العبيلة"}': {
    path: "/البدائع/حي-العبيلة",
    __typename: "DistrictType",
    district_id: 2084,
    name: "حي العبيلة",
    uri: "حي-العبيلة",
  },
  'DistrictType:{"path":"/البدائع/حي-العثمانية"}': {
    path: "/البدائع/حي-العثمانية",
    __typename: "DistrictType",
    district_id: 2086,
    name: "حي العثمانية",
    uri: "حي-العثمانية",
  },
  'DistrictType:{"path":"/البدائع/حي-النخيل"}': {
    path: "/البدائع/حي-النخيل",
    __typename: "DistrictType",
    district_id: 2094,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/البدائع/حي-الوسطى"}': {
    path: "/البدائع/حي-الوسطى",
    __typename: "DistrictType",
    district_id: 2096,
    name: "حي الوسطى",
    uri: "حي-الوسطى",
  },
  'DistrictType:{"path":"/البكيرية/حي-البلد-القديم"}': {
    path: "/البكيرية/حي-البلد-القديم",
    __typename: "DistrictType",
    district_id: 2106,
    name: "حي البلد القديم",
    uri: "حي-البلد-القديم",
  },
  'DistrictType:{"path":"/البكيرية/حي-الزهرة"}': {
    path: "/البكيرية/حي-الزهرة",
    __typename: "DistrictType",
    district_id: 2114,
    name: "حي الزهرة",
    uri: "حي-الزهرة",
  },
  'DistrictType:{"path":"/البكيرية/حي-الهلالية"}': {
    path: "/البكيرية/حي-الهلالية",
    __typename: "DistrictType",
    district_id: 2124,
    name: "حي الهلالية",
    uri: "حي-الهلالية",
  },
  'DistrictType:{"path":"/الرس/حي-الحوطة"}': {
    path: "/الرس/حي-الحوطة",
    __typename: "DistrictType",
    district_id: 2138,
    name: "حي الحوطة",
    uri: "حي-الحوطة",
  },
  'DistrictType:{"path":"/الرس/حي-المطار"}': {
    path: "/الرس/حي-المطار",
    __typename: "DistrictType",
    district_id: 2156,
    name: "حي المطار",
    uri: "حي-المطار",
  },
  'DistrictType:{"path":"/الرس/حي-الملك-خالد"}': {
    path: "/الرس/حي-الملك-خالد",
    __typename: "DistrictType",
    district_id: 2158,
    name: "حي الملك خالد",
    uri: "حي-الملك-خالد",
  },
  'DistrictType:{"path":"/الرس/حي-اليرموك"}': {
    path: "/الرس/حي-اليرموك",
    __typename: "DistrictType",
    district_id: 2166,
    name: "حي اليرموك",
    uri: "حي-اليرموك",
  },
  'DistrictType:{"path":"/الرس/حي-وادي-الرمة"}': {
    path: "/الرس/حي-وادي-الرمة",
    __typename: "DistrictType",
    district_id: 2170,
    name: "حي وادي الرمة",
    uri: "حي-وادي-الرمة",
  },
  'DistrictType:{"path":"/الشماسية/حي-الصفاء"}': {
    path: "/الشماسية/حي-الصفاء",
    __typename: "DistrictType",
    district_id: 2184,
    name: "حي الصفاء",
    uri: "حي-الصفاء",
  },
  'DistrictType:{"path":"/الشماسية/حي-الصناعية"}': {
    path: "/الشماسية/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 2186,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/املج/حي-ابو-شجرة"}': {
    path: "/املج/حي-ابو-شجرة",
    __typename: "DistrictType",
    district_id: 2814,
    name: "حي ابو شجرة",
    uri: "حي-ابو-شجرة",
  },
  'DistrictType:{"path":"/املج/حي-الروضة"}': {
    path: "/املج/حي-الروضة",
    __typename: "DistrictType",
    district_id: 2824,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/املج/حي-السلام"}': {
    path: "/املج/حي-السلام",
    __typename: "DistrictType",
    district_id: 2826,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/تبوك/حي-السليمانية"}': {
    path: "/تبوك/حي-السليمانية",
    __typename: "DistrictType",
    district_id: 2852,
    name: "حي السليمانية",
    uri: "حي-السليمانية",
  },
  'DistrictType:{"path":"/تبوك/حي-الشيخ"}': {
    path: "/تبوك/حي-الشيخ",
    __typename: "DistrictType",
    district_id: 2854,
    name: "حي الشيخ",
    uri: "حي-الشيخ",
  },
  'DistrictType:{"path":"/تبوك/حي-الصالحية"}': {
    path: "/تبوك/حي-الصالحية",
    __typename: "DistrictType",
    district_id: 2856,
    name: "حي الصالحية",
    uri: "حي-الصالحية",
  },
  'DistrictType:{"path":"/تبوك/حي-العزيزية-القديمة"}': {
    path: "/تبوك/حي-العزيزية-القديمة",
    __typename: "DistrictType",
    district_id: 2862,
    name: "حي العزيزية القديمة",
    uri: "حي-العزيزية-القديمة",
  },
  'DistrictType:{"path":"/تبوك/حي-العوايشة"}': {
    path: "/تبوك/حي-العوايشة",
    __typename: "DistrictType",
    district_id: 2866,
    name: "حي العوايشة",
    uri: "حي-العوايشة",
  },
  'DistrictType:{"path":"/تبوك/حي-الفيصلية-الجنوبية"}': {
    path: "/تبوك/حي-الفيصلية-الجنوبية",
    __typename: "DistrictType",
    district_id: 2868,
    name: "حي الفيصلية الجنوبية",
    uri: "حي-الفيصلية-الجنوبية",
  },
  'DistrictType:{"path":"/تبوك/حي-الفيصلية-الشمالية"}': {
    path: "/تبوك/حي-الفيصلية-الشمالية",
    __typename: "DistrictType",
    district_id: 2870,
    name: "حي الفيصلية الشمالية",
    uri: "حي-الفيصلية-الشمالية",
  },
  'DistrictType:{"path":"/تبوك/حي-المهرجان"}': {
    path: "/تبوك/حي-المهرجان",
    __typename: "DistrictType",
    district_id: 2884,
    name: "حي المهرجان",
    uri: "حي-المهرجان",
  },
  'DistrictType:{"path":"/تبوك/حي-كريم"}': {
    path: "/تبوك/حي-كريم",
    __typename: "DistrictType",
    district_id: 2896,
    name: "حي كريم",
    uri: "حي-كريم",
  },
  'DistrictType:{"path":"/تبوك/حي-مخطط-الرابية"}': {
    path: "/تبوك/حي-مخطط-الرابية",
    __typename: "DistrictType",
    district_id: 2898,
    name: "حي مخطط الرابية",
    uri: "حي-مخطط-الرابية",
  },
  'DistrictType:{"path":"/تبوك/حي-مخطط-الراجحي"}': {
    path: "/تبوك/حي-مخطط-الراجحي",
    __typename: "DistrictType",
    district_id: 2900,
    name: "حي مخطط الراجحي",
    uri: "حي-مخطط-الراجحي",
  },
  'DistrictType:{"path":"/تيماء/حي-التجاري"}': {
    path: "/تيماء/حي-التجاري",
    __typename: "DistrictType",
    district_id: 2904,
    name: "حي التجاري",
    uri: "حي-التجاري",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-البركة"}': {
    path: "/المدينة-المنورة/حي-البركة",
    __typename: "DistrictType",
    district_id: 2930,
    name: "حي البركة",
    uri: "حي-البركة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الجماوات"}': {
    path: "/المدينة-المنورة/حي-الجماوات",
    __typename: "DistrictType",
    district_id: 2940,
    name: "حي الجماوات",
    uri: "حي-الجماوات",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الحديقة"}': {
    path: "/المدينة-المنورة/حي-الحديقة",
    __typename: "DistrictType",
    district_id: 2944,
    name: "حي الحديقة",
    uri: "حي-الحديقة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الحفيا"}': {
    path: "/المدينة-المنورة/حي-الحفيا",
    __typename: "DistrictType",
    district_id: 2946,
    name: "حي الحفيا",
    uri: "حي-الحفيا",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الدار"}': {
    path: "/المدينة-المنورة/حي-الدار",
    __typename: "DistrictType",
    district_id: 2952,
    name: "حي الدار",
    uri: "حي-الدار",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الدفاع"}': {
    path: "/المدينة-المنورة/حي-الدفاع",
    __typename: "DistrictType",
    district_id: 2954,
    name: "حي الدفاع",
    uri: "حي-الدفاع",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الرانوناء"}': {
    path: "/المدينة-المنورة/حي-الرانوناء",
    __typename: "DistrictType",
    district_id: 2960,
    name: "حي الرانوناء",
    uri: "حي-الرانوناء",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الزهرة"}': {
    path: "/المدينة-المنورة/حي-الزهرة",
    __typename: "DistrictType",
    district_id: 2968,
    name: "حي الزهرة",
    uri: "حي-الزهرة",
  },
  'DistrictType:{"path":"/الهفوف/حي-الورود"}': {
    path: "/الهفوف/حي-الورود",
    __typename: "DistrictType",
    district_id: 1642,
    name: "حي الورود",
    uri: "حي-الورود",
  },
  'DistrictType:{"path":"/الهفوف/حي-مخطط-الراجحي"}': {
    path: "/الهفوف/حي-مخطط-الراجحي",
    __typename: "DistrictType",
    district_id: 1668,
    name: "حي مخطط الراجحي",
    uri: "حي-مخطط-الراجحي",
  },
  'DistrictType:{"path":"/الهفوف/حي-مدينة-الجفر"}': {
    path: "/الهفوف/حي-مدينة-الجفر",
    __typename: "DistrictType",
    district_id: 1672,
    name: "حي مدينة الجفر",
    uri: "حي-مدينة-الجفر",
  },
  'DistrictType:{"path":"/الهفوف/حي-وسط-المدينة"}': {
    path: "/الهفوف/حي-وسط-المدينة",
    __typename: "DistrictType",
    district_id: 1676,
    name: "حي وسط المدينة",
    uri: "حي-وسط-المدينة",
  },
  'DistrictType:{"path":"/بقيق/حي-البساتين"}': {
    path: "/بقيق/حي-البساتين",
    __typename: "DistrictType",
    district_id: 1684,
    name: "حي البساتين",
    uri: "حي-البساتين",
  },
  'DistrictType:{"path":"/بقيق/حي-الصناعية"}': {
    path: "/بقيق/حي-الصناعية",
    __typename: "DistrictType",
    district_id: 1690,
    name: "حي الصناعية",
    uri: "حي-الصناعية",
  },
  'DistrictType:{"path":"/بقيق/حي-النخيل"}': {
    path: "/بقيق/حي-النخيل",
    __typename: "DistrictType",
    district_id: 1698,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/بقيق/حي-النزهة"}': {
    path: "/بقيق/حي-النزهة",
    __typename: "DistrictType",
    district_id: 1700,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/تاروت/حي-دارين"}': {
    path: "/تاروت/حي-دارين",
    __typename: "DistrictType",
    district_id: 1736,
    name: "حي دارين",
    uri: "حي-دارين",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-التلال"}': {
    path: "/حفر-الباطن/حي-التلال",
    __typename: "DistrictType",
    district_id: 1748,
    name: "حي التلال",
    uri: "حي-التلال",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الروضة"}': {
    path: "/حفر-الباطن/حي-الروضة",
    __typename: "DistrictType",
    district_id: 1764,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-السليمانية"}': {
    path: "/حفر-الباطن/حي-السليمانية",
    __typename: "DistrictType",
    district_id: 1768,
    name: "حي السليمانية",
    uri: "حي-السليمانية",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الفيصلية"}': {
    path: "/حفر-الباطن/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 1780,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-المنار"}': {
    path: "/حفر-الباطن/حي-المنار",
    __typename: "DistrictType",
    district_id: 1788,
    name: "حي المنار",
    uri: "حي-المنار",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-النخيل"}': {
    path: "/حفر-الباطن/حي-النخيل",
    __typename: "DistrictType",
    district_id: 1792,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-النزهة"}': {
    path: "/حفر-الباطن/حي-النزهة",
    __typename: "DistrictType",
    district_id: 1794,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/حفر-الباطن/حي-الواحة"}': {
    path: "/حفر-الباطن/حي-الواحة",
    __typename: "DistrictType",
    district_id: 1798,
    name: "حي الواحة",
    uri: "حي-الواحة",
  },
  'DistrictType:{"path":"/المذنب/حي-الخالدية"}': {
    path: "/المذنب/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 2226,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/المذنب/حي-الروضة"}': {
    path: "/المذنب/حي-الروضة",
    __typename: "DistrictType",
    district_id: 2230,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/المذنب/حي-القفيفة"}': {
    path: "/المذنب/حي-القفيفة",
    __typename: "DistrictType",
    district_id: 2242,
    name: "حي القفيفة",
    uri: "حي-القفيفة",
  },
  'DistrictType:{"path":"/المذنب/حي-قرطبة"}': {
    path: "/المذنب/حي-قرطبة",
    __typename: "DistrictType",
    district_id: 2252,
    name: "حي قرطبة",
    uri: "حي-قرطبة",
  },
  'DistrictType:{"path":"/بريدة/حي-ابن-صبيح"}': {
    path: "/بريدة/حي-ابن-صبيح",
    __typename: "DistrictType",
    district_id: 2258,
    name: "حي ابن صبيح",
    uri: "حي-ابن-صبيح",
  },
  'DistrictType:{"path":"/بريدة/حي-الاخضر"}': {
    path: "/بريدة/حي-الاخضر",
    __typename: "DistrictType",
    district_id: 2260,
    name: "حي الاخضر",
    uri: "حي-الاخضر",
  },
  'DistrictType:{"path":"/بريدة/حي-البريكة"}': {
    path: "/بريدة/حي-البريكة",
    __typename: "DistrictType",
    district_id: 2266,
    name: "حي البريكة",
    uri: "حي-البريكة",
  },
  'DistrictType:{"path":"/بريدة/حي-التشليح"}': {
    path: "/بريدة/حي-التشليح",
    __typename: "DistrictType",
    district_id: 2272,
    name: "حي التشليح",
    uri: "حي-التشليح",
  },
  'DistrictType:{"path":"/بريدة/حي-التغيرة"}': {
    path: "/بريدة/حي-التغيرة",
    __typename: "DistrictType",
    district_id: 2274,
    name: "حي التغيرة",
    uri: "حي-التغيرة",
  },
  'DistrictType:{"path":"/بريدة/حي-الحقل-الاخضر"}': {
    path: "/بريدة/حي-الحقل-الاخضر",
    __typename: "DistrictType",
    district_id: 2284,
    name: "حي الحقل الاخضر",
    uri: "حي-الحقل-الاخضر",
  },
  'DistrictType:{"path":"/بريدة/حي-الربوة"}': {
    path: "/بريدة/حي-الربوة",
    __typename: "DistrictType",
    district_id: 2296,
    name: "حي الربوة",
    uri: "حي-الربوة",
  },
  'DistrictType:{"path":"/بريدة/حي-الرحاب"}': {
    path: "/بريدة/حي-الرحاب",
    __typename: "DistrictType",
    district_id: 2298,
    name: "حي الرحاب",
    uri: "حي-الرحاب",
  },
  'DistrictType:{"path":"/بريدة/حي-الروابي"}': {
    path: "/بريدة/حي-الروابي",
    __typename: "DistrictType",
    district_id: 2302,
    name: "حي الروابي",
    uri: "حي-الروابي",
  },
  'DistrictType:{"path":"/بريدة/حي-الشفق"}': {
    path: "/بريدة/حي-الشفق",
    __typename: "DistrictType",
    district_id: 2312,
    name: "حي الشفق",
    uri: "حي-الشفق",
  },
  'DistrictType:{"path":"/بريدة/حي-الصباخ"}': {
    path: "/بريدة/حي-الصباخ",
    __typename: "DistrictType",
    district_id: 2318,
    name: "حي الصباخ",
    uri: "حي-الصباخ",
  },
  'DistrictType:{"path":"/بريدة/حي-اللسيب"}': {
    path: "/بريدة/حي-اللسيب",
    __typename: "DistrictType",
    district_id: 2346,
    name: "حي اللسيب",
    uri: "حي-اللسيب",
  },
  'DistrictType:{"path":"/بريدة/حي-المطار-القديم"}': {
    path: "/بريدة/حي-المطار-القديم",
    __typename: "DistrictType",
    district_id: 2350,
    name: "حي المطار القديم",
    uri: "حي-المطار-القديم",
  },
  'DistrictType:{"path":"/بريدة/حي-الملك"}': {
    path: "/بريدة/حي-الملك",
    __typename: "DistrictType",
    district_id: 2354,
    name: "حي الملك",
    uri: "حي-الملك",
  },
  'DistrictType:{"path":"/بريدة/حي-ضراس"}': {
    path: "/بريدة/حي-ضراس",
    __typename: "DistrictType",
    district_id: 2404,
    name: "حي ضراس",
    uri: "حي-ضراس",
  },
  'DistrictType:{"path":"/بريدة/حي-عين-الذيب"}': {
    path: "/بريدة/حي-عين-الذيب",
    __typename: "DistrictType",
    district_id: 2406,
    name: "حي عين الذيب",
    uri: "حي-عين-الذيب",
  },
  'DistrictType:{"path":"/بريدة/حي-مخطط-الرواف"}': {
    path: "/بريدة/حي-مخطط-الرواف",
    __typename: "DistrictType",
    district_id: 2408,
    name: "حي مخطط الرواف",
    uri: "حي-مخطط-الرواف",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-الخبراء-القديمة"}': {
    path: "/رياض-الخبراء/حي-الخبراء-القديمة",
    __typename: "DistrictType",
    district_id: 2424,
    name: "حي الخبراء القديمة",
    uri: "حي-الخبراء-القديمة",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-الخزان"}': {
    path: "/رياض-الخبراء/حي-الخزان",
    __typename: "DistrictType",
    district_id: 2426,
    name: "حي الخزان",
    uri: "حي-الخزان",
  },
  'DistrictType:{"path":"/رياض-الخبراء/حي-المجد"}': {
    path: "/رياض-الخبراء/حي-المجد",
    __typename: "DistrictType",
    district_id: 2450,
    name: "حي المجد",
    uri: "حي-المجد",
  },
  'DistrictType:{"path":"/عنيزة/حي-الجزيرة"}': {
    path: "/عنيزة/حي-الجزيرة",
    __typename: "DistrictType",
    district_id: 2478,
    name: "حي الجزيرة",
    uri: "حي-الجزيرة",
  },
  'DistrictType:{"path":"/عنيزة/حي-الخليج"}': {
    path: "/عنيزة/حي-الخليج",
    __typename: "DistrictType",
    district_id: 2498,
    name: "حي الخليج",
    uri: "حي-الخليج",
  },
  'DistrictType:{"path":"/عنيزة/حي-الرحمانية"}': {
    path: "/عنيزة/حي-الرحمانية",
    __typename: "DistrictType",
    district_id: 2504,
    name: "حي الرحمانية",
    uri: "حي-الرحمانية",
  },
  'DistrictType:{"path":"/عنيزة/حي-الروغاني"}': {
    path: "/عنيزة/حي-الروغاني",
    __typename: "DistrictType",
    district_id: 2512,
    name: "حي الروغاني",
    uri: "حي-الروغاني",
  },
  'DistrictType:{"path":"/عنيزة/حي-الشفاء"}': {
    path: "/عنيزة/حي-الشفاء",
    __typename: "DistrictType",
    district_id: 2532,
    name: "حي الشفاء",
    uri: "حي-الشفاء",
  },
  'DistrictType:{"path":"/عنيزة/حي-الغضا"}': {
    path: "/عنيزة/حي-الغضا",
    __typename: "DistrictType",
    district_id: 2548,
    name: "حي الغضا",
    uri: "حي-الغضا",
  },
  'DistrictType:{"path":"/عنيزة/حي-القادسية"}': {
    path: "/عنيزة/حي-القادسية",
    __typename: "DistrictType",
    district_id: 2558,
    name: "حي القادسية",
    uri: "حي-القادسية",
  },
  'DistrictType:{"path":"/عنيزة/حي-المصيف"}': {
    path: "/عنيزة/حي-المصيف",
    __typename: "DistrictType",
    district_id: 2576,
    name: "حي المصيف",
    uri: "حي-المصيف",
  },
  'DistrictType:{"path":"/عنيزة/حي-النسيم"}': {
    path: "/عنيزة/حي-النسيم",
    __typename: "DistrictType",
    district_id: 2596,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/عنيزة/حي-النظيم"}': {
    path: "/عنيزة/حي-النظيم",
    __typename: "DistrictType",
    district_id: 2598,
    name: "حي النظيم",
    uri: "حي-النظيم",
  },
  'DistrictType:{"path":"/عنيزة/حي-الهداء"}': {
    path: "/عنيزة/حي-الهداء",
    __typename: "DistrictType",
    district_id: 2604,
    name: "حي الهداء",
    uri: "حي-الهداء",
  },
  'DistrictType:{"path":"/عنيزة/حي-اليرموك"}': {
    path: "/عنيزة/حي-اليرموك",
    __typename: "DistrictType",
    district_id: 2616,
    name: "حي اليرموك",
    uri: "حي-اليرموك",
  },
  'DistrictType:{"path":"/عنيزة/حي-دمشية"}': {
    path: "/عنيزة/حي-دمشية",
    __typename: "DistrictType",
    district_id: 2624,
    name: "حي دمشية",
    uri: "حي-دمشية",
  },
  'DistrictType:{"path":"/عنيزة/حي-غرناطة"}': {
    path: "/عنيزة/حي-غرناطة",
    __typename: "DistrictType",
    district_id: 2634,
    name: "حي غرناطة",
    uri: "حي-غرناطة",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-البحيرات"}': {
    path: "/دومة-الجندل/حي-البحيرات",
    __typename: "DistrictType",
    district_id: 2648,
    name: "حي البحيرات",
    uri: "حي-البحيرات",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-السوق-القديم"}': {
    path: "/دومة-الجندل/حي-السوق-القديم",
    __typename: "DistrictType",
    district_id: 2670,
    name: "حي السوق القديم",
    uri: "حي-السوق-القديم",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الغدير-الجنوبي"}': {
    path: "/دومة-الجندل/حي-الغدير-الجنوبي",
    __typename: "DistrictType",
    district_id: 2684,
    name: "حي الغدير الجنوبي",
    uri: "حي-الغدير-الجنوبي",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الغزالي"}': {
    path: "/دومة-الجندل/حي-الغزالي",
    __typename: "DistrictType",
    district_id: 2686,
    name: "حي الغزالي",
    uri: "حي-الغزالي",
  },
  'DistrictType:{"path":"/دومة-الجندل/حي-الملك-فهد-الجنوبي"}': {
    path: "/دومة-الجندل/حي-الملك-فهد-الجنوبي",
    __typename: "DistrictType",
    district_id: 2698,
    name: "حي الملك فهد الجنوبي",
    uri: "حي-الملك-فهد-الجنوبي",
  },
  'DistrictType:{"path":"/سكاكا/حي-الضلع"}': {
    path: "/سكاكا/حي-الضلع",
    __typename: "DistrictType",
    district_id: 2728,
    name: "حي الضلع",
    uri: "حي-الضلع",
  },
  'DistrictType:{"path":"/سكاكا/حي-اللقائط"}': {
    path: "/سكاكا/حي-اللقائط",
    __typename: "DistrictType",
    district_id: 2740,
    name: "حي اللقائط",
    uri: "حي-اللقائط",
  },
  'DistrictType:{"path":"/سكاكا/حي-المحمدية-و"}': {
    path: "/سكاكا/حي-المحمدية-و",
    __typename: "DistrictType",
    district_id: 2752,
    name: "حي المحمدية و",
    uri: "حي-المحمدية-و",
  },
  'DistrictType:{"path":"/سكاكا/حي-المنح-الخاصة"}': {
    path: "/سكاكا/حي-المنح-الخاصة",
    __typename: "DistrictType",
    district_id: 2762,
    name: "حي المنح الخاصة",
    uri: "حي-المنح-الخاصة",
  },
  'DistrictType:{"path":"/رفحاء/حي-العزيزية"}': {
    path: "/رفحاء/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 1924,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/رفحاء/حي-الملز"}': {
    path: "/رفحاء/حي-الملز",
    __typename: "DistrictType",
    district_id: 1938,
    name: "حي الملز",
    uri: "حي-الملز",
  },
  'DistrictType:{"path":"/رفحاء/حي-شمال-الخالدية"}': {
    path: "/رفحاء/حي-شمال-الخالدية",
    __typename: "DistrictType",
    district_id: 1944,
    name: "حي شمال الخالدية",
    uri: "حي-شمال-الخالدية",
  },
  'DistrictType:{"path":"/رفحاء/حي-شمال-النموذجية"}': {
    path: "/رفحاء/حي-شمال-النموذجية",
    __typename: "DistrictType",
    district_id: 1946,
    name: "حي شمال النموذجية",
    uri: "حي-شمال-النموذجية",
  },
  'DistrictType:{"path":"/طريف/حي-العزيزية"}': {
    path: "/طريف/حي-العزيزية",
    __typename: "DistrictType",
    district_id: 1956,
    name: "حي العزيزية",
    uri: "حي-العزيزية",
  },
  'DistrictType:{"path":"/طريف/حي-الورود"}': {
    path: "/طريف/حي-الورود",
    __typename: "DistrictType",
    district_id: 1962,
    name: "حي الورود",
    uri: "حي-الورود",
  },
  'DistrictType:{"path":"/عرعر/حي-المساعدية"}': {
    path: "/عرعر/حي-المساعدية",
    __typename: "DistrictType",
    district_id: 1984,
    name: "حي المساعدية",
    uri: "حي-المساعدية",
  },
  'DistrictType:{"path":"/عرعر/حي-المطار"}': {
    path: "/عرعر/حي-المطار",
    __typename: "DistrictType",
    district_id: 1986,
    name: "حي المطار",
    uri: "حي-المطار",
  },
  'DistrictType:{"path":"/الهفوف/حي-المحمدية"}': {
    path: "/الهفوف/حي-المحمدية",
    __typename: "DistrictType",
    district_id: 1610,
    name: "حي المحمدية",
    uri: "حي-المحمدية",
  },
  'DistrictType:{"path":"/الهفوف/حي-المزروع"}': {
    path: "/الهفوف/حي-المزروع",
    __typename: "DistrictType",
    district_id: 1616,
    name: "حي المزروع",
    uri: "حي-المزروع",
  },
  'DistrictType:{"path":"/الهفوف/حي-الملك-فهد"}': {
    path: "/الهفوف/حي-الملك-فهد",
    __typename: "DistrictType",
    district_id: 1626,
    name: "حي الملك فهد",
    uri: "حي-الملك-فهد",
  },
  'DistrictType:{"path":"/الهفوف/حي-المنيزلة"}': {
    path: "/الهفوف/حي-المنيزلة",
    __typename: "DistrictType",
    district_id: 1630,
    name: "حي المنيزلة",
    uri: "حي-المنيزلة",
  },
  'DistrictType:{"path":"/سكاكا/حي-شمال-مقبرة-اللقائط"}': {
    path: "/سكاكا/حي-شمال-مقبرة-اللقائط",
    __typename: "DistrictType",
    district_id: 2776,
    name: "حي شمال مقبرة اللقائط",
    uri: "حي-شمال-مقبرة-اللقائط",
  },
  'DistrictType:{"path":"/سكاكا/حي-مخطط-الصديق"}': {
    path: "/سكاكا/حي-مخطط-الصديق",
    __typename: "DistrictType",
    district_id: 2784,
    name: "حي مخطط الصديق",
    uri: "حي-مخطط-الصديق",
  },
  'DistrictType:{"path":"/الوجه/حي-البلد"}': {
    path: "/الوجه/حي-البلد",
    __typename: "DistrictType",
    district_id: 2804,
    name: "حي البلد",
    uri: "حي-البلد",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-السكب"}': {
    path: "/المدينة-المنورة/حي-السكب",
    __typename: "DistrictType",
    district_id: 2974,
    name: "حي السكب",
    uri: "حي-السكب",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-السكة-الحديدية"}': {
    path: "/المدينة-المنورة/حي-السكة-الحديدية",
    __typename: "DistrictType",
    district_id: 2976,
    name: "حي السكة الحديدية",
    uri: "حي-السكة-الحديدية",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-السيح"}': {
    path: "/المدينة-المنورة/حي-السيح",
    __typename: "DistrictType",
    district_id: 2980,
    name: "حي السيح",
    uri: "حي-السيح",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الظاهرة"}': {
    path: "/المدينة-المنورة/حي-الظاهرة",
    __typename: "DistrictType",
    district_id: 2988,
    name: "حي الظاهرة",
    uri: "حي-الظاهرة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-العانبس"}': {
    path: "/المدينة-المنورة/حي-العانبس",
    __typename: "DistrictType",
    district_id: 2990,
    name: "حي العانبس",
    uri: "حي-العانبس",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-العهن"}': {
    path: "/المدينة-المنورة/حي-العهن",
    __typename: "DistrictType",
    district_id: 2998,
    name: "حي العهن",
    uri: "حي-العهن",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الغابة"}': {
    path: "/المدينة-المنورة/حي-الغابة",
    __typename: "DistrictType",
    district_id: 3002,
    name: "حي الغابة",
    uri: "حي-الغابة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-الفتح"}': {
    path: "/المدينة-المنورة/حي-الفتح",
    __typename: "DistrictType",
    district_id: 3006,
    name: "حي الفتح",
    uri: "حي-الفتح",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-القلعة"}': {
    path: "/المدينة-المنورة/حي-القلعة",
    __typename: "DistrictType",
    district_id: 3012,
    name: "حي القلعة",
    uri: "حي-القلعة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-المصانع"}': {
    path: "/المدينة-المنورة/حي-المصانع",
    __typename: "DistrictType",
    district_id: 3016,
    name: "حي المصانع",
    uri: "حي-المصانع",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-المنطقة-المركزية"}': {
    path: "/المدينة-المنورة/حي-المنطقة-المركزية",
    __typename: "DistrictType",
    district_id: 3024,
    name: "حي المنطقة المركزية",
    uri: "حي-المنطقة-المركزية",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-النقس"}': {
    path: "/المدينة-المنورة/حي-النقس",
    __typename: "DistrictType",
    district_id: 3028,
    name: "حي النقس",
    uri: "حي-النقس",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-ام-خالد"}': {
    path: "/المدينة-المنورة/حي-ام-خالد",
    __typename: "DistrictType",
    district_id: 3034,
    name: "حي ام خالد",
    uri: "حي-ام-خالد",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-بئر-عثمان"}': {
    path: "/المدينة-المنورة/حي-بئر-عثمان",
    __typename: "DistrictType",
    district_id: 3046,
    name: "حي بئر عثمان",
    uri: "حي-بئر-عثمان",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-جبل-عير"}': {
    path: "/المدينة-المنورة/حي-جبل-عير",
    __typename: "DistrictType",
    district_id: 3052,
    name: "حي جبل عير",
    uri: "حي-جبل-عير",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-حثم"}': {
    path: "/المدينة-المنورة/حي-حثم",
    __typename: "DistrictType",
    district_id: 3054,
    name: "حي حثم",
    uri: "حي-حثم",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-خاخ"}': {
    path: "/المدينة-المنورة/حي-خاخ",
    __typename: "DistrictType",
    district_id: 3056,
    name: "حي خاخ",
    uri: "حي-خاخ",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-شوران"}': {
    path: "/المدينة-المنورة/حي-شوران",
    __typename: "DistrictType",
    district_id: 3066,
    name: "حي شوران",
    uri: "حي-شوران",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-طيبة"}': {
    path: "/المدينة-المنورة/حي-طيبة",
    __typename: "DistrictType",
    district_id: 3068,
    name: "حي طيبة",
    uri: "حي-طيبة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-عروة"}': {
    path: "/المدينة-المنورة/حي-عروة",
    __typename: "DistrictType",
    district_id: 3070,
    name: "حي عروة",
    uri: "حي-عروة",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-قربان"}': {
    path: "/المدينة-المنورة/حي-قربان",
    __typename: "DistrictType",
    district_id: 3074,
    name: "حي قربان",
    uri: "حي-قربان",
  },
  'DistrictType:{"path":"/المدينة-المنورة/حي-وعيرة"}': {
    path: "/المدينة-المنورة/حي-وعيرة",
    __typename: "DistrictType",
    district_id: 3090,
    name: "حي وعيرة",
    uri: "حي-وعيرة",
  },
  'DistrictType:{"path":"/بدر/حي-الجديد"}': {
    path: "/بدر/حي-الجديد",
    __typename: "DistrictType",
    district_id: 3094,
    name: "حي الجديد",
    uri: "حي-الجديد",
  },
  'DistrictType:{"path":"/بدر/حي-الغزلاني"}': {
    path: "/بدر/حي-الغزلاني",
    __typename: "DistrictType",
    district_id: 3102,
    name: "حي الغزلاني",
    uri: "حي-الغزلاني",
  },
  'DistrictType:{"path":"/بدر/حي-المفرق"}': {
    path: "/بدر/حي-المفرق",
    __typename: "DistrictType",
    district_id: 3106,
    name: "حي المفرق",
    uri: "حي-المفرق",
  },
  'DistrictType:{"path":"/ينبع/حي-الاضواء"}': {
    path: "/ينبع/حي-الاضواء",
    __typename: "DistrictType",
    district_id: 3122,
    name: "حي الاضواء",
    uri: "حي-الاضواء",
  },
  'DistrictType:{"path":"/ينبع/حي-التاخي"}': {
    path: "/ينبع/حي-التاخي",
    __typename: "DistrictType",
    district_id: 3134,
    name: "حي التاخي",
    uri: "حي-التاخي",
  },
  'DistrictType:{"path":"/ينبع/حي-الجامعة-العربية"}': {
    path: "/ينبع/حي-الجامعة-العربية",
    __typename: "DistrictType",
    district_id: 3146,
    name: "حي الجامعة العربية",
    uri: "حي-الجامعة-العربية",
  },
  'DistrictType:{"path":"/ينبع/حي-الحدائق"}': {
    path: "/ينبع/حي-الحدائق",
    __typename: "DistrictType",
    district_id: 3148,
    name: "حي الحدائق",
    uri: "حي-الحدائق",
  },
  'DistrictType:{"path":"/ينبع/حي-الشاطئ"}': {
    path: "/ينبع/حي-الشاطئ",
    __typename: "DistrictType",
    district_id: 3182,
    name: "حي الشاطئ",
    uri: "حي-الشاطئ",
  },
  'DistrictType:{"path":"/ينبع/حي-الصفا"}': {
    path: "/ينبع/حي-الصفا",
    __typename: "DistrictType",
    district_id: 3194,
    name: "حي الصفا",
    uri: "حي-الصفا",
  },
  'DistrictType:{"path":"/ينبع/حي-الصهاريج"}': {
    path: "/ينبع/حي-الصهاريج",
    __typename: "DistrictType",
    district_id: 3196,
    name: "حي الصهاريج",
    uri: "حي-الصهاريج",
  },
  'DistrictType:{"path":"/ينبع/حي-العيون"}': {
    path: "/ينبع/حي-العيون",
    __typename: "DistrictType",
    district_id: 3206,
    name: "حي العيون",
    uri: "حي-العيون",
  },
  'DistrictType:{"path":"/ينبع/حي-اللؤلؤ"}': {
    path: "/ينبع/حي-اللؤلؤ",
    __typename: "DistrictType",
    district_id: 3216,
    name: "حي اللؤلؤ",
    uri: "حي-اللؤلؤ",
  },
  'DistrictType:{"path":"/ينبع/حي-المشيريف"}': {
    path: "/ينبع/حي-المشيريف",
    __typename: "DistrictType",
    district_id: 3230,
    name: "حي المشيريف",
    uri: "حي-المشيريف",
  },
  'DistrictType:{"path":"/ينبع/حي-المهن"}': {
    path: "/ينبع/حي-المهن",
    __typename: "DistrictType",
    district_id: 3236,
    name: "حي المهن",
    uri: "حي-المهن",
  },
  'DistrictType:{"path":"/ينبع/حي-رضوى-النقادي"}': {
    path: "/ينبع/حي-رضوى-النقادي",
    __typename: "DistrictType",
    district_id: 3258,
    name: "حي رضوى النقادي",
    uri: "حي-رضوى-النقادي",
  },
  'DistrictType:{"path":"/الجموم/حي-الخالدية"}': {
    path: "/الجموم/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 3268,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/الجموم/حي-الفيصلية"}': {
    path: "/الجموم/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 3282,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/الجموم/حي-القريات"}': {
    path: "/الجموم/حي-القريات",
    __typename: "DistrictType",
    district_id: 3284,
    name: "حي القريات",
    uri: "حي-القريات",
  },
  'DistrictType:{"path":"/الجموم/حي-النخيل"}': {
    path: "/الجموم/حي-النخيل",
    __typename: "DistrictType",
    district_id: 3286,
    name: "حي النخيل",
    uri: "حي-النخيل",
  },
  'DistrictType:{"path":"/الخرمة/حي-الحزم"}': {
    path: "/الخرمة/حي-الحزم",
    __typename: "DistrictType",
    district_id: 3298,
    name: "حي الحزم",
    uri: "حي-الحزم",
  },
  'DistrictType:{"path":"/الخرمة/حي-الخالدية"}': {
    path: "/الخرمة/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 3300,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/الخرمة/حي-السوق-القديم"}': {
    path: "/الخرمة/حي-السوق-القديم",
    __typename: "DistrictType",
    district_id: 3306,
    name: "حي السوق القديم",
    uri: "حي-السوق-القديم",
  },
  'DistrictType:{"path":"/الخرمة/حي-النزهة"}': {
    path: "/الخرمة/حي-النزهة",
    __typename: "DistrictType",
    district_id: 3314,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/الطائف/حي-الخالدية"}': {
    path: "/الطائف/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 3320,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/الطائف/حي-الشهداء-الجنوبية"}': {
    path: "/الطائف/حي-الشهداء-الجنوبية",
    __typename: "DistrictType",
    district_id: 3330,
    name: "حي الشهداء الجنوبية",
    uri: "حي-الشهداء-الجنوبية",
  },
  'DistrictType:{"path":"/الطائف/حي-العقيق"}': {
    path: "/الطائف/حي-العقيق",
    __typename: "DistrictType",
    district_id: 3336,
    name: "حي العقيق",
    uri: "حي-العقيق",
  },
  'DistrictType:{"path":"/الطائف/حي-النزهة"}': {
    path: "/الطائف/حي-النزهة",
    __typename: "DistrictType",
    district_id: 3348,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/تربه/حي-العلاوة"}': {
    path: "/تربه/حي-العلاوة",
    __typename: "DistrictType",
    district_id: 3408,
    name: "حي العلاوة",
    uri: "حي-العلاوة",
  },
  'DistrictType:{"path":"/ثول/حي-جامعة-الملك-عبدالله-للعلوم-والتقنية"}': {
    path: "/ثول/حي-جامعة-الملك-عبدالله-للعلوم-والتقنية",
    __typename: "DistrictType",
    district_id: 3418,
    name: "حي جامعة الملك عبدالله للعلوم والتقنية",
    uri: "حي-جامعة-الملك-عبدالله-للعلوم-والتقنية",
  },
  'DistrictType:{"path":"/ثول/حي-وسط-ثول"}': {
    path: "/ثول/حي-وسط-ثول",
    __typename: "DistrictType",
    district_id: 3420,
    name: "حي وسط ثول",
    uri: "حي-وسط-ثول",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-ابرق-الرغامة"}': {
    path: "/جدة/شمال-جدة/حي-ابرق-الرغامة",
    __typename: "DistrictType",
    district_id: 3426,
    name: "حي ابرق الرغامة",
    uri: "حي-ابرق-الرغامة",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-البغدادية-الشرقية"}': {
    path: "/جدة/شمال-جدة/حي-البغدادية-الشرقية",
    __typename: "DistrictType",
    district_id: 3448,
    name: "حي البغدادية الشرقية",
    uri: "حي-البغدادية-الشرقية",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الحمراء"}': {
    path: "/جدة/شمال-جدة/حي-الحمراء",
    __typename: "DistrictType",
    district_id: 3470,
    name: "حي الحمراء",
    uri: "حي-الحمراء",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الرحمة"}': {
    path: "/جدة/جنوب-جدة/حي-الرحمة",
    __typename: "DistrictType",
    district_id: 3482,
    name: "حي الرحمة",
    uri: "حي-الرحمة",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الرياض"}': {
    path: "/جدة/شمال-جدة/حي-الرياض",
    __typename: "DistrictType",
    district_id: 3490,
    name: "حي الرياض",
    uri: "حي-الرياض",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الريان"}': {
    path: "/جدة/شمال-جدة/حي-الريان",
    __typename: "DistrictType",
    district_id: 3492,
    name: "حي الريان",
    uri: "حي-الريان",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الزمرد"}': {
    path: "/جدة/شمال-جدة/حي-الزمرد",
    __typename: "DistrictType",
    district_id: 3494,
    name: "حي الزمرد",
    uri: "حي-الزمرد",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-السنابل"}': {
    path: "/جدة/جنوب-جدة/حي-السنابل",
    __typename: "DistrictType",
    district_id: 3512,
    name: "حي السنابل",
    uri: "حي-السنابل",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الصفا"}': {
    path: "/جدة/شمال-جدة/حي-الصفا",
    __typename: "DistrictType",
    district_id: 3528,
    name: "حي الصفا",
    uri: "حي-الصفا",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-العمارية"}': {
    path: "/جدة/شمال-جدة/حي-العمارية",
    __typename: "DistrictType",
    district_id: 3540,
    name: "حي العمارية",
    uri: "حي-العمارية",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الفردوس"}': {
    path: "/جدة/شمال-جدة/حي-الفردوس",
    __typename: "DistrictType",
    district_id: 3546,
    name: "حي الفردوس",
    uri: "حي-الفردوس",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الفضل"}': {
    path: "/جدة/جنوب-جدة/حي-الفضل",
    __typename: "DistrictType",
    district_id: 3550,
    name: "حي الفضل",
    uri: "حي-الفضل",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-الفضيلة"}': {
    path: "/جدة/جنوب-جدة/حي-الفضيلة",
    __typename: "DistrictType",
    district_id: 3552,
    name: "حي الفضيلة",
    uri: "حي-الفضيلة",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الفلاح"}': {
    path: "/جدة/شمال-جدة/حي-الفلاح",
    __typename: "DistrictType",
    district_id: 3554,
    name: "حي الفلاح",
    uri: "حي-الفلاح",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الفيحاء"}': {
    path: "/جدة/شمال-جدة/حي-الفيحاء",
    __typename: "DistrictType",
    district_id: 3556,
    name: "حي الفيحاء",
    uri: "حي-الفيحاء",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-النهضة"}': {
    path: "/جدة/شمال-جدة/حي-النهضة",
    __typename: "DistrictType",
    district_id: 3608,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-الورود"}': {
    path: "/جدة/شمال-جدة/حي-الورود",
    __typename: "DistrictType",
    district_id: 3618,
    name: "حي الورود",
    uri: "حي-الورود",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-ام-السلم"}': {
    path: "/جدة/جنوب-جدة/حي-ام-السلم",
    __typename: "DistrictType",
    district_id: 3624,
    name: "حي ام السلم",
    uri: "حي-ام-السلم",
  },
  'DistrictType:{"path":"/جدة/جنوب-جدة/حي-بحرة"}': {
    path: "/جدة/جنوب-جدة/حي-بحرة",
    __typename: "DistrictType",
    district_id: 3630,
    name: "حي بحرة",
    uri: "حي-بحرة",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-بني-مالك"}': {
    path: "/جدة/شمال-جدة/حي-بني-مالك",
    __typename: "DistrictType",
    district_id: 3634,
    name: "حي بني مالك",
    uri: "حي-بني-مالك",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-مريخ"}': {
    path: "/جدة/شمال-جدة/حي-مريخ",
    __typename: "DistrictType",
    district_id: 3646,
    name: "حي مريخ",
    uri: "حي-مريخ",
  },
  'DistrictType:{"path":"/جدة/شمال-جدة/حي-مشرفة"}': {
    path: "/جدة/شمال-جدة/حي-مشرفة",
    __typename: "DistrictType",
    district_id: 3648,
    name: "حي مشرفة",
    uri: "حي-مشرفة",
  },
  'DistrictType:{"path":"/رابغ/حي-الصليب-الشرقي"}': {
    path: "/رابغ/حي-الصليب-الشرقي",
    __typename: "DistrictType",
    district_id: 3656,
    name: "حي الصليب الشرقي",
    uri: "حي-الصليب-الشرقي",
  },
  'DistrictType:{"path":"/رابغ/حي-السوق"}': {
    path: "/رابغ/حي-السوق",
    __typename: "DistrictType",
    district_id: 3662,
    name: "حي السوق",
    uri: "حي-السوق",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-اجياد"}': {
    path: "/مكة-المكرمة/حي-اجياد",
    __typename: "DistrictType",
    district_id: 3682,
    name: "حي اجياد",
    uri: "حي-اجياد",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الجامعة"}': {
    path: "/مكة-المكرمة/حي-الجامعة",
    __typename: "DistrictType",
    district_id: 3696,
    name: "حي الجامعة",
    uri: "حي-الجامعة",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الحمراء-و-ام-الجود"}': {
    path: "/مكة-المكرمة/حي-الحمراء-و-ام-الجود",
    __typename: "DistrictType",
    district_id: 3704,
    name: "حي الحمراء و ام الجود",
    uri: "حي-الحمراء-و-ام-الجود",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الخالدية"}': {
    path: "/مكة-المكرمة/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 3706,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الروضة"}': {
    path: "/مكة-المكرمة/حي-الروضة",
    __typename: "DistrictType",
    district_id: 3718,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-العوالي"}': {
    path: "/مكة-المكرمة/حي-العوالي",
    __typename: "DistrictType",
    district_id: 3752,
    name: "حي العوالي",
    uri: "حي-العوالي",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-القرارة-والنقا"}': {
    path: "/مكة-المكرمة/حي-القرارة-والنقا",
    __typename: "DistrictType",
    district_id: 3754,
    name: "حي القرارة والنقا",
    uri: "حي-القرارة-والنقا",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-المرسلات"}': {
    path: "/مكة-المكرمة/حي-المرسلات",
    __typename: "DistrictType",
    district_id: 3758,
    name: "حي المرسلات",
    uri: "حي-المرسلات",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-المسفلة"}': {
    path: "/مكة-المكرمة/حي-المسفلة",
    __typename: "DistrictType",
    district_id: 3760,
    name: "حي المسفلة",
    uri: "حي-المسفلة",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الملك-فهد"}': {
    path: "/مكة-المكرمة/حي-الملك-فهد",
    __typename: "DistrictType",
    district_id: 3766,
    name: "حي الملك فهد",
    uri: "حي-الملك-فهد",
  },
  'DistrictType:{"path":"/مكة-المكرمة/حي-الهجلة"}': {
    path: "/مكة-المكرمة/حي-الهجلة",
    __typename: "DistrictType",
    district_id: 3778,
    name: "حي الهجلة",
    uri: "حي-الهجلة",
  },
  'DistrictType:{"path":"/ابها/حي-السروات"}': {
    path: "/ابها/حي-السروات",
    __typename: "DistrictType",
    district_id: 3796,
    name: "حي السروات",
    uri: "حي-السروات",
  },
  'DistrictType:{"path":"/ابها/حي-الشفاء"}': {
    path: "/ابها/حي-الشفاء",
    __typename: "DistrictType",
    district_id: 3800,
    name: "حي الشفاء",
    uri: "حي-الشفاء",
  },
  'DistrictType:{"path":"/ابها/حي-القريقر"}': {
    path: "/ابها/حي-القريقر",
    __typename: "DistrictType",
    district_id: 3814,
    name: "حي القريقر",
    uri: "حي-القريقر",
  },
  'DistrictType:{"path":"/ابها/حي-درة-المنسك"}': {
    path: "/ابها/حي-درة-المنسك",
    __typename: "DistrictType",
    district_id: 3832,
    name: "حي درة المنسك",
    uri: "حي-درة-المنسك",
  },
  'DistrictType:{"path":"/ابها/حي-وسط-المدينة"}': {
    path: "/ابها/حي-وسط-المدينة",
    __typename: "DistrictType",
    district_id: 3838,
    name: "حي وسط المدينة",
    uri: "حي-وسط-المدينة",
  },
  'DistrictType:{"path":"/احد-رفيده/حي-الخالدية"}': {
    path: "/احد-رفيده/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 3840,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/احد-رفيده/حي-الزهور"}': {
    path: "/احد-رفيده/حي-الزهور",
    __typename: "DistrictType",
    district_id: 3846,
    name: "حي الزهور",
    uri: "حي-الزهور",
  },
  'DistrictType:{"path":"/احد-رفيده/حي-الورود"}': {
    path: "/احد-رفيده/حي-الورود",
    __typename: "DistrictType",
    district_id: 3862,
    name: "حي الورود",
    uri: "حي-الورود",
  },
  'DistrictType:{"path":"/المجاردة/حي-الخالدية"}': {
    path: "/المجاردة/حي-الخالدية",
    __typename: "DistrictType",
    district_id: 3872,
    name: "حي الخالدية",
    uri: "حي-الخالدية",
  },
  'DistrictType:{"path":"/المجاردة/حي-الروضة"}': {
    path: "/المجاردة/حي-الروضة",
    __typename: "DistrictType",
    district_id: 3878,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/المجاردة/حي-النهضة"}': {
    path: "/المجاردة/حي-النهضة",
    __typename: "DistrictType",
    district_id: 3890,
    name: "حي النهضة",
    uri: "حي-النهضة",
  },
  'DistrictType:{"path":"/بيشة/حي-الخزان"}': {
    path: "/بيشة/حي-الخزان",
    __typename: "DistrictType",
    district_id: 3934,
    name: "حي الخزان",
    uri: "حي-الخزان",
  },
  'DistrictType:{"path":"/بيشة/حي-الرمال"}': {
    path: "/بيشة/حي-الرمال",
    __typename: "DistrictType",
    district_id: 3940,
    name: "حي الرمال",
    uri: "حي-الرمال",
  },
  'DistrictType:{"path":"/بيشة/حي-الفيصلية"}': {
    path: "/بيشة/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 3960,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/بيشة/حي-النزهة"}': {
    path: "/بيشة/حي-النزهة",
    __typename: "DistrictType",
    district_id: 3970,
    name: "حي النزهة",
    uri: "حي-النزهة",
  },
  'DistrictType:{"path":"/بيشة/حي-الوادي"}': {
    path: "/بيشة/حي-الوادي",
    __typename: "DistrictType",
    district_id: 3976,
    name: "حي الوادي",
    uri: "حي-الوادي",
  },
  'DistrictType:{"path":"/تثليث/حي-الفاخرية"}': {
    path: "/تثليث/حي-الفاخرية",
    __typename: "DistrictType",
    district_id: 3994,
    name: "حي الفاخرية",
    uri: "حي-الفاخرية",
  },
  'DistrictType:{"path":"/تثليث/حي-المدينة"}': {
    path: "/تثليث/حي-المدينة",
    __typename: "DistrictType",
    district_id: 3996,
    name: "حي المدينة",
    uri: "حي-المدينة",
  },
  'DistrictType:{"path":"/تثليث/حي-الوجه"}': {
    path: "/تثليث/حي-الوجه",
    __typename: "DistrictType",
    district_id: 4000,
    name: "حي الوجه",
    uri: "حي-الوجه",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-الدوحة"}': {
    path: "/خميس-مشيط/حي-الدوحة",
    __typename: "DistrictType",
    district_id: 4012,
    name: "حي الدوحة",
    uri: "حي-الدوحة",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-الرصراص"}': {
    path: "/خميس-مشيط/حي-الرصراص",
    __typename: "DistrictType",
    district_id: 4016,
    name: "حي الرصراص",
    uri: "حي-الرصراص",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-الروضة"}': {
    path: "/خميس-مشيط/حي-الروضة",
    __typename: "DistrictType",
    district_id: 4018,
    name: "حي الروضة",
    uri: "حي-الروضة",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-الزهور"}': {
    path: "/خميس-مشيط/حي-الزهور",
    __typename: "DistrictType",
    district_id: 4020,
    name: "حي الزهور",
    uri: "حي-الزهور",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-السد"}': {
    path: "/خميس-مشيط/حي-السد",
    __typename: "DistrictType",
    district_id: 4022,
    name: "حي السد",
    uri: "حي-السد",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-السلام"}': {
    path: "/خميس-مشيط/حي-السلام",
    __typename: "DistrictType",
    district_id: 4024,
    name: "حي السلام",
    uri: "حي-السلام",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-الشرفية"}': {
    path: "/خميس-مشيط/حي-الشرفية",
    __typename: "DistrictType",
    district_id: 4026,
    name: "حي الشرفية",
    uri: "حي-الشرفية",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-الشفاء"}': {
    path: "/خميس-مشيط/حي-الشفاء",
    __typename: "DistrictType",
    district_id: 4028,
    name: "حي الشفاء",
    uri: "حي-الشفاء",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-العرق-الجنوبي"}': {
    path: "/خميس-مشيط/حي-العرق-الجنوبي",
    __typename: "DistrictType",
    district_id: 4032,
    name: "حي العرق الجنوبي",
    uri: "حي-العرق-الجنوبي",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-الفتح"}': {
    path: "/خميس-مشيط/حي-الفتح",
    __typename: "DistrictType",
    district_id: 4038,
    name: "حي الفتح",
    uri: "حي-الفتح",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-القافلة"}': {
    path: "/خميس-مشيط/حي-القافلة",
    __typename: "DistrictType",
    district_id: 4040,
    name: "حي القافلة",
    uri: "حي-القافلة",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-المثناة"}': {
    path: "/خميس-مشيط/حي-المثناة",
    __typename: "DistrictType",
    district_id: 4044,
    name: "حي المثناة",
    uri: "حي-المثناة",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-النسيم"}': {
    path: "/خميس-مشيط/حي-النسيم",
    __typename: "DistrictType",
    district_id: 4056,
    name: "حي النسيم",
    uri: "حي-النسيم",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-الهميلة"}': {
    path: "/خميس-مشيط/حي-الهميلة",
    __typename: "DistrictType",
    district_id: 4062,
    name: "حي الهميلة",
    uri: "حي-الهميلة",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-الواحة"}': {
    path: "/خميس-مشيط/حي-الواحة",
    __typename: "DistrictType",
    district_id: 4064,
    name: "حي الواحة",
    uri: "حي-الواحة",
  },
  'DistrictType:{"path":"/خميس-مشيط/حي-شباعة"}': {
    path: "/خميس-مشيط/حي-شباعة",
    __typename: "DistrictType",
    district_id: 4074,
    name: "حي شباعة",
    uri: "حي-شباعة",
  },
  'DistrictType:{"path":"/محايل/حي-الشهد"}': {
    path: "/محايل/حي-الشهد",
    __typename: "DistrictType",
    district_id: 4106,
    name: "حي الشهد",
    uri: "حي-الشهد",
  },
  'DistrictType:{"path":"/شرورة/حي-الروضة-الجنوبية"}': {
    path: "/شرورة/حي-الروضة-الجنوبية",
    __typename: "DistrictType",
    district_id: 4344,
    name: "حي الروضة الجنوبية",
    uri: "حي-الروضة-الجنوبية",
  },
  'DistrictType:{"path":"/شرورة/حي-الفهد"}': {
    path: "/شرورة/حي-الفهد",
    __typename: "DistrictType",
    district_id: 4352,
    name: "حي الفهد",
    uri: "حي-الفهد",
  },
  'DistrictType:{"path":"/شرورة/حي-مخطط-أ"}': {
    path: "/شرورة/حي-مخطط-أ",
    __typename: "DistrictType",
    district_id: 4362,
    name: "حي مخطط أ",
    uri: "حي-مخطط-أ",
  },
  'DistrictType:{"path":"/نجران/حي-الجربة"}': {
    path: "/نجران/حي-الجربة",
    __typename: "DistrictType",
    district_id: 4370,
    name: "حي الجربة",
    uri: "حي-الجربة",
  },
  'DistrictType:{"path":"/نجران/حي-الفهد"}': {
    path: "/نجران/حي-الفهد",
    __typename: "DistrictType",
    district_id: 4378,
    name: "حي الفهد",
    uri: "حي-الفهد",
  },
  'DistrictType:{"path":"/نجران/حي-الفيصلية"}': {
    path: "/نجران/حي-الفيصلية",
    __typename: "DistrictType",
    district_id: 4380,
    name: "حي الفيصلية",
    uri: "حي-الفيصلية",
  },
  'DistrictType:{"path":"/نجران/حي-مخطط-رجلا-الشمالية-الزراعي"}': {
    path: "/نجران/حي-مخطط-رجلا-الشمالية-الزراعي",
    __typename: "DistrictType",
    district_id: 4412,
    name: "حي مخطط رجلا الشمالية الزراعي",
    uri: "حي-مخطط-رجلا-الشمالية-الزراعي",
  },
  'DistrictType:{"path":"/نجران/حي-مخطط-نهوفة-الزراعي"}': {
    path: "/نجران/حي-مخطط-نهوفة-الزراعي",
    __typename: "DistrictType",
    district_id: 4416,
    name: "حي مخطط نهوفة الزراعي",
    uri: "حي-مخطط-نهوفة-الزراعي",
  },
  'DistrictType:{"path":"/الباحة/حي-الراعب"}': {
    path: "/الباحة/حي-الراعب",
    __typename: "DistrictType",
    district_id: 4426,
    name: "حي الراعب",
    uri: "حي-الراعب",
  },
  'DistrictType:{"path":"/الباحة/حي-رغدان"}': {
    path: "/الباحة/حي-رغدان",
    __typename: "DistrictType",
    district_id: 4432,
    name: "حي رغدان",
    uri: "حي-رغدان",
  },
};
